// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"2ebq0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "anime", ()=>(0, _animeEsJsDefault.default));
parcelHelpers.export(exports, "Lottie", ()=>(0, _tgsPlayerDefault.default));
parcelHelpers.export(exports, "jquery", ()=>jquery);
parcelHelpers.export(exports, "bootstrap", ()=>bootstrap);
var _animeEsJs = require("animejs/lib/anime.es.js");
var _animeEsJsDefault = parcelHelpers.interopDefault(_animeEsJs);
var _scrollreveal = require("scrollreveal");
var _scrollrevealDefault = parcelHelpers.interopDefault(_scrollreveal);
var _bootstrap = require("bootstrap");
var _tgsPlayer = require("@lottiefiles/lottie-player/dist/tgs-player");
var _tgsPlayerDefault = parcelHelpers.interopDefault(_tgsPlayer);
const sr = (0, _scrollrevealDefault.default)();
var jquery = require("db8079033e3de446");
window.$ = window.jQuery = jquery;
const bootstrap = {
    Modal: (0, _bootstrap.Modal)
};
(function($) {
    //- Loder
    const select = (el, all = false)=>{
        el = el.trim();
        if (all) return [
            ...document.querySelectorAll(el)
        ];
        else return document.querySelector(el);
    };
    let preloader = select(".preloader");
    if (preloader) window.addEventListener("load", ()=>{
        preloader.classList.add("fade-out");
        setTimeout(function() {
            preloader.classList.add("d-none");
        }, 1000);
    });
    //- Scroll Reveal
    window.onload = ()=>{
        (0, _scrollrevealDefault.default)().reveal(".fade-in", {
            easing: "ease-in"
        });
        // Modal
        let offCanvasModal = new bootstrap.Modal(document.getElementById("offCanvas"));
        document.querySelectorAll("a").forEach((anchor)=>{
            let href = anchor.getAttribute("href");
            // Check if href starts with '#'
            if (href.startsWith("#")) anchor.addEventListener("click", function(e) {
                e.preventDefault();
                offCanvasModal.hide();
                // Make sure that href is a valid ID selector.
                if (href.length > 1) {
                    let target = document.querySelector(href);
                    // Ensure that the target element exists
                    if (target) window.scrollTo({
                        top: target.offsetTop,
                        behavior: "smooth"
                    });
                }
            });
            else if (href.startsWith("/")) anchor.addEventListener("click", function(e) {
                offCanvasModal.hide();
            });
        });
        document.querySelectorAll("a").forEach((anchor)=>{
            anchor.addEventListener("click", function(e) {
                let href = this.getAttribute("href");
                // Check if href starts with '#'
                if (href.startsWith("#")) {
                    e.preventDefault();
                    offCanvasModal.hide();
                    // Make sure that href is a valid ID selector.
                    if (href.length > 1) {
                        let target = document.querySelector(href);
                        // Ensure that the target element exists
                        if (target) window.scrollTo({
                            top: target.offsetTop,
                            behavior: "smooth"
                        });
                    }
                } else if (href.startsWith("/")) offCanvasModal.hide();
            });
        });
    };
})(jQuery);

},{"animejs/lib/anime.es.js":"3IYsv","scrollreveal":"gwKMP","db8079033e3de446":"11TDa","bootstrap":"900Wv","@lottiefiles/lottie-player/dist/tgs-player":"hV4nY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3IYsv":[function(require,module,exports) {
/*
 * anime.js v3.2.1
 * (c) 2020 Julian Garnier
 * Released under the MIT license
 * animejs.com
 */ // Defaults
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var defaultInstanceSettings = {
    update: null,
    begin: null,
    loopBegin: null,
    changeBegin: null,
    change: null,
    changeComplete: null,
    loopComplete: null,
    complete: null,
    loop: 1,
    direction: "normal",
    autoplay: true,
    timelineOffset: 0
};
var defaultTweenSettings = {
    duration: 1000,
    delay: 0,
    endDelay: 0,
    easing: "easeOutElastic(1, .5)",
    round: 0
};
var validTransforms = [
    "translateX",
    "translateY",
    "translateZ",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "scale",
    "scaleX",
    "scaleY",
    "scaleZ",
    "skew",
    "skewX",
    "skewY",
    "perspective",
    "matrix",
    "matrix3d"
];
// Caching
var cache = {
    CSS: {},
    springs: {}
};
// Utils
function minMax(val, min, max) {
    return Math.min(Math.max(val, min), max);
}
function stringContains(str, text) {
    return str.indexOf(text) > -1;
}
function applyArguments(func, args) {
    return func.apply(null, args);
}
var is = {
    arr: function(a) {
        return Array.isArray(a);
    },
    obj: function(a) {
        return stringContains(Object.prototype.toString.call(a), "Object");
    },
    pth: function(a) {
        return is.obj(a) && a.hasOwnProperty("totalLength");
    },
    svg: function(a) {
        return a instanceof SVGElement;
    },
    inp: function(a) {
        return a instanceof HTMLInputElement;
    },
    dom: function(a) {
        return a.nodeType || is.svg(a);
    },
    str: function(a) {
        return typeof a === "string";
    },
    fnc: function(a) {
        return typeof a === "function";
    },
    und: function(a) {
        return typeof a === "undefined";
    },
    nil: function(a) {
        return is.und(a) || a === null;
    },
    hex: function(a) {
        return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a);
    },
    rgb: function(a) {
        return /^rgb/.test(a);
    },
    hsl: function(a) {
        return /^hsl/.test(a);
    },
    col: function(a) {
        return is.hex(a) || is.rgb(a) || is.hsl(a);
    },
    key: function(a) {
        return !defaultInstanceSettings.hasOwnProperty(a) && !defaultTweenSettings.hasOwnProperty(a) && a !== "targets" && a !== "keyframes";
    }
};
// Easings
function parseEasingParameters(string) {
    var match = /\(([^)]+)\)/.exec(string);
    return match ? match[1].split(",").map(function(p) {
        return parseFloat(p);
    }) : [];
}
// Spring solver inspired by Webkit Copyright © 2016 Apple Inc. All rights reserved. https://webkit.org/demos/spring/spring.js
function spring(string, duration) {
    var params = parseEasingParameters(string);
    var mass = minMax(is.und(params[0]) ? 1 : params[0], .1, 100);
    var stiffness = minMax(is.und(params[1]) ? 100 : params[1], .1, 100);
    var damping = minMax(is.und(params[2]) ? 10 : params[2], .1, 100);
    var velocity = minMax(is.und(params[3]) ? 0 : params[3], .1, 100);
    var w0 = Math.sqrt(stiffness / mass);
    var zeta = damping / (2 * Math.sqrt(stiffness * mass));
    var wd = zeta < 1 ? w0 * Math.sqrt(1 - zeta * zeta) : 0;
    var a = 1;
    var b = zeta < 1 ? (zeta * w0 + -velocity) / wd : -velocity + w0;
    function solver(t) {
        var progress = duration ? duration * t / 1000 : t;
        if (zeta < 1) progress = Math.exp(-progress * zeta * w0) * (a * Math.cos(wd * progress) + b * Math.sin(wd * progress));
        else progress = (a + b * progress) * Math.exp(-progress * w0);
        if (t === 0 || t === 1) return t;
        return 1 - progress;
    }
    function getDuration() {
        var cached = cache.springs[string];
        if (cached) return cached;
        var frame = 1 / 6;
        var elapsed = 0;
        var rest = 0;
        while(true){
            elapsed += frame;
            if (solver(elapsed) === 1) {
                rest++;
                if (rest >= 16) break;
            } else rest = 0;
        }
        var duration = elapsed * frame * 1000;
        cache.springs[string] = duration;
        return duration;
    }
    return duration ? solver : getDuration;
}
// Basic steps easing implementation https://developer.mozilla.org/fr/docs/Web/CSS/transition-timing-function
function steps(steps) {
    if (steps === void 0) steps = 10;
    return function(t) {
        return Math.ceil(minMax(t, 0.000001, 1) * steps) * (1 / steps);
    };
}
// BezierEasing https://github.com/gre/bezier-easing
var bezier = function() {
    var kSplineTableSize = 11;
    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
    function A(aA1, aA2) {
        return 1.0 - 3.0 * aA2 + 3.0 * aA1;
    }
    function B(aA1, aA2) {
        return 3.0 * aA2 - 6.0 * aA1;
    }
    function C(aA1) {
        return 3.0 * aA1;
    }
    function calcBezier(aT, aA1, aA2) {
        return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
    }
    function getSlope(aT, aA1, aA2) {
        return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }
    function binarySubdivide(aX, aA, aB, mX1, mX2) {
        var currentX, currentT, i = 0;
        do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) aB = currentT;
            else aA = currentT;
        }while (Math.abs(currentX) > 0.0000001 && ++i < 10);
        return currentT;
    }
    function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
        for(var i = 0; i < 4; ++i){
            var currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) return aGuessT;
            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    }
    function bezier(mX1, mY1, mX2, mY2) {
        if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) return;
        var sampleValues = new Float32Array(kSplineTableSize);
        if (mX1 !== mY1 || mX2 !== mY2) for(var i = 0; i < kSplineTableSize; ++i)sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
        function getTForX(aX) {
            var intervalStart = 0;
            var currentSample = 1;
            var lastSample = kSplineTableSize - 1;
            for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
            --currentSample;
            var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
            var guessForT = intervalStart + dist * kSampleStepSize;
            var initialSlope = getSlope(guessForT, mX1, mX2);
            if (initialSlope >= 0.001) return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
            else if (initialSlope === 0.0) return guessForT;
            else return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
        }
        return function(x) {
            if (mX1 === mY1 && mX2 === mY2) return x;
            if (x === 0 || x === 1) return x;
            return calcBezier(getTForX(x), mY1, mY2);
        };
    }
    return bezier;
}();
var penner = function() {
    // Based on jQuery UI's implemenation of easing equations from Robert Penner (http://www.robertpenner.com/easing)
    var eases = {
        linear: function() {
            return function(t) {
                return t;
            };
        }
    };
    var functionEasings = {
        Sine: function() {
            return function(t) {
                return 1 - Math.cos(t * Math.PI / 2);
            };
        },
        Circ: function() {
            return function(t) {
                return 1 - Math.sqrt(1 - t * t);
            };
        },
        Back: function() {
            return function(t) {
                return t * t * (3 * t - 2);
            };
        },
        Bounce: function() {
            return function(t) {
                var pow2, b = 4;
                while(t < ((pow2 = Math.pow(2, --b)) - 1) / 11);
                return 1 / Math.pow(4, 3 - b) - 7.5625 * Math.pow((pow2 * 3 - 2) / 22 - t, 2);
            };
        },
        Elastic: function(amplitude, period) {
            if (amplitude === void 0) amplitude = 1;
            if (period === void 0) period = .5;
            var a = minMax(amplitude, 1, 10);
            var p = minMax(period, .1, 2);
            return function(t) {
                return t === 0 || t === 1 ? t : -a * Math.pow(2, 10 * (t - 1)) * Math.sin((t - 1 - p / (Math.PI * 2) * Math.asin(1 / a)) * (Math.PI * 2) / p);
            };
        }
    };
    var baseEasings = [
        "Quad",
        "Cubic",
        "Quart",
        "Quint",
        "Expo"
    ];
    baseEasings.forEach(function(name, i) {
        functionEasings[name] = function() {
            return function(t) {
                return Math.pow(t, i + 2);
            };
        };
    });
    Object.keys(functionEasings).forEach(function(name) {
        var easeIn = functionEasings[name];
        eases["easeIn" + name] = easeIn;
        eases["easeOut" + name] = function(a, b) {
            return function(t) {
                return 1 - easeIn(a, b)(1 - t);
            };
        };
        eases["easeInOut" + name] = function(a, b) {
            return function(t) {
                return t < 0.5 ? easeIn(a, b)(t * 2) / 2 : 1 - easeIn(a, b)(t * -2 + 2) / 2;
            };
        };
        eases["easeOutIn" + name] = function(a, b) {
            return function(t) {
                return t < 0.5 ? (1 - easeIn(a, b)(1 - t * 2)) / 2 : (easeIn(a, b)(t * 2 - 1) + 1) / 2;
            };
        };
    });
    return eases;
}();
function parseEasings(easing, duration) {
    if (is.fnc(easing)) return easing;
    var name = easing.split("(")[0];
    var ease = penner[name];
    var args = parseEasingParameters(easing);
    switch(name){
        case "spring":
            return spring(easing, duration);
        case "cubicBezier":
            return applyArguments(bezier, args);
        case "steps":
            return applyArguments(steps, args);
        default:
            return applyArguments(ease, args);
    }
}
// Strings
function selectString(str) {
    try {
        var nodes = document.querySelectorAll(str);
        return nodes;
    } catch (e) {
        return;
    }
}
// Arrays
function filterArray(arr, callback) {
    var len = arr.length;
    var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
    var result = [];
    for(var i = 0; i < len; i++)if (i in arr) {
        var val = arr[i];
        if (callback.call(thisArg, val, i, arr)) result.push(val);
    }
    return result;
}
function flattenArray(arr) {
    return arr.reduce(function(a, b) {
        return a.concat(is.arr(b) ? flattenArray(b) : b);
    }, []);
}
function toArray(o) {
    if (is.arr(o)) return o;
    if (is.str(o)) o = selectString(o) || o;
    if (o instanceof NodeList || o instanceof HTMLCollection) return [].slice.call(o);
    return [
        o
    ];
}
function arrayContains(arr, val) {
    return arr.some(function(a) {
        return a === val;
    });
}
// Objects
function cloneObject(o) {
    var clone = {};
    for(var p in o)clone[p] = o[p];
    return clone;
}
function replaceObjectProps(o1, o2) {
    var o = cloneObject(o1);
    for(var p in o1)o[p] = o2.hasOwnProperty(p) ? o2[p] : o1[p];
    return o;
}
function mergeObjects(o1, o2) {
    var o = cloneObject(o1);
    for(var p in o2)o[p] = is.und(o1[p]) ? o2[p] : o1[p];
    return o;
}
// Colors
function rgbToRgba(rgbValue) {
    var rgb = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(rgbValue);
    return rgb ? "rgba(" + rgb[1] + ",1)" : rgbValue;
}
function hexToRgba(hexValue) {
    var rgx = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    var hex = hexValue.replace(rgx, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    var r = parseInt(rgb[1], 16);
    var g = parseInt(rgb[2], 16);
    var b = parseInt(rgb[3], 16);
    return "rgba(" + r + "," + g + "," + b + ",1)";
}
function hslToRgba(hslValue) {
    var hsl = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(hslValue) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(hslValue);
    var h = parseInt(hsl[1], 10) / 360;
    var s = parseInt(hsl[2], 10) / 100;
    var l = parseInt(hsl[3], 10) / 100;
    var a = hsl[4] || 1;
    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    var r, g, b;
    if (s == 0) r = g = b = l;
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return "rgba(" + r * 255 + "," + g * 255 + "," + b * 255 + "," + a + ")";
}
function colorToRgb(val) {
    if (is.rgb(val)) return rgbToRgba(val);
    if (is.hex(val)) return hexToRgba(val);
    if (is.hsl(val)) return hslToRgba(val);
}
// Units
function getUnit(val) {
    var split = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(val);
    if (split) return split[1];
}
function getTransformUnit(propName) {
    if (stringContains(propName, "translate") || propName === "perspective") return "px";
    if (stringContains(propName, "rotate") || stringContains(propName, "skew")) return "deg";
}
// Values
function getFunctionValue(val, animatable) {
    if (!is.fnc(val)) return val;
    return val(animatable.target, animatable.id, animatable.total);
}
function getAttribute(el, prop) {
    return el.getAttribute(prop);
}
function convertPxToUnit(el, value, unit) {
    var valueUnit = getUnit(value);
    if (arrayContains([
        unit,
        "deg",
        "rad",
        "turn"
    ], valueUnit)) return value;
    var cached = cache.CSS[value + unit];
    if (!is.und(cached)) return cached;
    var baseline = 100;
    var tempEl = document.createElement(el.tagName);
    var parentEl = el.parentNode && el.parentNode !== document ? el.parentNode : document.body;
    parentEl.appendChild(tempEl);
    tempEl.style.position = "absolute";
    tempEl.style.width = baseline + unit;
    var factor = baseline / tempEl.offsetWidth;
    parentEl.removeChild(tempEl);
    var convertedUnit = factor * parseFloat(value);
    cache.CSS[value + unit] = convertedUnit;
    return convertedUnit;
}
function getCSSValue(el, prop, unit) {
    if (prop in el.style) {
        var uppercasePropName = prop.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        var value = el.style[prop] || getComputedStyle(el).getPropertyValue(uppercasePropName) || "0";
        return unit ? convertPxToUnit(el, value, unit) : value;
    }
}
function getAnimationType(el, prop) {
    if (is.dom(el) && !is.inp(el) && (!is.nil(getAttribute(el, prop)) || is.svg(el) && el[prop])) return "attribute";
    if (is.dom(el) && arrayContains(validTransforms, prop)) return "transform";
    if (is.dom(el) && prop !== "transform" && getCSSValue(el, prop)) return "css";
    if (el[prop] != null) return "object";
}
function getElementTransforms(el) {
    if (!is.dom(el)) return;
    var str = el.style.transform || "";
    var reg = /(\w+)\(([^)]*)\)/g;
    var transforms = new Map();
    var m;
    while(m = reg.exec(str))transforms.set(m[1], m[2]);
    return transforms;
}
function getTransformValue(el, propName, animatable, unit) {
    var defaultVal = stringContains(propName, "scale") ? 1 : 0 + getTransformUnit(propName);
    var value = getElementTransforms(el).get(propName) || defaultVal;
    if (animatable) {
        animatable.transforms.list.set(propName, value);
        animatable.transforms["last"] = propName;
    }
    return unit ? convertPxToUnit(el, value, unit) : value;
}
function getOriginalTargetValue(target, propName, unit, animatable) {
    switch(getAnimationType(target, propName)){
        case "transform":
            return getTransformValue(target, propName, animatable, unit);
        case "css":
            return getCSSValue(target, propName, unit);
        case "attribute":
            return getAttribute(target, propName);
        default:
            return target[propName] || 0;
    }
}
function getRelativeValue(to, from) {
    var operator = /^(\*=|\+=|-=)/.exec(to);
    if (!operator) return to;
    var u = getUnit(to) || 0;
    var x = parseFloat(from);
    var y = parseFloat(to.replace(operator[0], ""));
    switch(operator[0][0]){
        case "+":
            return x + y + u;
        case "-":
            return x - y + u;
        case "*":
            return x * y + u;
    }
}
function validateValue(val, unit) {
    if (is.col(val)) return colorToRgb(val);
    if (/\s/g.test(val)) return val;
    var originalUnit = getUnit(val);
    var unitLess = originalUnit ? val.substr(0, val.length - originalUnit.length) : val;
    if (unit) return unitLess + unit;
    return unitLess;
}
// getTotalLength() equivalent for circle, rect, polyline, polygon and line shapes
// adapted from https://gist.github.com/SebLambla/3e0550c496c236709744
function getDistance(p1, p2) {
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}
function getCircleLength(el) {
    return Math.PI * 2 * getAttribute(el, "r");
}
function getRectLength(el) {
    return getAttribute(el, "width") * 2 + getAttribute(el, "height") * 2;
}
function getLineLength(el) {
    return getDistance({
        x: getAttribute(el, "x1"),
        y: getAttribute(el, "y1")
    }, {
        x: getAttribute(el, "x2"),
        y: getAttribute(el, "y2")
    });
}
function getPolylineLength(el) {
    var points = el.points;
    var totalLength = 0;
    var previousPos;
    for(var i = 0; i < points.numberOfItems; i++){
        var currentPos = points.getItem(i);
        if (i > 0) totalLength += getDistance(previousPos, currentPos);
        previousPos = currentPos;
    }
    return totalLength;
}
function getPolygonLength(el) {
    var points = el.points;
    return getPolylineLength(el) + getDistance(points.getItem(points.numberOfItems - 1), points.getItem(0));
}
// Path animation
function getTotalLength(el) {
    if (el.getTotalLength) return el.getTotalLength();
    switch(el.tagName.toLowerCase()){
        case "circle":
            return getCircleLength(el);
        case "rect":
            return getRectLength(el);
        case "line":
            return getLineLength(el);
        case "polyline":
            return getPolylineLength(el);
        case "polygon":
            return getPolygonLength(el);
    }
}
function setDashoffset(el) {
    var pathLength = getTotalLength(el);
    el.setAttribute("stroke-dasharray", pathLength);
    return pathLength;
}
// Motion path
function getParentSvgEl(el) {
    var parentEl = el.parentNode;
    while(is.svg(parentEl)){
        if (!is.svg(parentEl.parentNode)) break;
        parentEl = parentEl.parentNode;
    }
    return parentEl;
}
function getParentSvg(pathEl, svgData) {
    var svg = svgData || {};
    var parentSvgEl = svg.el || getParentSvgEl(pathEl);
    var rect = parentSvgEl.getBoundingClientRect();
    var viewBoxAttr = getAttribute(parentSvgEl, "viewBox");
    var width = rect.width;
    var height = rect.height;
    var viewBox = svg.viewBox || (viewBoxAttr ? viewBoxAttr.split(" ") : [
        0,
        0,
        width,
        height
    ]);
    return {
        el: parentSvgEl,
        viewBox: viewBox,
        x: viewBox[0] / 1,
        y: viewBox[1] / 1,
        w: width,
        h: height,
        vW: viewBox[2],
        vH: viewBox[3]
    };
}
function getPath(path, percent) {
    var pathEl = is.str(path) ? selectString(path)[0] : path;
    var p = percent || 100;
    return function(property) {
        return {
            property: property,
            el: pathEl,
            svg: getParentSvg(pathEl),
            totalLength: getTotalLength(pathEl) * (p / 100)
        };
    };
}
function getPathProgress(path, progress, isPathTargetInsideSVG) {
    function point(offset) {
        if (offset === void 0) offset = 0;
        var l = progress + offset >= 1 ? progress + offset : 0;
        return path.el.getPointAtLength(l);
    }
    var svg = getParentSvg(path.el, path.svg);
    var p = point();
    var p0 = point(-1);
    var p1 = point(1);
    var scaleX = isPathTargetInsideSVG ? 1 : svg.w / svg.vW;
    var scaleY = isPathTargetInsideSVG ? 1 : svg.h / svg.vH;
    switch(path.property){
        case "x":
            return (p.x - svg.x) * scaleX;
        case "y":
            return (p.y - svg.y) * scaleY;
        case "angle":
            return Math.atan2(p1.y - p0.y, p1.x - p0.x) * 180 / Math.PI;
    }
}
// Decompose value
function decomposeValue(val, unit) {
    // const rgx = /-?\d*\.?\d+/g; // handles basic numbers
    // const rgx = /[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g; // handles exponents notation
    var rgx = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g; // handles exponents notation
    var value = validateValue(is.pth(val) ? val.totalLength : val, unit) + "";
    return {
        original: value,
        numbers: value.match(rgx) ? value.match(rgx).map(Number) : [
            0
        ],
        strings: is.str(val) || unit ? value.split(rgx) : []
    };
}
// Animatables
function parseTargets(targets) {
    var targetsArray = targets ? flattenArray(is.arr(targets) ? targets.map(toArray) : toArray(targets)) : [];
    return filterArray(targetsArray, function(item, pos, self) {
        return self.indexOf(item) === pos;
    });
}
function getAnimatables(targets) {
    var parsed = parseTargets(targets);
    return parsed.map(function(t, i) {
        return {
            target: t,
            id: i,
            total: parsed.length,
            transforms: {
                list: getElementTransforms(t)
            }
        };
    });
}
// Properties
function normalizePropertyTweens(prop, tweenSettings) {
    var settings = cloneObject(tweenSettings);
    // Override duration if easing is a spring
    if (/^spring/.test(settings.easing)) settings.duration = spring(settings.easing);
    if (is.arr(prop)) {
        var l = prop.length;
        var isFromTo = l === 2 && !is.obj(prop[0]);
        if (!isFromTo) // Duration divided by the number of tweens
        {
            if (!is.fnc(tweenSettings.duration)) settings.duration = tweenSettings.duration / l;
        } else // Transform [from, to] values shorthand to a valid tween value
        prop = {
            value: prop
        };
    }
    var propArray = is.arr(prop) ? prop : [
        prop
    ];
    return propArray.map(function(v, i) {
        var obj = is.obj(v) && !is.pth(v) ? v : {
            value: v
        };
        // Default delay value should only be applied to the first tween
        if (is.und(obj.delay)) obj.delay = !i ? tweenSettings.delay : 0;
        // Default endDelay value should only be applied to the last tween
        if (is.und(obj.endDelay)) obj.endDelay = i === propArray.length - 1 ? tweenSettings.endDelay : 0;
        return obj;
    }).map(function(k) {
        return mergeObjects(k, settings);
    });
}
function flattenKeyframes(keyframes) {
    var propertyNames = filterArray(flattenArray(keyframes.map(function(key) {
        return Object.keys(key);
    })), function(p) {
        return is.key(p);
    }).reduce(function(a, b) {
        if (a.indexOf(b) < 0) a.push(b);
        return a;
    }, []);
    var properties = {};
    var loop = function(i) {
        var propName = propertyNames[i];
        properties[propName] = keyframes.map(function(key) {
            var newKey = {};
            for(var p in key){
                if (is.key(p)) {
                    if (p == propName) newKey.value = key[p];
                } else newKey[p] = key[p];
            }
            return newKey;
        });
    };
    for(var i = 0; i < propertyNames.length; i++)loop(i);
    return properties;
}
function getProperties(tweenSettings, params) {
    var properties = [];
    var keyframes = params.keyframes;
    if (keyframes) params = mergeObjects(flattenKeyframes(keyframes), params);
    for(var p in params)if (is.key(p)) properties.push({
        name: p,
        tweens: normalizePropertyTweens(params[p], tweenSettings)
    });
    return properties;
}
// Tweens
function normalizeTweenValues(tween, animatable) {
    var t = {};
    for(var p in tween){
        var value = getFunctionValue(tween[p], animatable);
        if (is.arr(value)) {
            value = value.map(function(v) {
                return getFunctionValue(v, animatable);
            });
            if (value.length === 1) value = value[0];
        }
        t[p] = value;
    }
    t.duration = parseFloat(t.duration);
    t.delay = parseFloat(t.delay);
    return t;
}
function normalizeTweens(prop, animatable) {
    var previousTween;
    return prop.tweens.map(function(t) {
        var tween = normalizeTweenValues(t, animatable);
        var tweenValue = tween.value;
        var to = is.arr(tweenValue) ? tweenValue[1] : tweenValue;
        var toUnit = getUnit(to);
        var originalValue = getOriginalTargetValue(animatable.target, prop.name, toUnit, animatable);
        var previousValue = previousTween ? previousTween.to.original : originalValue;
        var from = is.arr(tweenValue) ? tweenValue[0] : previousValue;
        var fromUnit = getUnit(from) || getUnit(originalValue);
        var unit = toUnit || fromUnit;
        if (is.und(to)) to = previousValue;
        tween.from = decomposeValue(from, unit);
        tween.to = decomposeValue(getRelativeValue(to, from), unit);
        tween.start = previousTween ? previousTween.end : 0;
        tween.end = tween.start + tween.delay + tween.duration + tween.endDelay;
        tween.easing = parseEasings(tween.easing, tween.duration);
        tween.isPath = is.pth(tweenValue);
        tween.isPathTargetInsideSVG = tween.isPath && is.svg(animatable.target);
        tween.isColor = is.col(tween.from.original);
        if (tween.isColor) tween.round = 1;
        previousTween = tween;
        return tween;
    });
}
// Tween progress
var setProgressValue = {
    css: function(t, p, v) {
        return t.style[p] = v;
    },
    attribute: function(t, p, v) {
        return t.setAttribute(p, v);
    },
    object: function(t, p, v) {
        return t[p] = v;
    },
    transform: function(t, p, v, transforms, manual) {
        transforms.list.set(p, v);
        if (p === transforms.last || manual) {
            var str = "";
            transforms.list.forEach(function(value, prop) {
                str += prop + "(" + value + ") ";
            });
            t.style.transform = str;
        }
    }
};
// Set Value helper
function setTargetsValue(targets, properties) {
    var animatables = getAnimatables(targets);
    animatables.forEach(function(animatable) {
        for(var property in properties){
            var value = getFunctionValue(properties[property], animatable);
            var target = animatable.target;
            var valueUnit = getUnit(value);
            var originalValue = getOriginalTargetValue(target, property, valueUnit, animatable);
            var unit = valueUnit || getUnit(originalValue);
            var to = getRelativeValue(validateValue(value, unit), originalValue);
            var animType = getAnimationType(target, property);
            setProgressValue[animType](target, property, to, animatable.transforms, true);
        }
    });
}
// Animations
function createAnimation(animatable, prop) {
    var animType = getAnimationType(animatable.target, prop.name);
    if (animType) {
        var tweens = normalizeTweens(prop, animatable);
        var lastTween = tweens[tweens.length - 1];
        return {
            type: animType,
            property: prop.name,
            animatable: animatable,
            tweens: tweens,
            duration: lastTween.end,
            delay: tweens[0].delay,
            endDelay: lastTween.endDelay
        };
    }
}
function getAnimations(animatables, properties) {
    return filterArray(flattenArray(animatables.map(function(animatable) {
        return properties.map(function(prop) {
            return createAnimation(animatable, prop);
        });
    })), function(a) {
        return !is.und(a);
    });
}
// Create Instance
function getInstanceTimings(animations, tweenSettings) {
    var animLength = animations.length;
    var getTlOffset = function(anim) {
        return anim.timelineOffset ? anim.timelineOffset : 0;
    };
    var timings = {};
    timings.duration = animLength ? Math.max.apply(Math, animations.map(function(anim) {
        return getTlOffset(anim) + anim.duration;
    })) : tweenSettings.duration;
    timings.delay = animLength ? Math.min.apply(Math, animations.map(function(anim) {
        return getTlOffset(anim) + anim.delay;
    })) : tweenSettings.delay;
    timings.endDelay = animLength ? timings.duration - Math.max.apply(Math, animations.map(function(anim) {
        return getTlOffset(anim) + anim.duration - anim.endDelay;
    })) : tweenSettings.endDelay;
    return timings;
}
var instanceID = 0;
function createNewInstance(params) {
    var instanceSettings = replaceObjectProps(defaultInstanceSettings, params);
    var tweenSettings = replaceObjectProps(defaultTweenSettings, params);
    var properties = getProperties(tweenSettings, params);
    var animatables = getAnimatables(params.targets);
    var animations = getAnimations(animatables, properties);
    var timings = getInstanceTimings(animations, tweenSettings);
    var id = instanceID;
    instanceID++;
    return mergeObjects(instanceSettings, {
        id: id,
        children: [],
        animatables: animatables,
        animations: animations,
        duration: timings.duration,
        delay: timings.delay,
        endDelay: timings.endDelay
    });
}
// Core
var activeInstances = [];
var engine = function() {
    var raf;
    function play() {
        if (!raf && (!isDocumentHidden() || !anime.suspendWhenDocumentHidden) && activeInstances.length > 0) raf = requestAnimationFrame(step);
    }
    function step(t) {
        // memo on algorithm issue:
        // dangerous iteration over mutable `activeInstances`
        // (that collection may be updated from within callbacks of `tick`-ed animation instances)
        var activeInstancesLength = activeInstances.length;
        var i = 0;
        while(i < activeInstancesLength){
            var activeInstance = activeInstances[i];
            if (!activeInstance.paused) {
                activeInstance.tick(t);
                i++;
            } else {
                activeInstances.splice(i, 1);
                activeInstancesLength--;
            }
        }
        raf = i > 0 ? requestAnimationFrame(step) : undefined;
    }
    function handleVisibilityChange() {
        if (!anime.suspendWhenDocumentHidden) return;
        if (isDocumentHidden()) // suspend ticks
        raf = cancelAnimationFrame(raf);
        else {
            // first adjust animations to consider the time that ticks were suspended
            activeInstances.forEach(function(instance) {
                return instance._onDocumentVisibility();
            });
            engine();
        }
    }
    if (typeof document !== "undefined") document.addEventListener("visibilitychange", handleVisibilityChange);
    return play;
}();
function isDocumentHidden() {
    return !!document && document.hidden;
}
// Public Instance
function anime(params) {
    if (params === void 0) params = {};
    var startTime = 0, lastTime = 0, now = 0;
    var children, childrenLength = 0;
    var resolve = null;
    function makePromise(instance) {
        var promise = window.Promise && new Promise(function(_resolve) {
            return resolve = _resolve;
        });
        instance.finished = promise;
        return promise;
    }
    var instance = createNewInstance(params);
    var promise = makePromise(instance);
    function toggleInstanceDirection() {
        var direction = instance.direction;
        if (direction !== "alternate") instance.direction = direction !== "normal" ? "normal" : "reverse";
        instance.reversed = !instance.reversed;
        children.forEach(function(child) {
            return child.reversed = instance.reversed;
        });
    }
    function adjustTime(time) {
        return instance.reversed ? instance.duration - time : time;
    }
    function resetTime() {
        startTime = 0;
        lastTime = adjustTime(instance.currentTime) * (1 / anime.speed);
    }
    function seekChild(time, child) {
        if (child) child.seek(time - child.timelineOffset);
    }
    function syncInstanceChildren(time) {
        if (!instance.reversePlayback) for(var i = 0; i < childrenLength; i++)seekChild(time, children[i]);
        else for(var i$1 = childrenLength; i$1--;)seekChild(time, children[i$1]);
    }
    function setAnimationsProgress(insTime) {
        var i = 0;
        var animations = instance.animations;
        var animationsLength = animations.length;
        while(i < animationsLength){
            var anim = animations[i];
            var animatable = anim.animatable;
            var tweens = anim.tweens;
            var tweenLength = tweens.length - 1;
            var tween = tweens[tweenLength];
            // Only check for keyframes if there is more than one tween
            if (tweenLength) tween = filterArray(tweens, function(t) {
                return insTime < t.end;
            })[0] || tween;
            var elapsed = minMax(insTime - tween.start - tween.delay, 0, tween.duration) / tween.duration;
            var eased = isNaN(elapsed) ? 1 : tween.easing(elapsed);
            var strings = tween.to.strings;
            var round = tween.round;
            var numbers = [];
            var toNumbersLength = tween.to.numbers.length;
            var progress = void 0;
            for(var n = 0; n < toNumbersLength; n++){
                var value = void 0;
                var toNumber = tween.to.numbers[n];
                var fromNumber = tween.from.numbers[n] || 0;
                if (!tween.isPath) value = fromNumber + eased * (toNumber - fromNumber);
                else value = getPathProgress(tween.value, eased * toNumber, tween.isPathTargetInsideSVG);
                if (round) {
                    if (!(tween.isColor && n > 2)) value = Math.round(value * round) / round;
                }
                numbers.push(value);
            }
            // Manual Array.reduce for better performances
            var stringsLength = strings.length;
            if (!stringsLength) progress = numbers[0];
            else {
                progress = strings[0];
                for(var s = 0; s < stringsLength; s++){
                    var a = strings[s];
                    var b = strings[s + 1];
                    var n$1 = numbers[s];
                    if (!isNaN(n$1)) {
                        if (!b) progress += n$1 + " ";
                        else progress += n$1 + b;
                    }
                }
            }
            setProgressValue[anim.type](animatable.target, anim.property, progress, animatable.transforms);
            anim.currentValue = progress;
            i++;
        }
    }
    function setCallback(cb) {
        if (instance[cb] && !instance.passThrough) instance[cb](instance);
    }
    function countIteration() {
        if (instance.remaining && instance.remaining !== true) instance.remaining--;
    }
    function setInstanceProgress(engineTime) {
        var insDuration = instance.duration;
        var insDelay = instance.delay;
        var insEndDelay = insDuration - instance.endDelay;
        var insTime = adjustTime(engineTime);
        instance.progress = minMax(insTime / insDuration * 100, 0, 100);
        instance.reversePlayback = insTime < instance.currentTime;
        if (children) syncInstanceChildren(insTime);
        if (!instance.began && instance.currentTime > 0) {
            instance.began = true;
            setCallback("begin");
        }
        if (!instance.loopBegan && instance.currentTime > 0) {
            instance.loopBegan = true;
            setCallback("loopBegin");
        }
        if (insTime <= insDelay && instance.currentTime !== 0) setAnimationsProgress(0);
        if (insTime >= insEndDelay && instance.currentTime !== insDuration || !insDuration) setAnimationsProgress(insDuration);
        if (insTime > insDelay && insTime < insEndDelay) {
            if (!instance.changeBegan) {
                instance.changeBegan = true;
                instance.changeCompleted = false;
                setCallback("changeBegin");
            }
            setCallback("change");
            setAnimationsProgress(insTime);
        } else if (instance.changeBegan) {
            instance.changeCompleted = true;
            instance.changeBegan = false;
            setCallback("changeComplete");
        }
        instance.currentTime = minMax(insTime, 0, insDuration);
        if (instance.began) setCallback("update");
        if (engineTime >= insDuration) {
            lastTime = 0;
            countIteration();
            if (!instance.remaining) {
                instance.paused = true;
                if (!instance.completed) {
                    instance.completed = true;
                    setCallback("loopComplete");
                    setCallback("complete");
                    if (!instance.passThrough && "Promise" in window) {
                        resolve();
                        promise = makePromise(instance);
                    }
                }
            } else {
                startTime = now;
                setCallback("loopComplete");
                instance.loopBegan = false;
                if (instance.direction === "alternate") toggleInstanceDirection();
            }
        }
    }
    instance.reset = function() {
        var direction = instance.direction;
        instance.passThrough = false;
        instance.currentTime = 0;
        instance.progress = 0;
        instance.paused = true;
        instance.began = false;
        instance.loopBegan = false;
        instance.changeBegan = false;
        instance.completed = false;
        instance.changeCompleted = false;
        instance.reversePlayback = false;
        instance.reversed = direction === "reverse";
        instance.remaining = instance.loop;
        children = instance.children;
        childrenLength = children.length;
        for(var i = childrenLength; i--;)instance.children[i].reset();
        if (instance.reversed && instance.loop !== true || direction === "alternate" && instance.loop === 1) instance.remaining++;
        setAnimationsProgress(instance.reversed ? instance.duration : 0);
    };
    // internal method (for engine) to adjust animation timings before restoring engine ticks (rAF)
    instance._onDocumentVisibility = resetTime;
    // Set Value helper
    instance.set = function(targets, properties) {
        setTargetsValue(targets, properties);
        return instance;
    };
    instance.tick = function(t) {
        now = t;
        if (!startTime) startTime = now;
        setInstanceProgress((now + (lastTime - startTime)) * anime.speed);
    };
    instance.seek = function(time) {
        setInstanceProgress(adjustTime(time));
    };
    instance.pause = function() {
        instance.paused = true;
        resetTime();
    };
    instance.play = function() {
        if (!instance.paused) return;
        if (instance.completed) instance.reset();
        instance.paused = false;
        activeInstances.push(instance);
        resetTime();
        engine();
    };
    instance.reverse = function() {
        toggleInstanceDirection();
        instance.completed = instance.reversed ? false : true;
        resetTime();
    };
    instance.restart = function() {
        instance.reset();
        instance.play();
    };
    instance.remove = function(targets) {
        var targetsArray = parseTargets(targets);
        removeTargetsFromInstance(targetsArray, instance);
    };
    instance.reset();
    if (instance.autoplay) instance.play();
    return instance;
}
// Remove targets from animation
function removeTargetsFromAnimations(targetsArray, animations) {
    for(var a = animations.length; a--;)if (arrayContains(targetsArray, animations[a].animatable.target)) animations.splice(a, 1);
}
function removeTargetsFromInstance(targetsArray, instance) {
    var animations = instance.animations;
    var children = instance.children;
    removeTargetsFromAnimations(targetsArray, animations);
    for(var c = children.length; c--;){
        var child = children[c];
        var childAnimations = child.animations;
        removeTargetsFromAnimations(targetsArray, childAnimations);
        if (!childAnimations.length && !child.children.length) children.splice(c, 1);
    }
    if (!animations.length && !children.length) instance.pause();
}
function removeTargetsFromActiveInstances(targets) {
    var targetsArray = parseTargets(targets);
    for(var i = activeInstances.length; i--;){
        var instance = activeInstances[i];
        removeTargetsFromInstance(targetsArray, instance);
    }
}
// Stagger helpers
function stagger(val, params) {
    if (params === void 0) params = {};
    var direction = params.direction || "normal";
    var easing = params.easing ? parseEasings(params.easing) : null;
    var grid = params.grid;
    var axis = params.axis;
    var fromIndex = params.from || 0;
    var fromFirst = fromIndex === "first";
    var fromCenter = fromIndex === "center";
    var fromLast = fromIndex === "last";
    var isRange = is.arr(val);
    var val1 = isRange ? parseFloat(val[0]) : parseFloat(val);
    var val2 = isRange ? parseFloat(val[1]) : 0;
    var unit = getUnit(isRange ? val[1] : val) || 0;
    var start = params.start || 0 + (isRange ? val1 : 0);
    var values = [];
    var maxValue = 0;
    return function(el, i, t) {
        if (fromFirst) fromIndex = 0;
        if (fromCenter) fromIndex = (t - 1) / 2;
        if (fromLast) fromIndex = t - 1;
        if (!values.length) {
            for(var index = 0; index < t; index++){
                if (!grid) values.push(Math.abs(fromIndex - index));
                else {
                    var fromX = !fromCenter ? fromIndex % grid[0] : (grid[0] - 1) / 2;
                    var fromY = !fromCenter ? Math.floor(fromIndex / grid[0]) : (grid[1] - 1) / 2;
                    var toX = index % grid[0];
                    var toY = Math.floor(index / grid[0]);
                    var distanceX = fromX - toX;
                    var distanceY = fromY - toY;
                    var value = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
                    if (axis === "x") value = -distanceX;
                    if (axis === "y") value = -distanceY;
                    values.push(value);
                }
                maxValue = Math.max.apply(Math, values);
            }
            if (easing) values = values.map(function(val) {
                return easing(val / maxValue) * maxValue;
            });
            if (direction === "reverse") values = values.map(function(val) {
                return axis ? val < 0 ? val * -1 : -val : Math.abs(maxValue - val);
            });
        }
        var spacing = isRange ? (val2 - val1) / maxValue : val1;
        return start + spacing * (Math.round(values[i] * 100) / 100) + unit;
    };
}
// Timeline
function timeline(params) {
    if (params === void 0) params = {};
    var tl = anime(params);
    tl.duration = 0;
    tl.add = function(instanceParams, timelineOffset) {
        var tlIndex = activeInstances.indexOf(tl);
        var children = tl.children;
        if (tlIndex > -1) activeInstances.splice(tlIndex, 1);
        function passThrough(ins) {
            ins.passThrough = true;
        }
        for(var i = 0; i < children.length; i++)passThrough(children[i]);
        var insParams = mergeObjects(instanceParams, replaceObjectProps(defaultTweenSettings, params));
        insParams.targets = insParams.targets || params.targets;
        var tlDuration = tl.duration;
        insParams.autoplay = false;
        insParams.direction = tl.direction;
        insParams.timelineOffset = is.und(timelineOffset) ? tlDuration : getRelativeValue(timelineOffset, tlDuration);
        passThrough(tl);
        tl.seek(insParams.timelineOffset);
        var ins = anime(insParams);
        passThrough(ins);
        children.push(ins);
        var timings = getInstanceTimings(children, params);
        tl.delay = timings.delay;
        tl.endDelay = timings.endDelay;
        tl.duration = timings.duration;
        tl.seek(0);
        tl.reset();
        if (tl.autoplay) tl.play();
        return tl;
    };
    return tl;
}
anime.version = "3.2.1";
anime.speed = 1;
// TODO:#review: naming, documentation
anime.suspendWhenDocumentHidden = true;
anime.running = activeInstances;
anime.remove = removeTargetsFromActiveInstances;
anime.get = getOriginalTargetValue;
anime.set = setTargetsValue;
anime.convertPx = convertPxToUnit;
anime.path = getPath;
anime.setDashoffset = setDashoffset;
anime.stagger = stagger;
anime.timeline = timeline;
anime.easing = parseEasings;
anime.penner = penner;
anime.random = function(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
exports.default = anime;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3151":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"gwKMP":[function(require,module,exports) {
/*! @license ScrollReveal v4.0.9

	Copyright 2021 Fisssion LLC.

	Licensed under the GNU General Public License 3.0 for
	compatible open source projects and non-commercial use.

	For commercial sites, themes, projects, and applications,
	keep your source code private/proprietary by purchasing
	a commercial license from https://scrollrevealjs.org/
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tealight = require("tealight");
var _tealightDefault = parcelHelpers.interopDefault(_tealight);
var _rematrix = require("rematrix");
var _miniraf = require("miniraf");
var _minirafDefault = parcelHelpers.interopDefault(_miniraf);
var defaults = {
    delay: 0,
    distance: "0",
    duration: 600,
    easing: "cubic-bezier(0.5, 0, 0, 1)",
    interval: 0,
    opacity: 0,
    origin: "bottom",
    rotate: {
        x: 0,
        y: 0,
        z: 0
    },
    scale: 1,
    cleanup: false,
    container: document.documentElement,
    desktop: true,
    mobile: true,
    reset: false,
    useDelay: "always",
    viewFactor: 0.0,
    viewOffset: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    },
    afterReset: function afterReset() {},
    afterReveal: function afterReveal() {},
    beforeReset: function beforeReset() {},
    beforeReveal: function beforeReveal() {}
};
function failure() {
    document.documentElement.classList.remove("sr");
    return {
        clean: function clean() {},
        destroy: function destroy() {},
        reveal: function reveal() {},
        sync: function sync() {},
        get noop () {
            return true;
        }
    };
}
function success() {
    document.documentElement.classList.add("sr");
    if (document.body) document.body.style.height = "100%";
    else document.addEventListener("DOMContentLoaded", function() {
        document.body.style.height = "100%";
    });
}
var mount = {
    success: success,
    failure: failure
};
function isObject(x) {
    return x !== null && x instanceof Object && (x.constructor === Object || Object.prototype.toString.call(x) === "[object Object]");
}
function each(collection, callback) {
    if (isObject(collection)) {
        var keys = Object.keys(collection);
        return keys.forEach(function(key) {
            return callback(collection[key], key, collection);
        });
    }
    if (collection instanceof Array) return collection.forEach(function(item, i) {
        return callback(item, i, collection);
    });
    throw new TypeError("Expected either an array or object literal.");
}
function logger(message) {
    var details = [], len = arguments.length - 1;
    while(len-- > 0)details[len] = arguments[len + 1];
    if (this.constructor.debug && console) {
        var report = "%cScrollReveal: " + message;
        details.forEach(function(detail) {
            return report += "\n — " + detail;
        });
        console.log(report, "color: #ea654b;"); // eslint-disable-line no-console
    }
}
function rinse() {
    var this$1 = this;
    var struct = function() {
        return {
            active: [],
            stale: []
        };
    };
    var elementIds = struct();
    var sequenceIds = struct();
    var containerIds = struct();
    /**
	 * Take stock of active element IDs.
	 */ try {
        each((0, _tealightDefault.default)("[data-sr-id]"), function(node) {
            var id = parseInt(node.getAttribute("data-sr-id"));
            elementIds.active.push(id);
        });
    } catch (e) {
        throw e;
    }
    /**
	 * Destroy stale elements.
	 */ each(this.store.elements, function(element) {
        if (elementIds.active.indexOf(element.id) === -1) elementIds.stale.push(element.id);
    });
    each(elementIds.stale, function(staleId) {
        return delete this$1.store.elements[staleId];
    });
    /**
	 * Take stock of active container and sequence IDs.
	 */ each(this.store.elements, function(element) {
        if (containerIds.active.indexOf(element.containerId) === -1) containerIds.active.push(element.containerId);
        if (element.hasOwnProperty("sequence")) {
            if (sequenceIds.active.indexOf(element.sequence.id) === -1) sequenceIds.active.push(element.sequence.id);
        }
    });
    /**
	 * Destroy stale containers.
	 */ each(this.store.containers, function(container) {
        if (containerIds.active.indexOf(container.id) === -1) containerIds.stale.push(container.id);
    });
    each(containerIds.stale, function(staleId) {
        var stale = this$1.store.containers[staleId].node;
        stale.removeEventListener("scroll", this$1.delegate);
        stale.removeEventListener("resize", this$1.delegate);
        delete this$1.store.containers[staleId];
    });
    /**
	 * Destroy stale sequences.
	 */ each(this.store.sequences, function(sequence) {
        if (sequenceIds.active.indexOf(sequence.id) === -1) sequenceIds.stale.push(sequence.id);
    });
    each(sequenceIds.stale, function(staleId) {
        return delete this$1.store.sequences[staleId];
    });
}
var getPrefixedCssProp = function() {
    var properties = {};
    var style = document.documentElement.style;
    function getPrefixedCssProperty(name, source) {
        if (source === void 0) source = style;
        if (name && typeof name === "string") {
            if (properties[name]) return properties[name];
            if (typeof source[name] === "string") return properties[name] = name;
            if (typeof source["-webkit-" + name] === "string") return properties[name] = "-webkit-" + name;
            throw new RangeError('Unable to find "' + name + '" style property.');
        }
        throw new TypeError("Expected a string.");
    }
    getPrefixedCssProperty.clearCache = function() {
        return properties = {};
    };
    return getPrefixedCssProperty;
}();
function style(element) {
    var computed = window.getComputedStyle(element.node);
    var position = computed.position;
    var config = element.config;
    /**
	 * Generate inline styles
	 */ var inline = {};
    var inlineStyle = element.node.getAttribute("style") || "";
    var inlineMatch = inlineStyle.match(/[\w-]+\s*:\s*[^;]+\s*/gi) || [];
    inline.computed = inlineMatch ? inlineMatch.map(function(m) {
        return m.trim();
    }).join("; ") + ";" : "";
    inline.generated = inlineMatch.some(function(m) {
        return m.match(/visibility\s?:\s?visible/i);
    }) ? inline.computed : inlineMatch.concat([
        "visibility: visible"
    ]).map(function(m) {
        return m.trim();
    }).join("; ") + ";";
    /**
	 * Generate opacity styles
	 */ var computedOpacity = parseFloat(computed.opacity);
    var configOpacity = !isNaN(parseFloat(config.opacity)) ? parseFloat(config.opacity) : parseFloat(computed.opacity);
    var opacity = {
        computed: computedOpacity !== configOpacity ? "opacity: " + computedOpacity + ";" : "",
        generated: computedOpacity !== configOpacity ? "opacity: " + configOpacity + ";" : ""
    };
    /**
	 * Generate transformation styles
	 */ var transformations = [];
    if (parseFloat(config.distance)) {
        var axis = config.origin === "top" || config.origin === "bottom" ? "Y" : "X";
        /**
		 * Let’s make sure our our pixel distances are negative for top and left.
		 * e.g. { origin: 'top', distance: '25px' } starts at `top: -25px` in CSS.
		 */ var distance = config.distance;
        if (config.origin === "top" || config.origin === "left") distance = /^-/.test(distance) ? distance.substr(1) : "-" + distance;
        var ref = distance.match(/(^-?\d+\.?\d?)|(em$|px$|%$)/g);
        var value = ref[0];
        var unit = ref[1];
        switch(unit){
            case "em":
                distance = parseInt(computed.fontSize) * value;
                break;
            case "px":
                distance = value;
                break;
            case "%":
                /**
				 * Here we use `getBoundingClientRect` instead of
				 * the existing data attached to `element.geometry`
				 * because only the former includes any transformations
				 * current applied to the element.
				 *
				 * If that behavior ends up being unintuitive, this
				 * logic could instead utilize `element.geometry.height`
				 * and `element.geoemetry.width` for the distance calculation
				 */ distance = axis === "Y" ? element.node.getBoundingClientRect().height * value / 100 : element.node.getBoundingClientRect().width * value / 100;
                break;
            default:
                throw new RangeError("Unrecognized or missing distance unit.");
        }
        if (axis === "Y") transformations.push((0, _rematrix.translateY)(distance));
        else transformations.push((0, _rematrix.translateX)(distance));
    }
    if (config.rotate.x) transformations.push((0, _rematrix.rotateX)(config.rotate.x));
    if (config.rotate.y) transformations.push((0, _rematrix.rotateY)(config.rotate.y));
    if (config.rotate.z) transformations.push((0, _rematrix.rotateZ)(config.rotate.z));
    if (config.scale !== 1) {
        if (config.scale === 0) /**
			 * The CSS Transforms matrix interpolation specification
			 * basically disallows transitions of non-invertible
			 * matrixes, which means browsers won't transition
			 * elements with zero scale.
			 *
			 * That’s inconvenient for the API and developer
			 * experience, so we simply nudge their value
			 * slightly above zero; this allows browsers
			 * to transition our element as expected.
			 *
			 * `0.0002` was the smallest number
			 * that performed across browsers.
			 */ transformations.push((0, _rematrix.scale)(0.0002));
        else transformations.push((0, _rematrix.scale)(config.scale));
    }
    var transform = {};
    if (transformations.length) {
        transform.property = getPrefixedCssProp("transform");
        /**
		 * The default computed transform value should be one of:
		 * undefined || 'none' || 'matrix()' || 'matrix3d()'
		 */ transform.computed = {
            raw: computed[transform.property],
            matrix: (0, _rematrix.parse)(computed[transform.property])
        };
        transformations.unshift(transform.computed.matrix);
        var product = transformations.reduce((0, _rematrix.multiply));
        transform.generated = {
            initial: transform.property + ": matrix3d(" + product.join(", ") + ");",
            final: transform.property + ": matrix3d(" + transform.computed.matrix.join(", ") + ");"
        };
    } else transform.generated = {
        initial: "",
        final: ""
    };
    /**
	 * Generate transition styles
	 */ var transition = {};
    if (opacity.generated || transform.generated.initial) {
        transition.property = getPrefixedCssProp("transition");
        transition.computed = computed[transition.property];
        transition.fragments = [];
        var delay = config.delay;
        var duration = config.duration;
        var easing = config.easing;
        if (opacity.generated) transition.fragments.push({
            delayed: "opacity " + duration / 1000 + "s " + easing + " " + delay / 1000 + "s",
            instant: "opacity " + duration / 1000 + "s " + easing + " 0s"
        });
        if (transform.generated.initial) transition.fragments.push({
            delayed: transform.property + " " + duration / 1000 + "s " + easing + " " + delay / 1000 + "s",
            instant: transform.property + " " + duration / 1000 + "s " + easing + " 0s"
        });
        /**
		 * The default computed transition property should be undefined, or one of:
		 * '' || 'none 0s ease 0s' || 'all 0s ease 0s' || 'all 0s 0s cubic-bezier()'
		 */ var hasCustomTransition = transition.computed && !transition.computed.match(/all 0s|none 0s/);
        if (hasCustomTransition) transition.fragments.unshift({
            delayed: transition.computed,
            instant: transition.computed
        });
        var composed = transition.fragments.reduce(function(composition, fragment, i) {
            composition.delayed += i === 0 ? fragment.delayed : ", " + fragment.delayed;
            composition.instant += i === 0 ? fragment.instant : ", " + fragment.instant;
            return composition;
        }, {
            delayed: "",
            instant: ""
        });
        transition.generated = {
            delayed: transition.property + ": " + composed.delayed + ";",
            instant: transition.property + ": " + composed.instant + ";"
        };
    } else transition.generated = {
        delayed: "",
        instant: ""
    };
    return {
        inline: inline,
        opacity: opacity,
        position: position,
        transform: transform,
        transition: transition
    };
}
/**
 * apply a CSS string to an element using the CSSOM (element.style) rather
 * than setAttribute, which may violate the content security policy.
 *
 * @param {Node}   [el]  Element to receive styles.
 * @param {string} [declaration] Styles to apply.
 */ function applyStyle(el, declaration) {
    declaration.split(";").forEach(function(pair) {
        var ref = pair.split(":");
        var property = ref[0];
        var value = ref.slice(1);
        if (property && value) el.style[property.trim()] = value.join(":");
    });
}
function clean(target) {
    var this$1 = this;
    var dirty;
    try {
        each((0, _tealightDefault.default)(target), function(node) {
            var id = node.getAttribute("data-sr-id");
            if (id !== null) {
                dirty = true;
                var element = this$1.store.elements[id];
                if (element.callbackTimer) window.clearTimeout(element.callbackTimer.clock);
                applyStyle(element.node, element.styles.inline.generated);
                node.removeAttribute("data-sr-id");
                delete this$1.store.elements[id];
            }
        });
    } catch (e) {
        return logger.call(this, "Clean failed.", e.message);
    }
    if (dirty) try {
        rinse.call(this);
    } catch (e) {
        return logger.call(this, "Clean failed.", e.message);
    }
}
function destroy() {
    var this$1 = this;
    /**
	 * Remove all generated styles and element ids
	 */ each(this.store.elements, function(element) {
        applyStyle(element.node, element.styles.inline.generated);
        element.node.removeAttribute("data-sr-id");
    });
    /**
	 * Remove all event listeners.
	 */ each(this.store.containers, function(container) {
        var target = container.node === document.documentElement ? window : container.node;
        target.removeEventListener("scroll", this$1.delegate);
        target.removeEventListener("resize", this$1.delegate);
    });
    /**
	 * Clear all data from the store
	 */ this.store = {
        containers: {},
        elements: {},
        history: [],
        sequences: {}
    };
}
function deepAssign(target) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    if (isObject(target)) {
        each(sources, function(source) {
            each(source, function(data, key) {
                if (isObject(data)) {
                    if (!target[key] || !isObject(target[key])) target[key] = {};
                    deepAssign(target[key], data);
                } else target[key] = data;
            });
        });
        return target;
    } else throw new TypeError("Target must be an object literal.");
}
function isMobile(agent) {
    if (agent === void 0) agent = navigator.userAgent;
    return /Android|iPhone|iPad|iPod/i.test(agent);
}
var nextUniqueId = function() {
    var uid = 0;
    return function() {
        return uid++;
    };
}();
function initialize() {
    var this$1 = this;
    rinse.call(this);
    each(this.store.elements, function(element) {
        var styles = [
            element.styles.inline.generated
        ];
        if (element.visible) {
            styles.push(element.styles.opacity.computed);
            styles.push(element.styles.transform.generated.final);
            element.revealed = true;
        } else {
            styles.push(element.styles.opacity.generated);
            styles.push(element.styles.transform.generated.initial);
            element.revealed = false;
        }
        applyStyle(element.node, styles.filter(function(s) {
            return s !== "";
        }).join(" "));
    });
    each(this.store.containers, function(container) {
        var target = container.node === document.documentElement ? window : container.node;
        target.addEventListener("scroll", this$1.delegate);
        target.addEventListener("resize", this$1.delegate);
    });
    /**
	 * Manually invoke delegate once to capture
	 * element and container dimensions, container
	 * scroll position, and trigger any valid reveals
	 */ this.delegate();
    /**
	 * Wipe any existing `setTimeout` now
	 * that initialization has completed.
	 */ this.initTimeout = null;
}
function animate(element, force) {
    if (force === void 0) force = {};
    var pristine = force.pristine || this.pristine;
    var delayed = element.config.useDelay === "always" || element.config.useDelay === "onload" && pristine || element.config.useDelay === "once" && !element.seen;
    var shouldReveal = element.visible && !element.revealed;
    var shouldReset = !element.visible && element.revealed && element.config.reset;
    if (force.reveal || shouldReveal) return triggerReveal.call(this, element, delayed);
    if (force.reset || shouldReset) return triggerReset.call(this, element);
}
function triggerReveal(element, delayed) {
    var styles = [
        element.styles.inline.generated,
        element.styles.opacity.computed,
        element.styles.transform.generated.final
    ];
    if (delayed) styles.push(element.styles.transition.generated.delayed);
    else styles.push(element.styles.transition.generated.instant);
    element.revealed = element.seen = true;
    applyStyle(element.node, styles.filter(function(s) {
        return s !== "";
    }).join(" "));
    registerCallbacks.call(this, element, delayed);
}
function triggerReset(element) {
    var styles = [
        element.styles.inline.generated,
        element.styles.opacity.generated,
        element.styles.transform.generated.initial,
        element.styles.transition.generated.instant
    ];
    element.revealed = false;
    applyStyle(element.node, styles.filter(function(s) {
        return s !== "";
    }).join(" "));
    registerCallbacks.call(this, element);
}
function registerCallbacks(element, isDelayed) {
    var this$1 = this;
    var duration = isDelayed ? element.config.duration + element.config.delay : element.config.duration;
    var beforeCallback = element.revealed ? element.config.beforeReveal : element.config.beforeReset;
    var afterCallback = element.revealed ? element.config.afterReveal : element.config.afterReset;
    var elapsed = 0;
    if (element.callbackTimer) {
        elapsed = Date.now() - element.callbackTimer.start;
        window.clearTimeout(element.callbackTimer.clock);
    }
    beforeCallback(element.node);
    element.callbackTimer = {
        start: Date.now(),
        clock: window.setTimeout(function() {
            afterCallback(element.node);
            element.callbackTimer = null;
            if (element.revealed && !element.config.reset && element.config.cleanup) clean.call(this$1, element.node);
        }, duration - elapsed)
    };
}
function sequence(element, pristine) {
    if (pristine === void 0) pristine = this.pristine;
    /**
	 * We first check if the element should reset.
	 */ if (!element.visible && element.revealed && element.config.reset) return animate.call(this, element, {
        reset: true
    });
    var seq = this.store.sequences[element.sequence.id];
    var i = element.sequence.index;
    if (seq) {
        var visible = new SequenceModel(seq, "visible", this.store);
        var revealed = new SequenceModel(seq, "revealed", this.store);
        seq.models = {
            visible: visible,
            revealed: revealed
        };
        /**
		 * If the sequence has no revealed members,
		 * then we reveal the first visible element
		 * within that sequence.
		 *
		 * The sequence then cues a recursive call
		 * in both directions.
		 */ if (!revealed.body.length) {
            var nextId = seq.members[visible.body[0]];
            var nextElement = this.store.elements[nextId];
            if (nextElement) {
                cue.call(this, seq, visible.body[0], -1, pristine);
                cue.call(this, seq, visible.body[0], 1, pristine);
                return animate.call(this, nextElement, {
                    reveal: true,
                    pristine: pristine
                });
            }
        }
        /**
		 * If our element isn’t resetting, we check the
		 * element sequence index against the head, and
		 * then the foot of the sequence.
		 */ if (!seq.blocked.head && i === [].concat(revealed.head).pop() && i >= [].concat(visible.body).shift()) {
            cue.call(this, seq, i, -1, pristine);
            return animate.call(this, element, {
                reveal: true,
                pristine: pristine
            });
        }
        if (!seq.blocked.foot && i === [].concat(revealed.foot).shift() && i <= [].concat(visible.body).pop()) {
            cue.call(this, seq, i, 1, pristine);
            return animate.call(this, element, {
                reveal: true,
                pristine: pristine
            });
        }
    }
}
function Sequence(interval) {
    var i = Math.abs(interval);
    if (!isNaN(i)) {
        this.id = nextUniqueId();
        this.interval = Math.max(i, 16);
        this.members = [];
        this.models = {};
        this.blocked = {
            head: false,
            foot: false
        };
    } else throw new RangeError("Invalid sequence interval.");
}
function SequenceModel(seq, prop, store) {
    var this$1 = this;
    this.head = [];
    this.body = [];
    this.foot = [];
    each(seq.members, function(id, index) {
        var element = store.elements[id];
        if (element && element[prop]) this$1.body.push(index);
    });
    if (this.body.length) each(seq.members, function(id, index) {
        var element = store.elements[id];
        if (element && !element[prop]) {
            if (index < this$1.body[0]) this$1.head.push(index);
            else this$1.foot.push(index);
        }
    });
}
function cue(seq, i, direction, pristine) {
    var this$1 = this;
    var blocked = [
        "head",
        null,
        "foot"
    ][1 + direction];
    var nextId = seq.members[i + direction];
    var nextElement = this.store.elements[nextId];
    seq.blocked[blocked] = true;
    setTimeout(function() {
        seq.blocked[blocked] = false;
        if (nextElement) sequence.call(this$1, nextElement, pristine);
    }, seq.interval);
}
function reveal(target, options, syncing) {
    var this$1 = this;
    if (options === void 0) options = {};
    if (syncing === void 0) syncing = false;
    var containerBuffer = [];
    var sequence$$1;
    var interval = options.interval || defaults.interval;
    try {
        if (interval) sequence$$1 = new Sequence(interval);
        var nodes = (0, _tealightDefault.default)(target);
        if (!nodes.length) throw new Error("Invalid reveal target.");
        var elements = nodes.reduce(function(elementBuffer, elementNode) {
            var element = {};
            var existingId = elementNode.getAttribute("data-sr-id");
            if (existingId) {
                deepAssign(element, this$1.store.elements[existingId]);
                /**
				 * In order to prevent previously generated styles
				 * from throwing off the new styles, the style tag
				 * has to be reverted to its pre-reveal state.
				 */ applyStyle(element.node, element.styles.inline.computed);
            } else {
                element.id = nextUniqueId();
                element.node = elementNode;
                element.seen = false;
                element.revealed = false;
                element.visible = false;
            }
            var config = deepAssign({}, element.config || this$1.defaults, options);
            if (!config.mobile && isMobile() || !config.desktop && !isMobile()) {
                if (existingId) clean.call(this$1, element);
                return elementBuffer // skip elements that are disabled
                ;
            }
            var containerNode = (0, _tealightDefault.default)(config.container)[0];
            if (!containerNode) throw new Error("Invalid container.");
            if (!containerNode.contains(elementNode)) return elementBuffer // skip elements found outside the container
            ;
            var containerId;
            containerId = getContainerId(containerNode, containerBuffer, this$1.store.containers);
            if (containerId === null) {
                containerId = nextUniqueId();
                containerBuffer.push({
                    id: containerId,
                    node: containerNode
                });
            }
            element.config = config;
            element.containerId = containerId;
            element.styles = style(element);
            if (sequence$$1) {
                element.sequence = {
                    id: sequence$$1.id,
                    index: sequence$$1.members.length
                };
                sequence$$1.members.push(element.id);
            }
            elementBuffer.push(element);
            return elementBuffer;
        }, []);
        /**
		 * Modifying the DOM via setAttribute needs to be handled
		 * separately from reading computed styles in the map above
		 * for the browser to batch DOM changes (limiting reflows)
		 */ each(elements, function(element) {
            this$1.store.elements[element.id] = element;
            element.node.setAttribute("data-sr-id", element.id);
        });
    } catch (e) {
        return logger.call(this, "Reveal failed.", e.message);
    }
    /**
	 * Now that element set-up is complete...
	 * Let’s commit any container and sequence data we have to the store.
	 */ each(containerBuffer, function(container) {
        this$1.store.containers[container.id] = {
            id: container.id,
            node: container.node
        };
    });
    if (sequence$$1) this.store.sequences[sequence$$1.id] = sequence$$1;
    /**
	 * If reveal wasn't invoked by sync, we want to
	 * make sure to add this call to the history.
	 */ if (syncing !== true) {
        this.store.history.push({
            target: target,
            options: options
        });
        /**
		 * Push initialization to the event queue, giving
		 * multiple reveal calls time to be interpreted.
		 */ if (this.initTimeout) window.clearTimeout(this.initTimeout);
        this.initTimeout = window.setTimeout(initialize.bind(this), 0);
    }
}
function getContainerId(node) {
    var collections = [], len = arguments.length - 1;
    while(len-- > 0)collections[len] = arguments[len + 1];
    var id = null;
    each(collections, function(collection) {
        each(collection, function(container) {
            if (id === null && container.node === node) id = container.id;
        });
    });
    return id;
}
/**
 * Re-runs the reveal method for each record stored in history,
 * for capturing new content asynchronously loaded into the DOM.
 */ function sync() {
    var this$1 = this;
    each(this.store.history, function(record) {
        reveal.call(this$1, record.target, record.options, true);
    });
    initialize.call(this);
}
var polyfill = function(x) {
    return (x > 0) - (x < 0) || +x;
};
var mathSign = Math.sign || polyfill;
function getGeometry(target, isContainer) {
    /**
	 * We want to ignore padding and scrollbars for container elements.
	 * More information here: https://goo.gl/vOZpbz
	 */ var height = isContainer ? target.node.clientHeight : target.node.offsetHeight;
    var width = isContainer ? target.node.clientWidth : target.node.offsetWidth;
    var offsetTop = 0;
    var offsetLeft = 0;
    var node = target.node;
    do {
        if (!isNaN(node.offsetTop)) offsetTop += node.offsetTop;
        if (!isNaN(node.offsetLeft)) offsetLeft += node.offsetLeft;
        node = node.offsetParent;
    }while (node);
    return {
        bounds: {
            top: offsetTop,
            right: offsetLeft + width,
            bottom: offsetTop + height,
            left: offsetLeft
        },
        height: height,
        width: width
    };
}
function getScrolled(container) {
    var top, left;
    if (container.node === document.documentElement) {
        top = window.pageYOffset;
        left = window.pageXOffset;
    } else {
        top = container.node.scrollTop;
        left = container.node.scrollLeft;
    }
    return {
        top: top,
        left: left
    };
}
function isElementVisible(element) {
    if (element === void 0) element = {};
    var container = this.store.containers[element.containerId];
    if (!container) return;
    var viewFactor = Math.max(0, Math.min(1, element.config.viewFactor));
    var viewOffset = element.config.viewOffset;
    var elementBounds = {
        top: element.geometry.bounds.top + element.geometry.height * viewFactor,
        right: element.geometry.bounds.right - element.geometry.width * viewFactor,
        bottom: element.geometry.bounds.bottom - element.geometry.height * viewFactor,
        left: element.geometry.bounds.left + element.geometry.width * viewFactor
    };
    var containerBounds = {
        top: container.geometry.bounds.top + container.scroll.top + viewOffset.top,
        right: container.geometry.bounds.right + container.scroll.left - viewOffset.right,
        bottom: container.geometry.bounds.bottom + container.scroll.top - viewOffset.bottom,
        left: container.geometry.bounds.left + container.scroll.left + viewOffset.left
    };
    return elementBounds.top < containerBounds.bottom && elementBounds.right > containerBounds.left && elementBounds.bottom > containerBounds.top && elementBounds.left < containerBounds.right || element.styles.position === "fixed";
}
function delegate(event, elements) {
    var this$1 = this;
    if (event === void 0) event = {
        type: "init"
    };
    if (elements === void 0) elements = this.store.elements;
    (0, _minirafDefault.default)(function() {
        var stale = event.type === "init" || event.type === "resize";
        each(this$1.store.containers, function(container) {
            if (stale) container.geometry = getGeometry.call(this$1, container, true);
            var scroll = getScrolled.call(this$1, container);
            if (container.scroll) container.direction = {
                x: mathSign(scroll.left - container.scroll.left),
                y: mathSign(scroll.top - container.scroll.top)
            };
            container.scroll = scroll;
        });
        /**
		 * Due to how the sequencer is implemented, it’s
		 * important that we update the state of all
		 * elements, before any animation logic is
		 * evaluated (in the second loop below).
		 */ each(elements, function(element) {
            if (stale || element.geometry === undefined) element.geometry = getGeometry.call(this$1, element);
            element.visible = isElementVisible.call(this$1, element);
        });
        each(elements, function(element) {
            if (element.sequence) sequence.call(this$1, element);
            else animate.call(this$1, element);
        });
        this$1.pristine = false;
    });
}
function isTransformSupported() {
    var style = document.documentElement.style;
    return "transform" in style || "WebkitTransform" in style;
}
function isTransitionSupported() {
    var style = document.documentElement.style;
    return "transition" in style || "WebkitTransition" in style;
}
var version = "4.0.9";
var boundDelegate;
var boundDestroy;
var boundReveal;
var boundClean;
var boundSync;
var config;
var debug;
var instance;
function ScrollReveal(options) {
    if (options === void 0) options = {};
    var invokedWithoutNew = typeof this === "undefined" || Object.getPrototypeOf(this) !== ScrollReveal.prototype;
    if (invokedWithoutNew) return new ScrollReveal(options);
    if (!ScrollReveal.isSupported()) {
        logger.call(this, "Instantiation failed.", "This browser is not supported.");
        return mount.failure();
    }
    var buffer;
    try {
        buffer = config ? deepAssign({}, config, options) : deepAssign({}, defaults, options);
    } catch (e) {
        logger.call(this, "Invalid configuration.", e.message);
        return mount.failure();
    }
    try {
        var container = (0, _tealightDefault.default)(buffer.container)[0];
        if (!container) throw new Error("Invalid container.");
    } catch (e) {
        logger.call(this, e.message);
        return mount.failure();
    }
    config = buffer;
    if (!config.mobile && isMobile() || !config.desktop && !isMobile()) {
        logger.call(this, "This device is disabled.", "desktop: " + config.desktop, "mobile: " + config.mobile);
        return mount.failure();
    }
    mount.success();
    this.store = {
        containers: {},
        elements: {},
        history: [],
        sequences: {}
    };
    this.pristine = true;
    boundDelegate = boundDelegate || delegate.bind(this);
    boundDestroy = boundDestroy || destroy.bind(this);
    boundReveal = boundReveal || reveal.bind(this);
    boundClean = boundClean || clean.bind(this);
    boundSync = boundSync || sync.bind(this);
    Object.defineProperty(this, "delegate", {
        get: function() {
            return boundDelegate;
        }
    });
    Object.defineProperty(this, "destroy", {
        get: function() {
            return boundDestroy;
        }
    });
    Object.defineProperty(this, "reveal", {
        get: function() {
            return boundReveal;
        }
    });
    Object.defineProperty(this, "clean", {
        get: function() {
            return boundClean;
        }
    });
    Object.defineProperty(this, "sync", {
        get: function() {
            return boundSync;
        }
    });
    Object.defineProperty(this, "defaults", {
        get: function() {
            return config;
        }
    });
    Object.defineProperty(this, "version", {
        get: function() {
            return version;
        }
    });
    Object.defineProperty(this, "noop", {
        get: function() {
            return false;
        }
    });
    return instance ? instance : instance = this;
}
ScrollReveal.isSupported = function() {
    return isTransformSupported() && isTransitionSupported();
};
Object.defineProperty(ScrollReveal, "debug", {
    get: function() {
        return debug || false;
    },
    set: function(value) {
        return debug = typeof value === "boolean" ? value : debug;
    }
});
ScrollReveal();
exports.default = ScrollReveal;

},{"tealight":"iqaoz","rematrix":"bs2fw","miniraf":"fnkF3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iqaoz":[function(require,module,exports) {
/*! @license Tealight v0.3.6

	Copyright 2018 Fisssion LLC.

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.

*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isDomNode = require("is-dom-node");
var _isDomNodeDefault = parcelHelpers.interopDefault(_isDomNode);
var _isDomNodeList = require("is-dom-node-list");
var _isDomNodeListDefault = parcelHelpers.interopDefault(_isDomNodeList);
function tealight(target, context) {
    if (context === void 0) context = document;
    if (target instanceof Array) return target.filter((0, _isDomNodeDefault.default));
    if ((0, _isDomNodeDefault.default)(target)) return [
        target
    ];
    if ((0, _isDomNodeListDefault.default)(target)) return Array.prototype.slice.call(target);
    if (typeof target === "string") try {
        var query = context.querySelectorAll(target);
        return Array.prototype.slice.call(query);
    } catch (err) {
        return [];
    }
    return [];
}
exports.default = tealight;

},{"is-dom-node":"eTJMo","is-dom-node-list":"2nLdM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eTJMo":[function(require,module,exports) {
/*! @license is-dom-node v1.0.4

	Copyright 2018 Fisssion LLC.

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.

*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isDomNode(x) {
    return typeof window.Node === "object" ? x instanceof window.Node : x !== null && typeof x === "object" && typeof x.nodeType === "number" && typeof x.nodeName === "string";
}
exports.default = isDomNode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2nLdM":[function(require,module,exports) {
/*! @license is-dom-node-list v1.2.1

	Copyright 2018 Fisssion LLC.

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.

*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isDomNode = require("is-dom-node");
var _isDomNodeDefault = parcelHelpers.interopDefault(_isDomNode);
function isDomNodeList(x) {
    var prototypeToString = Object.prototype.toString.call(x);
    var regex = /^\[object (HTMLCollection|NodeList|Object)\]$/;
    return typeof window.NodeList === "object" ? x instanceof window.NodeList : x !== null && typeof x === "object" && typeof x.length === "number" && regex.test(prototypeToString) && (x.length === 0 || (0, _isDomNodeDefault.default)(x[0]));
}
exports.default = isDomNodeList;

},{"is-dom-node":"eTJMo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bs2fw":[function(require,module,exports) {
/*! @license Rematrix v0.3.0

	Copyright 2018 Julian Lloyd.

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
*/ /**
 * @module Rematrix
 */ /**
 * Transformation matrices in the browser come in two flavors:
 *
 *  - `matrix` using 6 values (short)
 *  - `matrix3d` using 16 values (long)
 *
 * This utility follows this [conversion guide](https://goo.gl/EJlUQ1)
 * to expand short form matrices to their equivalent long form.
 *
 * @param  {array} source - Accepts both short and long form matrices.
 * @return {array}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", ()=>format);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "inverse", ()=>inverse);
parcelHelpers.export(exports, "multiply", ()=>multiply);
parcelHelpers.export(exports, "parse", ()=>parse);
parcelHelpers.export(exports, "rotate", ()=>rotate);
parcelHelpers.export(exports, "rotateX", ()=>rotateX);
parcelHelpers.export(exports, "rotateY", ()=>rotateY);
parcelHelpers.export(exports, "rotateZ", ()=>rotateZ);
parcelHelpers.export(exports, "scale", ()=>scale);
parcelHelpers.export(exports, "scaleX", ()=>scaleX);
parcelHelpers.export(exports, "scaleY", ()=>scaleY);
parcelHelpers.export(exports, "scaleZ", ()=>scaleZ);
parcelHelpers.export(exports, "skew", ()=>skew);
parcelHelpers.export(exports, "skewX", ()=>skewX);
parcelHelpers.export(exports, "skewY", ()=>skewY);
parcelHelpers.export(exports, "toString", ()=>toString);
parcelHelpers.export(exports, "translate", ()=>translate);
parcelHelpers.export(exports, "translateX", ()=>translateX);
parcelHelpers.export(exports, "translateY", ()=>translateY);
parcelHelpers.export(exports, "translateZ", ()=>translateZ);
function format(source) {
    if (source.constructor !== Array) throw new TypeError("Expected array.");
    if (source.length === 16) return source;
    if (source.length === 6) {
        var matrix = identity();
        matrix[0] = source[0];
        matrix[1] = source[1];
        matrix[4] = source[2];
        matrix[5] = source[3];
        matrix[12] = source[4];
        matrix[13] = source[5];
        return matrix;
    }
    throw new RangeError("Expected array with either 6 or 16 values.");
}
/**
 * Returns a matrix representing no transformation. The product of any matrix
 * multiplied by the identity matrix will be the original matrix.
 *
 * > **Tip:** Similar to how `5 * 1 === 5`, where `1` is the identity.
 *
 * @return {array}
 */ function identity() {
    var matrix = [];
    for(var i = 0; i < 16; i++)i % 5 == 0 ? matrix.push(1) : matrix.push(0);
    return matrix;
}
/**
 * Returns a matrix describing the inverse transformation of the source
 * matrix. The product of any matrix multiplied by its inverse will be the
 * identity matrix.
 *
 * > **Tip:** Similar to how `5 * (1/5) === 1`, where `1/5` is the inverse.
 *
 * @param  {array} source - Accepts both short and long form matrices.
 * @return {array}
 */ function inverse(source) {
    var m = format(source);
    var s0 = m[0] * m[5] - m[4] * m[1];
    var s1 = m[0] * m[6] - m[4] * m[2];
    var s2 = m[0] * m[7] - m[4] * m[3];
    var s3 = m[1] * m[6] - m[5] * m[2];
    var s4 = m[1] * m[7] - m[5] * m[3];
    var s5 = m[2] * m[7] - m[6] * m[3];
    var c5 = m[10] * m[15] - m[14] * m[11];
    var c4 = m[9] * m[15] - m[13] * m[11];
    var c3 = m[9] * m[14] - m[13] * m[10];
    var c2 = m[8] * m[15] - m[12] * m[11];
    var c1 = m[8] * m[14] - m[12] * m[10];
    var c0 = m[8] * m[13] - m[12] * m[9];
    var determinant = 1 / (s0 * c5 - s1 * c4 + s2 * c3 + s3 * c2 - s4 * c1 + s5 * c0);
    if (isNaN(determinant) || determinant === Infinity) throw new Error("Inverse determinant attempted to divide by zero.");
    return [
        (m[5] * c5 - m[6] * c4 + m[7] * c3) * determinant,
        (-m[1] * c5 + m[2] * c4 - m[3] * c3) * determinant,
        (m[13] * s5 - m[14] * s4 + m[15] * s3) * determinant,
        (-m[9] * s5 + m[10] * s4 - m[11] * s3) * determinant,
        (-m[4] * c5 + m[6] * c2 - m[7] * c1) * determinant,
        (m[0] * c5 - m[2] * c2 + m[3] * c1) * determinant,
        (-m[12] * s5 + m[14] * s2 - m[15] * s1) * determinant,
        (m[8] * s5 - m[10] * s2 + m[11] * s1) * determinant,
        (m[4] * c4 - m[5] * c2 + m[7] * c0) * determinant,
        (-m[0] * c4 + m[1] * c2 - m[3] * c0) * determinant,
        (m[12] * s4 - m[13] * s2 + m[15] * s0) * determinant,
        (-m[8] * s4 + m[9] * s2 - m[11] * s0) * determinant,
        (-m[4] * c3 + m[5] * c1 - m[6] * c0) * determinant,
        (m[0] * c3 - m[1] * c1 + m[2] * c0) * determinant,
        (-m[12] * s3 + m[13] * s1 - m[14] * s0) * determinant,
        (m[8] * s3 - m[9] * s1 + m[10] * s0) * determinant
    ];
}
/**
 * Returns a 4x4 matrix describing the combined transformations
 * of both arguments.
 *
 * > **Note:** Order is very important. For example, rotating 45°
 * along the Z-axis, followed by translating 500 pixels along the
 * Y-axis... is not the same as translating 500 pixels along the
 * Y-axis, followed by rotating 45° along on the Z-axis.
 *
 * @param  {array} m - Accepts both short and long form matrices.
 * @param  {array} x - Accepts both short and long form matrices.
 * @return {array}
 */ function multiply(m, x) {
    var fm = format(m);
    var fx = format(x);
    var product = [];
    for(var i = 0; i < 4; i++){
        var row = [
            fm[i],
            fm[i + 4],
            fm[i + 8],
            fm[i + 12]
        ];
        for(var j = 0; j < 4; j++){
            var k = j * 4;
            var col = [
                fx[k],
                fx[k + 1],
                fx[k + 2],
                fx[k + 3]
            ];
            var result = row[0] * col[0] + row[1] * col[1] + row[2] * col[2] + row[3] * col[3];
            product[i + k] = result;
        }
    }
    return product;
}
/**
 * Attempts to return a 4x4 matrix describing the CSS transform
 * matrix passed in, but will return the identity matrix as a
 * fallback.
 *
 * > **Tip:** This method is used to convert a CSS matrix (retrieved as a
 * `string` from computed styles) to its equivalent array format.
 *
 * @param  {string} source - `matrix` or `matrix3d` CSS Transform value.
 * @return {array}
 */ function parse(source) {
    if (typeof source === "string") {
        var match = source.match(/matrix(3d)?\(([^)]+)\)/);
        if (match) {
            var raw = match[2].split(", ").map(parseFloat);
            return format(raw);
        }
    }
    return identity();
}
/**
 * Returns a 4x4 matrix describing Z-axis rotation.
 *
 * > **Tip:** This is just an alias for `Rematrix.rotateZ` for parity with CSS
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function rotate(angle) {
    return rotateZ(angle);
}
/**
 * Returns a 4x4 matrix describing X-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function rotateX(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = identity();
    matrix[5] = matrix[10] = Math.cos(theta);
    matrix[6] = matrix[9] = Math.sin(theta);
    matrix[9] *= -1;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function rotateY(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = identity();
    matrix[0] = matrix[10] = Math.cos(theta);
    matrix[2] = matrix[8] = Math.sin(theta);
    matrix[2] *= -1;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Z-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function rotateZ(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = identity();
    matrix[0] = matrix[5] = Math.cos(theta);
    matrix[1] = matrix[4] = Math.sin(theta);
    matrix[4] *= -1;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing 2D scaling. The first argument
 * is used for both X and Y-axis scaling, unless an optional
 * second argument is provided to explicitly define Y-axis scaling.
 *
 * @param  {number} scalar    - Decimal multiplier.
 * @param  {number} [scalarY] - Decimal multiplier.
 * @return {array}
 */ function scale(scalar, scalarY) {
    var matrix = identity();
    matrix[0] = scalar;
    matrix[5] = typeof scalarY === "number" ? scalarY : scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing X-axis scaling.
 *
 * @param  {number} scalar - Decimal multiplier.
 * @return {array}
 */ function scaleX(scalar) {
    var matrix = identity();
    matrix[0] = scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis scaling.
 *
 * @param  {number} scalar - Decimal multiplier.
 * @return {array}
 */ function scaleY(scalar) {
    var matrix = identity();
    matrix[5] = scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Z-axis scaling.
 *
 * @param  {number} scalar - Decimal multiplier.
 * @return {array}
 */ function scaleZ(scalar) {
    var matrix = identity();
    matrix[10] = scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing shear. The first argument
 * defines X-axis shearing, and an optional second argument
 * defines Y-axis shearing.
 *
 * @param  {number} angleX   - Measured in degrees.
 * @param  {number} [angleY] - Measured in degrees.
 * @return {array}
 */ function skew(angleX, angleY) {
    var thetaX = Math.PI / 180 * angleX;
    var matrix = identity();
    matrix[4] = Math.tan(thetaX);
    if (angleY) {
        var thetaY = Math.PI / 180 * angleY;
        matrix[1] = Math.tan(thetaY);
    }
    return matrix;
}
/**
 * Returns a 4x4 matrix describing X-axis shear.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function skewX(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = identity();
    matrix[4] = Math.tan(theta);
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis shear.
 *
 * @param  {number} angle - Measured in degrees
 * @return {array}
 */ function skewY(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = identity();
    matrix[1] = Math.tan(theta);
    return matrix;
}
/**
 * Returns a CSS Transform property value equivalent to the source matrix.
 *
 * @param  {array} source - Accepts both short and long form matrices.
 * @return {string}
 */ function toString(source) {
    return "matrix3d(" + format(source).join(", ") + ")";
}
/**
 * Returns a 4x4 matrix describing 2D translation. The first
 * argument defines X-axis translation, and an optional second
 * argument defines Y-axis translation.
 *
 * @param  {number} distanceX   - Measured in pixels.
 * @param  {number} [distanceY] - Measured in pixels.
 * @return {array}
 */ function translate(distanceX, distanceY) {
    var matrix = identity();
    matrix[12] = distanceX;
    if (distanceY) matrix[13] = distanceY;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing X-axis translation.
 *
 * @param  {number} distance - Measured in pixels.
 * @return {array}
 */ function translateX(distance) {
    var matrix = identity();
    matrix[12] = distance;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis translation.
 *
 * @param  {number} distance - Measured in pixels.
 * @return {array}
 */ function translateY(distance) {
    var matrix = identity();
    matrix[13] = distance;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Z-axis translation.
 *
 * @param  {number} distance - Measured in pixels.
 * @return {array}
 */ function translateZ(distance) {
    var matrix = identity();
    matrix[14] = distance;
    return matrix;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fnkF3":[function(require,module,exports) {
/*! @license miniraf v1.0.0

	Copyright 2018 Fisssion LLC.

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.

*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var polyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            return polyfill(callback);
        }, 0);
    };
}();
var index = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || polyfill;
exports.default = index;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"11TDa":[function(require,module,exports) {
/*!
 * jQuery JavaScript Library v3.7.0
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-05-11T18:29Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : this, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.0", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            else if (nodeType === 1 || nodeType === 9 || nodeType === 11) return elem.textContent;
            else if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\x00") return "�";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\x00-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors (see trac-13936)
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented
        // as part of Sizzle so let's maintain them in the 3.x line
        // for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Reenable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is display: block
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

},{}],"900Wv":[function(require,module,exports) {
/*!
  * Bootstrap v5.3.0 (https://getbootstrap.com/)
  * Copyright 2011-2023 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alert", ()=>Alert);
parcelHelpers.export(exports, "Button", ()=>Button);
parcelHelpers.export(exports, "Carousel", ()=>Carousel);
parcelHelpers.export(exports, "Collapse", ()=>Collapse);
parcelHelpers.export(exports, "Dropdown", ()=>Dropdown);
parcelHelpers.export(exports, "Modal", ()=>Modal);
parcelHelpers.export(exports, "Offcanvas", ()=>Offcanvas);
parcelHelpers.export(exports, "Popover", ()=>Popover);
parcelHelpers.export(exports, "ScrollSpy", ()=>ScrollSpy);
parcelHelpers.export(exports, "Tab", ()=>Tab);
parcelHelpers.export(exports, "Toast", ()=>Toast);
parcelHelpers.export(exports, "Tooltip", ()=>Tooltip);
var _core = require("@popperjs/core");
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const elementMap = new Map();
const Data = {
    set (element, key, instance) {
        if (!elementMap.has(element)) elementMap.set(element, new Map());
        const instanceMap = elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if (elementMap.has(element)) return elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!elementMap.has(element)) return;
        const instanceMap = elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const MAX_UID = 1000000;
const MILLISECONDS_MULTIPLIER = 1000;
const TRANSITION_END = "transitionend";
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration, transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(",")[0];
    transitionDelay = transitionDelay.split(",")[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
};
const triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event(TRANSITION_END));
};
const isElement = (object)=>{
    if (!object || typeof object !== "object") return false;
    if (typeof object.jquery !== "undefined") object = object[0];
    return typeof object.nodeType !== "undefined";
};
const getElement = (object)=>{
    // it's a jQuery object or a node element
    if (isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === "string" && object.length > 0) return document.querySelector(parseSelector(object));
    return null;
};
const isVisible = (element)=>{
    if (!isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue("visibility") === "visible";
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest("details:not([open])");
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest("summary");
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains("disabled")) return true;
    if (typeof element.disabled !== "undefined") return element.disabled;
    return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
};
const findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === "function") {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return findShadowRoot(element.parentNode);
};
const noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return window.jQuery;
    return null;
};
const DOMContentLoadedCallbacks = [];
const onDOMContentLoaded = (callback)=>{
    if (document.readyState === "loading") {
        // add listener on the first call when the document is in loading state
        if (!DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
            for (const callback of DOMContentLoadedCallbacks)callback();
        });
        DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const isRTL = ()=>document.documentElement.dir === "rtl";
const defineJQueryPlugin = (plugin)=>{
    onDOMContentLoaded(()=>{
        const $ = getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === "function" ? possibleCallback(...args) : defaultValue;
};
const executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener(TRANSITION_END, handler);
        execute(callback);
    };
    transitionElement.addEventListener(TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const stripNameRegex = /\..*/;
const stripUidRegex = /::\d+$/;
const eventRegistry = {}; // Events storage
let uidEvent = 1;
const customEvents = {
    mouseenter: "mouseover",
    mouseleave: "mouseout"
};
const nativeEvents = new Set([
    "click",
    "dblclick",
    "mouseup",
    "mousedown",
    "contextmenu",
    "mousewheel",
    "DOMMouseScroll",
    "mouseover",
    "mouseout",
    "mousemove",
    "selectstart",
    "selectend",
    "keydown",
    "keypress",
    "keyup",
    "orientationchange",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel",
    "gesturestart",
    "gesturechange",
    "gestureend",
    "focus",
    "blur",
    "change",
    "reset",
    "select",
    "submit",
    "focusin",
    "focusout",
    "load",
    "unload",
    "beforeunload",
    "resize",
    "move",
    "DOMContentLoaded",
    "readystatechange",
    "error",
    "abort",
    "scroll"
]);
/**
 * Private methods
 */ function makeEventUid(element, uid) {
    return uid && `${uid}::${uidEvent++}` || element.uidEvent || uidEvent++;
}
function getElementEvents(element) {
    const uid = makeEventUid(element);
    element.uidEvent = uid;
    eventRegistry[uid] = eventRegistry[uid] || {};
    return eventRegistry[uid];
}
function bootstrapHandler(element, fn) {
    return function handler(event) {
        hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === "string";
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = getTypeEvent(originalTypeEvent);
    if (!nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== "string" || !element) return;
    let [isDelegated, callable, typeEvent] = normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = makeEventUid(callable, originalTypeEvent.replace(namespaceRegex, ""));
    const fn = isDelegated ? bootstrapDelegationHandler(element, handler, callable) : bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace(stripNameRegex, "");
    return customEvents[event] || event;
}
const EventHandler = {
    on (element, event, handler, delegationFunction) {
        addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        const [isDelegated, callable, typeEvent] = normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith(".");
        if (typeof callable !== "undefined") {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace(stripUidRegex, "");
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== "string" || !element) return null;
        const $ = getjQuery();
        const typeEvent = getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = hydrateObj(new Event(event, {
            bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function normalizeData(value) {
    if (value === "true") return true;
    if (value === "false") return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === "" || value === "null") return null;
    if (typeof value !== "string") return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith("bs") && !key.startsWith("bsConfig"));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, "");
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
            attributes[pureKey] = normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return normalizeData(element.getAttribute(`data-bs-${normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = isElement(element) ? Manipulator.getDataAttribute(element, "config") : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === "object" ? jsonConfig : {},
            ...isElement(element) ? Manipulator.getDataAttributes(element) : {},
            ...typeof config === "object" ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = isElement(value) ? "element" : toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const VERSION = "5.3.0";
/**
 * Class definition
 */ class BaseComponent extends Config {
    constructor(element, config){
        super();
        element = getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        Data.remove(this._element, this.constructor.DATA_KEY);
        EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element, isAnimated = true) {
        executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return Data.get(getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
    }
    static get VERSION() {
        return VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const getSelector = (element)=>{
    let selector = element.getAttribute("data-bs-target");
    if (!selector || selector === "#") {
        let hrefAttribute = element.getAttribute("href");
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = `#${hrefAttribute.split("#")[1]}`;
        selector = hrefAttribute && hrefAttribute !== "#" ? hrefAttribute.trim() : null;
    }
    return parseSelector(selector);
};
const SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            "a",
            "button",
            "input",
            "textarea",
            "select",
            "details",
            "[tabindex]",
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(",");
        return this.find(focusables, element).filter((el)=>!isDisabled(el) && isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = getSelector(element);
        if (selector) return SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = getSelector(element);
        return selector ? SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = getSelector(element);
        return selector ? SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const enableDismissTrigger = (component, method = "hide")=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if (isDisabled(this)) return;
        const target = SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$f = "alert";
const DATA_KEY$a = "bs.alert";
const EVENT_KEY$b = `.${DATA_KEY$a}`;
const EVENT_CLOSE = `close${EVENT_KEY$b}`;
const EVENT_CLOSED = `closed${EVENT_KEY$b}`;
const CLASS_NAME_FADE$5 = "fade";
const CLASS_NAME_SHOW$8 = "show";
/**
 * Class definition
 */ class Alert extends BaseComponent {
    // Getters
    static get NAME() {
        return NAME$f;
    }
    // Public
    close() {
        const closeEvent = EventHandler.trigger(this._element, EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove(CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains(CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        EventHandler.trigger(this._element, EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Alert.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ enableDismissTrigger(Alert, "close");
/**
 * jQuery
 */ defineJQueryPlugin(Alert);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$e = "button";
const DATA_KEY$9 = "bs.button";
const EVENT_KEY$a = `.${DATA_KEY$9}`;
const DATA_API_KEY$6 = ".data-api";
const CLASS_NAME_ACTIVE$3 = "active";
const SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const EVENT_CLICK_DATA_API$6 = `click${EVENT_KEY$a}${DATA_API_KEY$6}`;
/**
 * Class definition
 */ class Button extends BaseComponent {
    // Getters
    static get NAME() {
        return NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute("aria-pressed", this._element.classList.toggle(CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Button.getOrCreateInstance(this);
            if (config === "toggle") data[config]();
        });
    }
}
/**
 * Data API implementation
 */ EventHandler.on(document, EVENT_CLICK_DATA_API$6, SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest(SELECTOR_DATA_TOGGLE$5);
    const data = Button.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ defineJQueryPlugin(Button);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$d = "swipe";
const EVENT_KEY$9 = ".bs.swipe";
const EVENT_TOUCHSTART = `touchstart${EVENT_KEY$9}`;
const EVENT_TOUCHMOVE = `touchmove${EVENT_KEY$9}`;
const EVENT_TOUCHEND = `touchend${EVENT_KEY$9}`;
const EVENT_POINTERDOWN = `pointerdown${EVENT_KEY$9}`;
const EVENT_POINTERUP = `pointerup${EVENT_KEY$9}`;
const POINTER_TYPE_TOUCH = "touch";
const POINTER_TYPE_PEN = "pen";
const CLASS_NAME_POINTER_EVENT = "pointer-event";
const SWIPE_THRESHOLD = 40;
const Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const DefaultType$c = {
    endCallback: "(function|null)",
    leftCallback: "(function|null)",
    rightCallback: "(function|null)"
};
/**
 * Class definition
 */ class Swipe extends Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return Default$c;
    }
    static get DefaultType() {
        return DefaultType$c;
    }
    static get NAME() {
        return NAME$d;
    }
    // Public
    dispose() {
        EventHandler.off(this._element, EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            EventHandler.on(this._element, EVENT_POINTERDOWN, (event)=>this._start(event));
            EventHandler.on(this._element, EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add(CLASS_NAME_POINTER_EVENT);
        } else {
            EventHandler.on(this._element, EVENT_TOUCHSTART, (event)=>this._start(event));
            EventHandler.on(this._element, EVENT_TOUCHMOVE, (event)=>this._move(event));
            EventHandler.on(this._element, EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === POINTER_TYPE_PEN || event.pointerType === POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$c = "carousel";
const DATA_KEY$8 = "bs.carousel";
const EVENT_KEY$8 = `.${DATA_KEY$8}`;
const DATA_API_KEY$5 = ".data-api";
const ARROW_LEFT_KEY$1 = "ArrowLeft";
const ARROW_RIGHT_KEY$1 = "ArrowRight";
const TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const ORDER_NEXT = "next";
const ORDER_PREV = "prev";
const DIRECTION_LEFT = "left";
const DIRECTION_RIGHT = "right";
const EVENT_SLIDE = `slide${EVENT_KEY$8}`;
const EVENT_SLID = `slid${EVENT_KEY$8}`;
const EVENT_KEYDOWN$1 = `keydown${EVENT_KEY$8}`;
const EVENT_MOUSEENTER$1 = `mouseenter${EVENT_KEY$8}`;
const EVENT_MOUSELEAVE$1 = `mouseleave${EVENT_KEY$8}`;
const EVENT_DRAG_START = `dragstart${EVENT_KEY$8}`;
const EVENT_LOAD_DATA_API$3 = `load${EVENT_KEY$8}${DATA_API_KEY$5}`;
const EVENT_CLICK_DATA_API$5 = `click${EVENT_KEY$8}${DATA_API_KEY$5}`;
const CLASS_NAME_CAROUSEL = "carousel";
const CLASS_NAME_ACTIVE$2 = "active";
const CLASS_NAME_SLIDE = "slide";
const CLASS_NAME_END = "carousel-item-end";
const CLASS_NAME_START = "carousel-item-start";
const CLASS_NAME_NEXT = "carousel-item-next";
const CLASS_NAME_PREV = "carousel-item-prev";
const SELECTOR_ACTIVE = ".active";
const SELECTOR_ITEM = ".carousel-item";
const SELECTOR_ACTIVE_ITEM = SELECTOR_ACTIVE + SELECTOR_ITEM;
const SELECTOR_ITEM_IMG = ".carousel-item img";
const SELECTOR_INDICATORS = ".carousel-indicators";
const SELECTOR_DATA_SLIDE = "[data-bs-slide], [data-bs-slide-to]";
const SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const KEY_TO_DIRECTION = {
    [ARROW_LEFT_KEY$1]: DIRECTION_RIGHT,
    [ARROW_RIGHT_KEY$1]: DIRECTION_LEFT
};
const Default$b = {
    interval: 5000,
    keyboard: true,
    pause: "hover",
    ride: false,
    touch: true,
    wrap: true
};
const DefaultType$b = {
    interval: "(number|boolean)",
    // TODO:v6 remove boolean support
    keyboard: "boolean",
    pause: "(string|boolean)",
    ride: "(boolean|string)",
    touch: "boolean",
    wrap: "boolean"
};
/**
 * Class definition
 */ class Carousel extends BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = SelectorEngine.findOne(SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return Default$b;
    }
    static get DefaultType() {
        return DefaultType$b;
    }
    static get NAME() {
        return NAME$c;
    }
    // Public
    next() {
        this._slide(ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && isVisible(this._element)) this.next();
    }
    prev() {
        this._slide(ORDER_PREV);
    }
    pause() {
        if (this._isSliding) triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            EventHandler.one(this._element, EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            EventHandler.one(this._element, EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? ORDER_NEXT : ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) EventHandler.on(this._element, EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === "hover") {
            EventHandler.on(this._element, EVENT_MOUSEENTER$1, ()=>this.pause());
            EventHandler.on(this._element, EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of SelectorEngine.find(SELECTOR_ITEM_IMG, this._element))EventHandler.on(img, EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== "hover") return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder(DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder(DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = SelectorEngine.findOne(SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove(CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute("aria-current");
        const newActiveIndicator = SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add(CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute("aria-current", "true");
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute("data-bs-interval"), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === ORDER_NEXT;
        const nextElement = element || getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent(EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? CLASS_NAME_START : CLASS_NAME_END;
        const orderClassName = isNext ? CLASS_NAME_NEXT : CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add(CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove(CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent(EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains(CLASS_NAME_SLIDE);
    }
    _getActive() {
        return SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return SelectorEngine.find(SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if (isRTL()) return direction === DIRECTION_LEFT ? ORDER_PREV : ORDER_NEXT;
        return direction === DIRECTION_LEFT ? ORDER_NEXT : ORDER_PREV;
    }
    _orderToDirection(order) {
        if (isRTL()) return order === ORDER_PREV ? DIRECTION_LEFT : DIRECTION_RIGHT;
        return order === ORDER_PREV ? DIRECTION_RIGHT : DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Carousel.getOrCreateInstance(this, config);
            if (typeof config === "number") {
                data.to(config);
                return;
            }
            if (typeof config === "string") {
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ EventHandler.on(document, EVENT_CLICK_DATA_API$5, SELECTOR_DATA_SLIDE, function(event) {
    const target = SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains(CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = Carousel.getOrCreateInstance(target);
    const slideIndex = this.getAttribute("data-bs-slide-to");
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if (Manipulator.getDataAttribute(this, "slide") === "next") {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
EventHandler.on(window, EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = SelectorEngine.find(SELECTOR_DATA_RIDE);
    for (const carousel of carousels)Carousel.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ defineJQueryPlugin(Carousel);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$b = "collapse";
const DATA_KEY$7 = "bs.collapse";
const EVENT_KEY$7 = `.${DATA_KEY$7}`;
const DATA_API_KEY$4 = ".data-api";
const EVENT_SHOW$6 = `show${EVENT_KEY$7}`;
const EVENT_SHOWN$6 = `shown${EVENT_KEY$7}`;
const EVENT_HIDE$6 = `hide${EVENT_KEY$7}`;
const EVENT_HIDDEN$6 = `hidden${EVENT_KEY$7}`;
const EVENT_CLICK_DATA_API$4 = `click${EVENT_KEY$7}${DATA_API_KEY$4}`;
const CLASS_NAME_SHOW$7 = "show";
const CLASS_NAME_COLLAPSE = "collapse";
const CLASS_NAME_COLLAPSING = "collapsing";
const CLASS_NAME_COLLAPSED = "collapsed";
const CLASS_NAME_DEEPER_CHILDREN = `:scope .${CLASS_NAME_COLLAPSE} .${CLASS_NAME_COLLAPSE}`;
const CLASS_NAME_HORIZONTAL = "collapse-horizontal";
const WIDTH = "width";
const HEIGHT = "height";
const SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
const SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const Default$a = {
    parent: null,
    toggle: true
};
const DefaultType$a = {
    parent: "(null|element)",
    toggle: "boolean"
};
/**
 * Class definition
 */ class Collapse extends BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = SelectorEngine.find(SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = SelectorEngine.getSelectorFromElement(elem);
            const filterElement = SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return Default$a;
    }
    static get DefaultType() {
        return DefaultType$a;
    }
    static get NAME() {
        return NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren(SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>Collapse.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = EventHandler.trigger(this._element, EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove(CLASS_NAME_COLLAPSE);
        this._element.classList.add(CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove(CLASS_NAME_COLLAPSING);
            this._element.classList.add(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$7);
            this._element.style[dimension] = "";
            EventHandler.trigger(this._element, EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = EventHandler.trigger(this._element, EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        reflow(this._element);
        this._element.classList.add(CLASS_NAME_COLLAPSING);
        this._element.classList.remove(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove(CLASS_NAME_COLLAPSING);
            this._element.classList.add(CLASS_NAME_COLLAPSE);
            EventHandler.trigger(this._element, EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = "";
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element = this._element) {
        return element.classList.contains(CLASS_NAME_SHOW$7);
    }
    // Private
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains(CLASS_NAME_HORIZONTAL) ? WIDTH : HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren(SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = SelectorEngine.find(CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle(CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute("aria-expanded", isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = Collapse.getOrCreateInstance(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ EventHandler.on(document, EVENT_CLICK_DATA_API$4, SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
    for (const element of SelectorEngine.getMultipleElementsFromSelector(this))Collapse.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ defineJQueryPlugin(Collapse);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$a = "dropdown";
const DATA_KEY$6 = "bs.dropdown";
const EVENT_KEY$6 = `.${DATA_KEY$6}`;
const DATA_API_KEY$3 = ".data-api";
const ESCAPE_KEY$2 = "Escape";
const TAB_KEY$1 = "Tab";
const ARROW_UP_KEY$1 = "ArrowUp";
const ARROW_DOWN_KEY$1 = "ArrowDown";
const RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const EVENT_HIDE$5 = `hide${EVENT_KEY$6}`;
const EVENT_HIDDEN$5 = `hidden${EVENT_KEY$6}`;
const EVENT_SHOW$5 = `show${EVENT_KEY$6}`;
const EVENT_SHOWN$5 = `shown${EVENT_KEY$6}`;
const EVENT_CLICK_DATA_API$3 = `click${EVENT_KEY$6}${DATA_API_KEY$3}`;
const EVENT_KEYDOWN_DATA_API = `keydown${EVENT_KEY$6}${DATA_API_KEY$3}`;
const EVENT_KEYUP_DATA_API = `keyup${EVENT_KEY$6}${DATA_API_KEY$3}`;
const CLASS_NAME_SHOW$6 = "show";
const CLASS_NAME_DROPUP = "dropup";
const CLASS_NAME_DROPEND = "dropend";
const CLASS_NAME_DROPSTART = "dropstart";
const CLASS_NAME_DROPUP_CENTER = "dropup-center";
const CLASS_NAME_DROPDOWN_CENTER = "dropdown-center";
const SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const SELECTOR_DATA_TOGGLE_SHOWN = `${SELECTOR_DATA_TOGGLE$3}.${CLASS_NAME_SHOW$6}`;
const SELECTOR_MENU = ".dropdown-menu";
const SELECTOR_NAVBAR = ".navbar";
const SELECTOR_NAVBAR_NAV = ".navbar-nav";
const SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
const PLACEMENT_TOP = isRTL() ? "top-end" : "top-start";
const PLACEMENT_TOPEND = isRTL() ? "top-start" : "top-end";
const PLACEMENT_BOTTOM = isRTL() ? "bottom-end" : "bottom-start";
const PLACEMENT_BOTTOMEND = isRTL() ? "bottom-start" : "bottom-end";
const PLACEMENT_RIGHT = isRTL() ? "left-start" : "right-start";
const PLACEMENT_LEFT = isRTL() ? "right-start" : "left-start";
const PLACEMENT_TOPCENTER = "top";
const PLACEMENT_BOTTOMCENTER = "bottom";
const Default$9 = {
    autoClose: true,
    boundary: "clippingParents",
    display: "dynamic",
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: "toggle"
};
const DefaultType$9 = {
    autoClose: "(boolean|string)",
    boundary: "(string|element)",
    display: "string",
    offset: "(array|string|function)",
    popperConfig: "(null|object|function)",
    reference: "(string|element|object)"
};
/**
 * Class definition
 */ class Dropdown extends BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = SelectorEngine.next(this._element, SELECTOR_MENU)[0] || SelectorEngine.prev(this._element, SELECTOR_MENU)[0] || SelectorEngine.findOne(SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return Default$9;
    }
    static get DefaultType() {
        return DefaultType$9;
    }
    static get NAME() {
        return NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if (isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement && !this._parent.closest(SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))EventHandler.on(element, "mouseover", noop);
        this._element.focus();
        this._element.setAttribute("aria-expanded", true);
        this._menu.classList.add(CLASS_NAME_SHOW$6);
        this._element.classList.add(CLASS_NAME_SHOW$6);
        EventHandler.trigger(this._element, EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if (isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))EventHandler.off(element, "mouseover", noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove(CLASS_NAME_SHOW$6);
        this._element.classList.remove(CLASS_NAME_SHOW$6);
        this._element.setAttribute("aria-expanded", "false");
        Manipulator.removeDataAttribute(this._menu, "popper");
        EventHandler.trigger(this._element, EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === "object" && !isElement(config.reference) && typeof config.reference.getBoundingClientRect !== "function") // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof _core === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
        let referenceElement = this._element;
        if (this._config.reference === "parent") referenceElement = this._parent;
        else if (isElement(this._config.reference)) referenceElement = getElement(this._config.reference);
        else if (typeof this._config.reference === "object") referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = _core.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains(CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains(CLASS_NAME_DROPEND)) return PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains(CLASS_NAME_DROPSTART)) return PLACEMENT_LEFT;
        if (parentDropdown.classList.contains(CLASS_NAME_DROPUP_CENTER)) return PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains(CLASS_NAME_DROPDOWN_CENTER)) return PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
        if (parentDropdown.classList.contains(CLASS_NAME_DROPUP)) return isEnd ? PLACEMENT_TOPEND : PLACEMENT_TOP;
        return isEnd ? PLACEMENT_BOTTOMEND : PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest(SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === "static") {
            Manipulator.setDataAttribute(this._menu, "popper", "static"); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: "applyStyles",
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key, target }) {
        const items = SelectorEngine.find(SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        getNextActiveElement(items, target, key === ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Dropdown.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === RIGHT_MOUSE_BUTTON || event.type === "keyup" && event.key !== TAB_KEY$1) return;
        const openToggles = SelectorEngine.find(SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = Dropdown.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === "inside" && !isMenuTarget || context._config.autoClose === "outside" && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === "keyup" && event.key === TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === "click") relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            ARROW_UP_KEY$1,
            ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches(SELECTOR_DATA_TOGGLE$3) ? this : SelectorEngine.prev(this, SELECTOR_DATA_TOGGLE$3)[0] || SelectorEngine.next(this, SELECTOR_DATA_TOGGLE$3)[0] || SelectorEngine.findOne(SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = Dropdown.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE$3, Dropdown.dataApiKeydownHandler);
EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown.dataApiKeydownHandler);
EventHandler.on(document, EVENT_CLICK_DATA_API$3, Dropdown.clearMenus);
EventHandler.on(document, EVENT_KEYUP_DATA_API, Dropdown.clearMenus);
EventHandler.on(document, EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    Dropdown.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ defineJQueryPlugin(Dropdown);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$9 = "backdrop";
const CLASS_NAME_FADE$4 = "fade";
const CLASS_NAME_SHOW$5 = "show";
const EVENT_MOUSEDOWN = `mousedown.bs.${NAME$9}`;
const Default$8 = {
    className: "modal-backdrop",
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: "body" // give the choice to place backdrop under different elements
};
const DefaultType$8 = {
    className: "string",
    clickCallback: "(function|null)",
    isAnimated: "boolean",
    isVisible: "boolean",
    rootElement: "(element|string)"
};
/**
 * Class definition
 */ class Backdrop extends Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return Default$8;
    }
    static get DefaultType() {
        return DefaultType$8;
    }
    static get NAME() {
        return NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) reflow(element);
        element.classList.add(CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            execute(callback);
            return;
        }
        this._getElement().classList.remove(CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        EventHandler.off(this._element, EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement("div");
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add(CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        EventHandler.on(element, EVENT_MOUSEDOWN, ()=>{
            execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$8 = "focustrap";
const DATA_KEY$5 = "bs.focustrap";
const EVENT_KEY$5 = `.${DATA_KEY$5}`;
const EVENT_FOCUSIN$2 = `focusin${EVENT_KEY$5}`;
const EVENT_KEYDOWN_TAB = `keydown.tab${EVENT_KEY$5}`;
const TAB_KEY = "Tab";
const TAB_NAV_FORWARD = "forward";
const TAB_NAV_BACKWARD = "backward";
const Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const DefaultType$7 = {
    autofocus: "boolean",
    trapElement: "element"
};
/**
 * Class definition
 */ class FocusTrap extends Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return Default$7;
    }
    static get DefaultType() {
        return DefaultType$7;
    }
    static get NAME() {
        return NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        EventHandler.off(document, EVENT_KEY$5); // guard against infinite focus loop
        EventHandler.on(document, EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        EventHandler.on(document, EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        EventHandler.off(document, EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? TAB_NAV_BACKWARD : TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
const SELECTOR_STICKY_CONTENT = ".sticky-top";
const PROPERTY_PADDING = "padding-right";
const PROPERTY_MARGIN = "margin-right";
/**
 * Class definition
 */ class ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes(SELECTOR_FIXED_CONTENT, PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes(SELECTOR_STICKY_CONTENT, PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, "overflow");
        this._resetElementAttributes(this._element, PROPERTY_PADDING);
        this._resetElementAttributes(SELECTOR_FIXED_CONTENT, PROPERTY_PADDING);
        this._resetElementAttributes(SELECTOR_STICKY_CONTENT, PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, "overflow");
        this._element.style.overflow = "hidden";
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if (isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$7 = "modal";
const DATA_KEY$4 = "bs.modal";
const EVENT_KEY$4 = `.${DATA_KEY$4}`;
const DATA_API_KEY$2 = ".data-api";
const ESCAPE_KEY$1 = "Escape";
const EVENT_HIDE$4 = `hide${EVENT_KEY$4}`;
const EVENT_HIDE_PREVENTED$1 = `hidePrevented${EVENT_KEY$4}`;
const EVENT_HIDDEN$4 = `hidden${EVENT_KEY$4}`;
const EVENT_SHOW$4 = `show${EVENT_KEY$4}`;
const EVENT_SHOWN$4 = `shown${EVENT_KEY$4}`;
const EVENT_RESIZE$1 = `resize${EVENT_KEY$4}`;
const EVENT_CLICK_DISMISS = `click.dismiss${EVENT_KEY$4}`;
const EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${EVENT_KEY$4}`;
const EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${EVENT_KEY$4}`;
const EVENT_CLICK_DATA_API$2 = `click${EVENT_KEY$4}${DATA_API_KEY$2}`;
const CLASS_NAME_OPEN = "modal-open";
const CLASS_NAME_FADE$3 = "fade";
const CLASS_NAME_SHOW$4 = "show";
const CLASS_NAME_STATIC = "modal-static";
const OPEN_SELECTOR$1 = ".modal.show";
const SELECTOR_DIALOG = ".modal-dialog";
const SELECTOR_MODAL_BODY = ".modal-body";
const SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const DefaultType$6 = {
    backdrop: "(boolean|string)",
    focus: "boolean",
    keyboard: "boolean"
};
/**
 * Class definition
 */ class Modal extends BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = SelectorEngine.findOne(SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return Default$6;
    }
    static get DefaultType() {
        return DefaultType$6;
    }
    static get NAME() {
        return NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$4, {
            relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add(CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove(CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        EventHandler.off(window, EVENT_KEY$4);
        EventHandler.off(this._dialog, EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = "block";
        this._element.removeAttribute("aria-hidden");
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.scrollTop = 0;
        const modalBody = SelectorEngine.findOne(SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        reflow(this._element);
        this._element.classList.add(CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            EventHandler.trigger(this._element, EVENT_SHOWN$4, {
                relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        EventHandler.on(window, EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        EventHandler.on(this._element, EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            EventHandler.one(this._element, EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === "static") {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = "none";
        this._element.setAttribute("aria-hidden", true);
        this._element.removeAttribute("aria-modal");
        this._element.removeAttribute("role");
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove(CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            EventHandler.trigger(this._element, EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains(CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === "hidden" || this._element.classList.contains(CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = "hidden";
        this._element.classList.add(CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove(CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = isRTL() ? "paddingLeft" : "paddingRight";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = isRTL() ? "paddingRight" : "paddingLeft";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = "";
        this._element.style.paddingRight = "";
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = Modal.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ EventHandler.on(document, EVENT_CLICK_DATA_API$2, SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    EventHandler.one(target, EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        EventHandler.one(target, EVENT_HIDDEN$4, ()=>{
            if (isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = SelectorEngine.findOne(OPEN_SELECTOR$1);
    if (alreadyOpen) Modal.getInstance(alreadyOpen).hide();
    const data = Modal.getOrCreateInstance(target);
    data.toggle(this);
});
enableDismissTrigger(Modal);
/**
 * jQuery
 */ defineJQueryPlugin(Modal);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$6 = "offcanvas";
const DATA_KEY$3 = "bs.offcanvas";
const EVENT_KEY$3 = `.${DATA_KEY$3}`;
const DATA_API_KEY$1 = ".data-api";
const EVENT_LOAD_DATA_API$2 = `load${EVENT_KEY$3}${DATA_API_KEY$1}`;
const ESCAPE_KEY = "Escape";
const CLASS_NAME_SHOW$3 = "show";
const CLASS_NAME_SHOWING$1 = "showing";
const CLASS_NAME_HIDING = "hiding";
const CLASS_NAME_BACKDROP = "offcanvas-backdrop";
const OPEN_SELECTOR = ".offcanvas.show";
const EVENT_SHOW$3 = `show${EVENT_KEY$3}`;
const EVENT_SHOWN$3 = `shown${EVENT_KEY$3}`;
const EVENT_HIDE$3 = `hide${EVENT_KEY$3}`;
const EVENT_HIDE_PREVENTED = `hidePrevented${EVENT_KEY$3}`;
const EVENT_HIDDEN$3 = `hidden${EVENT_KEY$3}`;
const EVENT_RESIZE = `resize${EVENT_KEY$3}`;
const EVENT_CLICK_DATA_API$1 = `click${EVENT_KEY$3}${DATA_API_KEY$1}`;
const EVENT_KEYDOWN_DISMISS = `keydown.dismiss${EVENT_KEY$3}`;
const SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const DefaultType$5 = {
    backdrop: "(boolean|string)",
    keyboard: "boolean",
    scroll: "boolean"
};
/**
 * Class definition
 */ class Offcanvas extends BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return Default$5;
    }
    static get DefaultType() {
        return DefaultType$5;
    }
    static get NAME() {
        return NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$3, {
            relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new ScrollBarHelper().hide();
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.classList.add(CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add(CLASS_NAME_SHOW$3);
            this._element.classList.remove(CLASS_NAME_SHOWING$1);
            EventHandler.trigger(this._element, EVENT_SHOWN$3, {
                relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add(CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove(CLASS_NAME_SHOW$3, CLASS_NAME_HIDING);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            if (!this._config.scroll) new ScrollBarHelper().reset();
            EventHandler.trigger(this._element, EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === "static") {
                EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new Backdrop({
            className: CLASS_NAME_BACKDROP,
            isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Offcanvas.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ EventHandler.on(document, EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if (isDisabled(this)) return;
    EventHandler.one(target, EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if (isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = SelectorEngine.findOne(OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) Offcanvas.getInstance(alreadyOpen).hide();
    const data = Offcanvas.getOrCreateInstance(target);
    data.toggle(this);
});
EventHandler.on(window, EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of SelectorEngine.find(OPEN_SELECTOR))Offcanvas.getOrCreateInstance(selector).show();
});
EventHandler.on(window, EVENT_RESIZE, ()=>{
    for (const element of SelectorEngine.find("[aria-modal][class*=show][class*=offcanvas-]"))if (getComputedStyle(element).position !== "fixed") Offcanvas.getOrCreateInstance(element).hide();
});
enableDismissTrigger(Offcanvas);
/**
 * jQuery
 */ defineJQueryPlugin(Offcanvas);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    "*": [
        "class",
        "dir",
        "id",
        "lang",
        "role",
        ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        "target",
        "href",
        "title",
        "rel"
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        "src",
        "srcset",
        "alt",
        "title",
        "width",
        "height"
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const uriAttributes = new Set([
    "background",
    "cite",
    "href",
    "itemtype",
    "longdesc",
    "poster",
    "src",
    "xlink:href"
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
const SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if (uriAttributes.has(attributeName)) return Boolean(SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === "function") return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
    const elements = [].concat(...createdDocument.body.querySelectorAll("*"));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList["*"] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$5 = "TemplateFactory";
const Default$4 = {
    allowList: DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: "",
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: "<div></div>"
};
const DefaultType$4 = {
    allowList: "object",
    content: "object",
    extraClass: "(string|function)",
    html: "boolean",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    template: "string"
};
const DefaultContentType = {
    entry: "(string|element|function|null)",
    selector: "(string|element)"
};
/**
 * Class definition
 */ class TemplateFactory extends Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return Default$4;
    }
    static get DefaultType() {
        return DefaultType$4;
    }
    static get NAME() {
        return NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement("div");
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(" "));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector,
            entry: content
        }, DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if (isElement(content)) {
            this._putElementInTemplate(getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return execute(arg, [
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = "";
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$4 = "tooltip";
const DISALLOWED_ATTRIBUTES = new Set([
    "sanitize",
    "allowList",
    "sanitizeFn"
]);
const CLASS_NAME_FADE$2 = "fade";
const CLASS_NAME_MODAL = "modal";
const CLASS_NAME_SHOW$2 = "show";
const SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
const SELECTOR_MODAL = `.${CLASS_NAME_MODAL}`;
const EVENT_MODAL_HIDE = "hide.bs.modal";
const TRIGGER_HOVER = "hover";
const TRIGGER_FOCUS = "focus";
const TRIGGER_CLICK = "click";
const TRIGGER_MANUAL = "manual";
const EVENT_HIDE$2 = "hide";
const EVENT_HIDDEN$2 = "hidden";
const EVENT_SHOW$2 = "show";
const EVENT_SHOWN$2 = "shown";
const EVENT_INSERTED = "inserted";
const EVENT_CLICK$1 = "click";
const EVENT_FOCUSIN$1 = "focusin";
const EVENT_FOCUSOUT$1 = "focusout";
const EVENT_MOUSEENTER = "mouseenter";
const EVENT_MOUSELEAVE = "mouseleave";
const AttachmentMap = {
    AUTO: "auto",
    TOP: "top",
    RIGHT: isRTL() ? "left" : "right",
    BOTTOM: "bottom",
    LEFT: isRTL() ? "right" : "left"
};
const Default$3 = {
    allowList: DefaultAllowlist,
    animation: true,
    boundary: "clippingParents",
    container: false,
    customClass: "",
    delay: 0,
    fallbackPlacements: [
        "top",
        "right",
        "bottom",
        "left"
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: "top",
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: "",
    trigger: "hover focus"
};
const DefaultType$3 = {
    allowList: "object",
    animation: "boolean",
    boundary: "(string|element)",
    container: "(string|element|boolean)",
    customClass: "(string|function)",
    delay: "(number|object)",
    fallbackPlacements: "array",
    html: "boolean",
    offset: "(array|string|function)",
    placement: "(string|function)",
    popperConfig: "(null|object|function)",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    selector: "(string|boolean)",
    template: "string",
    title: "(string|element|function)",
    trigger: "string"
};
/**
 * Class definition
 */ class Tooltip extends BaseComponent {
    constructor(element, config){
        if (typeof _core === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return Default$3;
    }
    static get DefaultType() {
        return DefaultType$3;
    }
    static get NAME() {
        return NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        this._activeTrigger.click = !this._activeTrigger.click;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        EventHandler.off(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute("data-bs-original-title")) this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title"));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = EventHandler.trigger(this._element, this.constructor.eventName(EVENT_SHOW$2));
        const shadowRoot = findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute("aria-describedby", tip.getAttribute("id"));
        const { container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            EventHandler.trigger(this._element, this.constructor.eventName(EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add(CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))EventHandler.on(element, "mouseover", noop);
        const complete = ()=>{
            EventHandler.trigger(this._element, this.constructor.eventName(EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = EventHandler.trigger(this._element, this.constructor.eventName(EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove(CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))EventHandler.off(element, "mouseover", noop);
        this._activeTrigger[TRIGGER_CLICK] = false;
        this._activeTrigger[TRIGGER_FOCUS] = false;
        this._activeTrigger[TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute("aria-describedby");
            EventHandler.trigger(this._element, this.constructor.eventName(EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove(CLASS_NAME_FADE$2, CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = getUID(this.constructor.NAME).toString();
        tip.setAttribute("id", tipId);
        if (this._isAnimated()) tip.classList.add(CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new TemplateFactory({
            ...this._config,
            // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains(CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains(CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = AttachmentMap[placement.toUpperCase()];
        return _core.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return execute(arg, [
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: "flip",
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "arrow",
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: "preSetPlacement",
                    enabled: true,
                    phase: "beforeMain",
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute("data-popper-placement", data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(" ");
        for (const trigger of triggers){
            if (trigger === "click") EventHandler.on(this._element, this.constructor.eventName(EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== TRIGGER_MANUAL) {
                const eventIn = trigger === TRIGGER_HOVER ? this.constructor.eventName(EVENT_MOUSEENTER) : this.constructor.eventName(EVENT_FOCUSIN$1);
                const eventOut = trigger === TRIGGER_HOVER ? this.constructor.eventName(EVENT_MOUSELEAVE) : this.constructor.eventName(EVENT_FOCUSOUT$1);
                EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusin" ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
                    context._enter();
                });
                EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusout" ? TRIGGER_FOCUS : TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        EventHandler.on(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute("title");
        if (!title) return;
        if (!this._element.getAttribute("aria-label") && !this._element.textContent.trim()) this._element.setAttribute("aria-label", title);
        this._element.setAttribute("data-bs-original-title", title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute("title");
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if (DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === "object" && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : getElement(config.container);
        if (typeof config.delay === "number") config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === "number") config.title = config.title.toString();
        if (typeof config.content === "number") config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = "manual";
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Tooltip.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ defineJQueryPlugin(Tooltip);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$3 = "popover";
const SELECTOR_TITLE = ".popover-header";
const SELECTOR_CONTENT = ".popover-body";
const Default$2 = {
    ...Tooltip.Default,
    content: "",
    offset: [
        0,
        8
    ],
    placement: "right",
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: "click"
};
const DefaultType$2 = {
    ...Tooltip.DefaultType,
    content: "(null|string|element|function)"
};
/**
 * Class definition
 */ class Popover extends Tooltip {
    // Getters
    static get Default() {
        return Default$2;
    }
    static get DefaultType() {
        return DefaultType$2;
    }
    static get NAME() {
        return NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [SELECTOR_TITLE]: this._getTitle(),
            [SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Popover.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ defineJQueryPlugin(Popover);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$2 = "scrollspy";
const DATA_KEY$2 = "bs.scrollspy";
const EVENT_KEY$2 = `.${DATA_KEY$2}`;
const DATA_API_KEY = ".data-api";
const EVENT_ACTIVATE = `activate${EVENT_KEY$2}`;
const EVENT_CLICK = `click${EVENT_KEY$2}`;
const EVENT_LOAD_DATA_API$1 = `load${EVENT_KEY$2}${DATA_API_KEY}`;
const CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
const CLASS_NAME_ACTIVE$1 = "active";
const SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const SELECTOR_TARGET_LINKS = "[href]";
const SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
const SELECTOR_NAV_LINKS = ".nav-link";
const SELECTOR_NAV_ITEMS = ".nav-item";
const SELECTOR_LIST_ITEMS = ".list-group-item";
const SELECTOR_LINK_ITEMS = `${SELECTOR_NAV_LINKS}, ${SELECTOR_NAV_ITEMS} > ${SELECTOR_NAV_LINKS}, ${SELECTOR_LIST_ITEMS}`;
const SELECTOR_DROPDOWN = ".dropdown";
const SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
const Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "0px 0px -25%",
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const DefaultType$1 = {
    offset: "(number|null)",
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "string",
    smoothScroll: "boolean",
    target: "element",
    threshold: "array"
};
/**
 * Class definition
 */ class ScrollSpy extends BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return Default$1;
    }
    static get DefaultType() {
        return DefaultType$1;
    }
    static get NAME() {
        return NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === "string") config.threshold = config.threshold.split(",").map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        EventHandler.off(this._config.target, EVENT_CLICK);
        EventHandler.on(this._config.target, EVENT_CLICK, SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: "smooth"
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = SelectorEngine.find(SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || isDisabled(anchor)) continue;
            const observableSection = SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if (isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add(CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        EventHandler.trigger(this._element, EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains(CLASS_NAME_DROPDOWN_ITEM)) {
            SelectorEngine.findOne(SELECTOR_DROPDOWN_TOGGLE$1, target.closest(SELECTOR_DROPDOWN)).classList.add(CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of SelectorEngine.parents(target, SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of SelectorEngine.prev(listGroup, SELECTOR_LINK_ITEMS))item.classList.add(CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove(CLASS_NAME_ACTIVE$1);
        const activeNodes = SelectorEngine.find(`${SELECTOR_TARGET_LINKS}.${CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove(CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = ScrollSpy.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ EventHandler.on(window, EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of SelectorEngine.find(SELECTOR_DATA_SPY))ScrollSpy.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ defineJQueryPlugin(ScrollSpy);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$1 = "tab";
const DATA_KEY$1 = "bs.tab";
const EVENT_KEY$1 = `.${DATA_KEY$1}`;
const EVENT_HIDE$1 = `hide${EVENT_KEY$1}`;
const EVENT_HIDDEN$1 = `hidden${EVENT_KEY$1}`;
const EVENT_SHOW$1 = `show${EVENT_KEY$1}`;
const EVENT_SHOWN$1 = `shown${EVENT_KEY$1}`;
const EVENT_CLICK_DATA_API = `click${EVENT_KEY$1}`;
const EVENT_KEYDOWN = `keydown${EVENT_KEY$1}`;
const EVENT_LOAD_DATA_API = `load${EVENT_KEY$1}`;
const ARROW_LEFT_KEY = "ArrowLeft";
const ARROW_RIGHT_KEY = "ArrowRight";
const ARROW_UP_KEY = "ArrowUp";
const ARROW_DOWN_KEY = "ArrowDown";
const CLASS_NAME_ACTIVE = "active";
const CLASS_NAME_FADE$1 = "fade";
const CLASS_NAME_SHOW$1 = "show";
const CLASS_DROPDOWN = "dropdown";
const SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
const SELECTOR_DROPDOWN_MENU = ".dropdown-menu";
const NOT_SELECTOR_DROPDOWN_TOGGLE = ":not(.dropdown-toggle)";
const SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const SELECTOR_OUTER = ".nav-item, .list-group-item";
const SELECTOR_INNER = `.nav-link${NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const SELECTOR_INNER_ELEM = `${SELECTOR_INNER}, ${SELECTOR_DATA_TOGGLE}`;
const SELECTOR_DATA_TOGGLE_ACTIVE = `.${CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class Tab extends BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest(SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        EventHandler.on(this._element, EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? EventHandler.trigger(active, EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = EventHandler.trigger(innerElem, EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add(CLASS_NAME_ACTIVE);
        this._activate(SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.add(CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute("tabindex");
            element.setAttribute("aria-selected", true);
            this._toggleDropDown(element, true);
            EventHandler.trigger(element, EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains(CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove(CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate(SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.remove(CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute("aria-selected", false);
            element.setAttribute("tabindex", "-1");
            this._toggleDropDown(element, false);
            EventHandler.trigger(element, EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains(CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            ARROW_LEFT_KEY,
            ARROW_RIGHT_KEY,
            ARROW_UP_KEY,
            ARROW_DOWN_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const isNext = [
            ARROW_RIGHT_KEY,
            ARROW_DOWN_KEY
        ].includes(event.key);
        const nextActiveElement = getNextActiveElement(this._getChildren().filter((element)=>!isDisabled(element)), event.target, isNext, true);
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            Tab.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return SelectorEngine.find(SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, "role", "tablist");
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute("aria-selected", isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, "role", "presentation");
        if (!isActive) child.setAttribute("tabindex", "-1");
        this._setAttributeIfNotExists(child, "role", "tab");
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, "role", "tabpanel");
        if (child.id) this._setAttributeIfNotExists(target, "aria-labelledby", `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains(CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle(SELECTOR_DROPDOWN_TOGGLE, CLASS_NAME_ACTIVE);
        toggle(SELECTOR_DROPDOWN_MENU, CLASS_NAME_SHOW$1);
        outerElem.setAttribute("aria-expanded", open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains(CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches(SELECTOR_INNER_ELEM) ? elem : SelectorEngine.findOne(SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest(SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Tab.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ EventHandler.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if (isDisabled(this)) return;
    Tab.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ EventHandler.on(window, EVENT_LOAD_DATA_API, ()=>{
    for (const element of SelectorEngine.find(SELECTOR_DATA_TOGGLE_ACTIVE))Tab.getOrCreateInstance(element);
});
/**
 * jQuery
 */ defineJQueryPlugin(Tab);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME = "toast";
const DATA_KEY = "bs.toast";
const EVENT_KEY = `.${DATA_KEY}`;
const EVENT_MOUSEOVER = `mouseover${EVENT_KEY}`;
const EVENT_MOUSEOUT = `mouseout${EVENT_KEY}`;
const EVENT_FOCUSIN = `focusin${EVENT_KEY}`;
const EVENT_FOCUSOUT = `focusout${EVENT_KEY}`;
const EVENT_HIDE = `hide${EVENT_KEY}`;
const EVENT_HIDDEN = `hidden${EVENT_KEY}`;
const EVENT_SHOW = `show${EVENT_KEY}`;
const EVENT_SHOWN = `shown${EVENT_KEY}`;
const CLASS_NAME_FADE = "fade";
const CLASS_NAME_HIDE = "hide"; // @deprecated - kept here only for backwards compatibility
const CLASS_NAME_SHOW = "show";
const CLASS_NAME_SHOWING = "showing";
const DefaultType = {
    animation: "boolean",
    autohide: "boolean",
    delay: "number"
};
const Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class Toast extends BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return Default;
    }
    static get DefaultType() {
        return DefaultType;
    }
    static get NAME() {
        return NAME;
    }
    // Public
    show() {
        const showEvent = EventHandler.trigger(this._element, EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add(CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove(CLASS_NAME_SHOWING);
            EventHandler.trigger(this._element, EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove(CLASS_NAME_HIDE); // @deprecated
        reflow(this._element);
        this._element.classList.add(CLASS_NAME_SHOW, CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add(CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove(CLASS_NAME_SHOWING, CLASS_NAME_SHOW);
            EventHandler.trigger(this._element, EVENT_HIDDEN);
        };
        this._element.classList.add(CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove(CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains(CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case "mouseover":
            case "mouseout":
                this._hasMouseInteraction = isInteracting;
                break;
            case "focusin":
            case "focusout":
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        EventHandler.on(this._element, EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        EventHandler.on(this._element, EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        EventHandler.on(this._element, EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        EventHandler.on(this._element, EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Toast.getOrCreateInstance(this, config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ enableDismissTrigger(Toast);
/**
 * jQuery
 */ defineJQueryPlugin(Toast);

},{"@popperjs/core":"lJ8zG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lJ8zG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
parcelHelpers.export(exports, "createPopperBase", ()=>(0, _createPopperJs.createPopper));
parcelHelpers.export(exports, "createPopper", ()=>(0, _popperJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper));
var _enumsJs = require("./enums.js");
parcelHelpers.exportAll(_enumsJs, exports);
var _indexJs = require("./modifiers/index.js"); // eslint-disable-next-line import/no-unused-modules
parcelHelpers.exportAll(_indexJs, exports);
var _createPopperJs = require("./createPopper.js");
var _popperJs = require("./popper.js");
var _popperLiteJs = require("./popper-lite.js");

},{"./enums.js":"aVHEw","./modifiers/index.js":"cTWLz","./createPopper.js":"5bix2","./popper.js":"9PKmn","./popper-lite.js":"jbutu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aVHEw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "top", ()=>top);
parcelHelpers.export(exports, "bottom", ()=>bottom);
parcelHelpers.export(exports, "right", ()=>right);
parcelHelpers.export(exports, "left", ()=>left);
parcelHelpers.export(exports, "auto", ()=>auto);
parcelHelpers.export(exports, "basePlacements", ()=>basePlacements);
parcelHelpers.export(exports, "start", ()=>start);
parcelHelpers.export(exports, "end", ()=>end);
parcelHelpers.export(exports, "clippingParents", ()=>clippingParents);
parcelHelpers.export(exports, "viewport", ()=>viewport);
parcelHelpers.export(exports, "popper", ()=>popper);
parcelHelpers.export(exports, "reference", ()=>reference);
parcelHelpers.export(exports, "variationPlacements", ()=>variationPlacements);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "beforeRead", ()=>beforeRead);
parcelHelpers.export(exports, "read", ()=>read);
parcelHelpers.export(exports, "afterRead", ()=>afterRead);
parcelHelpers.export(exports, "beforeMain", ()=>beforeMain);
parcelHelpers.export(exports, "main", ()=>main);
parcelHelpers.export(exports, "afterMain", ()=>afterMain);
parcelHelpers.export(exports, "beforeWrite", ()=>beforeWrite);
parcelHelpers.export(exports, "write", ()=>write);
parcelHelpers.export(exports, "afterWrite", ()=>afterWrite);
parcelHelpers.export(exports, "modifierPhases", ()=>modifierPhases);
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [
    top,
    bottom,
    right,
    left
];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []);
var placements = /*#__PURE__*/ [].concat(basePlacements, [
    auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []); // modifiers that need to read the DOM
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead"; // pure-logic modifiers
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [
    beforeRead,
    read,
    afterRead,
    beforeMain,
    main,
    afterMain,
    beforeWrite,
    write,
    afterWrite
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cTWLz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyStyles", ()=>(0, _applyStylesJsDefault.default));
parcelHelpers.export(exports, "arrow", ()=>(0, _arrowJsDefault.default));
parcelHelpers.export(exports, "computeStyles", ()=>(0, _computeStylesJsDefault.default));
parcelHelpers.export(exports, "eventListeners", ()=>(0, _eventListenersJsDefault.default));
parcelHelpers.export(exports, "flip", ()=>(0, _flipJsDefault.default));
parcelHelpers.export(exports, "hide", ()=>(0, _hideJsDefault.default));
parcelHelpers.export(exports, "offset", ()=>(0, _offsetJsDefault.default));
parcelHelpers.export(exports, "popperOffsets", ()=>(0, _popperOffsetsJsDefault.default));
parcelHelpers.export(exports, "preventOverflow", ()=>(0, _preventOverflowJsDefault.default));
var _applyStylesJs = require("./applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var _arrowJs = require("./arrow.js");
var _arrowJsDefault = parcelHelpers.interopDefault(_arrowJs);
var _computeStylesJs = require("./computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _eventListenersJs = require("./eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _flipJs = require("./flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _hideJs = require("./hide.js");
var _hideJsDefault = parcelHelpers.interopDefault(_hideJs);
var _offsetJs = require("./offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
var _popperOffsetsJs = require("./popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _preventOverflowJs = require("./preventOverflow.js");
var _preventOverflowJsDefault = parcelHelpers.interopDefault(_preventOverflowJs);

},{"./applyStyles.js":"axnJn","./arrow.js":"013Ka","./computeStyles.js":"cicmq","./eventListeners.js":"jlw8n","./flip.js":"d52GI","./hide.js":"04i94","./offset.js":"4U7Nh","./popperOffsets.js":"c9hkC","./preventOverflow.js":"e2LIN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"axnJn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNodeNameJs = require("../dom-utils/getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("../dom-utils/instanceOf.js"); // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow
function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: applyStyles,
    effect: effect,
    requires: [
        "computeStyles"
    ]
};

},{"../dom-utils/getNodeName.js":"ieVOk","../dom-utils/instanceOf.js":"2T0o5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ieVOk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeName);
function getNodeName(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2T0o5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function isElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, _getWindowJsDefault.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

},{"./getWindow.js":"dfve1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dfve1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindow);
function getWindow(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"013Ka":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _containsJs = require("../dom-utils/contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _withinJs = require("../utils/within.js");
var _mergePaddingObjectJs = require("../utils/mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("../utils/expandToHashMap.js");
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, _mergePaddingObjectJsDefault.default)(typeof padding !== "number" ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
};
function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var axis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var isVertical = [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = (0, _getLayoutRectJsDefault.default)(arrowElement);
    var minProp = axis === "y" ? (0, _enumsJs.top) : (0, _enumsJs.left);
    var maxProp = axis === "y" ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, _getOffsetParentJsDefault.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, _withinJs.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, _containsJsDefault.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: arrow,
    effect: effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

},{"../utils/getBasePlacement.js":"9MJkV","../dom-utils/getLayoutRect.js":"kG7jY","../dom-utils/contains.js":"7L99u","../dom-utils/getOffsetParent.js":"bwrIe","../utils/getMainAxisFromPlacement.js":"g9UdY","../utils/within.js":"jZfhy","../utils/mergePaddingObject.js":"5ChzK","../utils/expandToHashMap.js":"cjMxw","../enums.js":"aVHEw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9MJkV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBasePlacement);
var _enumsJs = require("../enums.js");
function getBasePlacement(placement) {
    return placement.split("-")[0];
}

},{"../enums.js":"aVHEw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kG7jY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getLayoutRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js"); // Returns the layout rect of an element relative to its offsetParent. Layout
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
function getLayoutRect(element) {
    var clientRect = (0, _getBoundingClientRectJsDefault.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

},{"./getBoundingClientRect.js":"7Xusb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Xusb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBoundingClientRect);
var _instanceOfJs = require("./instanceOf.js");
var _mathJs = require("../utils/math.js");
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, _instanceOfJs.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, _mathJs.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, _mathJs.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, _instanceOfJs.isElement)(element) ? (0, _getWindowJsDefault.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, _isLayoutViewportJsDefault.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

},{"./instanceOf.js":"2T0o5","../utils/math.js":"dciKy","./getWindow.js":"dfve1","./isLayoutViewport.js":"eFy6F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dciKy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "round", ()=>round);
var max = Math.max;
var min = Math.min;
var round = Math.round;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eFy6F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isLayoutViewport);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test((0, _userAgentJsDefault.default)());
}

},{"../utils/userAgent.js":"dJQYM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dJQYM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUAString);
function getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7L99u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>contains);
var _instanceOfJs = require("./instanceOf.js");
function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, _instanceOfJs.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

},{"./instanceOf.js":"2T0o5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bwrIe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOffsetParent);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _isTableElementJs = require("./isTableElement.js");
var _isTableElementJsDefault = parcelHelpers.interopDefault(_isTableElementJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function getTrueOffsetParent(element) {
    if (!(0, _instanceOfJs.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, _getComputedStyleJsDefault.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, _userAgentJsDefault.default)());
    var isIE = /Trident/i.test((0, _userAgentJsDefault.default)());
    if (isIE && (0, _instanceOfJs.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, _getComputedStyleJsDefault.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, _getParentNodeJsDefault.default)(element);
    if ((0, _instanceOfJs.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, _instanceOfJs.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, _getNodeNameJsDefault.default)(currentNode)) < 0){
        var css = (0, _getComputedStyleJsDefault.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function getOffsetParent(element) {
    var window = (0, _getWindowJsDefault.default)(element);
    var offsetParent = getTrueOffsetParent(element);
    while(offsetParent && (0, _isTableElementJsDefault.default)(offsetParent) && (0, _getComputedStyleJsDefault.default)(offsetParent).position === "static")offsetParent = getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, _getNodeNameJsDefault.default)(offsetParent) === "html" || (0, _getNodeNameJsDefault.default)(offsetParent) === "body" && (0, _getComputedStyleJsDefault.default)(offsetParent).position === "static")) return window;
    return offsetParent || getContainingBlock(element) || window;
}

},{"./getWindow.js":"dfve1","./getNodeName.js":"ieVOk","./getComputedStyle.js":"e5Z6G","./instanceOf.js":"2T0o5","./isTableElement.js":"hdQlE","./getParentNode.js":"3lnhM","../utils/userAgent.js":"dJQYM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e5Z6G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getComputedStyle);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getComputedStyle(element) {
    return (0, _getWindowJsDefault.default)(element).getComputedStyle(element);
}

},{"./getWindow.js":"dfve1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hdQlE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isTableElement);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
function isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, _getNodeNameJsDefault.default)(element)) >= 0;
}

},{"./getNodeName.js":"ieVOk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3lnhM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getParentNode);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _instanceOfJs = require("./instanceOf.js");
function getParentNode(element) {
    if ((0, _getNodeNameJsDefault.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, _instanceOfJs.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, _getDocumentElementJsDefault.default)(element) // fallback
    );
}

},{"./getNodeName.js":"ieVOk","./getDocumentElement.js":"6Q5T4","./instanceOf.js":"2T0o5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Q5T4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentElement);
var _instanceOfJs = require("./instanceOf.js");
function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, _instanceOfJs.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

},{"./instanceOf.js":"2T0o5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g9UdY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMainAxisFromPlacement);
function getMainAxisFromPlacement(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jZfhy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "within", ()=>within);
parcelHelpers.export(exports, "withinMaxClamp", ()=>withinMaxClamp);
var _mathJs = require("./math.js");
function within(min, value, max) {
    return (0, _mathJs.max)(min, (0, _mathJs.min)(value, max));
}
function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
}

},{"./math.js":"dciKy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5ChzK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergePaddingObject);
var _getFreshSideObjectJs = require("./getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
function mergePaddingObject(paddingObject) {
    return Object.assign({}, (0, _getFreshSideObjectJsDefault.default)(), paddingObject);
}

},{"./getFreshSideObject.js":"fSN4P","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fSN4P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getFreshSideObject);
function getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cjMxw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>expandToHashMap);
function expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cicmq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapToStyles", ()=>mapToStyles);
var _enumsJs = require("../enums.js");
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getWindowJs = require("../dom-utils/getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("../dom-utils/getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _mathJs = require("../utils/math.js"); // eslint-disable-next-line import/no-unused-modules
var unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, _mathJs.round)(x * dpr) / dpr || 0,
        y: (0, _mathJs.round)(y * dpr) / dpr || 0
    };
}
function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, _enumsJs.left);
    var sideY = (0, _enumsJs.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, _getOffsetParentJsDefault.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, _getWindowJsDefault.default)(popper)) {
            offsetParent = (0, _getDocumentElementJsDefault.default)(popper);
            if ((0, _getComputedStyleJsDefault.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, _enumsJs.top) || (placement === (0, _enumsJs.left) || placement === (0, _enumsJs.right)) && variation === (0, _enumsJs.end)) {
            sideY = (0, _enumsJs.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, _enumsJs.left) || (placement === (0, _enumsJs.top) || placement === (0, _enumsJs.bottom)) && variation === (0, _enumsJs.end)) {
            sideX = (0, _enumsJs.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && unsetSides);
    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, _getWindowJsDefault.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, _getBasePlacementJsDefault.default)(state.placement),
        variation: (0, _getVariationJsDefault.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: computeStyles,
    data: {}
};

},{"../enums.js":"aVHEw","../dom-utils/getOffsetParent.js":"bwrIe","../dom-utils/getWindow.js":"dfve1","../dom-utils/getDocumentElement.js":"6Q5T4","../dom-utils/getComputedStyle.js":"e5Z6G","../utils/getBasePlacement.js":"9MJkV","../utils/getVariation.js":"ffjaD","../utils/math.js":"dciKy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ffjaD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getVariation);
function getVariation(placement) {
    return placement.split("-")[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jlw8n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getWindowJs = require("../dom-utils/getWindow.js"); // eslint-disable-next-line import/no-unused-modules
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var passive = {
    passive: true
};
function effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, _getWindowJsDefault.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, passive);
    });
    if (resize) window.addEventListener("resize", instance.update, passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, passive);
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: effect,
    data: {}
};

},{"../dom-utils/getWindow.js":"dfve1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d52GI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getOppositePlacementJs = require("../utils/getOppositePlacement.js");
var _getOppositePlacementJsDefault = parcelHelpers.interopDefault(_getOppositePlacementJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getOppositeVariationPlacementJs = require("../utils/getOppositeVariationPlacement.js");
var _getOppositeVariationPlacementJsDefault = parcelHelpers.interopDefault(_getOppositeVariationPlacementJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _computeAutoPlacementJs = require("../utils/computeAutoPlacement.js");
var _computeAutoPlacementJsDefault = parcelHelpers.interopDefault(_computeAutoPlacementJs);
var _enumsJs = require("../enums.js");
var _getVariationJs = require("../utils/getVariation.js"); // eslint-disable-next-line import/no-unused-modules
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
function getExpandedFallbackPlacements(placement) {
    if ((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto)) return [];
    var oppositePlacement = (0, _getOppositePlacementJsDefault.default)(placement);
    return [
        (0, _getOppositeVariationPlacementJsDefault.default)(placement),
        oppositePlacement,
        (0, _getOppositeVariationPlacementJsDefault.default)(oppositePlacement)
    ];
}
function flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, _getOppositePlacementJsDefault.default)(preferredPlacement)
    ] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto) ? (0, _computeAutoPlacementJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
        var isStartVariation = (0, _getVariationJsDefault.default)(placement) === (0, _enumsJs.start);
        var isVertical = [
            (0, _enumsJs.top),
            (0, _enumsJs.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, _enumsJs.right) : (0, _enumsJs.left) : isStartVariation ? (0, _enumsJs.bottom) : (0, _enumsJs.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var altVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

},{"../utils/getOppositePlacement.js":"6YTF4","../utils/getBasePlacement.js":"9MJkV","../utils/getOppositeVariationPlacement.js":"geQZR","../utils/detectOverflow.js":"b9d7D","../utils/computeAutoPlacement.js":"1nCo5","../enums.js":"aVHEw","../utils/getVariation.js":"ffjaD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6YTF4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositePlacement);
var hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"geQZR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositeVariationPlacement);
var hash = {
    start: "end",
    end: "start"
};
function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b9d7D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>detectOverflow);
var _getClippingRectJs = require("../dom-utils/getClippingRect.js");
var _getClippingRectJsDefault = parcelHelpers.interopDefault(_getClippingRectJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getBoundingClientRectJs = require("../dom-utils/getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _computeOffsetsJs = require("./computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
var _rectToClientRectJs = require("./rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _enumsJs = require("../enums.js");
var _instanceOfJs = require("../dom-utils/instanceOf.js");
var _mergePaddingObjectJs = require("./mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("./expandToHashMap.js"); // eslint-disable-next-line import/no-unused-modules
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
function detectOverflow(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, _enumsJs.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, _enumsJs.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, _enumsJs.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, _mergePaddingObjectJsDefault.default)(typeof padding !== "number" ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
    var altContext = elementContext === (0, _enumsJs.popper) ? (0, _enumsJs.reference) : (0, _enumsJs.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, _getClippingRectJsDefault.default)((0, _instanceOfJs.isElement)(element) ? element : element.contextElement || (0, _getDocumentElementJsDefault.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, _getBoundingClientRectJsDefault.default)(state.elements.reference);
    var popperOffsets = (0, _computeOffsetsJsDefault.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, _rectToClientRectJsDefault.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, _enumsJs.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, _enumsJs.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, _enumsJs.right),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, _enumsJs.top),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

},{"../dom-utils/getClippingRect.js":"co3QM","../dom-utils/getDocumentElement.js":"6Q5T4","../dom-utils/getBoundingClientRect.js":"7Xusb","./computeOffsets.js":"avGZq","./rectToClientRect.js":"dTyTB","../enums.js":"aVHEw","../dom-utils/instanceOf.js":"2T0o5","./mergePaddingObject.js":"5ChzK","./expandToHashMap.js":"cjMxw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"co3QM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getClippingRect);
var _enumsJs = require("../enums.js");
var _getViewportRectJs = require("./getViewportRect.js");
var _getViewportRectJsDefault = parcelHelpers.interopDefault(_getViewportRectJs);
var _getDocumentRectJs = require("./getDocumentRect.js");
var _getDocumentRectJsDefault = parcelHelpers.interopDefault(_getDocumentRectJs);
var _listScrollParentsJs = require("./listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _rectToClientRectJs = require("../utils/rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _mathJs = require("../utils/math.js");
function getInnerBoundingClientRect(element, strategy) {
    var rect = (0, _getBoundingClientRectJsDefault.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, _enumsJs.viewport) ? (0, _rectToClientRectJsDefault.default)((0, _getViewportRectJsDefault.default)(element, strategy)) : (0, _instanceOfJs.isElement)(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : (0, _rectToClientRectJsDefault.default)((0, _getDocumentRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function getClippingParents(element) {
    var clippingParents = (0, _listScrollParentsJsDefault.default)((0, _getParentNodeJsDefault.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, _getComputedStyleJsDefault.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, _instanceOfJs.isHTMLElement)(element) ? (0, _getOffsetParentJsDefault.default)(element) : element;
    if (!(0, _instanceOfJs.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, _instanceOfJs.isElement)(clippingParent) && (0, _containsJsDefault.default)(clippingParent, clipperElement) && (0, _getNodeNameJsDefault.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, _mathJs.max)(rect.top, accRect.top);
        accRect.right = (0, _mathJs.min)(rect.right, accRect.right);
        accRect.bottom = (0, _mathJs.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _mathJs.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

},{"../enums.js":"aVHEw","./getViewportRect.js":"hGVzr","./getDocumentRect.js":"6IHKV","./listScrollParents.js":"hfcbR","./getOffsetParent.js":"bwrIe","./getDocumentElement.js":"6Q5T4","./getComputedStyle.js":"e5Z6G","./instanceOf.js":"2T0o5","./getBoundingClientRect.js":"7Xusb","./getParentNode.js":"3lnhM","./contains.js":"7L99u","./getNodeName.js":"ieVOk","../utils/rectToClientRect.js":"dTyTB","../utils/math.js":"dciKy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hGVzr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getViewportRect);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getViewportRect(element, strategy) {
    var win = (0, _getWindowJsDefault.default)(element);
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, _isLayoutViewportJsDefault.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, _getWindowScrollBarXJsDefault.default)(element),
        y: y
    };
}

},{"./getWindow.js":"dfve1","./getDocumentElement.js":"6Q5T4","./getWindowScrollBarX.js":"lXicm","./isLayoutViewport.js":"eFy6F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lXicm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScrollBarX);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, _getBoundingClientRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)).left + (0, _getWindowScrollJsDefault.default)(element).scrollLeft;
}

},{"./getBoundingClientRect.js":"7Xusb","./getDocumentElement.js":"6Q5T4","./getWindowScroll.js":"7Wym7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Wym7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScroll);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getWindowScroll(node) {
    var win = (0, _getWindowJsDefault.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

},{"./getWindow.js":"dfve1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6IHKV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentRect);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _mathJs = require("../utils/math.js"); // Gets the entire size of the scrollable document area, even extending outside
function getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var winScroll = (0, _getWindowScrollJsDefault.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, _mathJs.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, _mathJs.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, _getWindowScrollBarXJsDefault.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, _getComputedStyleJsDefault.default)(body || html).direction === "rtl") x += (0, _mathJs.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

},{"./getDocumentElement.js":"6Q5T4","./getComputedStyle.js":"e5Z6G","./getWindowScrollBarX.js":"lXicm","./getWindowScroll.js":"7Wym7","../utils/math.js":"dciKy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hfcbR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>listScrollParents);
var _getScrollParentJs = require("./getScrollParent.js");
var _getScrollParentJsDefault = parcelHelpers.interopDefault(_getScrollParentJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, _getScrollParentJsDefault.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, _getWindowJsDefault.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, _isScrollParentJsDefault.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat(listScrollParents((0, _getParentNodeJsDefault.default)(target)));
}

},{"./getScrollParent.js":"2cf06","./getParentNode.js":"3lnhM","./getWindow.js":"dfve1","./isScrollParent.js":"fFR6W","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2cf06":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getScrollParent);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
function getScrollParent(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, _getNodeNameJsDefault.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, _instanceOfJs.isHTMLElement)(node) && (0, _isScrollParentJsDefault.default)(node)) return node;
    return getScrollParent((0, _getParentNodeJsDefault.default)(node));
}

},{"./getParentNode.js":"3lnhM","./isScrollParent.js":"fFR6W","./getNodeName.js":"ieVOk","./instanceOf.js":"2T0o5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fFR6W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isScrollParent);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, _getComputedStyleJsDefault.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

},{"./getComputedStyle.js":"e5Z6G","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dTyTB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rectToClientRect);
function rectToClientRect(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"avGZq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeOffsets);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getMainAxisFromPlacementJs = require("./getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _enumsJs = require("../enums.js");
function computeOffsets(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, _getBasePlacementJsDefault.default)(placement) : null;
    var variation = placement ? (0, _getVariationJsDefault.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, _enumsJs.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, _enumsJs.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, _enumsJs.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, _enumsJs.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, _enumsJs.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, _enumsJs.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

},{"./getBasePlacement.js":"9MJkV","./getVariation.js":"ffjaD","./getMainAxisFromPlacement.js":"g9UdY","../enums.js":"aVHEw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1nCo5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeAutoPlacement);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("./detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
function computeAutoPlacement(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, _enumsJs.placements) : _options$allowedAutoP;
    var variation = (0, _getVariationJsDefault.default)(placement);
    var placements = variation ? flipVariations ? (0, _enumsJs.variationPlacements) : (0, _enumsJs.variationPlacements).filter(function(placement) {
        return (0, _getVariationJsDefault.default)(placement) === variation;
    }) : (0, _enumsJs.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, _getBasePlacementJsDefault.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

},{"./getVariation.js":"ffjaD","../enums.js":"aVHEw","./detectOverflow.js":"b9d7D","./getBasePlacement.js":"9MJkV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"04i94":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function isAnySideFullyClipped(overflow) {
    return [
        (0, _enumsJs.top),
        (0, _enumsJs.right),
        (0, _enumsJs.bottom),
        (0, _enumsJs.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, _detectOverflowJsDefault.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, _detectOverflowJsDefault.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: hide
};

},{"../enums.js":"aVHEw","../utils/detectOverflow.js":"b9d7D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4U7Nh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distanceAndSkiddingToXY", ()=>distanceAndSkiddingToXY);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
    var invertDistance = [
        (0, _enumsJs.left),
        (0, _enumsJs.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, _enumsJs.placements).reduce(function(acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: offset
};

},{"../utils/getBasePlacement.js":"9MJkV","../enums.js":"aVHEw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c9hkC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _computeOffsetsJs = require("../utils/computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
function popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, _computeOffsetsJsDefault.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: popperOffsets,
    data: {}
};

},{"../utils/computeOffsets.js":"avGZq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e2LIN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _getAltAxisJs = require("../utils/getAltAxis.js");
var _getAltAxisJsDefault = parcelHelpers.interopDefault(_getAltAxisJs);
var _withinJs = require("../utils/within.js");
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getFreshSideObjectJs = require("../utils/getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
var _mathJs = require("../utils/math.js");
function preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, _detectOverflowJsDefault.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var variation = (0, _getVariationJsDefault.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var altAxis = (0, _getAltAxisJsDefault.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var altSide = mainAxis === "y" ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, _enumsJs.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, _enumsJs.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, _getLayoutRectJsDefault.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, _getFreshSideObjectJsDefault.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, _withinJs.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, _getOffsetParentJsDefault.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, _withinJs.within)(tether ? (0, _mathJs.min)(min, tetherMin) : min, offset, tether ? (0, _mathJs.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var _altSide = mainAxis === "x" ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, _enumsJs.top),
            (0, _enumsJs.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, _withinJs.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, _withinJs.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

},{"../enums.js":"aVHEw","../utils/getBasePlacement.js":"9MJkV","../utils/getMainAxisFromPlacement.js":"g9UdY","../utils/getAltAxis.js":"7EpoZ","../utils/within.js":"jZfhy","../dom-utils/getLayoutRect.js":"kG7jY","../dom-utils/getOffsetParent.js":"bwrIe","../utils/detectOverflow.js":"b9d7D","../utils/getVariation.js":"ffjaD","../utils/getFreshSideObject.js":"fSN4P","../utils/math.js":"dciKy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7EpoZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getAltAxis);
function getAltAxis(axis) {
    return axis === "x" ? "y" : "x";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5bix2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>popperGenerator);
parcelHelpers.export(exports, "createPopper", ()=>createPopper);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _detectOverflowJsDefault.default));
var _getCompositeRectJs = require("./dom-utils/getCompositeRect.js");
var _getCompositeRectJsDefault = parcelHelpers.interopDefault(_getCompositeRectJs);
var _getLayoutRectJs = require("./dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _listScrollParentsJs = require("./dom-utils/listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _orderModifiersJs = require("./utils/orderModifiers.js");
var _orderModifiersJsDefault = parcelHelpers.interopDefault(_orderModifiersJs);
var _debounceJs = require("./utils/debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _mergeByNameJs = require("./utils/mergeByName.js");
var _mergeByNameJsDefault = parcelHelpers.interopDefault(_mergeByNameJs);
var _detectOverflowJs = require("./utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _instanceOfJs = require("./dom-utils/instanceOf.js");
var DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, _instanceOfJs.isElement)(reference) ? (0, _listScrollParentsJsDefault.default)(reference) : reference.contextElement ? (0, _listScrollParentsJsDefault.default)(reference.contextElement) : [],
                    popper: (0, _listScrollParentsJsDefault.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, _orderModifiersJsDefault.default)((0, _mergeByNameJsDefault.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, _getCompositeRectJsDefault.default)(reference, (0, _getOffsetParentJsDefault.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, _getLayoutRectJsDefault.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, _debounceJsDefault.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var createPopper = /*#__PURE__*/ popperGenerator(); // eslint-disable-next-line import/no-unused-modules

},{"./dom-utils/getCompositeRect.js":"j9xOu","./dom-utils/getLayoutRect.js":"kG7jY","./dom-utils/listScrollParents.js":"hfcbR","./dom-utils/getOffsetParent.js":"bwrIe","./utils/orderModifiers.js":"djBhV","./utils/debounce.js":"7uJdm","./utils/mergeByName.js":"3LgOA","./utils/detectOverflow.js":"b9d7D","./dom-utils/instanceOf.js":"2T0o5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j9xOu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getCompositeRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getNodeScrollJs = require("./getNodeScroll.js");
var _getNodeScrollJsDefault = parcelHelpers.interopDefault(_getNodeScrollJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _mathJs = require("../utils/math.js");
function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, _mathJs.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, _mathJs.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, _instanceOfJs.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, _instanceOfJs.isHTMLElement)(offsetParent) && isElementScaled(offsetParent);
    var documentElement = (0, _getDocumentElementJsDefault.default)(offsetParent);
    var rect = (0, _getBoundingClientRectJsDefault.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _getNodeNameJsDefault.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, _isScrollParentJsDefault.default)(documentElement)) scroll = (0, _getNodeScrollJsDefault.default)(offsetParent);
        if ((0, _instanceOfJs.isHTMLElement)(offsetParent)) {
            offsets = (0, _getBoundingClientRectJsDefault.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, _getWindowScrollBarXJsDefault.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

},{"./getBoundingClientRect.js":"7Xusb","./getNodeScroll.js":"FfOIL","./getNodeName.js":"ieVOk","./instanceOf.js":"2T0o5","./getWindowScrollBarX.js":"lXicm","./getDocumentElement.js":"6Q5T4","./isScrollParent.js":"fFR6W","../utils/math.js":"dciKy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"FfOIL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeScroll);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _instanceOfJs = require("./instanceOf.js");
var _getHTMLElementScrollJs = require("./getHTMLElementScroll.js");
var _getHTMLElementScrollJsDefault = parcelHelpers.interopDefault(_getHTMLElementScrollJs);
function getNodeScroll(node) {
    if (node === (0, _getWindowJsDefault.default)(node) || !(0, _instanceOfJs.isHTMLElement)(node)) return (0, _getWindowScrollJsDefault.default)(node);
    else return (0, _getHTMLElementScrollJsDefault.default)(node);
}

},{"./getWindowScroll.js":"7Wym7","./getWindow.js":"dfve1","./instanceOf.js":"2T0o5","./getHTMLElementScroll.js":"fgxlE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fgxlE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getHTMLElementScroll);
function getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"djBhV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>orderModifiers);
var _enumsJs = require("../enums.js"); // source: https://stackoverflow.com/questions/49875255
function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase
    return (0, _enumsJs.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

},{"../enums.js":"aVHEw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7uJdm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>debounce);
function debounce(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3LgOA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeByName);
function mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9PKmn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopper", ()=>createPopper) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator));
parcelHelpers.export(exports, "defaultModifiers", ()=>defaultModifiers);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
var _createPopperJs = require("./createPopper.js");
var _eventListenersJs = require("./modifiers/eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _popperOffsetsJs = require("./modifiers/popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _computeStylesJs = require("./modifiers/computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _applyStylesJs = require("./modifiers/applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var _offsetJs = require("./modifiers/offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
var _flipJs = require("./modifiers/flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _preventOverflowJs = require("./modifiers/preventOverflow.js");
var _preventOverflowJsDefault = parcelHelpers.interopDefault(_preventOverflowJs);
var _arrowJs = require("./modifiers/arrow.js");
var _arrowJsDefault = parcelHelpers.interopDefault(_arrowJs);
var _hideJs = require("./modifiers/hide.js");
var _hideJsDefault = parcelHelpers.interopDefault(_hideJs);
var _popperLiteJs = require("./popper-lite.js");
var _indexJs = require("./modifiers/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var defaultModifiers = [
    (0, _eventListenersJsDefault.default),
    (0, _popperOffsetsJsDefault.default),
    (0, _computeStylesJsDefault.default),
    (0, _applyStylesJsDefault.default),
    (0, _offsetJsDefault.default),
    (0, _flipJsDefault.default),
    (0, _preventOverflowJsDefault.default),
    (0, _arrowJsDefault.default),
    (0, _hideJsDefault.default)
];
var createPopper = /*#__PURE__*/ (0, _createPopperJs.popperGenerator)({
    defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

},{"./createPopper.js":"5bix2","./modifiers/eventListeners.js":"jlw8n","./modifiers/popperOffsets.js":"c9hkC","./modifiers/computeStyles.js":"cicmq","./modifiers/applyStyles.js":"axnJn","./modifiers/offset.js":"4U7Nh","./modifiers/flip.js":"d52GI","./modifiers/preventOverflow.js":"e2LIN","./modifiers/arrow.js":"013Ka","./modifiers/hide.js":"04i94","./popper-lite.js":false,"./modifiers/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jbutu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopper", ()=>createPopper);
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator));
parcelHelpers.export(exports, "defaultModifiers", ()=>defaultModifiers);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
var _createPopperJs = require("./createPopper.js");
var _eventListenersJs = require("./modifiers/eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _popperOffsetsJs = require("./modifiers/popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _computeStylesJs = require("./modifiers/computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _applyStylesJs = require("./modifiers/applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var defaultModifiers = [
    (0, _eventListenersJsDefault.default),
    (0, _popperOffsetsJsDefault.default),
    (0, _computeStylesJsDefault.default),
    (0, _applyStylesJsDefault.default)
];
var createPopper = /*#__PURE__*/ (0, _createPopperJs.popperGenerator)({
    defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

},{"./createPopper.js":"5bix2","./modifiers/eventListeners.js":"jlw8n","./modifiers/popperOffsets.js":"c9hkC","./modifiers/computeStyles.js":"cicmq","./modifiers/applyStyles.js":"axnJn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hV4nY":[function(require,module,exports) {
var global = arguments[3];
!function(t1, e1) {
    e1(exports);
}(this, function(exports) {
    "use strict";
    function ownKeys(t1, e1) {
        var i1 = Object.keys(t1);
        if (Object.getOwnPropertySymbols) {
            var r1 = Object.getOwnPropertySymbols(t1);
            e1 && (r1 = r1.filter(function(e1) {
                return Object.getOwnPropertyDescriptor(t1, e1).enumerable;
            })), i1.push.apply(i1, r1);
        }
        return i1;
    }
    function _objectSpread2(t1) {
        for(var e1 = 1; e1 < arguments.length; e1++){
            var i1 = null != arguments[e1] ? arguments[e1] : {};
            e1 % 2 ? ownKeys(Object(i1), !0).forEach(function(e1) {
                _defineProperty(t1, e1, i1[e1]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t1, Object.getOwnPropertyDescriptors(i1)) : ownKeys(Object(i1)).forEach(function(e1) {
                Object.defineProperty(t1, e1, Object.getOwnPropertyDescriptor(i1, e1));
            });
        }
        return t1;
    }
    function asyncGeneratorStep(t1, e1, i1, r1, a1, s1, n1) {
        try {
            var o1 = t1[s1](n1), h1 = o1.value;
        } catch (t1) {
            return void i1(t1);
        }
        o1.done ? e1(h1) : Promise.resolve(h1).then(r1, a1);
    }
    function _asyncToGenerator(t1) {
        return function() {
            var e1 = this, i1 = arguments;
            return new Promise(function(r1, a1) {
                var s1 = t1.apply(e1, i1);
                function n1(t1) {
                    asyncGeneratorStep(s1, r1, a1, n1, o1, "next", t1);
                }
                function o1(t1) {
                    asyncGeneratorStep(s1, r1, a1, n1, o1, "throw", t1);
                }
                n1(void 0);
            });
        };
    }
    function _defineProperty(t1, e1, i1) {
        return e1 in t1 ? Object.defineProperty(t1, e1, {
            value: i1,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t1[e1] = i1, t1;
    }
    function _taggedTemplateLiteral(t1, e1) {
        return e1 || (e1 = t1.slice(0)), Object.freeze(Object.defineProperties(t1, {
            raw: {
                value: Object.freeze(e1)
            }
        }));
    }
    /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.

  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */ function __decorate(t1, e1, i1, r1) {
        var a1, s1 = arguments.length, n1 = s1 < 3 ? e1 : null === r1 ? r1 = Object.getOwnPropertyDescriptor(e1, i1) : r1;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) n1 = Reflect.decorate(t1, e1, i1, r1);
        else for(var o1 = t1.length - 1; o1 >= 0; o1--)(a1 = t1[o1]) && (n1 = (s1 < 3 ? a1(n1) : s1 > 3 ? a1(e1, i1, n1) : a1(e1, i1)) || n1);
        return s1 > 3 && n1 && Object.defineProperty(e1, i1, n1), n1;
    /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */ }
    var n$5 = (t1)=>(e1)=>"function" == typeof e1 ? ((t1, e1)=>(window.customElements.define(t1, e1), e1))(t1, e1) : ((t1, e1)=>{
                var { kind: i1, elements: r1 } = e1;
                return {
                    kind: i1,
                    elements: r1,
                    finisher (e1) {
                        window.customElements.define(t1, e1);
                    }
                };
            })(t1, e1), i$3 = (t1, e1)=>"method" === e1.kind && e1.descriptor && !("value" in e1.descriptor) ? _objectSpread2(_objectSpread2({}, e1), {}, {
            finisher (i1) {
                i1.createProperty(e1.key, t1);
            }
        }) : {
            kind: "field",
            key: Symbol(),
            placement: "own",
            descriptor: {},
            originalKey: e1.key,
            initializer () {
                "function" == typeof e1.initializer && (this[e1.key] = e1.initializer.call(this));
            },
            finisher (i1) {
                i1.createProperty(e1.key, t1);
            }
        };
    function e$3(t1) {
        return (e1, i1)=>void 0 !== i1 ? ((t1, e1, i1)=>{
                e1.constructor.createProperty(i1, t1);
            })(t1, e1, i1) : i$3(t1, e1);
    }
    /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */ var o$4 = (t1)=>{
        var { finisher: e1, descriptor: i1 } = t1;
        return (t1, r1)=>{
            var a1;
            if (void 0 === r1) {
                var s1 = null !== (a1 = t1.originalKey) && void 0 !== a1 ? a1 : t1.key, n1 = null != i1 ? {
                    kind: "method",
                    placement: "prototype",
                    key: s1,
                    descriptor: i1(t1.key)
                } : _objectSpread2(_objectSpread2({}, t1), {}, {
                    key: s1
                });
                return null != e1 && (n1.finisher = function(t1) {
                    e1(t1, s1);
                }), n1;
            }
            var o1 = t1.constructor;
            void 0 !== i1 && Object.defineProperty(t1, r1, i1(r1)), null == e1 || e1(o1, r1);
        };
    }, n$4;
    /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */ function i$2(t1, e1) {
        return o$4({
            descriptor: (i1)=>{
                var r1 = {
                    get () {
                        var e1, i1;
                        return null !== (i1 = null === (e1 = this.renderRoot) || void 0 === e1 ? void 0 : e1.querySelector(t1)) && void 0 !== i1 ? i1 : null;
                    },
                    enumerable: !0,
                    configurable: !0
                };
                if (e1) {
                    var a1 = "symbol" == typeof i1 ? Symbol() : "__" + i1;
                    r1.get = function() {
                        var e1, i1;
                        return void 0 === this[a1] && (this[a1] = null !== (i1 = null === (e1 = this.renderRoot) || void 0 === e1 ? void 0 : e1.querySelector(t1)) && void 0 !== i1 ? i1 : null), this[a1];
                    };
                }
                return r1;
            }
        });
    }
    /**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */ null === (n$4 = window.HTMLSlotElement) || void 0 === n$4 || n$4.prototype.assignedElements;
    /*! pako 2.0.4 https://github.com/nodeca/pako @license (MIT AND Zlib) */ var Z_FIXED$1 = 4, Z_BINARY = 0, Z_TEXT = 1, Z_UNKNOWN$1 = 2;
    function zero$1(t1) {
        for(var e1 = t1.length; --e1 >= 0;)t1[e1] = 0;
    }
    var STORED_BLOCK = 0, STATIC_TREES = 1, DYN_TREES = 2, MIN_MATCH$1 = 3, MAX_MATCH$1 = 258, LENGTH_CODES$1 = 29, LITERALS$1 = 256, L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1, D_CODES$1 = 30, BL_CODES$1 = 19, HEAP_SIZE$1 = 2 * L_CODES$1 + 1, MAX_BITS$1 = 15, Buf_size = 16, MAX_BL_BITS = 7, END_BLOCK = 256, REP_3_6 = 16, REPZ_3_10 = 17, REPZ_11_138 = 18, extra_lbits = new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        2,
        2,
        2,
        2,
        3,
        3,
        3,
        3,
        4,
        4,
        4,
        4,
        5,
        5,
        5,
        5,
        0
    ]), extra_dbits = new Uint8Array([
        0,
        0,
        0,
        0,
        1,
        1,
        2,
        2,
        3,
        3,
        4,
        4,
        5,
        5,
        6,
        6,
        7,
        7,
        8,
        8,
        9,
        9,
        10,
        10,
        11,
        11,
        12,
        12,
        13,
        13
    ]), extra_blbits = new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        3,
        7
    ]), bl_order = new Uint8Array([
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ]), DIST_CODE_LEN = 512, static_ltree = new Array(2 * (L_CODES$1 + 2));
    zero$1(static_ltree);
    var static_dtree = new Array(2 * D_CODES$1);
    zero$1(static_dtree);
    var _dist_code = new Array(DIST_CODE_LEN);
    zero$1(_dist_code);
    var _length_code = new Array(MAX_MATCH$1 - MIN_MATCH$1 + 1);
    zero$1(_length_code);
    var base_length = new Array(LENGTH_CODES$1);
    zero$1(base_length);
    var base_dist = new Array(D_CODES$1), static_l_desc, static_d_desc, static_bl_desc;
    function StaticTreeDesc(t1, e1, i1, r1, a1) {
        this.static_tree = t1, this.extra_bits = e1, this.extra_base = i1, this.elems = r1, this.max_length = a1, this.has_stree = t1 && t1.length;
    }
    function TreeDesc(t1, e1) {
        this.dyn_tree = t1, this.max_code = 0, this.stat_desc = e1;
    }
    zero$1(base_dist);
    var d_code = (t1)=>t1 < 256 ? _dist_code[t1] : _dist_code[256 + (t1 >>> 7)], put_short = (t1, e1)=>{
        t1.pending_buf[t1.pending++] = 255 & e1, t1.pending_buf[t1.pending++] = e1 >>> 8 & 255;
    }, send_bits = (t1, e1, i1)=>{
        t1.bi_valid > Buf_size - i1 ? (t1.bi_buf |= e1 << t1.bi_valid & 65535, put_short(t1, t1.bi_buf), t1.bi_buf = e1 >> Buf_size - t1.bi_valid, t1.bi_valid += i1 - Buf_size) : (t1.bi_buf |= e1 << t1.bi_valid & 65535, t1.bi_valid += i1);
    }, send_code = (t1, e1, i1)=>{
        send_bits(t1, i1[2 * e1], i1[2 * e1 + 1]);
    }, bi_reverse = (t1, e1)=>{
        var i1 = 0;
        do i1 |= 1 & t1, t1 >>>= 1, i1 <<= 1;
        while (--e1 > 0);
        return i1 >>> 1;
    }, bi_flush = (t1)=>{
        16 === t1.bi_valid ? (put_short(t1, t1.bi_buf), t1.bi_buf = 0, t1.bi_valid = 0) : t1.bi_valid >= 8 && (t1.pending_buf[t1.pending++] = 255 & t1.bi_buf, t1.bi_buf >>= 8, t1.bi_valid -= 8);
    }, gen_bitlen = (t1, e1)=>{
        var i1, r1, a1, s1, n1, o1, h1 = e1.dyn_tree, l1 = e1.max_code, p1 = e1.stat_desc.static_tree, f1 = e1.stat_desc.has_stree, d1 = e1.stat_desc.extra_bits, c1 = e1.stat_desc.extra_base, m1 = e1.stat_desc.max_length, u1 = 0;
        for(s1 = 0; s1 <= MAX_BITS$1; s1++)t1.bl_count[s1] = 0;
        for(h1[2 * t1.heap[t1.heap_max] + 1] = 0, i1 = t1.heap_max + 1; i1 < HEAP_SIZE$1; i1++)(s1 = h1[2 * h1[2 * (r1 = t1.heap[i1]) + 1] + 1] + 1) > m1 && (s1 = m1, u1++), h1[2 * r1 + 1] = s1, r1 > l1 || (t1.bl_count[s1]++, n1 = 0, r1 >= c1 && (n1 = d1[r1 - c1]), o1 = h1[2 * r1], t1.opt_len += o1 * (s1 + n1), f1 && (t1.static_len += o1 * (p1[2 * r1 + 1] + n1)));
        if (0 !== u1) {
            do {
                for(s1 = m1 - 1; 0 === t1.bl_count[s1];)s1--;
                t1.bl_count[s1]--, t1.bl_count[s1 + 1] += 2, t1.bl_count[m1]--, u1 -= 2;
            }while (u1 > 0);
            for(s1 = m1; 0 !== s1; s1--)for(r1 = t1.bl_count[s1]; 0 !== r1;)(a1 = t1.heap[--i1]) > l1 || (h1[2 * a1 + 1] !== s1 && (t1.opt_len += (s1 - h1[2 * a1 + 1]) * h1[2 * a1], h1[2 * a1 + 1] = s1), r1--);
        }
    }, gen_codes = (t1, e1, i1)=>{
        var r1, a1, s1 = new Array(MAX_BITS$1 + 1), n1 = 0;
        for(r1 = 1; r1 <= MAX_BITS$1; r1++)s1[r1] = n1 = n1 + i1[r1 - 1] << 1;
        for(a1 = 0; a1 <= e1; a1++){
            var o1 = t1[2 * a1 + 1];
            0 !== o1 && (t1[2 * a1] = bi_reverse(s1[o1]++, o1));
        }
    }, tr_static_init = ()=>{
        var t1, e1, i1, r1, a1, s1 = new Array(MAX_BITS$1 + 1);
        for(i1 = 0, r1 = 0; r1 < LENGTH_CODES$1 - 1; r1++)for(base_length[r1] = i1, t1 = 0; t1 < 1 << extra_lbits[r1]; t1++)_length_code[i1++] = r1;
        for(_length_code[i1 - 1] = r1, a1 = 0, r1 = 0; r1 < 16; r1++)for(base_dist[r1] = a1, t1 = 0; t1 < 1 << extra_dbits[r1]; t1++)_dist_code[a1++] = r1;
        for(a1 >>= 7; r1 < D_CODES$1; r1++)for(base_dist[r1] = a1 << 7, t1 = 0; t1 < 1 << extra_dbits[r1] - 7; t1++)_dist_code[256 + a1++] = r1;
        for(e1 = 0; e1 <= MAX_BITS$1; e1++)s1[e1] = 0;
        for(t1 = 0; t1 <= 143;)static_ltree[2 * t1 + 1] = 8, t1++, s1[8]++;
        for(; t1 <= 255;)static_ltree[2 * t1 + 1] = 9, t1++, s1[9]++;
        for(; t1 <= 279;)static_ltree[2 * t1 + 1] = 7, t1++, s1[7]++;
        for(; t1 <= 287;)static_ltree[2 * t1 + 1] = 8, t1++, s1[8]++;
        for(gen_codes(static_ltree, L_CODES$1 + 1, s1), t1 = 0; t1 < D_CODES$1; t1++)static_dtree[2 * t1 + 1] = 5, static_dtree[2 * t1] = bi_reverse(t1, 5);
        static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS$1 + 1, L_CODES$1, MAX_BITS$1), static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES$1, MAX_BITS$1), static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES$1, MAX_BL_BITS);
    }, init_block = (t1)=>{
        var e1;
        for(e1 = 0; e1 < L_CODES$1; e1++)t1.dyn_ltree[2 * e1] = 0;
        for(e1 = 0; e1 < D_CODES$1; e1++)t1.dyn_dtree[2 * e1] = 0;
        for(e1 = 0; e1 < BL_CODES$1; e1++)t1.bl_tree[2 * e1] = 0;
        t1.dyn_ltree[2 * END_BLOCK] = 1, t1.opt_len = t1.static_len = 0, t1.last_lit = t1.matches = 0;
    }, bi_windup = (t1)=>{
        t1.bi_valid > 8 ? put_short(t1, t1.bi_buf) : t1.bi_valid > 0 && (t1.pending_buf[t1.pending++] = t1.bi_buf), t1.bi_buf = 0, t1.bi_valid = 0;
    }, copy_block = (t1, e1, i1, r1)=>{
        bi_windup(t1), r1 && (put_short(t1, i1), put_short(t1, ~i1)), t1.pending_buf.set(t1.window.subarray(e1, e1 + i1), t1.pending), t1.pending += i1;
    }, smaller = (t1, e1, i1, r1)=>{
        var a1 = 2 * e1, s1 = 2 * i1;
        return t1[a1] < t1[s1] || t1[a1] === t1[s1] && r1[e1] <= r1[i1];
    }, pqdownheap = (t1, e1, i1)=>{
        for(var r1 = t1.heap[i1], a1 = i1 << 1; a1 <= t1.heap_len && (a1 < t1.heap_len && smaller(e1, t1.heap[a1 + 1], t1.heap[a1], t1.depth) && a1++, !smaller(e1, r1, t1.heap[a1], t1.depth));)t1.heap[i1] = t1.heap[a1], i1 = a1, a1 <<= 1;
        t1.heap[i1] = r1;
    }, compress_block = (t1, e1, i1)=>{
        var r1, a1, s1, n1, o1 = 0;
        if (0 !== t1.last_lit) do r1 = t1.pending_buf[t1.d_buf + 2 * o1] << 8 | t1.pending_buf[t1.d_buf + 2 * o1 + 1], a1 = t1.pending_buf[t1.l_buf + o1], o1++, 0 === r1 ? send_code(t1, a1, e1) : (s1 = _length_code[a1], send_code(t1, s1 + LITERALS$1 + 1, e1), 0 !== (n1 = extra_lbits[s1]) && (a1 -= base_length[s1], send_bits(t1, a1, n1)), r1--, s1 = d_code(r1), send_code(t1, s1, i1), 0 !== (n1 = extra_dbits[s1]) && (r1 -= base_dist[s1], send_bits(t1, r1, n1)));
        while (o1 < t1.last_lit);
        send_code(t1, END_BLOCK, e1);
    }, build_tree = (t1, e1)=>{
        var i1, r1, a1, s1 = e1.dyn_tree, n1 = e1.stat_desc.static_tree, o1 = e1.stat_desc.has_stree, h1 = e1.stat_desc.elems, l1 = -1;
        for(t1.heap_len = 0, t1.heap_max = HEAP_SIZE$1, i1 = 0; i1 < h1; i1++)0 !== s1[2 * i1] ? (t1.heap[++t1.heap_len] = l1 = i1, t1.depth[i1] = 0) : s1[2 * i1 + 1] = 0;
        for(; t1.heap_len < 2;)s1[2 * (a1 = t1.heap[++t1.heap_len] = l1 < 2 ? ++l1 : 0)] = 1, t1.depth[a1] = 0, t1.opt_len--, o1 && (t1.static_len -= n1[2 * a1 + 1]);
        for(e1.max_code = l1, i1 = t1.heap_len >> 1; i1 >= 1; i1--)pqdownheap(t1, s1, i1);
        a1 = h1;
        do i1 = t1.heap[1], t1.heap[1] = t1.heap[t1.heap_len--], pqdownheap(t1, s1, 1), r1 = t1.heap[1], t1.heap[--t1.heap_max] = i1, t1.heap[--t1.heap_max] = r1, s1[2 * a1] = s1[2 * i1] + s1[2 * r1], t1.depth[a1] = (t1.depth[i1] >= t1.depth[r1] ? t1.depth[i1] : t1.depth[r1]) + 1, s1[2 * i1 + 1] = s1[2 * r1 + 1] = a1, t1.heap[1] = a1++, pqdownheap(t1, s1, 1);
        while (t1.heap_len >= 2);
        t1.heap[--t1.heap_max] = t1.heap[1], gen_bitlen(t1, e1), gen_codes(s1, l1, t1.bl_count);
    }, scan_tree = (t1, e1, i1)=>{
        var r1, a1, s1 = -1, n1 = e1[1], o1 = 0, h1 = 7, l1 = 4;
        for(0 === n1 && (h1 = 138, l1 = 3), e1[2 * (i1 + 1) + 1] = 65535, r1 = 0; r1 <= i1; r1++)a1 = n1, n1 = e1[2 * (r1 + 1) + 1], ++o1 < h1 && a1 === n1 || (o1 < l1 ? t1.bl_tree[2 * a1] += o1 : 0 !== a1 ? (a1 !== s1 && t1.bl_tree[2 * a1]++, t1.bl_tree[2 * REP_3_6]++) : o1 <= 10 ? t1.bl_tree[2 * REPZ_3_10]++ : t1.bl_tree[2 * REPZ_11_138]++, o1 = 0, s1 = a1, 0 === n1 ? (h1 = 138, l1 = 3) : a1 === n1 ? (h1 = 6, l1 = 3) : (h1 = 7, l1 = 4));
    }, send_tree = (t1, e1, i1)=>{
        var r1, a1, s1 = -1, n1 = e1[1], o1 = 0, h1 = 7, l1 = 4;
        for(0 === n1 && (h1 = 138, l1 = 3), r1 = 0; r1 <= i1; r1++)if (a1 = n1, n1 = e1[2 * (r1 + 1) + 1], !(++o1 < h1 && a1 === n1)) {
            if (o1 < l1) do send_code(t1, a1, t1.bl_tree);
            while (0 != --o1);
            else 0 !== a1 ? (a1 !== s1 && (send_code(t1, a1, t1.bl_tree), o1--), send_code(t1, REP_3_6, t1.bl_tree), send_bits(t1, o1 - 3, 2)) : o1 <= 10 ? (send_code(t1, REPZ_3_10, t1.bl_tree), send_bits(t1, o1 - 3, 3)) : (send_code(t1, REPZ_11_138, t1.bl_tree), send_bits(t1, o1 - 11, 7));
            o1 = 0, s1 = a1, 0 === n1 ? (h1 = 138, l1 = 3) : a1 === n1 ? (h1 = 6, l1 = 3) : (h1 = 7, l1 = 4);
        }
    }, build_bl_tree = (t1)=>{
        var e1;
        for(scan_tree(t1, t1.dyn_ltree, t1.l_desc.max_code), scan_tree(t1, t1.dyn_dtree, t1.d_desc.max_code), build_tree(t1, t1.bl_desc), e1 = BL_CODES$1 - 1; e1 >= 3 && 0 === t1.bl_tree[2 * bl_order[e1] + 1]; e1--);
        return t1.opt_len += 3 * (e1 + 1) + 5 + 5 + 4, e1;
    }, send_all_trees = (t1, e1, i1, r1)=>{
        var a1;
        for(send_bits(t1, e1 - 257, 5), send_bits(t1, i1 - 1, 5), send_bits(t1, r1 - 4, 4), a1 = 0; a1 < r1; a1++)send_bits(t1, t1.bl_tree[2 * bl_order[a1] + 1], 3);
        send_tree(t1, t1.dyn_ltree, e1 - 1), send_tree(t1, t1.dyn_dtree, i1 - 1);
    }, detect_data_type = (t1)=>{
        var e1, i1 = 4093624447;
        for(e1 = 0; e1 <= 31; e1++, i1 >>>= 1)if (1 & i1 && 0 !== t1.dyn_ltree[2 * e1]) return Z_BINARY;
        if (0 !== t1.dyn_ltree[18] || 0 !== t1.dyn_ltree[20] || 0 !== t1.dyn_ltree[26]) return Z_TEXT;
        for(e1 = 32; e1 < LITERALS$1; e1++)if (0 !== t1.dyn_ltree[2 * e1]) return Z_TEXT;
        return Z_BINARY;
    }, static_init_done = !1, _tr_init$1 = (t1)=>{
        static_init_done || (tr_static_init(), static_init_done = !0), t1.l_desc = new TreeDesc(t1.dyn_ltree, static_l_desc), t1.d_desc = new TreeDesc(t1.dyn_dtree, static_d_desc), t1.bl_desc = new TreeDesc(t1.bl_tree, static_bl_desc), t1.bi_buf = 0, t1.bi_valid = 0, init_block(t1);
    }, _tr_stored_block$1 = (t1, e1, i1, r1)=>{
        send_bits(t1, (STORED_BLOCK << 1) + (r1 ? 1 : 0), 3), copy_block(t1, e1, i1, !0);
    }, _tr_align$1 = (t1)=>{
        send_bits(t1, STATIC_TREES << 1, 3), send_code(t1, END_BLOCK, static_ltree), bi_flush(t1);
    }, _tr_flush_block$1 = (t1, e1, i1, r1)=>{
        var a1, s1, n1 = 0;
        t1.level > 0 ? (t1.strm.data_type === Z_UNKNOWN$1 && (t1.strm.data_type = detect_data_type(t1)), build_tree(t1, t1.l_desc), build_tree(t1, t1.d_desc), n1 = build_bl_tree(t1), a1 = t1.opt_len + 3 + 7 >>> 3, (s1 = t1.static_len + 3 + 7 >>> 3) <= a1 && (a1 = s1)) : a1 = s1 = i1 + 5, i1 + 4 <= a1 && -1 !== e1 ? _tr_stored_block$1(t1, e1, i1, r1) : t1.strategy === Z_FIXED$1 || s1 === a1 ? (send_bits(t1, (STATIC_TREES << 1) + (r1 ? 1 : 0), 3), compress_block(t1, static_ltree, static_dtree)) : (send_bits(t1, (DYN_TREES << 1) + (r1 ? 1 : 0), 3), send_all_trees(t1, t1.l_desc.max_code + 1, t1.d_desc.max_code + 1, n1 + 1), compress_block(t1, t1.dyn_ltree, t1.dyn_dtree)), init_block(t1), r1 && bi_windup(t1);
    }, _tr_tally$1 = (t1, e1, i1)=>(t1.pending_buf[t1.d_buf + 2 * t1.last_lit] = e1 >>> 8 & 255, t1.pending_buf[t1.d_buf + 2 * t1.last_lit + 1] = 255 & e1, t1.pending_buf[t1.l_buf + t1.last_lit] = 255 & i1, t1.last_lit++, 0 === e1 ? t1.dyn_ltree[2 * i1]++ : (t1.matches++, e1--, t1.dyn_ltree[2 * (_length_code[i1] + LITERALS$1 + 1)]++, t1.dyn_dtree[2 * d_code(e1)]++), t1.last_lit === t1.lit_bufsize - 1), _tr_init_1 = _tr_init$1, _tr_stored_block_1 = _tr_stored_block$1, _tr_flush_block_1 = _tr_flush_block$1, _tr_tally_1 = _tr_tally$1, _tr_align_1 = _tr_align$1, trees = {
        _tr_init: _tr_init_1,
        _tr_stored_block: _tr_stored_block_1,
        _tr_flush_block: _tr_flush_block_1,
        _tr_tally: _tr_tally_1,
        _tr_align: _tr_align_1
    }, adler32 = (t1, e1, i1, r1)=>{
        for(var a1 = 65535 & t1 | 0, s1 = t1 >>> 16 & 65535 | 0, n1 = 0; 0 !== i1;){
            i1 -= n1 = i1 > 2e3 ? 2e3 : i1;
            do s1 = s1 + (a1 = a1 + e1[r1++] | 0) | 0;
            while (--n1);
            a1 %= 65521, s1 %= 65521;
        }
        return a1 | s1 << 16 | 0;
    }, adler32_1 = adler32, makeTable = ()=>{
        for(var t1, e1 = [], i1 = 0; i1 < 256; i1++){
            t1 = i1;
            for(var r1 = 0; r1 < 8; r1++)t1 = 1 & t1 ? 3988292384 ^ t1 >>> 1 : t1 >>> 1;
            e1[i1] = t1;
        }
        return e1;
    }, crcTable = new Uint32Array(makeTable()), crc32 = (t1, e1, i1, r1)=>{
        var a1 = crcTable, s1 = r1 + i1;
        t1 ^= -1;
        for(var n1 = r1; n1 < s1; n1++)t1 = t1 >>> 8 ^ a1[255 & (t1 ^ e1[n1])];
        return -1 ^ t1;
    }, crc32_1 = crc32, messages = {
        2: "need dictionary",
        1: "stream end",
        0: "",
        "-1": "file error",
        "-2": "stream error",
        "-3": "data error",
        "-4": "insufficient memory",
        "-5": "buffer error",
        "-6": "incompatible version"
    }, constants$2 = {
        Z_NO_FLUSH: 0,
        Z_PARTIAL_FLUSH: 1,
        Z_SYNC_FLUSH: 2,
        Z_FULL_FLUSH: 3,
        Z_FINISH: 4,
        Z_BLOCK: 5,
        Z_TREES: 6,
        Z_OK: 0,
        Z_STREAM_END: 1,
        Z_NEED_DICT: 2,
        Z_ERRNO: -1,
        Z_STREAM_ERROR: -2,
        Z_DATA_ERROR: -3,
        Z_MEM_ERROR: -4,
        Z_BUF_ERROR: -5,
        Z_NO_COMPRESSION: 0,
        Z_BEST_SPEED: 1,
        Z_BEST_COMPRESSION: 9,
        Z_DEFAULT_COMPRESSION: -1,
        Z_FILTERED: 1,
        Z_HUFFMAN_ONLY: 2,
        Z_RLE: 3,
        Z_FIXED: 4,
        Z_DEFAULT_STRATEGY: 0,
        Z_BINARY: 0,
        Z_TEXT: 1,
        Z_UNKNOWN: 2,
        Z_DEFLATED: 8
    }, { _tr_init: _tr_init, _tr_stored_block: _tr_stored_block, _tr_flush_block: _tr_flush_block, _tr_tally: _tr_tally, _tr_align: _tr_align } = trees, { Z_NO_FLUSH: Z_NO_FLUSH$2, Z_PARTIAL_FLUSH: Z_PARTIAL_FLUSH, Z_FULL_FLUSH: Z_FULL_FLUSH$1, Z_FINISH: Z_FINISH$3, Z_BLOCK: Z_BLOCK$1, Z_OK: Z_OK$3, Z_STREAM_END: Z_STREAM_END$3, Z_STREAM_ERROR: Z_STREAM_ERROR$2, Z_DATA_ERROR: Z_DATA_ERROR$2, Z_BUF_ERROR: Z_BUF_ERROR$1, Z_DEFAULT_COMPRESSION: Z_DEFAULT_COMPRESSION$1, Z_FILTERED: Z_FILTERED, Z_HUFFMAN_ONLY: Z_HUFFMAN_ONLY, Z_RLE: Z_RLE, Z_FIXED: Z_FIXED, Z_DEFAULT_STRATEGY: Z_DEFAULT_STRATEGY$1, Z_UNKNOWN: Z_UNKNOWN, Z_DEFLATED: Z_DEFLATED$2 } = constants$2, MAX_MEM_LEVEL = 9, MAX_WBITS$1 = 15, DEF_MEM_LEVEL = 8, LENGTH_CODES = 29, LITERALS = 256, L_CODES = LITERALS + 1 + LENGTH_CODES, D_CODES = 30, BL_CODES = 19, HEAP_SIZE = 2 * L_CODES + 1, MAX_BITS = 15, MIN_MATCH = 3, MAX_MATCH = 258, MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1, PRESET_DICT = 32, INIT_STATE = 42, EXTRA_STATE = 69, NAME_STATE = 73, COMMENT_STATE = 91, HCRC_STATE = 103, BUSY_STATE = 113, FINISH_STATE = 666, BS_NEED_MORE = 1, BS_BLOCK_DONE = 2, BS_FINISH_STARTED = 3, BS_FINISH_DONE = 4, OS_CODE = 3, err = (t1, e1)=>(t1.msg = messages[e1], e1), rank = (t1)=>(t1 << 1) - (t1 > 4 ? 9 : 0), zero = (t1)=>{
        for(var e1 = t1.length; --e1 >= 0;)t1[e1] = 0;
    }, HASH_ZLIB = (t1, e1, i1)=>(e1 << t1.hash_shift ^ i1) & t1.hash_mask, HASH = HASH_ZLIB, flush_pending = (t1)=>{
        var e1 = t1.state, i1 = e1.pending;
        i1 > t1.avail_out && (i1 = t1.avail_out), 0 !== i1 && (t1.output.set(e1.pending_buf.subarray(e1.pending_out, e1.pending_out + i1), t1.next_out), t1.next_out += i1, e1.pending_out += i1, t1.total_out += i1, t1.avail_out -= i1, e1.pending -= i1, 0 === e1.pending && (e1.pending_out = 0));
    }, flush_block_only = (t1, e1)=>{
        _tr_flush_block(t1, t1.block_start >= 0 ? t1.block_start : -1, t1.strstart - t1.block_start, e1), t1.block_start = t1.strstart, flush_pending(t1.strm);
    }, put_byte = (t1, e1)=>{
        t1.pending_buf[t1.pending++] = e1;
    }, putShortMSB = (t1, e1)=>{
        t1.pending_buf[t1.pending++] = e1 >>> 8 & 255, t1.pending_buf[t1.pending++] = 255 & e1;
    }, read_buf = (t1, e1, i1, r1)=>{
        var a1 = t1.avail_in;
        return a1 > r1 && (a1 = r1), 0 === a1 ? 0 : (t1.avail_in -= a1, e1.set(t1.input.subarray(t1.next_in, t1.next_in + a1), i1), 1 === t1.state.wrap ? t1.adler = adler32_1(t1.adler, e1, a1, i1) : 2 === t1.state.wrap && (t1.adler = crc32_1(t1.adler, e1, a1, i1)), t1.next_in += a1, t1.total_in += a1, a1);
    }, longest_match = (t1, e1)=>{
        var i1, r1, a1 = t1.max_chain_length, s1 = t1.strstart, n1 = t1.prev_length, o1 = t1.nice_match, h1 = t1.strstart > t1.w_size - MIN_LOOKAHEAD ? t1.strstart - (t1.w_size - MIN_LOOKAHEAD) : 0, l1 = t1.window, p1 = t1.w_mask, f1 = t1.prev, d1 = t1.strstart + MAX_MATCH, c1 = l1[s1 + n1 - 1], m1 = l1[s1 + n1];
        t1.prev_length >= t1.good_match && (a1 >>= 2), o1 > t1.lookahead && (o1 = t1.lookahead);
        do if (l1[(i1 = e1) + n1] === m1 && l1[i1 + n1 - 1] === c1 && l1[i1] === l1[s1] && l1[++i1] === l1[s1 + 1]) {
            s1 += 2, i1++;
            do ;
            while (l1[++s1] === l1[++i1] && l1[++s1] === l1[++i1] && l1[++s1] === l1[++i1] && l1[++s1] === l1[++i1] && l1[++s1] === l1[++i1] && l1[++s1] === l1[++i1] && l1[++s1] === l1[++i1] && l1[++s1] === l1[++i1] && s1 < d1);
            if (r1 = MAX_MATCH - (d1 - s1), s1 = d1 - MAX_MATCH, r1 > n1) {
                if (t1.match_start = e1, n1 = r1, r1 >= o1) break;
                c1 = l1[s1 + n1 - 1], m1 = l1[s1 + n1];
            }
        }
        while ((e1 = f1[e1 & p1]) > h1 && 0 != --a1);
        return n1 <= t1.lookahead ? n1 : t1.lookahead;
    }, fill_window = (t1)=>{
        var e1, i1, r1, a1, s1, n1 = t1.w_size;
        do {
            if (a1 = t1.window_size - t1.lookahead - t1.strstart, t1.strstart >= n1 + (n1 - MIN_LOOKAHEAD)) {
                t1.window.set(t1.window.subarray(n1, n1 + n1), 0), t1.match_start -= n1, t1.strstart -= n1, t1.block_start -= n1, e1 = i1 = t1.hash_size;
                do r1 = t1.head[--e1], t1.head[e1] = r1 >= n1 ? r1 - n1 : 0;
                while (--i1);
                e1 = i1 = n1;
                do r1 = t1.prev[--e1], t1.prev[e1] = r1 >= n1 ? r1 - n1 : 0;
                while (--i1);
                a1 += n1;
            }
            if (0 === t1.strm.avail_in) break;
            if (i1 = read_buf(t1.strm, t1.window, t1.strstart + t1.lookahead, a1), t1.lookahead += i1, t1.lookahead + t1.insert >= MIN_MATCH) for(s1 = t1.strstart - t1.insert, t1.ins_h = t1.window[s1], t1.ins_h = HASH(t1, t1.ins_h, t1.window[s1 + 1]); t1.insert && (t1.ins_h = HASH(t1, t1.ins_h, t1.window[s1 + MIN_MATCH - 1]), t1.prev[s1 & t1.w_mask] = t1.head[t1.ins_h], t1.head[t1.ins_h] = s1, s1++, t1.insert--, !(t1.lookahead + t1.insert < MIN_MATCH)););
        }while (t1.lookahead < MIN_LOOKAHEAD && 0 !== t1.strm.avail_in);
    }, deflate_stored = (t1, e1)=>{
        var i1 = 65535;
        for(i1 > t1.pending_buf_size - 5 && (i1 = t1.pending_buf_size - 5);;){
            if (t1.lookahead <= 1) {
                if (fill_window(t1), 0 === t1.lookahead && e1 === Z_NO_FLUSH$2) return BS_NEED_MORE;
                if (0 === t1.lookahead) break;
            }
            t1.strstart += t1.lookahead, t1.lookahead = 0;
            var r1 = t1.block_start + i1;
            if ((0 === t1.strstart || t1.strstart >= r1) && (t1.lookahead = t1.strstart - r1, t1.strstart = r1, flush_block_only(t1, !1), 0 === t1.strm.avail_out)) return BS_NEED_MORE;
            if (t1.strstart - t1.block_start >= t1.w_size - MIN_LOOKAHEAD && (flush_block_only(t1, !1), 0 === t1.strm.avail_out)) return BS_NEED_MORE;
        }
        return t1.insert = 0, e1 === Z_FINISH$3 ? (flush_block_only(t1, !0), 0 === t1.strm.avail_out ? BS_FINISH_STARTED : BS_FINISH_DONE) : (t1.strstart > t1.block_start && (flush_block_only(t1, !1), t1.strm.avail_out), BS_NEED_MORE);
    }, deflate_fast = (t1, e1)=>{
        for(var i1, r1;;){
            if (t1.lookahead < MIN_LOOKAHEAD) {
                if (fill_window(t1), t1.lookahead < MIN_LOOKAHEAD && e1 === Z_NO_FLUSH$2) return BS_NEED_MORE;
                if (0 === t1.lookahead) break;
            }
            if (i1 = 0, t1.lookahead >= MIN_MATCH && (t1.ins_h = HASH(t1, t1.ins_h, t1.window[t1.strstart + MIN_MATCH - 1]), i1 = t1.prev[t1.strstart & t1.w_mask] = t1.head[t1.ins_h], t1.head[t1.ins_h] = t1.strstart), 0 !== i1 && t1.strstart - i1 <= t1.w_size - MIN_LOOKAHEAD && (t1.match_length = longest_match(t1, i1)), t1.match_length >= MIN_MATCH) {
                if (r1 = _tr_tally(t1, t1.strstart - t1.match_start, t1.match_length - MIN_MATCH), t1.lookahead -= t1.match_length, t1.match_length <= t1.max_lazy_match && t1.lookahead >= MIN_MATCH) {
                    t1.match_length--;
                    do t1.strstart++, t1.ins_h = HASH(t1, t1.ins_h, t1.window[t1.strstart + MIN_MATCH - 1]), i1 = t1.prev[t1.strstart & t1.w_mask] = t1.head[t1.ins_h], t1.head[t1.ins_h] = t1.strstart;
                    while (0 != --t1.match_length);
                    t1.strstart++;
                } else t1.strstart += t1.match_length, t1.match_length = 0, t1.ins_h = t1.window[t1.strstart], t1.ins_h = HASH(t1, t1.ins_h, t1.window[t1.strstart + 1]);
            } else r1 = _tr_tally(t1, 0, t1.window[t1.strstart]), t1.lookahead--, t1.strstart++;
            if (r1 && (flush_block_only(t1, !1), 0 === t1.strm.avail_out)) return BS_NEED_MORE;
        }
        return t1.insert = t1.strstart < MIN_MATCH - 1 ? t1.strstart : MIN_MATCH - 1, e1 === Z_FINISH$3 ? (flush_block_only(t1, !0), 0 === t1.strm.avail_out ? BS_FINISH_STARTED : BS_FINISH_DONE) : t1.last_lit && (flush_block_only(t1, !1), 0 === t1.strm.avail_out) ? BS_NEED_MORE : BS_BLOCK_DONE;
    }, deflate_slow = (t1, e1)=>{
        for(var i1, r1, a1;;){
            if (t1.lookahead < MIN_LOOKAHEAD) {
                if (fill_window(t1), t1.lookahead < MIN_LOOKAHEAD && e1 === Z_NO_FLUSH$2) return BS_NEED_MORE;
                if (0 === t1.lookahead) break;
            }
            if (i1 = 0, t1.lookahead >= MIN_MATCH && (t1.ins_h = HASH(t1, t1.ins_h, t1.window[t1.strstart + MIN_MATCH - 1]), i1 = t1.prev[t1.strstart & t1.w_mask] = t1.head[t1.ins_h], t1.head[t1.ins_h] = t1.strstart), t1.prev_length = t1.match_length, t1.prev_match = t1.match_start, t1.match_length = MIN_MATCH - 1, 0 !== i1 && t1.prev_length < t1.max_lazy_match && t1.strstart - i1 <= t1.w_size - MIN_LOOKAHEAD && (t1.match_length = longest_match(t1, i1), t1.match_length <= 5 && (t1.strategy === Z_FILTERED || t1.match_length === MIN_MATCH && t1.strstart - t1.match_start > 4096) && (t1.match_length = MIN_MATCH - 1)), t1.prev_length >= MIN_MATCH && t1.match_length <= t1.prev_length) {
                a1 = t1.strstart + t1.lookahead - MIN_MATCH, r1 = _tr_tally(t1, t1.strstart - 1 - t1.prev_match, t1.prev_length - MIN_MATCH), t1.lookahead -= t1.prev_length - 1, t1.prev_length -= 2;
                do ++t1.strstart <= a1 && (t1.ins_h = HASH(t1, t1.ins_h, t1.window[t1.strstart + MIN_MATCH - 1]), i1 = t1.prev[t1.strstart & t1.w_mask] = t1.head[t1.ins_h], t1.head[t1.ins_h] = t1.strstart);
                while (0 != --t1.prev_length);
                if (t1.match_available = 0, t1.match_length = MIN_MATCH - 1, t1.strstart++, r1 && (flush_block_only(t1, !1), 0 === t1.strm.avail_out)) return BS_NEED_MORE;
            } else if (t1.match_available) {
                if ((r1 = _tr_tally(t1, 0, t1.window[t1.strstart - 1])) && flush_block_only(t1, !1), t1.strstart++, t1.lookahead--, 0 === t1.strm.avail_out) return BS_NEED_MORE;
            } else t1.match_available = 1, t1.strstart++, t1.lookahead--;
        }
        return t1.match_available && (r1 = _tr_tally(t1, 0, t1.window[t1.strstart - 1]), t1.match_available = 0), t1.insert = t1.strstart < MIN_MATCH - 1 ? t1.strstart : MIN_MATCH - 1, e1 === Z_FINISH$3 ? (flush_block_only(t1, !0), 0 === t1.strm.avail_out ? BS_FINISH_STARTED : BS_FINISH_DONE) : t1.last_lit && (flush_block_only(t1, !1), 0 === t1.strm.avail_out) ? BS_NEED_MORE : BS_BLOCK_DONE;
    }, deflate_rle = (t1, e1)=>{
        for(var i1, r1, a1, s1, n1 = t1.window;;){
            if (t1.lookahead <= MAX_MATCH) {
                if (fill_window(t1), t1.lookahead <= MAX_MATCH && e1 === Z_NO_FLUSH$2) return BS_NEED_MORE;
                if (0 === t1.lookahead) break;
            }
            if (t1.match_length = 0, t1.lookahead >= MIN_MATCH && t1.strstart > 0 && (r1 = n1[a1 = t1.strstart - 1]) === n1[++a1] && r1 === n1[++a1] && r1 === n1[++a1]) {
                s1 = t1.strstart + MAX_MATCH;
                do ;
                while (r1 === n1[++a1] && r1 === n1[++a1] && r1 === n1[++a1] && r1 === n1[++a1] && r1 === n1[++a1] && r1 === n1[++a1] && r1 === n1[++a1] && r1 === n1[++a1] && a1 < s1);
                t1.match_length = MAX_MATCH - (s1 - a1), t1.match_length > t1.lookahead && (t1.match_length = t1.lookahead);
            }
            if (t1.match_length >= MIN_MATCH ? (i1 = _tr_tally(t1, 1, t1.match_length - MIN_MATCH), t1.lookahead -= t1.match_length, t1.strstart += t1.match_length, t1.match_length = 0) : (i1 = _tr_tally(t1, 0, t1.window[t1.strstart]), t1.lookahead--, t1.strstart++), i1 && (flush_block_only(t1, !1), 0 === t1.strm.avail_out)) return BS_NEED_MORE;
        }
        return t1.insert = 0, e1 === Z_FINISH$3 ? (flush_block_only(t1, !0), 0 === t1.strm.avail_out ? BS_FINISH_STARTED : BS_FINISH_DONE) : t1.last_lit && (flush_block_only(t1, !1), 0 === t1.strm.avail_out) ? BS_NEED_MORE : BS_BLOCK_DONE;
    }, deflate_huff = (t1, e1)=>{
        for(var i1;;){
            if (0 === t1.lookahead && (fill_window(t1), 0 === t1.lookahead)) {
                if (e1 === Z_NO_FLUSH$2) return BS_NEED_MORE;
                break;
            }
            if (t1.match_length = 0, i1 = _tr_tally(t1, 0, t1.window[t1.strstart]), t1.lookahead--, t1.strstart++, i1 && (flush_block_only(t1, !1), 0 === t1.strm.avail_out)) return BS_NEED_MORE;
        }
        return t1.insert = 0, e1 === Z_FINISH$3 ? (flush_block_only(t1, !0), 0 === t1.strm.avail_out ? BS_FINISH_STARTED : BS_FINISH_DONE) : t1.last_lit && (flush_block_only(t1, !1), 0 === t1.strm.avail_out) ? BS_NEED_MORE : BS_BLOCK_DONE;
    };
    function Config(t1, e1, i1, r1, a1) {
        this.good_length = t1, this.max_lazy = e1, this.nice_length = i1, this.max_chain = r1, this.func = a1;
    }
    var configuration_table = [
        new Config(0, 0, 0, 0, deflate_stored),
        new Config(4, 4, 8, 4, deflate_fast),
        new Config(4, 5, 16, 8, deflate_fast),
        new Config(4, 6, 32, 32, deflate_fast),
        new Config(4, 4, 16, 16, deflate_slow),
        new Config(8, 16, 32, 32, deflate_slow),
        new Config(8, 16, 128, 128, deflate_slow),
        new Config(8, 32, 128, 256, deflate_slow),
        new Config(32, 128, 258, 1024, deflate_slow),
        new Config(32, 258, 258, 4096, deflate_slow)
    ], lm_init = (t1)=>{
        t1.window_size = 2 * t1.w_size, zero(t1.head), t1.max_lazy_match = configuration_table[t1.level].max_lazy, t1.good_match = configuration_table[t1.level].good_length, t1.nice_match = configuration_table[t1.level].nice_length, t1.max_chain_length = configuration_table[t1.level].max_chain, t1.strstart = 0, t1.block_start = 0, t1.lookahead = 0, t1.insert = 0, t1.match_length = t1.prev_length = MIN_MATCH - 1, t1.match_available = 0, t1.ins_h = 0;
    };
    function DeflateState() {
        this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = Z_DEFLATED$2, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Uint16Array(2 * HEAP_SIZE), this.dyn_dtree = new Uint16Array(2 * (2 * D_CODES + 1)), this.bl_tree = new Uint16Array(2 * (2 * BL_CODES + 1)), zero(this.dyn_ltree), zero(this.dyn_dtree), zero(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Uint16Array(MAX_BITS + 1), this.heap = new Uint16Array(2 * L_CODES + 1), zero(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Uint16Array(2 * L_CODES + 1), zero(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
    }
    var deflateResetKeep = (t1)=>{
        if (!t1 || !t1.state) return err(t1, Z_STREAM_ERROR$2);
        t1.total_in = t1.total_out = 0, t1.data_type = Z_UNKNOWN;
        var e1 = t1.state;
        return e1.pending = 0, e1.pending_out = 0, e1.wrap < 0 && (e1.wrap = -e1.wrap), e1.status = e1.wrap ? INIT_STATE : BUSY_STATE, t1.adler = 2 === e1.wrap ? 0 : 1, e1.last_flush = Z_NO_FLUSH$2, _tr_init(e1), Z_OK$3;
    }, deflateReset = (t1)=>{
        var e1 = deflateResetKeep(t1);
        return e1 === Z_OK$3 && lm_init(t1.state), e1;
    }, deflateSetHeader = (t1, e1)=>t1 && t1.state ? 2 !== t1.state.wrap ? Z_STREAM_ERROR$2 : (t1.state.gzhead = e1, Z_OK$3) : Z_STREAM_ERROR$2, deflateInit2 = (t1, e1, i1, r1, a1, s1)=>{
        if (!t1) return Z_STREAM_ERROR$2;
        var n1 = 1;
        if (e1 === Z_DEFAULT_COMPRESSION$1 && (e1 = 6), r1 < 0 ? (n1 = 0, r1 = -r1) : r1 > 15 && (n1 = 2, r1 -= 16), a1 < 1 || a1 > MAX_MEM_LEVEL || i1 !== Z_DEFLATED$2 || r1 < 8 || r1 > 15 || e1 < 0 || e1 > 9 || s1 < 0 || s1 > Z_FIXED) return err(t1, Z_STREAM_ERROR$2);
        8 === r1 && (r1 = 9);
        var o1 = new DeflateState;
        return t1.state = o1, o1.strm = t1, o1.wrap = n1, o1.gzhead = null, o1.w_bits = r1, o1.w_size = 1 << o1.w_bits, o1.w_mask = o1.w_size - 1, o1.hash_bits = a1 + 7, o1.hash_size = 1 << o1.hash_bits, o1.hash_mask = o1.hash_size - 1, o1.hash_shift = ~~((o1.hash_bits + MIN_MATCH - 1) / MIN_MATCH), o1.window = new Uint8Array(2 * o1.w_size), o1.head = new Uint16Array(o1.hash_size), o1.prev = new Uint16Array(o1.w_size), o1.lit_bufsize = 1 << a1 + 6, o1.pending_buf_size = 4 * o1.lit_bufsize, o1.pending_buf = new Uint8Array(o1.pending_buf_size), o1.d_buf = 1 * o1.lit_bufsize, o1.l_buf = 3 * o1.lit_bufsize, o1.level = e1, o1.strategy = s1, o1.method = i1, deflateReset(t1);
    }, deflateInit = (t1, e1)=>deflateInit2(t1, e1, Z_DEFLATED$2, MAX_WBITS$1, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY$1), deflate$2 = (t1, e1)=>{
        var i1, r1;
        if (!t1 || !t1.state || e1 > Z_BLOCK$1 || e1 < 0) return t1 ? err(t1, Z_STREAM_ERROR$2) : Z_STREAM_ERROR$2;
        var a1 = t1.state;
        if (!t1.output || !t1.input && 0 !== t1.avail_in || a1.status === FINISH_STATE && e1 !== Z_FINISH$3) return err(t1, 0 === t1.avail_out ? Z_BUF_ERROR$1 : Z_STREAM_ERROR$2);
        a1.strm = t1;
        var s1 = a1.last_flush;
        if (a1.last_flush = e1, a1.status === INIT_STATE) {
            if (2 === a1.wrap) t1.adler = 0, put_byte(a1, 31), put_byte(a1, 139), put_byte(a1, 8), a1.gzhead ? (put_byte(a1, (a1.gzhead.text ? 1 : 0) + (a1.gzhead.hcrc ? 2 : 0) + (a1.gzhead.extra ? 4 : 0) + (a1.gzhead.name ? 8 : 0) + (a1.gzhead.comment ? 16 : 0)), put_byte(a1, 255 & a1.gzhead.time), put_byte(a1, a1.gzhead.time >> 8 & 255), put_byte(a1, a1.gzhead.time >> 16 & 255), put_byte(a1, a1.gzhead.time >> 24 & 255), put_byte(a1, 9 === a1.level ? 2 : a1.strategy >= Z_HUFFMAN_ONLY || a1.level < 2 ? 4 : 0), put_byte(a1, 255 & a1.gzhead.os), a1.gzhead.extra && a1.gzhead.extra.length && (put_byte(a1, 255 & a1.gzhead.extra.length), put_byte(a1, a1.gzhead.extra.length >> 8 & 255)), a1.gzhead.hcrc && (t1.adler = crc32_1(t1.adler, a1.pending_buf, a1.pending, 0)), a1.gzindex = 0, a1.status = EXTRA_STATE) : (put_byte(a1, 0), put_byte(a1, 0), put_byte(a1, 0), put_byte(a1, 0), put_byte(a1, 0), put_byte(a1, 9 === a1.level ? 2 : a1.strategy >= Z_HUFFMAN_ONLY || a1.level < 2 ? 4 : 0), put_byte(a1, OS_CODE), a1.status = BUSY_STATE);
            else {
                var n1 = Z_DEFLATED$2 + (a1.w_bits - 8 << 4) << 8;
                n1 |= (a1.strategy >= Z_HUFFMAN_ONLY || a1.level < 2 ? 0 : a1.level < 6 ? 1 : 6 === a1.level ? 2 : 3) << 6, 0 !== a1.strstart && (n1 |= PRESET_DICT), n1 += 31 - n1 % 31, a1.status = BUSY_STATE, putShortMSB(a1, n1), 0 !== a1.strstart && (putShortMSB(a1, t1.adler >>> 16), putShortMSB(a1, 65535 & t1.adler)), t1.adler = 1;
            }
        }
        if (a1.status === EXTRA_STATE) {
            if (a1.gzhead.extra) {
                for(i1 = a1.pending; a1.gzindex < (65535 & a1.gzhead.extra.length) && (a1.pending !== a1.pending_buf_size || (a1.gzhead.hcrc && a1.pending > i1 && (t1.adler = crc32_1(t1.adler, a1.pending_buf, a1.pending - i1, i1)), flush_pending(t1), i1 = a1.pending, a1.pending !== a1.pending_buf_size));)put_byte(a1, 255 & a1.gzhead.extra[a1.gzindex]), a1.gzindex++;
                a1.gzhead.hcrc && a1.pending > i1 && (t1.adler = crc32_1(t1.adler, a1.pending_buf, a1.pending - i1, i1)), a1.gzindex === a1.gzhead.extra.length && (a1.gzindex = 0, a1.status = NAME_STATE);
            } else a1.status = NAME_STATE;
        }
        if (a1.status === NAME_STATE) {
            if (a1.gzhead.name) {
                i1 = a1.pending;
                do {
                    if (a1.pending === a1.pending_buf_size && (a1.gzhead.hcrc && a1.pending > i1 && (t1.adler = crc32_1(t1.adler, a1.pending_buf, a1.pending - i1, i1)), flush_pending(t1), i1 = a1.pending, a1.pending === a1.pending_buf_size)) {
                        r1 = 1;
                        break;
                    }
                    r1 = a1.gzindex < a1.gzhead.name.length ? 255 & a1.gzhead.name.charCodeAt(a1.gzindex++) : 0, put_byte(a1, r1);
                }while (0 !== r1);
                a1.gzhead.hcrc && a1.pending > i1 && (t1.adler = crc32_1(t1.adler, a1.pending_buf, a1.pending - i1, i1)), 0 === r1 && (a1.gzindex = 0, a1.status = COMMENT_STATE);
            } else a1.status = COMMENT_STATE;
        }
        if (a1.status === COMMENT_STATE) {
            if (a1.gzhead.comment) {
                i1 = a1.pending;
                do {
                    if (a1.pending === a1.pending_buf_size && (a1.gzhead.hcrc && a1.pending > i1 && (t1.adler = crc32_1(t1.adler, a1.pending_buf, a1.pending - i1, i1)), flush_pending(t1), i1 = a1.pending, a1.pending === a1.pending_buf_size)) {
                        r1 = 1;
                        break;
                    }
                    r1 = a1.gzindex < a1.gzhead.comment.length ? 255 & a1.gzhead.comment.charCodeAt(a1.gzindex++) : 0, put_byte(a1, r1);
                }while (0 !== r1);
                a1.gzhead.hcrc && a1.pending > i1 && (t1.adler = crc32_1(t1.adler, a1.pending_buf, a1.pending - i1, i1)), 0 === r1 && (a1.status = HCRC_STATE);
            } else a1.status = HCRC_STATE;
        }
        if (a1.status === HCRC_STATE && (a1.gzhead.hcrc ? (a1.pending + 2 > a1.pending_buf_size && flush_pending(t1), a1.pending + 2 <= a1.pending_buf_size && (put_byte(a1, 255 & t1.adler), put_byte(a1, t1.adler >> 8 & 255), t1.adler = 0, a1.status = BUSY_STATE)) : a1.status = BUSY_STATE), 0 !== a1.pending) {
            if (flush_pending(t1), 0 === t1.avail_out) return a1.last_flush = -1, Z_OK$3;
        } else if (0 === t1.avail_in && rank(e1) <= rank(s1) && e1 !== Z_FINISH$3) return err(t1, Z_BUF_ERROR$1);
        if (a1.status === FINISH_STATE && 0 !== t1.avail_in) return err(t1, Z_BUF_ERROR$1);
        if (0 !== t1.avail_in || 0 !== a1.lookahead || e1 !== Z_NO_FLUSH$2 && a1.status !== FINISH_STATE) {
            var o1 = a1.strategy === Z_HUFFMAN_ONLY ? deflate_huff(a1, e1) : a1.strategy === Z_RLE ? deflate_rle(a1, e1) : configuration_table[a1.level].func(a1, e1);
            if (o1 !== BS_FINISH_STARTED && o1 !== BS_FINISH_DONE || (a1.status = FINISH_STATE), o1 === BS_NEED_MORE || o1 === BS_FINISH_STARTED) return 0 === t1.avail_out && (a1.last_flush = -1), Z_OK$3;
            if (o1 === BS_BLOCK_DONE && (e1 === Z_PARTIAL_FLUSH ? _tr_align(a1) : e1 !== Z_BLOCK$1 && (_tr_stored_block(a1, 0, 0, !1), e1 === Z_FULL_FLUSH$1 && (zero(a1.head), 0 === a1.lookahead && (a1.strstart = 0, a1.block_start = 0, a1.insert = 0))), flush_pending(t1), 0 === t1.avail_out)) return a1.last_flush = -1, Z_OK$3;
        }
        return e1 !== Z_FINISH$3 ? Z_OK$3 : a1.wrap <= 0 ? Z_STREAM_END$3 : (2 === a1.wrap ? (put_byte(a1, 255 & t1.adler), put_byte(a1, t1.adler >> 8 & 255), put_byte(a1, t1.adler >> 16 & 255), put_byte(a1, t1.adler >> 24 & 255), put_byte(a1, 255 & t1.total_in), put_byte(a1, t1.total_in >> 8 & 255), put_byte(a1, t1.total_in >> 16 & 255), put_byte(a1, t1.total_in >> 24 & 255)) : (putShortMSB(a1, t1.adler >>> 16), putShortMSB(a1, 65535 & t1.adler)), flush_pending(t1), a1.wrap > 0 && (a1.wrap = -a1.wrap), 0 !== a1.pending ? Z_OK$3 : Z_STREAM_END$3);
    }, deflateEnd = (t1)=>{
        if (!t1 || !t1.state) return Z_STREAM_ERROR$2;
        var e1 = t1.state.status;
        return e1 !== INIT_STATE && e1 !== EXTRA_STATE && e1 !== NAME_STATE && e1 !== COMMENT_STATE && e1 !== HCRC_STATE && e1 !== BUSY_STATE && e1 !== FINISH_STATE ? err(t1, Z_STREAM_ERROR$2) : (t1.state = null, e1 === BUSY_STATE ? err(t1, Z_DATA_ERROR$2) : Z_OK$3);
    }, deflateSetDictionary = (t1, e1)=>{
        var i1 = e1.length;
        if (!t1 || !t1.state) return Z_STREAM_ERROR$2;
        var r1 = t1.state, a1 = r1.wrap;
        if (2 === a1 || 1 === a1 && r1.status !== INIT_STATE || r1.lookahead) return Z_STREAM_ERROR$2;
        if (1 === a1 && (t1.adler = adler32_1(t1.adler, e1, i1, 0)), r1.wrap = 0, i1 >= r1.w_size) {
            0 === a1 && (zero(r1.head), r1.strstart = 0, r1.block_start = 0, r1.insert = 0);
            var s1 = new Uint8Array(r1.w_size);
            s1.set(e1.subarray(i1 - r1.w_size, i1), 0), e1 = s1, i1 = r1.w_size;
        }
        var n1 = t1.avail_in, o1 = t1.next_in, h1 = t1.input;
        for(t1.avail_in = i1, t1.next_in = 0, t1.input = e1, fill_window(r1); r1.lookahead >= MIN_MATCH;){
            var l1 = r1.strstart, p1 = r1.lookahead - (MIN_MATCH - 1);
            do r1.ins_h = HASH(r1, r1.ins_h, r1.window[l1 + MIN_MATCH - 1]), r1.prev[l1 & r1.w_mask] = r1.head[r1.ins_h], r1.head[r1.ins_h] = l1, l1++;
            while (--p1);
            r1.strstart = l1, r1.lookahead = MIN_MATCH - 1, fill_window(r1);
        }
        return r1.strstart += r1.lookahead, r1.block_start = r1.strstart, r1.insert = r1.lookahead, r1.lookahead = 0, r1.match_length = r1.prev_length = MIN_MATCH - 1, r1.match_available = 0, t1.next_in = o1, t1.input = h1, t1.avail_in = n1, r1.wrap = a1, Z_OK$3;
    }, deflateInit_1 = deflateInit, deflateInit2_1 = deflateInit2, deflateReset_1 = deflateReset, deflateResetKeep_1 = deflateResetKeep, deflateSetHeader_1 = deflateSetHeader, deflate_2$1 = deflate$2, deflateEnd_1 = deflateEnd, deflateSetDictionary_1 = deflateSetDictionary, deflateInfo = "pako deflate (from Nodeca project)", deflate_1$2 = {
        deflateInit: deflateInit_1,
        deflateInit2: deflateInit2_1,
        deflateReset: deflateReset_1,
        deflateResetKeep: deflateResetKeep_1,
        deflateSetHeader: deflateSetHeader_1,
        deflate: deflate_2$1,
        deflateEnd: deflateEnd_1,
        deflateSetDictionary: deflateSetDictionary_1,
        deflateInfo: deflateInfo
    }, _has = (t1, e1)=>Object.prototype.hasOwnProperty.call(t1, e1), assign = function(t1) {
        for(var e1 = Array.prototype.slice.call(arguments, 1); e1.length;){
            var i1 = e1.shift();
            if (i1) {
                if ("object" != typeof i1) throw new TypeError(i1 + "must be non-object");
                for(var r1 in i1)_has(i1, r1) && (t1[r1] = i1[r1]);
            }
        }
        return t1;
    }, flattenChunks = (t1)=>{
        for(var e1 = 0, i1 = 0, r1 = t1.length; i1 < r1; i1++)e1 += t1[i1].length;
        for(var a1 = new Uint8Array(e1), s1 = 0, n1 = 0, o1 = t1.length; s1 < o1; s1++){
            var h1 = t1[s1];
            a1.set(h1, n1), n1 += h1.length;
        }
        return a1;
    }, common = {
        assign: assign,
        flattenChunks: flattenChunks
    }, STR_APPLY_UIA_OK = !0;
    try {
        String.fromCharCode.apply(null, new Uint8Array(1));
    } catch (t) {
        STR_APPLY_UIA_OK = !1;
    }
    for(var _utf8len = new Uint8Array(256), q = 0; q < 256; q++)_utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
    _utf8len[254] = _utf8len[254] = 1;
    var string2buf = (t1)=>{
        if ("function" == typeof TextEncoder && TextEncoder.prototype.encode) return (new TextEncoder).encode(t1);
        var e1, i1, r1, a1, s1, n1 = t1.length, o1 = 0;
        for(a1 = 0; a1 < n1; a1++)55296 == (64512 & (i1 = t1.charCodeAt(a1))) && a1 + 1 < n1 && 56320 == (64512 & (r1 = t1.charCodeAt(a1 + 1))) && (i1 = 65536 + (i1 - 55296 << 10) + (r1 - 56320), a1++), o1 += i1 < 128 ? 1 : i1 < 2048 ? 2 : i1 < 65536 ? 3 : 4;
        for(e1 = new Uint8Array(o1), s1 = 0, a1 = 0; s1 < o1; a1++)55296 == (64512 & (i1 = t1.charCodeAt(a1))) && a1 + 1 < n1 && 56320 == (64512 & (r1 = t1.charCodeAt(a1 + 1))) && (i1 = 65536 + (i1 - 55296 << 10) + (r1 - 56320), a1++), i1 < 128 ? e1[s1++] = i1 : i1 < 2048 ? (e1[s1++] = 192 | i1 >>> 6, e1[s1++] = 128 | 63 & i1) : i1 < 65536 ? (e1[s1++] = 224 | i1 >>> 12, e1[s1++] = 128 | i1 >>> 6 & 63, e1[s1++] = 128 | 63 & i1) : (e1[s1++] = 240 | i1 >>> 18, e1[s1++] = 128 | i1 >>> 12 & 63, e1[s1++] = 128 | i1 >>> 6 & 63, e1[s1++] = 128 | 63 & i1);
        return e1;
    }, buf2binstring = (t1, e1)=>{
        if (e1 < 65534 && t1.subarray && STR_APPLY_UIA_OK) return String.fromCharCode.apply(null, t1.length === e1 ? t1 : t1.subarray(0, e1));
        for(var i1 = "", r1 = 0; r1 < e1; r1++)i1 += String.fromCharCode(t1[r1]);
        return i1;
    }, buf2string = (t1, e1)=>{
        var i1, r1, a1 = e1 || t1.length;
        if ("function" == typeof TextDecoder && TextDecoder.prototype.decode) return (new TextDecoder).decode(t1.subarray(0, e1));
        var s1 = new Array(2 * a1);
        for(r1 = 0, i1 = 0; i1 < a1;){
            var n1 = t1[i1++];
            if (n1 < 128) s1[r1++] = n1;
            else {
                var o1 = _utf8len[n1];
                if (o1 > 4) s1[r1++] = 65533, i1 += o1 - 1;
                else {
                    for(n1 &= 2 === o1 ? 31 : 3 === o1 ? 15 : 7; o1 > 1 && i1 < a1;)n1 = n1 << 6 | 63 & t1[i1++], o1--;
                    o1 > 1 ? s1[r1++] = 65533 : n1 < 65536 ? s1[r1++] = n1 : (n1 -= 65536, s1[r1++] = 55296 | n1 >> 10 & 1023, s1[r1++] = 56320 | 1023 & n1);
                }
            }
        }
        return buf2binstring(s1, r1);
    }, utf8border = (t1, e1)=>{
        (e1 = e1 || t1.length) > t1.length && (e1 = t1.length);
        for(var i1 = e1 - 1; i1 >= 0 && 128 == (192 & t1[i1]);)i1--;
        return i1 < 0 || 0 === i1 ? e1 : i1 + _utf8len[t1[i1]] > e1 ? i1 : e1;
    }, strings = {
        string2buf: string2buf,
        buf2string: buf2string,
        utf8border: utf8border
    };
    function ZStream() {
        this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
    }
    var zstream = ZStream, toString$1 = Object.prototype.toString, { Z_NO_FLUSH: Z_NO_FLUSH$1, Z_SYNC_FLUSH: Z_SYNC_FLUSH, Z_FULL_FLUSH: Z_FULL_FLUSH, Z_FINISH: Z_FINISH$2, Z_OK: Z_OK$2, Z_STREAM_END: Z_STREAM_END$2, Z_DEFAULT_COMPRESSION: Z_DEFAULT_COMPRESSION, Z_DEFAULT_STRATEGY: Z_DEFAULT_STRATEGY, Z_DEFLATED: Z_DEFLATED$1 } = constants$2;
    function Deflate$1(t1) {
        this.options = common.assign({
            level: Z_DEFAULT_COMPRESSION,
            method: Z_DEFLATED$1,
            chunkSize: 16384,
            windowBits: 15,
            memLevel: 8,
            strategy: Z_DEFAULT_STRATEGY
        }, t1 || {});
        var e1 = this.options;
        e1.raw && e1.windowBits > 0 ? e1.windowBits = -e1.windowBits : e1.gzip && e1.windowBits > 0 && e1.windowBits < 16 && (e1.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new zstream, this.strm.avail_out = 0;
        var i1 = deflate_1$2.deflateInit2(this.strm, e1.level, e1.method, e1.windowBits, e1.memLevel, e1.strategy);
        if (i1 !== Z_OK$2) throw new Error(messages[i1]);
        if (e1.header && deflate_1$2.deflateSetHeader(this.strm, e1.header), e1.dictionary) {
            var r1;
            if (r1 = "string" == typeof e1.dictionary ? strings.string2buf(e1.dictionary) : "[object ArrayBuffer]" === toString$1.call(e1.dictionary) ? new Uint8Array(e1.dictionary) : e1.dictionary, (i1 = deflate_1$2.deflateSetDictionary(this.strm, r1)) !== Z_OK$2) throw new Error(messages[i1]);
            this._dict_set = !0;
        }
    }
    Deflate$1.prototype.push = function(t1, e1) {
        var i1, r1, a1 = this.strm, s1 = this.options.chunkSize;
        if (this.ended) return !1;
        for(r1 = e1 === ~~e1 ? e1 : !0 === e1 ? Z_FINISH$2 : Z_NO_FLUSH$1, "string" == typeof t1 ? a1.input = strings.string2buf(t1) : "[object ArrayBuffer]" === toString$1.call(t1) ? a1.input = new Uint8Array(t1) : a1.input = t1, a1.next_in = 0, a1.avail_in = a1.input.length;;)if (0 === a1.avail_out && (a1.output = new Uint8Array(s1), a1.next_out = 0, a1.avail_out = s1), (r1 === Z_SYNC_FLUSH || r1 === Z_FULL_FLUSH) && a1.avail_out <= 6) this.onData(a1.output.subarray(0, a1.next_out)), a1.avail_out = 0;
        else {
            if ((i1 = deflate_1$2.deflate(a1, r1)) === Z_STREAM_END$2) return a1.next_out > 0 && this.onData(a1.output.subarray(0, a1.next_out)), i1 = deflate_1$2.deflateEnd(this.strm), this.onEnd(i1), this.ended = !0, i1 === Z_OK$2;
            if (0 !== a1.avail_out) {
                if (r1 > 0 && a1.next_out > 0) this.onData(a1.output.subarray(0, a1.next_out)), a1.avail_out = 0;
                else if (0 === a1.avail_in) break;
            } else this.onData(a1.output);
        }
        return !0;
    }, Deflate$1.prototype.onData = function(t1) {
        this.chunks.push(t1);
    }, Deflate$1.prototype.onEnd = function(t1) {
        t1 === Z_OK$2 && (this.result = common.flattenChunks(this.chunks)), this.chunks = [], this.err = t1, this.msg = this.strm.msg;
    };
    var BAD$1 = 30, TYPE$1 = 12, inffast = function(t1, e1) {
        var i1, r1, a1, s1, n1, o1, h1, l1, p1, f1, d1, c1, m1, u1, y1, g1, _1, v1, b1, E1, S1, A1, P1, x1, T1 = t1.state;
        i1 = t1.next_in, P1 = t1.input, r1 = i1 + (t1.avail_in - 5), a1 = t1.next_out, x1 = t1.output, s1 = a1 - (e1 - t1.avail_out), n1 = a1 + (t1.avail_out - 257), o1 = T1.dmax, h1 = T1.wsize, l1 = T1.whave, p1 = T1.wnext, f1 = T1.window, d1 = T1.hold, c1 = T1.bits, m1 = T1.lencode, u1 = T1.distcode, y1 = (1 << T1.lenbits) - 1, g1 = (1 << T1.distbits) - 1;
        t: do {
            c1 < 15 && (d1 += P1[i1++] << c1, c1 += 8, d1 += P1[i1++] << c1, c1 += 8), _1 = m1[d1 & y1];
            e: for(;;){
                if (d1 >>>= v1 = _1 >>> 24, c1 -= v1, 0 === (v1 = _1 >>> 16 & 255)) x1[a1++] = 65535 & _1;
                else {
                    if (!(16 & v1)) {
                        if (0 == (64 & v1)) {
                            _1 = m1[(65535 & _1) + (d1 & (1 << v1) - 1)];
                            continue e;
                        }
                        if (32 & v1) {
                            T1.mode = TYPE$1;
                            break t;
                        }
                        t1.msg = "invalid literal/length code", T1.mode = BAD$1;
                        break t;
                    }
                    b1 = 65535 & _1, (v1 &= 15) && (c1 < v1 && (d1 += P1[i1++] << c1, c1 += 8), b1 += d1 & (1 << v1) - 1, d1 >>>= v1, c1 -= v1), c1 < 15 && (d1 += P1[i1++] << c1, c1 += 8, d1 += P1[i1++] << c1, c1 += 8), _1 = u1[d1 & g1];
                    i: for(;;){
                        if (d1 >>>= v1 = _1 >>> 24, c1 -= v1, !(16 & (v1 = _1 >>> 16 & 255))) {
                            if (0 == (64 & v1)) {
                                _1 = u1[(65535 & _1) + (d1 & (1 << v1) - 1)];
                                continue i;
                            }
                            t1.msg = "invalid distance code", T1.mode = BAD$1;
                            break t;
                        }
                        if (E1 = 65535 & _1, c1 < (v1 &= 15) && (d1 += P1[i1++] << c1, (c1 += 8) < v1 && (d1 += P1[i1++] << c1, c1 += 8)), (E1 += d1 & (1 << v1) - 1) > o1) {
                            t1.msg = "invalid distance too far back", T1.mode = BAD$1;
                            break t;
                        }
                        if (d1 >>>= v1, c1 -= v1, E1 > (v1 = a1 - s1)) {
                            if ((v1 = E1 - v1) > l1 && T1.sane) {
                                t1.msg = "invalid distance too far back", T1.mode = BAD$1;
                                break t;
                            }
                            if (S1 = 0, A1 = f1, 0 === p1) {
                                if (S1 += h1 - v1, v1 < b1) {
                                    b1 -= v1;
                                    do x1[a1++] = f1[S1++];
                                    while (--v1);
                                    S1 = a1 - E1, A1 = x1;
                                }
                            } else if (p1 < v1) {
                                if (S1 += h1 + p1 - v1, (v1 -= p1) < b1) {
                                    b1 -= v1;
                                    do x1[a1++] = f1[S1++];
                                    while (--v1);
                                    if (S1 = 0, p1 < b1) {
                                        b1 -= v1 = p1;
                                        do x1[a1++] = f1[S1++];
                                        while (--v1);
                                        S1 = a1 - E1, A1 = x1;
                                    }
                                }
                            } else if (S1 += p1 - v1, v1 < b1) {
                                b1 -= v1;
                                do x1[a1++] = f1[S1++];
                                while (--v1);
                                S1 = a1 - E1, A1 = x1;
                            }
                            for(; b1 > 2;)x1[a1++] = A1[S1++], x1[a1++] = A1[S1++], x1[a1++] = A1[S1++], b1 -= 3;
                            b1 && (x1[a1++] = A1[S1++], b1 > 1 && (x1[a1++] = A1[S1++]));
                        } else {
                            S1 = a1 - E1;
                            do x1[a1++] = x1[S1++], x1[a1++] = x1[S1++], x1[a1++] = x1[S1++], b1 -= 3;
                            while (b1 > 2);
                            b1 && (x1[a1++] = x1[S1++], b1 > 1 && (x1[a1++] = x1[S1++]));
                        }
                        break;
                    }
                }
                break;
            }
        }while (i1 < r1 && a1 < n1);
        i1 -= b1 = c1 >> 3, d1 &= (1 << (c1 -= b1 << 3)) - 1, t1.next_in = i1, t1.next_out = a1, t1.avail_in = i1 < r1 ? r1 - i1 + 5 : 5 - (i1 - r1), t1.avail_out = a1 < n1 ? n1 - a1 + 257 : 257 - (a1 - n1), T1.hold = d1, T1.bits = c1;
    }, MAXBITS = 15, ENOUGH_LENS$1 = 852, ENOUGH_DISTS$1 = 592, CODES$1 = 0, LENS$1 = 1, DISTS$1 = 2, lbase = new Uint16Array([
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        13,
        15,
        17,
        19,
        23,
        27,
        31,
        35,
        43,
        51,
        59,
        67,
        83,
        99,
        115,
        131,
        163,
        195,
        227,
        258,
        0,
        0
    ]), lext = new Uint8Array([
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        17,
        17,
        17,
        17,
        18,
        18,
        18,
        18,
        19,
        19,
        19,
        19,
        20,
        20,
        20,
        20,
        21,
        21,
        21,
        21,
        16,
        72,
        78
    ]), dbase = new Uint16Array([
        1,
        2,
        3,
        4,
        5,
        7,
        9,
        13,
        17,
        25,
        33,
        49,
        65,
        97,
        129,
        193,
        257,
        385,
        513,
        769,
        1025,
        1537,
        2049,
        3073,
        4097,
        6145,
        8193,
        12289,
        16385,
        24577,
        0,
        0
    ]), dext = new Uint8Array([
        16,
        16,
        16,
        16,
        17,
        17,
        18,
        18,
        19,
        19,
        20,
        20,
        21,
        21,
        22,
        22,
        23,
        23,
        24,
        24,
        25,
        25,
        26,
        26,
        27,
        27,
        28,
        28,
        29,
        29,
        64,
        64
    ]), inflate_table = (t1, e1, i1, r1, a1, s1, n1, o1)=>{
        var h1, l1, p1, f1, d1, c1, m1, u1, y1, g1 = o1.bits, _1 = 0, v1 = 0, b1 = 0, E1 = 0, S1 = 0, A1 = 0, P1 = 0, x1 = 0, T1 = 0, w1 = 0, C1 = null, k1 = 0, D1 = new Uint16Array(MAXBITS + 1), M1 = new Uint16Array(MAXBITS + 1), I1 = null, F1 = 0;
        for(_1 = 0; _1 <= MAXBITS; _1++)D1[_1] = 0;
        for(v1 = 0; v1 < r1; v1++)D1[e1[i1 + v1]]++;
        for(S1 = g1, E1 = MAXBITS; E1 >= 1 && 0 === D1[E1]; E1--);
        if (S1 > E1 && (S1 = E1), 0 === E1) return a1[s1++] = 20971520, a1[s1++] = 20971520, o1.bits = 1, 0;
        for(b1 = 1; b1 < E1 && 0 === D1[b1]; b1++);
        for(S1 < b1 && (S1 = b1), x1 = 1, _1 = 1; _1 <= MAXBITS; _1++)if (x1 <<= 1, (x1 -= D1[_1]) < 0) return -1;
        if (x1 > 0 && (t1 === CODES$1 || 1 !== E1)) return -1;
        for(M1[1] = 0, _1 = 1; _1 < MAXBITS; _1++)M1[_1 + 1] = M1[_1] + D1[_1];
        for(v1 = 0; v1 < r1; v1++)0 !== e1[i1 + v1] && (n1[M1[e1[i1 + v1]]++] = v1);
        if (t1 === CODES$1 ? (C1 = I1 = n1, c1 = 19) : t1 === LENS$1 ? (C1 = lbase, k1 -= 257, I1 = lext, F1 -= 257, c1 = 256) : (C1 = dbase, I1 = dext, c1 = -1), w1 = 0, v1 = 0, _1 = b1, d1 = s1, A1 = S1, P1 = 0, p1 = -1, f1 = (T1 = 1 << S1) - 1, t1 === LENS$1 && T1 > ENOUGH_LENS$1 || t1 === DISTS$1 && T1 > ENOUGH_DISTS$1) return 1;
        for(;;){
            m1 = _1 - P1, n1[v1] < c1 ? (u1 = 0, y1 = n1[v1]) : n1[v1] > c1 ? (u1 = I1[F1 + n1[v1]], y1 = C1[k1 + n1[v1]]) : (u1 = 96, y1 = 0), h1 = 1 << _1 - P1, b1 = l1 = 1 << A1;
            do a1[d1 + (w1 >> P1) + (l1 -= h1)] = m1 << 24 | u1 << 16 | y1 | 0;
            while (0 !== l1);
            for(h1 = 1 << _1 - 1; w1 & h1;)h1 >>= 1;
            if (0 !== h1 ? (w1 &= h1 - 1, w1 += h1) : w1 = 0, v1++, 0 == --D1[_1]) {
                if (_1 === E1) break;
                _1 = e1[i1 + n1[v1]];
            }
            if (_1 > S1 && (w1 & f1) !== p1) {
                for(0 === P1 && (P1 = S1), d1 += b1, x1 = 1 << (A1 = _1 - P1); A1 + P1 < E1 && !((x1 -= D1[A1 + P1]) <= 0);)A1++, x1 <<= 1;
                if (T1 += 1 << A1, t1 === LENS$1 && T1 > ENOUGH_LENS$1 || t1 === DISTS$1 && T1 > ENOUGH_DISTS$1) return 1;
                a1[p1 = w1 & f1] = S1 << 24 | A1 << 16 | d1 - s1 | 0;
            }
        }
        return 0 !== w1 && (a1[d1 + w1] = _1 - P1 << 24 | 4194304), o1.bits = S1, 0;
    }, inftrees = inflate_table, CODES = 0, LENS = 1, DISTS = 2, { Z_FINISH: Z_FINISH$1, Z_BLOCK: Z_BLOCK, Z_TREES: Z_TREES, Z_OK: Z_OK$1, Z_STREAM_END: Z_STREAM_END$1, Z_NEED_DICT: Z_NEED_DICT$1, Z_STREAM_ERROR: Z_STREAM_ERROR$1, Z_DATA_ERROR: Z_DATA_ERROR$1, Z_MEM_ERROR: Z_MEM_ERROR$1, Z_BUF_ERROR: Z_BUF_ERROR, Z_DEFLATED: Z_DEFLATED } = constants$2, HEAD = 1, FLAGS = 2, TIME = 3, OS = 4, EXLEN = 5, EXTRA = 6, NAME = 7, COMMENT = 8, HCRC = 9, DICTID = 10, DICT = 11, TYPE = 12, TYPEDO = 13, STORED = 14, COPY_ = 15, COPY = 16, TABLE = 17, LENLENS = 18, CODELENS = 19, LEN_ = 20, LEN = 21, LENEXT = 22, DIST = 23, DISTEXT = 24, MATCH = 25, LIT = 26, CHECK = 27, LENGTH = 28, DONE = 29, BAD = 30, MEM = 31, SYNC = 32, ENOUGH_LENS = 852, ENOUGH_DISTS = 592, MAX_WBITS = 15, DEF_WBITS = MAX_WBITS, zswap32 = (t1)=>(t1 >>> 24 & 255) + (t1 >>> 8 & 65280) + ((65280 & t1) << 8) + ((255 & t1) << 24);
    function InflateState() {
        this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
    }
    var inflateResetKeep = (t1)=>{
        if (!t1 || !t1.state) return Z_STREAM_ERROR$1;
        var e1 = t1.state;
        return t1.total_in = t1.total_out = e1.total = 0, t1.msg = "", e1.wrap && (t1.adler = 1 & e1.wrap), e1.mode = HEAD, e1.last = 0, e1.havedict = 0, e1.dmax = 32768, e1.head = null, e1.hold = 0, e1.bits = 0, e1.lencode = e1.lendyn = new Int32Array(ENOUGH_LENS), e1.distcode = e1.distdyn = new Int32Array(ENOUGH_DISTS), e1.sane = 1, e1.back = -1, Z_OK$1;
    }, inflateReset = (t1)=>{
        if (!t1 || !t1.state) return Z_STREAM_ERROR$1;
        var e1 = t1.state;
        return e1.wsize = 0, e1.whave = 0, e1.wnext = 0, inflateResetKeep(t1);
    }, inflateReset2 = (t1, e1)=>{
        var i1;
        if (!t1 || !t1.state) return Z_STREAM_ERROR$1;
        var r1 = t1.state;
        return e1 < 0 ? (i1 = 0, e1 = -e1) : (i1 = 1 + (e1 >> 4), e1 < 48 && (e1 &= 15)), e1 && (e1 < 8 || e1 > 15) ? Z_STREAM_ERROR$1 : (null !== r1.window && r1.wbits !== e1 && (r1.window = null), r1.wrap = i1, r1.wbits = e1, inflateReset(t1));
    }, inflateInit2 = (t1, e1)=>{
        if (!t1) return Z_STREAM_ERROR$1;
        var i1 = new InflateState;
        t1.state = i1, i1.window = null;
        var r1 = inflateReset2(t1, e1);
        return r1 !== Z_OK$1 && (t1.state = null), r1;
    }, inflateInit = (t1)=>inflateInit2(t1, DEF_WBITS), virgin = !0, lenfix, distfix, fixedtables = (t1)=>{
        if (virgin) {
            lenfix = new Int32Array(512), distfix = new Int32Array(32);
            for(var e1 = 0; e1 < 144;)t1.lens[e1++] = 8;
            for(; e1 < 256;)t1.lens[e1++] = 9;
            for(; e1 < 280;)t1.lens[e1++] = 7;
            for(; e1 < 288;)t1.lens[e1++] = 8;
            for(inftrees(LENS, t1.lens, 0, 288, lenfix, 0, t1.work, {
                bits: 9
            }), e1 = 0; e1 < 32;)t1.lens[e1++] = 5;
            inftrees(DISTS, t1.lens, 0, 32, distfix, 0, t1.work, {
                bits: 5
            }), virgin = !1;
        }
        t1.lencode = lenfix, t1.lenbits = 9, t1.distcode = distfix, t1.distbits = 5;
    }, updatewindow = (t1, e1, i1, r1)=>{
        var a1, s1 = t1.state;
        return null === s1.window && (s1.wsize = 1 << s1.wbits, s1.wnext = 0, s1.whave = 0, s1.window = new Uint8Array(s1.wsize)), r1 >= s1.wsize ? (s1.window.set(e1.subarray(i1 - s1.wsize, i1), 0), s1.wnext = 0, s1.whave = s1.wsize) : ((a1 = s1.wsize - s1.wnext) > r1 && (a1 = r1), s1.window.set(e1.subarray(i1 - r1, i1 - r1 + a1), s1.wnext), (r1 -= a1) ? (s1.window.set(e1.subarray(i1 - r1, i1), 0), s1.wnext = r1, s1.whave = s1.wsize) : (s1.wnext += a1, s1.wnext === s1.wsize && (s1.wnext = 0), s1.whave < s1.wsize && (s1.whave += a1))), 0;
    }, inflate$2 = (t1, e1)=>{
        var i1, r1, a1, s1, n1, o1, h1, l1, p1, f1, d1, c1, m1, u1, y1, g1, _1, v1, b1, E1, S1, A1, P1, x1, T1 = 0, w1 = new Uint8Array(4), C1 = new Uint8Array([
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ]);
        if (!t1 || !t1.state || !t1.output || !t1.input && 0 !== t1.avail_in) return Z_STREAM_ERROR$1;
        (i1 = t1.state).mode === TYPE && (i1.mode = TYPEDO), n1 = t1.next_out, a1 = t1.output, h1 = t1.avail_out, s1 = t1.next_in, r1 = t1.input, o1 = t1.avail_in, l1 = i1.hold, p1 = i1.bits, f1 = o1, d1 = h1, A1 = Z_OK$1;
        t: for(;;)switch(i1.mode){
            case HEAD:
                if (0 === i1.wrap) {
                    i1.mode = TYPEDO;
                    break;
                }
                for(; p1 < 16;){
                    if (0 === o1) break t;
                    o1--, l1 += r1[s1++] << p1, p1 += 8;
                }
                if (2 & i1.wrap && 35615 === l1) {
                    i1.check = 0, w1[0] = 255 & l1, w1[1] = l1 >>> 8 & 255, i1.check = crc32_1(i1.check, w1, 2, 0), l1 = 0, p1 = 0, i1.mode = FLAGS;
                    break;
                }
                if (i1.flags = 0, i1.head && (i1.head.done = !1), !(1 & i1.wrap) || (((255 & l1) << 8) + (l1 >> 8)) % 31) {
                    t1.msg = "incorrect header check", i1.mode = BAD;
                    break;
                }
                if ((15 & l1) !== Z_DEFLATED) {
                    t1.msg = "unknown compression method", i1.mode = BAD;
                    break;
                }
                if (p1 -= 4, S1 = 8 + (15 & (l1 >>>= 4)), 0 === i1.wbits) i1.wbits = S1;
                else if (S1 > i1.wbits) {
                    t1.msg = "invalid window size", i1.mode = BAD;
                    break;
                }
                i1.dmax = 1 << i1.wbits, t1.adler = i1.check = 1, i1.mode = 512 & l1 ? DICTID : TYPE, l1 = 0, p1 = 0;
                break;
            case FLAGS:
                for(; p1 < 16;){
                    if (0 === o1) break t;
                    o1--, l1 += r1[s1++] << p1, p1 += 8;
                }
                if (i1.flags = l1, (255 & i1.flags) !== Z_DEFLATED) {
                    t1.msg = "unknown compression method", i1.mode = BAD;
                    break;
                }
                if (57344 & i1.flags) {
                    t1.msg = "unknown header flags set", i1.mode = BAD;
                    break;
                }
                i1.head && (i1.head.text = l1 >> 8 & 1), 512 & i1.flags && (w1[0] = 255 & l1, w1[1] = l1 >>> 8 & 255, i1.check = crc32_1(i1.check, w1, 2, 0)), l1 = 0, p1 = 0, i1.mode = TIME;
            case TIME:
                for(; p1 < 32;){
                    if (0 === o1) break t;
                    o1--, l1 += r1[s1++] << p1, p1 += 8;
                }
                i1.head && (i1.head.time = l1), 512 & i1.flags && (w1[0] = 255 & l1, w1[1] = l1 >>> 8 & 255, w1[2] = l1 >>> 16 & 255, w1[3] = l1 >>> 24 & 255, i1.check = crc32_1(i1.check, w1, 4, 0)), l1 = 0, p1 = 0, i1.mode = OS;
            case OS:
                for(; p1 < 16;){
                    if (0 === o1) break t;
                    o1--, l1 += r1[s1++] << p1, p1 += 8;
                }
                i1.head && (i1.head.xflags = 255 & l1, i1.head.os = l1 >> 8), 512 & i1.flags && (w1[0] = 255 & l1, w1[1] = l1 >>> 8 & 255, i1.check = crc32_1(i1.check, w1, 2, 0)), l1 = 0, p1 = 0, i1.mode = EXLEN;
            case EXLEN:
                if (1024 & i1.flags) {
                    for(; p1 < 16;){
                        if (0 === o1) break t;
                        o1--, l1 += r1[s1++] << p1, p1 += 8;
                    }
                    i1.length = l1, i1.head && (i1.head.extra_len = l1), 512 & i1.flags && (w1[0] = 255 & l1, w1[1] = l1 >>> 8 & 255, i1.check = crc32_1(i1.check, w1, 2, 0)), l1 = 0, p1 = 0;
                } else i1.head && (i1.head.extra = null);
                i1.mode = EXTRA;
            case EXTRA:
                if (1024 & i1.flags && ((c1 = i1.length) > o1 && (c1 = o1), c1 && (i1.head && (S1 = i1.head.extra_len - i1.length, i1.head.extra || (i1.head.extra = new Uint8Array(i1.head.extra_len)), i1.head.extra.set(r1.subarray(s1, s1 + c1), S1)), 512 & i1.flags && (i1.check = crc32_1(i1.check, r1, c1, s1)), o1 -= c1, s1 += c1, i1.length -= c1), i1.length)) break t;
                i1.length = 0, i1.mode = NAME;
            case NAME:
                if (2048 & i1.flags) {
                    if (0 === o1) break t;
                    c1 = 0;
                    do S1 = r1[s1 + c1++], i1.head && S1 && i1.length < 65536 && (i1.head.name += String.fromCharCode(S1));
                    while (S1 && c1 < o1);
                    if (512 & i1.flags && (i1.check = crc32_1(i1.check, r1, c1, s1)), o1 -= c1, s1 += c1, S1) break t;
                } else i1.head && (i1.head.name = null);
                i1.length = 0, i1.mode = COMMENT;
            case COMMENT:
                if (4096 & i1.flags) {
                    if (0 === o1) break t;
                    c1 = 0;
                    do S1 = r1[s1 + c1++], i1.head && S1 && i1.length < 65536 && (i1.head.comment += String.fromCharCode(S1));
                    while (S1 && c1 < o1);
                    if (512 & i1.flags && (i1.check = crc32_1(i1.check, r1, c1, s1)), o1 -= c1, s1 += c1, S1) break t;
                } else i1.head && (i1.head.comment = null);
                i1.mode = HCRC;
            case HCRC:
                if (512 & i1.flags) {
                    for(; p1 < 16;){
                        if (0 === o1) break t;
                        o1--, l1 += r1[s1++] << p1, p1 += 8;
                    }
                    if (l1 !== (65535 & i1.check)) {
                        t1.msg = "header crc mismatch", i1.mode = BAD;
                        break;
                    }
                    l1 = 0, p1 = 0;
                }
                i1.head && (i1.head.hcrc = i1.flags >> 9 & 1, i1.head.done = !0), t1.adler = i1.check = 0, i1.mode = TYPE;
                break;
            case DICTID:
                for(; p1 < 32;){
                    if (0 === o1) break t;
                    o1--, l1 += r1[s1++] << p1, p1 += 8;
                }
                t1.adler = i1.check = zswap32(l1), l1 = 0, p1 = 0, i1.mode = DICT;
            case DICT:
                if (0 === i1.havedict) return t1.next_out = n1, t1.avail_out = h1, t1.next_in = s1, t1.avail_in = o1, i1.hold = l1, i1.bits = p1, Z_NEED_DICT$1;
                t1.adler = i1.check = 1, i1.mode = TYPE;
            case TYPE:
                if (e1 === Z_BLOCK || e1 === Z_TREES) break t;
            case TYPEDO:
                if (i1.last) {
                    l1 >>>= 7 & p1, p1 -= 7 & p1, i1.mode = CHECK;
                    break;
                }
                for(; p1 < 3;){
                    if (0 === o1) break t;
                    o1--, l1 += r1[s1++] << p1, p1 += 8;
                }
                switch(i1.last = 1 & l1, p1 -= 1, 3 & (l1 >>>= 1)){
                    case 0:
                        i1.mode = STORED;
                        break;
                    case 1:
                        if (fixedtables(i1), i1.mode = LEN_, e1 === Z_TREES) {
                            l1 >>>= 2, p1 -= 2;
                            break t;
                        }
                        break;
                    case 2:
                        i1.mode = TABLE;
                        break;
                    case 3:
                        t1.msg = "invalid block type", i1.mode = BAD;
                }
                l1 >>>= 2, p1 -= 2;
                break;
            case STORED:
                for(l1 >>>= 7 & p1, p1 -= 7 & p1; p1 < 32;){
                    if (0 === o1) break t;
                    o1--, l1 += r1[s1++] << p1, p1 += 8;
                }
                if ((65535 & l1) != (l1 >>> 16 ^ 65535)) {
                    t1.msg = "invalid stored block lengths", i1.mode = BAD;
                    break;
                }
                if (i1.length = 65535 & l1, l1 = 0, p1 = 0, i1.mode = COPY_, e1 === Z_TREES) break t;
            case COPY_:
                i1.mode = COPY;
            case COPY:
                if (c1 = i1.length) {
                    if (c1 > o1 && (c1 = o1), c1 > h1 && (c1 = h1), 0 === c1) break t;
                    a1.set(r1.subarray(s1, s1 + c1), n1), o1 -= c1, s1 += c1, h1 -= c1, n1 += c1, i1.length -= c1;
                    break;
                }
                i1.mode = TYPE;
                break;
            case TABLE:
                for(; p1 < 14;){
                    if (0 === o1) break t;
                    o1--, l1 += r1[s1++] << p1, p1 += 8;
                }
                if (i1.nlen = 257 + (31 & l1), l1 >>>= 5, p1 -= 5, i1.ndist = 1 + (31 & l1), l1 >>>= 5, p1 -= 5, i1.ncode = 4 + (15 & l1), l1 >>>= 4, p1 -= 4, i1.nlen > 286 || i1.ndist > 30) {
                    t1.msg = "too many length or distance symbols", i1.mode = BAD;
                    break;
                }
                i1.have = 0, i1.mode = LENLENS;
            case LENLENS:
                for(; i1.have < i1.ncode;){
                    for(; p1 < 3;){
                        if (0 === o1) break t;
                        o1--, l1 += r1[s1++] << p1, p1 += 8;
                    }
                    i1.lens[C1[i1.have++]] = 7 & l1, l1 >>>= 3, p1 -= 3;
                }
                for(; i1.have < 19;)i1.lens[C1[i1.have++]] = 0;
                if (i1.lencode = i1.lendyn, i1.lenbits = 7, P1 = {
                    bits: i1.lenbits
                }, A1 = inftrees(CODES, i1.lens, 0, 19, i1.lencode, 0, i1.work, P1), i1.lenbits = P1.bits, A1) {
                    t1.msg = "invalid code lengths set", i1.mode = BAD;
                    break;
                }
                i1.have = 0, i1.mode = CODELENS;
            case CODELENS:
                for(; i1.have < i1.nlen + i1.ndist;){
                    for(; g1 = (T1 = i1.lencode[l1 & (1 << i1.lenbits) - 1]) >>> 16 & 255, _1 = 65535 & T1, !((y1 = T1 >>> 24) <= p1);){
                        if (0 === o1) break t;
                        o1--, l1 += r1[s1++] << p1, p1 += 8;
                    }
                    if (_1 < 16) l1 >>>= y1, p1 -= y1, i1.lens[i1.have++] = _1;
                    else {
                        if (16 === _1) {
                            for(x1 = y1 + 2; p1 < x1;){
                                if (0 === o1) break t;
                                o1--, l1 += r1[s1++] << p1, p1 += 8;
                            }
                            if (l1 >>>= y1, p1 -= y1, 0 === i1.have) {
                                t1.msg = "invalid bit length repeat", i1.mode = BAD;
                                break;
                            }
                            S1 = i1.lens[i1.have - 1], c1 = 3 + (3 & l1), l1 >>>= 2, p1 -= 2;
                        } else if (17 === _1) {
                            for(x1 = y1 + 3; p1 < x1;){
                                if (0 === o1) break t;
                                o1--, l1 += r1[s1++] << p1, p1 += 8;
                            }
                            p1 -= y1, S1 = 0, c1 = 3 + (7 & (l1 >>>= y1)), l1 >>>= 3, p1 -= 3;
                        } else {
                            for(x1 = y1 + 7; p1 < x1;){
                                if (0 === o1) break t;
                                o1--, l1 += r1[s1++] << p1, p1 += 8;
                            }
                            p1 -= y1, S1 = 0, c1 = 11 + (127 & (l1 >>>= y1)), l1 >>>= 7, p1 -= 7;
                        }
                        if (i1.have + c1 > i1.nlen + i1.ndist) {
                            t1.msg = "invalid bit length repeat", i1.mode = BAD;
                            break;
                        }
                        for(; c1--;)i1.lens[i1.have++] = S1;
                    }
                }
                if (i1.mode === BAD) break;
                if (0 === i1.lens[256]) {
                    t1.msg = "invalid code -- missing end-of-block", i1.mode = BAD;
                    break;
                }
                if (i1.lenbits = 9, P1 = {
                    bits: i1.lenbits
                }, A1 = inftrees(LENS, i1.lens, 0, i1.nlen, i1.lencode, 0, i1.work, P1), i1.lenbits = P1.bits, A1) {
                    t1.msg = "invalid literal/lengths set", i1.mode = BAD;
                    break;
                }
                if (i1.distbits = 6, i1.distcode = i1.distdyn, P1 = {
                    bits: i1.distbits
                }, A1 = inftrees(DISTS, i1.lens, i1.nlen, i1.ndist, i1.distcode, 0, i1.work, P1), i1.distbits = P1.bits, A1) {
                    t1.msg = "invalid distances set", i1.mode = BAD;
                    break;
                }
                if (i1.mode = LEN_, e1 === Z_TREES) break t;
            case LEN_:
                i1.mode = LEN;
            case LEN:
                if (o1 >= 6 && h1 >= 258) {
                    t1.next_out = n1, t1.avail_out = h1, t1.next_in = s1, t1.avail_in = o1, i1.hold = l1, i1.bits = p1, inffast(t1, d1), n1 = t1.next_out, a1 = t1.output, h1 = t1.avail_out, s1 = t1.next_in, r1 = t1.input, o1 = t1.avail_in, l1 = i1.hold, p1 = i1.bits, i1.mode === TYPE && (i1.back = -1);
                    break;
                }
                for(i1.back = 0; g1 = (T1 = i1.lencode[l1 & (1 << i1.lenbits) - 1]) >>> 16 & 255, _1 = 65535 & T1, !((y1 = T1 >>> 24) <= p1);){
                    if (0 === o1) break t;
                    o1--, l1 += r1[s1++] << p1, p1 += 8;
                }
                if (g1 && 0 == (240 & g1)) {
                    for(v1 = y1, b1 = g1, E1 = _1; g1 = (T1 = i1.lencode[E1 + ((l1 & (1 << v1 + b1) - 1) >> v1)]) >>> 16 & 255, _1 = 65535 & T1, !(v1 + (y1 = T1 >>> 24) <= p1);){
                        if (0 === o1) break t;
                        o1--, l1 += r1[s1++] << p1, p1 += 8;
                    }
                    l1 >>>= v1, p1 -= v1, i1.back += v1;
                }
                if (l1 >>>= y1, p1 -= y1, i1.back += y1, i1.length = _1, 0 === g1) {
                    i1.mode = LIT;
                    break;
                }
                if (32 & g1) {
                    i1.back = -1, i1.mode = TYPE;
                    break;
                }
                if (64 & g1) {
                    t1.msg = "invalid literal/length code", i1.mode = BAD;
                    break;
                }
                i1.extra = 15 & g1, i1.mode = LENEXT;
            case LENEXT:
                if (i1.extra) {
                    for(x1 = i1.extra; p1 < x1;){
                        if (0 === o1) break t;
                        o1--, l1 += r1[s1++] << p1, p1 += 8;
                    }
                    i1.length += l1 & (1 << i1.extra) - 1, l1 >>>= i1.extra, p1 -= i1.extra, i1.back += i1.extra;
                }
                i1.was = i1.length, i1.mode = DIST;
            case DIST:
                for(; g1 = (T1 = i1.distcode[l1 & (1 << i1.distbits) - 1]) >>> 16 & 255, _1 = 65535 & T1, !((y1 = T1 >>> 24) <= p1);){
                    if (0 === o1) break t;
                    o1--, l1 += r1[s1++] << p1, p1 += 8;
                }
                if (0 == (240 & g1)) {
                    for(v1 = y1, b1 = g1, E1 = _1; g1 = (T1 = i1.distcode[E1 + ((l1 & (1 << v1 + b1) - 1) >> v1)]) >>> 16 & 255, _1 = 65535 & T1, !(v1 + (y1 = T1 >>> 24) <= p1);){
                        if (0 === o1) break t;
                        o1--, l1 += r1[s1++] << p1, p1 += 8;
                    }
                    l1 >>>= v1, p1 -= v1, i1.back += v1;
                }
                if (l1 >>>= y1, p1 -= y1, i1.back += y1, 64 & g1) {
                    t1.msg = "invalid distance code", i1.mode = BAD;
                    break;
                }
                i1.offset = _1, i1.extra = 15 & g1, i1.mode = DISTEXT;
            case DISTEXT:
                if (i1.extra) {
                    for(x1 = i1.extra; p1 < x1;){
                        if (0 === o1) break t;
                        o1--, l1 += r1[s1++] << p1, p1 += 8;
                    }
                    i1.offset += l1 & (1 << i1.extra) - 1, l1 >>>= i1.extra, p1 -= i1.extra, i1.back += i1.extra;
                }
                if (i1.offset > i1.dmax) {
                    t1.msg = "invalid distance too far back", i1.mode = BAD;
                    break;
                }
                i1.mode = MATCH;
            case MATCH:
                if (0 === h1) break t;
                if (c1 = d1 - h1, i1.offset > c1) {
                    if ((c1 = i1.offset - c1) > i1.whave && i1.sane) {
                        t1.msg = "invalid distance too far back", i1.mode = BAD;
                        break;
                    }
                    c1 > i1.wnext ? (c1 -= i1.wnext, m1 = i1.wsize - c1) : m1 = i1.wnext - c1, c1 > i1.length && (c1 = i1.length), u1 = i1.window;
                } else u1 = a1, m1 = n1 - i1.offset, c1 = i1.length;
                c1 > h1 && (c1 = h1), h1 -= c1, i1.length -= c1;
                do a1[n1++] = u1[m1++];
                while (--c1);
                0 === i1.length && (i1.mode = LEN);
                break;
            case LIT:
                if (0 === h1) break t;
                a1[n1++] = i1.length, h1--, i1.mode = LEN;
                break;
            case CHECK:
                if (i1.wrap) {
                    for(; p1 < 32;){
                        if (0 === o1) break t;
                        o1--, l1 |= r1[s1++] << p1, p1 += 8;
                    }
                    if (d1 -= h1, t1.total_out += d1, i1.total += d1, d1 && (t1.adler = i1.check = i1.flags ? crc32_1(i1.check, a1, d1, n1 - d1) : adler32_1(i1.check, a1, d1, n1 - d1)), d1 = h1, (i1.flags ? l1 : zswap32(l1)) !== i1.check) {
                        t1.msg = "incorrect data check", i1.mode = BAD;
                        break;
                    }
                    l1 = 0, p1 = 0;
                }
                i1.mode = LENGTH;
            case LENGTH:
                if (i1.wrap && i1.flags) {
                    for(; p1 < 32;){
                        if (0 === o1) break t;
                        o1--, l1 += r1[s1++] << p1, p1 += 8;
                    }
                    if (l1 !== (4294967295 & i1.total)) {
                        t1.msg = "incorrect length check", i1.mode = BAD;
                        break;
                    }
                    l1 = 0, p1 = 0;
                }
                i1.mode = DONE;
            case DONE:
                A1 = Z_STREAM_END$1;
                break t;
            case BAD:
                A1 = Z_DATA_ERROR$1;
                break t;
            case MEM:
                return Z_MEM_ERROR$1;
            default:
                return Z_STREAM_ERROR$1;
        }
        return t1.next_out = n1, t1.avail_out = h1, t1.next_in = s1, t1.avail_in = o1, i1.hold = l1, i1.bits = p1, (i1.wsize || d1 !== t1.avail_out && i1.mode < BAD && (i1.mode < CHECK || e1 !== Z_FINISH$1)) && updatewindow(t1, t1.output, t1.next_out, d1 - t1.avail_out), f1 -= t1.avail_in, d1 -= t1.avail_out, t1.total_in += f1, t1.total_out += d1, i1.total += d1, i1.wrap && d1 && (t1.adler = i1.check = i1.flags ? crc32_1(i1.check, a1, d1, t1.next_out - d1) : adler32_1(i1.check, a1, d1, t1.next_out - d1)), t1.data_type = i1.bits + (i1.last ? 64 : 0) + (i1.mode === TYPE ? 128 : 0) + (i1.mode === LEN_ || i1.mode === COPY_ ? 256 : 0), (0 === f1 && 0 === d1 || e1 === Z_FINISH$1) && A1 === Z_OK$1 && (A1 = Z_BUF_ERROR), A1;
    }, inflateEnd = (t1)=>{
        if (!t1 || !t1.state) return Z_STREAM_ERROR$1;
        var e1 = t1.state;
        return e1.window && (e1.window = null), t1.state = null, Z_OK$1;
    }, inflateGetHeader = (t1, e1)=>{
        if (!t1 || !t1.state) return Z_STREAM_ERROR$1;
        var i1 = t1.state;
        return 0 == (2 & i1.wrap) ? Z_STREAM_ERROR$1 : (i1.head = e1, e1.done = !1, Z_OK$1);
    }, inflateSetDictionary = (t1, e1)=>{
        var i1, r1 = e1.length;
        return t1 && t1.state ? 0 !== (i1 = t1.state).wrap && i1.mode !== DICT ? Z_STREAM_ERROR$1 : i1.mode === DICT && adler32_1(1, e1, r1, 0) !== i1.check ? Z_DATA_ERROR$1 : updatewindow(t1, e1, r1, r1) ? (i1.mode = MEM, Z_MEM_ERROR$1) : (i1.havedict = 1, Z_OK$1) : Z_STREAM_ERROR$1;
    }, inflateReset_1 = inflateReset, inflateReset2_1 = inflateReset2, inflateResetKeep_1 = inflateResetKeep, inflateInit_1 = inflateInit, inflateInit2_1 = inflateInit2, inflate_2$1 = inflate$2, inflateEnd_1 = inflateEnd, inflateGetHeader_1 = inflateGetHeader, inflateSetDictionary_1 = inflateSetDictionary, inflateInfo = "pako inflate (from Nodeca project)", inflate_1$2 = {
        inflateReset: inflateReset_1,
        inflateReset2: inflateReset2_1,
        inflateResetKeep: inflateResetKeep_1,
        inflateInit: inflateInit_1,
        inflateInit2: inflateInit2_1,
        inflate: inflate_2$1,
        inflateEnd: inflateEnd_1,
        inflateGetHeader: inflateGetHeader_1,
        inflateSetDictionary: inflateSetDictionary_1,
        inflateInfo: inflateInfo
    };
    function GZheader() {
        this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
    }
    var gzheader = GZheader, toString = Object.prototype.toString, { Z_NO_FLUSH: Z_NO_FLUSH, Z_FINISH: Z_FINISH, Z_OK: Z_OK, Z_STREAM_END: Z_STREAM_END, Z_NEED_DICT: Z_NEED_DICT, Z_STREAM_ERROR: Z_STREAM_ERROR, Z_DATA_ERROR: Z_DATA_ERROR, Z_MEM_ERROR: Z_MEM_ERROR } = constants$2;
    function Inflate$1(t1) {
        this.options = common.assign({
            chunkSize: 65536,
            windowBits: 15,
            to: ""
        }, t1 || {});
        var e1 = this.options;
        e1.raw && e1.windowBits >= 0 && e1.windowBits < 16 && (e1.windowBits = -e1.windowBits, 0 === e1.windowBits && (e1.windowBits = -15)), !(e1.windowBits >= 0 && e1.windowBits < 16) || t1 && t1.windowBits || (e1.windowBits += 32), e1.windowBits > 15 && e1.windowBits < 48 && 0 == (15 & e1.windowBits) && (e1.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new zstream, this.strm.avail_out = 0;
        var i1 = inflate_1$2.inflateInit2(this.strm, e1.windowBits);
        if (i1 !== Z_OK) throw new Error(messages[i1]);
        if (this.header = new gzheader, inflate_1$2.inflateGetHeader(this.strm, this.header), e1.dictionary && ("string" == typeof e1.dictionary ? e1.dictionary = strings.string2buf(e1.dictionary) : "[object ArrayBuffer]" === toString.call(e1.dictionary) && (e1.dictionary = new Uint8Array(e1.dictionary)), e1.raw && (i1 = inflate_1$2.inflateSetDictionary(this.strm, e1.dictionary)) !== Z_OK)) throw new Error(messages[i1]);
    }
    function inflate$1(t1, e1) {
        var i1 = new Inflate$1(e1);
        if (i1.push(t1), i1.err) throw i1.msg || messages[i1.err];
        return i1.result;
    }
    function inflateRaw$1(t1, e1) {
        return (e1 = e1 || {}).raw = !0, inflate$1(t1, e1);
    }
    Inflate$1.prototype.push = function(t1, e1) {
        var i1, r1, a1, s1 = this.strm, n1 = this.options.chunkSize, o1 = this.options.dictionary;
        if (this.ended) return !1;
        for(r1 = e1 === ~~e1 ? e1 : !0 === e1 ? Z_FINISH : Z_NO_FLUSH, "[object ArrayBuffer]" === toString.call(t1) ? s1.input = new Uint8Array(t1) : s1.input = t1, s1.next_in = 0, s1.avail_in = s1.input.length;;){
            for(0 === s1.avail_out && (s1.output = new Uint8Array(n1), s1.next_out = 0, s1.avail_out = n1), (i1 = inflate_1$2.inflate(s1, r1)) === Z_NEED_DICT && o1 && ((i1 = inflate_1$2.inflateSetDictionary(s1, o1)) === Z_OK ? i1 = inflate_1$2.inflate(s1, r1) : i1 === Z_DATA_ERROR && (i1 = Z_NEED_DICT)); s1.avail_in > 0 && i1 === Z_STREAM_END && s1.state.wrap > 0 && 0 !== t1[s1.next_in];)inflate_1$2.inflateReset(s1), i1 = inflate_1$2.inflate(s1, r1);
            switch(i1){
                case Z_STREAM_ERROR:
                case Z_DATA_ERROR:
                case Z_NEED_DICT:
                case Z_MEM_ERROR:
                    return this.onEnd(i1), this.ended = !0, !1;
            }
            if (a1 = s1.avail_out, s1.next_out && (0 === s1.avail_out || i1 === Z_STREAM_END)) {
                if ("string" === this.options.to) {
                    var h1 = strings.utf8border(s1.output, s1.next_out), l1 = s1.next_out - h1, p1 = strings.buf2string(s1.output, h1);
                    s1.next_out = l1, s1.avail_out = n1 - l1, l1 && s1.output.set(s1.output.subarray(h1, h1 + l1), 0), this.onData(p1);
                } else this.onData(s1.output.length === s1.next_out ? s1.output : s1.output.subarray(0, s1.next_out));
            }
            if (i1 !== Z_OK || 0 !== a1) {
                if (i1 === Z_STREAM_END) return i1 = inflate_1$2.inflateEnd(this.strm), this.onEnd(i1), this.ended = !0, !0;
                if (0 === s1.avail_in) break;
            }
        }
        return !0;
    }, Inflate$1.prototype.onData = function(t1) {
        this.chunks.push(t1);
    }, Inflate$1.prototype.onEnd = function(t1) {
        t1 === Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = common.flattenChunks(this.chunks)), this.chunks = [], this.err = t1, this.msg = this.strm.msg;
    };
    var Inflate_1$1 = Inflate$1, inflate_2 = inflate$1, inflateRaw_1$1 = inflateRaw$1, ungzip$1 = inflate$1, constants = constants$2, inflate_1$1 = {
        Inflate: Inflate_1$1,
        inflate: inflate_2,
        inflateRaw: inflateRaw_1$1,
        ungzip: ungzip$1,
        constants: constants
    }, { Inflate: Inflate, inflate: inflate, inflateRaw: inflateRaw, ungzip: ungzip } = inflate_1$1, inflate_1 = inflate, t$1 = window.ShadowRoot && (void 0 === window.ShadyCSS || window.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, e$2 = Symbol(), n$3 = new Map;
    class s$3 {
        constructor(t1, e1){
            if (this._$cssResult$ = !0, e1 !== e$2) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
            this.cssText = t1;
        }
        get styleSheet() {
            var t1 = n$3.get(this.cssText);
            return t$1 && void 0 === t1 && (n$3.set(this.cssText, t1 = new CSSStyleSheet), t1.replaceSync(this.cssText)), t1;
        }
        toString() {
            return this.cssText;
        }
    }
    var o$3 = (t1)=>new s$3("string" == typeof t1 ? t1 : t1 + "", e$2), r$2 = function(t1) {
        for(var e1 = arguments.length, i1 = new Array(e1 > 1 ? e1 - 1 : 0), r1 = 1; r1 < e1; r1++)i1[r1 - 1] = arguments[r1];
        var a1 = 1 === t1.length ? t1[0] : i1.reduce((e1, i1, r1)=>e1 + ((t1)=>{
                if (!0 === t1._$cssResult$) return t1.cssText;
                if ("number" == typeof t1) return t1;
                throw Error("Value passed to 'css' function must be a 'css' function result: " + t1 + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
            })(i1) + t1[r1 + 1], t1[0]);
        return new s$3(a1, e$2);
    }, i$1 = (t1, e1)=>{
        t$1 ? t1.adoptedStyleSheets = e1.map((t1)=>t1 instanceof CSSStyleSheet ? t1 : t1.styleSheet) : e1.forEach((e1)=>{
            var i1 = document.createElement("style"), r1 = window.litNonce;
            void 0 !== r1 && i1.setAttribute("nonce", r1), i1.textContent = e1.cssText, t1.appendChild(i1);
        });
    }, S$1 = t$1 ? (t1)=>t1 : (t1)=>t1 instanceof CSSStyleSheet ? ((t1)=>{
            var e1 = "";
            for (var i1 of t1.cssRules)e1 += i1.cssText;
            return o$3(e1);
        })(t1) : t1, s$2, e$1 = window.trustedTypes, r$1 = e$1 ? e$1.emptyScript : "", h$1 = window.reactiveElementPolyfillSupport, o$2 = {
        toAttribute (t1, e1) {
            switch(e1){
                case Boolean:
                    t1 = t1 ? r$1 : null;
                    break;
                case Object:
                case Array:
                    t1 = null == t1 ? t1 : JSON.stringify(t1);
            }
            return t1;
        },
        fromAttribute (t1, e1) {
            var i1 = t1;
            switch(e1){
                case Boolean:
                    i1 = null !== t1;
                    break;
                case Number:
                    i1 = null === t1 ? null : Number(t1);
                    break;
                case Object:
                case Array:
                    try {
                        i1 = JSON.parse(t1);
                    } catch (t1) {
                        i1 = null;
                    }
            }
            return i1;
        }
    }, n$2 = (t1, e1)=>e1 !== t1 && (e1 == e1 || t1 == t1), l$2 = {
        attribute: !0,
        type: String,
        converter: o$2,
        reflect: !1,
        hasChanged: n$2
    }, t;
    class a$1 extends HTMLElement {
        constructor(){
            super(), this._$Et = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Ei = null, this.o();
        }
        static addInitializer(t1) {
            var e1;
            null !== (e1 = this.l) && void 0 !== e1 || (this.l = []), this.l.push(t1);
        }
        static get observedAttributes() {
            this.finalize();
            var t1 = [];
            return this.elementProperties.forEach((e1, i1)=>{
                var r1 = this._$Eh(i1, e1);
                void 0 !== r1 && (this._$Eu.set(r1, i1), t1.push(r1));
            }), t1;
        }
        static createProperty(t1) {
            var e1 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l$2;
            if (e1.state && (e1.attribute = !1), this.finalize(), this.elementProperties.set(t1, e1), !e1.noAccessor && !this.prototype.hasOwnProperty(t1)) {
                var i1 = "symbol" == typeof t1 ? Symbol() : "__" + t1, r1 = this.getPropertyDescriptor(t1, i1, e1);
                void 0 !== r1 && Object.defineProperty(this.prototype, t1, r1);
            }
        }
        static getPropertyDescriptor(t1, e1, i1) {
            return {
                get () {
                    return this[e1];
                },
                set (r1) {
                    var a1 = this[t1];
                    this[e1] = r1, this.requestUpdate(t1, a1, i1);
                },
                configurable: !0,
                enumerable: !0
            };
        }
        static getPropertyOptions(t1) {
            return this.elementProperties.get(t1) || l$2;
        }
        static finalize() {
            if (this.hasOwnProperty("finalized")) return !1;
            this.finalized = !0;
            var t1 = Object.getPrototypeOf(this);
            if (t1.finalize(), this.elementProperties = new Map(t1.elementProperties), this._$Eu = new Map, this.hasOwnProperty("properties")) {
                var e1 = this.properties, i1 = [
                    ...Object.getOwnPropertyNames(e1),
                    ...Object.getOwnPropertySymbols(e1)
                ];
                for (var r1 of i1)this.createProperty(r1, e1[r1]);
            }
            return this.elementStyles = this.finalizeStyles(this.styles), !0;
        }
        static finalizeStyles(t1) {
            var e1 = [];
            if (Array.isArray(t1)) {
                var i1 = new Set(t1.flat(1 / 0).reverse());
                for (var r1 of i1)e1.unshift(S$1(r1));
            } else void 0 !== t1 && e1.push(S$1(t1));
            return e1;
        }
        static _$Eh(t1, e1) {
            var i1 = e1.attribute;
            return !1 === i1 ? void 0 : "string" == typeof i1 ? i1 : "string" == typeof t1 ? t1.toLowerCase() : void 0;
        }
        o() {
            var t1;
            this._$Ep = new Promise((t1)=>this.enableUpdating = t1), this._$AL = new Map, this._$Em(), this.requestUpdate(), null === (t1 = this.constructor.l) || void 0 === t1 || t1.forEach((t1)=>t1(this));
        }
        addController(t1) {
            var e1, i1;
            (null !== (e1 = this._$Eg) && void 0 !== e1 ? e1 : this._$Eg = []).push(t1), void 0 !== this.renderRoot && this.isConnected && (null === (i1 = t1.hostConnected) || void 0 === i1 || i1.call(t1));
        }
        removeController(t1) {
            var e1;
            null === (e1 = this._$Eg) || void 0 === e1 || e1.splice(this._$Eg.indexOf(t1) >>> 0, 1);
        }
        _$Em() {
            this.constructor.elementProperties.forEach((t1, e1)=>{
                this.hasOwnProperty(e1) && (this._$Et.set(e1, this[e1]), delete this[e1]);
            });
        }
        createRenderRoot() {
            var t1, e1 = null !== (t1 = this.shadowRoot) && void 0 !== t1 ? t1 : this.attachShadow(this.constructor.shadowRootOptions);
            return i$1(e1, this.constructor.elementStyles), e1;
        }
        connectedCallback() {
            var t1;
            void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t1 = this._$Eg) || void 0 === t1 || t1.forEach((t1)=>{
                var e1;
                return null === (e1 = t1.hostConnected) || void 0 === e1 ? void 0 : e1.call(t1);
            });
        }
        enableUpdating(t1) {}
        disconnectedCallback() {
            var t1;
            null === (t1 = this._$Eg) || void 0 === t1 || t1.forEach((t1)=>{
                var e1;
                return null === (e1 = t1.hostDisconnected) || void 0 === e1 ? void 0 : e1.call(t1);
            });
        }
        attributeChangedCallback(t1, e1, i1) {
            this._$AK(t1, i1);
        }
        _$ES(t1, e1) {
            var i1, r1, a1 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : l$2, s1 = this.constructor._$Eh(t1, a1);
            if (void 0 !== s1 && !0 === a1.reflect) {
                var n1 = (null !== (r1 = null === (i1 = a1.converter) || void 0 === i1 ? void 0 : i1.toAttribute) && void 0 !== r1 ? r1 : o$2.toAttribute)(e1, a1.type);
                this._$Ei = t1, null == n1 ? this.removeAttribute(s1) : this.setAttribute(s1, n1), this._$Ei = null;
            }
        }
        _$AK(t1, e1) {
            var i1, r1, a1, s1 = this.constructor, n1 = s1._$Eu.get(t1);
            if (void 0 !== n1 && this._$Ei !== n1) {
                var o1 = s1.getPropertyOptions(n1), h1 = o1.converter, l1 = null !== (a1 = null !== (r1 = null === (i1 = h1) || void 0 === i1 ? void 0 : i1.fromAttribute) && void 0 !== r1 ? r1 : "function" == typeof h1 ? h1 : null) && void 0 !== a1 ? a1 : o$2.fromAttribute;
                this._$Ei = n1, this[n1] = l1(e1, o1.type), this._$Ei = null;
            }
        }
        requestUpdate(t1, e1, i1) {
            var r1 = !0;
            void 0 !== t1 && (((i1 = i1 || this.constructor.getPropertyOptions(t1)).hasChanged || n$2)(this[t1], e1) ? (this._$AL.has(t1) || this._$AL.set(t1, e1), !0 === i1.reflect && this._$Ei !== t1 && (void 0 === this._$E_ && (this._$E_ = new Map), this._$E_.set(t1, i1))) : r1 = !1), !this.isUpdatePending && r1 && (this._$Ep = this._$EC());
        }
        _$EC() {
            var t1 = this;
            return _asyncToGenerator(function*() {
                t1.isUpdatePending = !0;
                try {
                    yield t1._$Ep;
                } catch (e1) {
                    Promise.reject(e1);
                }
                var e1 = t1.scheduleUpdate();
                return null != e1 && (yield e1), !t1.isUpdatePending;
            })();
        }
        scheduleUpdate() {
            return this.performUpdate();
        }
        performUpdate() {
            var t1;
            if (this.isUpdatePending) {
                this.hasUpdated, this._$Et && (this._$Et.forEach((t1, e1)=>this[e1] = t1), this._$Et = void 0);
                var e1 = !1, i1 = this._$AL;
                try {
                    (e1 = this.shouldUpdate(i1)) ? (this.willUpdate(i1), null === (t1 = this._$Eg) || void 0 === t1 || t1.forEach((t1)=>{
                        var e1;
                        return null === (e1 = t1.hostUpdate) || void 0 === e1 ? void 0 : e1.call(t1);
                    }), this.update(i1)) : this._$EU();
                } catch (t1) {
                    throw e1 = !1, this._$EU(), t1;
                }
                e1 && this._$AE(i1);
            }
        }
        willUpdate(t1) {}
        _$AE(t1) {
            var e1;
            null === (e1 = this._$Eg) || void 0 === e1 || e1.forEach((t1)=>{
                var e1;
                return null === (e1 = t1.hostUpdated) || void 0 === e1 ? void 0 : e1.call(t1);
            }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t1)), this.updated(t1);
        }
        _$EU() {
            this._$AL = new Map, this.isUpdatePending = !1;
        }
        get updateComplete() {
            return this.getUpdateComplete();
        }
        getUpdateComplete() {
            return this._$Ep;
        }
        shouldUpdate(t1) {
            return !0;
        }
        update(t1) {
            void 0 !== this._$E_ && (this._$E_.forEach((t1, e1)=>this._$ES(e1, this[e1], t1)), this._$E_ = void 0), this._$EU();
        }
        updated(t1) {}
        firstUpdated(t1) {}
    }
    a$1.finalized = !0, a$1.elementProperties = new Map, a$1.elementStyles = [], a$1.shadowRootOptions = {
        mode: "open"
    }, null == h$1 || h$1({
        ReactiveElement: a$1
    }), (null !== (s$2 = globalThis.reactiveElementVersions) && void 0 !== s$2 ? s$2 : globalThis.reactiveElementVersions = []).push("1.2.1");
    var i = globalThis.trustedTypes, s$1 = i ? i.createPolicy("lit-html", {
        createHTML: (t1)=>t1
    }) : void 0, e = "lit$".concat((Math.random() + "").slice(9), "$"), o$1 = "?" + e, n$1 = "<".concat(o$1, ">"), l$1 = document, h = function() {
        var t1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
        return l$1.createComment(t1);
    }, r = (t1)=>null === t1 || "object" != typeof t1 && "function" != typeof t1, d = Array.isArray, u = (t1)=>{
        var e1;
        return d(t1) || "function" == typeof (null === (e1 = t1) || void 0 === e1 ? void 0 : e1[Symbol.iterator]);
    }, c = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, v = /-->/g, a = />/g, f = />|[ 	\n\r](?:([^\s"'>=/]+)([ 	\n\r]*=[ 	\n\r]*(?:[^ 	\n\r"'`<>=]|("|')|))|$)/g, _ = /'/g, m = /"/g, g = /^(?:script|style|textarea)$/i, p = (t1)=>function(e1) {
            for(var i1 = arguments.length, r1 = new Array(i1 > 1 ? i1 - 1 : 0), a1 = 1; a1 < i1; a1++)r1[a1 - 1] = arguments[a1];
            return {
                _$litType$: t1,
                strings: e1,
                values: r1
            };
        }, $ = p(1), b = Symbol.for("lit-noChange"), w = Symbol.for("lit-nothing"), T = new WeakMap, x = (t1, e1, i1)=>{
        var r1, a1, s1 = null !== (r1 = null == i1 ? void 0 : i1.renderBefore) && void 0 !== r1 ? r1 : e1, n1 = s1._$litPart$;
        if (void 0 === n1) {
            var o1 = null !== (a1 = null == i1 ? void 0 : i1.renderBefore) && void 0 !== a1 ? a1 : null;
            s1._$litPart$ = n1 = new N(e1.insertBefore(h(), o1), o1, void 0, null != i1 ? i1 : {});
        }
        return n1._$AI(t1), n1;
    }, A = l$1.createTreeWalker(l$1, 129, null, !1), C = (t1, i1)=>{
        for(var r1, s1 = t1.length - 1, n1 = [], o1 = 2 === i1 ? "<svg>" : "", h1 = c, l1 = 0; l1 < s1; l1++){
            for(var p1 = t1[l1], d1 = void 0, u1 = void 0, y1 = -1, b1 = 0; b1 < p1.length && (h1.lastIndex = b1, null !== (u1 = h1.exec(p1)));)b1 = h1.lastIndex, h1 === c ? "!--" === u1[1] ? h1 = v : void 0 !== u1[1] ? h1 = a : void 0 !== u1[2] ? (g.test(u1[2]) && (r1 = RegExp("</" + u1[2], "g")), h1 = f) : void 0 !== u1[3] && (h1 = f) : h1 === f ? ">" === u1[0] ? (h1 = null != r1 ? r1 : c, y1 = -1) : void 0 === u1[1] ? y1 = -2 : (y1 = h1.lastIndex - u1[2].length, d1 = u1[1], h1 = void 0 === u1[3] ? f : '"' === u1[3] ? m : _) : h1 === m || h1 === _ ? h1 = f : h1 === v || h1 === a ? h1 = c : (h1 = f, r1 = void 0);
            var E1 = h1 === f && t1[l1 + 1].startsWith("/>") ? " " : "";
            o1 += h1 === c ? p1 + n$1 : y1 >= 0 ? (n1.push(d1), p1.slice(0, y1) + "$lit$" + p1.slice(y1) + e + E1) : p1 + e + (-2 === y1 ? (n1.push(void 0), l1) : E1);
        }
        var S1 = o1 + (t1[s1] || "<?>") + (2 === i1 ? "</svg>" : "");
        if (!Array.isArray(t1) || !t1.hasOwnProperty("raw")) throw Error("invalid template strings array");
        return [
            void 0 !== s$1 ? s$1.createHTML(S1) : S1,
            n1
        ];
    };
    class E {
        constructor(t1, r1){
            var a1, { strings: s1, _$litType$: n1 } = t1;
            this.parts = [];
            var o1 = 0, l1 = 0, p1 = s1.length - 1, f1 = this.parts, [d1, c1] = C(s1, n1);
            if (this.el = E.createElement(d1, r1), A.currentNode = this.el.content, 2 === n1) {
                var m1 = this.el.content, u1 = m1.firstChild;
                u1.remove(), m1.append(...u1.childNodes);
            }
            for(; null !== (a1 = A.nextNode()) && f1.length < p1;){
                if (1 === a1.nodeType) {
                    if (a1.hasAttributes()) {
                        var y1 = [];
                        for (var _1 of a1.getAttributeNames())if (_1.endsWith("$lit$") || _1.startsWith(e)) {
                            var v1 = c1[l1++];
                            if (y1.push(_1), void 0 !== v1) {
                                var b1 = a1.getAttribute(v1.toLowerCase() + "$lit$").split(e), P1 = /([.?@])?(.*)/.exec(v1);
                                f1.push({
                                    type: 1,
                                    index: o1,
                                    name: P1[2],
                                    strings: b1,
                                    ctor: "." === P1[1] ? M : "?" === P1[1] ? H : "@" === P1[1] ? I : S
                                });
                            } else f1.push({
                                type: 6,
                                index: o1
                            });
                        }
                        for (var x1 of y1)a1.removeAttribute(x1);
                    }
                    if (g.test(a1.tagName)) {
                        var T1 = a1.textContent.split(e), w1 = T1.length - 1;
                        if (w1 > 0) {
                            a1.textContent = i ? i.emptyScript : "";
                            for(var k1 = 0; k1 < w1; k1++)a1.append(T1[k1], h()), A.nextNode(), f1.push({
                                type: 2,
                                index: ++o1
                            });
                            a1.append(T1[w1], h());
                        }
                    }
                } else if (8 === a1.nodeType) {
                    if (a1.data === o$1) f1.push({
                        type: 2,
                        index: o1
                    });
                    else for(var D1 = -1; -1 !== (D1 = a1.data.indexOf(e, D1 + 1));)f1.push({
                        type: 7,
                        index: o1
                    }), D1 += e.length - 1;
                }
                o1++;
            }
        }
        static createElement(t1, e1) {
            var i1 = l$1.createElement("template");
            return i1.innerHTML = t1, i1;
        }
    }
    function P(t1, e1) {
        var i1, a1, s1, n1, o1 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t1, h1 = arguments.length > 3 ? arguments[3] : void 0;
        if (e1 === b) return e1;
        var l1 = void 0 !== h1 ? null === (i1 = o1._$Cl) || void 0 === i1 ? void 0 : i1[h1] : o1._$Cu, p1 = r(e1) ? void 0 : e1._$litDirective$;
        return (null == l1 ? void 0 : l1.constructor) !== p1 && (null === (a1 = null == l1 ? void 0 : l1._$AO) || void 0 === a1 || a1.call(l1, !1), void 0 === p1 ? l1 = void 0 : (l1 = new p1(t1))._$AT(t1, o1, h1), void 0 !== h1 ? (null !== (s1 = (n1 = o1)._$Cl) && void 0 !== s1 ? s1 : n1._$Cl = [])[h1] = l1 : o1._$Cu = l1), void 0 !== l1 && (e1 = P(t1, l1._$AS(t1, e1.values), l1, h1)), e1;
    }
    class V {
        constructor(t1, e1){
            this.v = [], this._$AN = void 0, this._$AD = t1, this._$AM = e1;
        }
        get parentNode() {
            return this._$AM.parentNode;
        }
        get _$AU() {
            return this._$AM._$AU;
        }
        p(t1) {
            var e1, { el: { content: i1 }, parts: r1 } = this._$AD, a1 = (null !== (e1 = null == t1 ? void 0 : t1.creationScope) && void 0 !== e1 ? e1 : l$1).importNode(i1, !0);
            A.currentNode = a1;
            for(var s1 = A.nextNode(), n1 = 0, o1 = 0, h1 = r1[0]; void 0 !== h1;){
                if (n1 === h1.index) {
                    var l1 = void 0;
                    2 === h1.type ? l1 = new N(s1, s1.nextSibling, this, t1) : 1 === h1.type ? l1 = new h1.ctor(s1, h1.name, h1.strings, this, t1) : 6 === h1.type && (l1 = new L(s1, this, t1)), this.v.push(l1), h1 = r1[++o1];
                }
                n1 !== (null == h1 ? void 0 : h1.index) && (s1 = A.nextNode(), n1++);
            }
            return a1;
        }
        m(t1) {
            var e1 = 0;
            for (var i1 of this.v)void 0 !== i1 && (void 0 !== i1.strings ? (i1._$AI(t1, i1, e1), e1 += i1.strings.length - 2) : i1._$AI(t1[e1])), e1++;
        }
    }
    class N {
        constructor(t1, e1, i1, r1){
            var a1;
            this.type = 2, this._$AH = w, this._$AN = void 0, this._$AA = t1, this._$AB = e1, this._$AM = i1, this.options = r1, this._$Cg = null === (a1 = null == r1 ? void 0 : r1.isConnected) || void 0 === a1 || a1;
        }
        get _$AU() {
            var t1, e1;
            return null !== (e1 = null === (t1 = this._$AM) || void 0 === t1 ? void 0 : t1._$AU) && void 0 !== e1 ? e1 : this._$Cg;
        }
        get parentNode() {
            var t1 = this._$AA.parentNode, e1 = this._$AM;
            return void 0 !== e1 && 11 === t1.nodeType && (t1 = e1.parentNode), t1;
        }
        get startNode() {
            return this._$AA;
        }
        get endNode() {
            return this._$AB;
        }
        _$AI(t1) {
            t1 = P(this, t1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this), r(t1) ? t1 === w || null == t1 || "" === t1 ? (this._$AH !== w && this._$AR(), this._$AH = w) : t1 !== this._$AH && t1 !== b && this.$(t1) : void 0 !== t1._$litType$ ? this.T(t1) : void 0 !== t1.nodeType ? this.S(t1) : u(t1) ? this.A(t1) : this.$(t1);
        }
        M(t1) {
            var e1 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this._$AB;
            return this._$AA.parentNode.insertBefore(t1, e1);
        }
        S(t1) {
            this._$AH !== t1 && (this._$AR(), this._$AH = this.M(t1));
        }
        $(t1) {
            this._$AH !== w && r(this._$AH) ? this._$AA.nextSibling.data = t1 : this.S(l$1.createTextNode(t1)), this._$AH = t1;
        }
        T(t1) {
            var e1, { values: i1, _$litType$: r1 } = t1, a1 = "number" == typeof r1 ? this._$AC(t1) : (void 0 === r1.el && (r1.el = E.createElement(r1.h, this.options)), r1);
            if ((null === (e1 = this._$AH) || void 0 === e1 ? void 0 : e1._$AD) === a1) this._$AH.m(i1);
            else {
                var s1 = new V(a1, this), n1 = s1.p(this.options);
                s1.m(i1), this.S(n1), this._$AH = s1;
            }
        }
        _$AC(t1) {
            var e1 = T.get(t1.strings);
            return void 0 === e1 && T.set(t1.strings, e1 = new E(t1)), e1;
        }
        A(t1) {
            d(this._$AH) || (this._$AH = [], this._$AR());
            var e1, i1 = this._$AH, r1 = 0;
            for (var a1 of t1)r1 === i1.length ? i1.push(e1 = new N(this.M(h()), this.M(h()), this, this.options)) : e1 = i1[r1], e1._$AI(a1), r1++;
            r1 < i1.length && (this._$AR(e1 && e1._$AB.nextSibling, r1), i1.length = r1);
        }
        _$AR() {
            var t1, e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._$AA.nextSibling, i1 = arguments.length > 1 ? arguments[1] : void 0;
            for(null === (t1 = this._$AP) || void 0 === t1 || t1.call(this, !1, !0, i1); e1 && e1 !== this._$AB;){
                var r1 = e1.nextSibling;
                e1.remove(), e1 = r1;
            }
        }
        setConnected(t1) {
            var e1;
            void 0 === this._$AM && (this._$Cg = t1, null === (e1 = this._$AP) || void 0 === e1 || e1.call(this, t1));
        }
    }
    class S {
        constructor(t1, e1, i1, r1, a1){
            this.type = 1, this._$AH = w, this._$AN = void 0, this.element = t1, this.name = e1, this._$AM = r1, this.options = a1, i1.length > 2 || "" !== i1[0] || "" !== i1[1] ? (this._$AH = Array(i1.length - 1).fill(new String), this.strings = i1) : this._$AH = w;
        }
        get tagName() {
            return this.element.tagName;
        }
        get _$AU() {
            return this._$AM._$AU;
        }
        _$AI(t1) {
            var e1 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this, i1 = arguments.length > 2 ? arguments[2] : void 0, a1 = arguments.length > 3 ? arguments[3] : void 0, s1 = this.strings, n1 = !1;
            if (void 0 === s1) t1 = P(this, t1, e1, 0), (n1 = !r(t1) || t1 !== this._$AH && t1 !== b) && (this._$AH = t1);
            else {
                var o1, h1, l1 = t1;
                for(t1 = s1[0], o1 = 0; o1 < s1.length - 1; o1++)(h1 = P(this, l1[i1 + o1], e1, o1)) === b && (h1 = this._$AH[o1]), n1 || (n1 = !r(h1) || h1 !== this._$AH[o1]), h1 === w ? t1 = w : t1 !== w && (t1 += (null != h1 ? h1 : "") + s1[o1 + 1]), this._$AH[o1] = h1;
            }
            n1 && !a1 && this.k(t1);
        }
        k(t1) {
            t1 === w ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t1 ? t1 : "");
        }
    }
    class M extends S {
        constructor(){
            super(...arguments), this.type = 3;
        }
        k(t1) {
            this.element[this.name] = t1 === w ? void 0 : t1;
        }
    }
    var k = i ? i.emptyScript : "";
    class H extends S {
        constructor(){
            super(...arguments), this.type = 4;
        }
        k(t1) {
            t1 && t1 !== w ? this.element.setAttribute(this.name, k) : this.element.removeAttribute(this.name);
        }
    }
    class I extends S {
        constructor(t1, e1, i1, r1, a1){
            super(t1, e1, i1, r1, a1), this.type = 5;
        }
        _$AI(t1) {
            var e1;
            if ((t1 = null !== (e1 = P(this, t1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this, 0)) && void 0 !== e1 ? e1 : w) !== b) {
                var i1 = this._$AH, r1 = t1 === w && i1 !== w || t1.capture !== i1.capture || t1.once !== i1.once || t1.passive !== i1.passive, a1 = t1 !== w && (i1 === w || r1);
                r1 && this.element.removeEventListener(this.name, this, i1), a1 && this.element.addEventListener(this.name, this, t1), this._$AH = t1;
            }
        }
        handleEvent(t1) {
            var e1, i1;
            "function" == typeof this._$AH ? this._$AH.call(null !== (i1 = null === (e1 = this.options) || void 0 === e1 ? void 0 : e1.host) && void 0 !== i1 ? i1 : this.element, t1) : this._$AH.handleEvent(t1);
        }
    }
    class L {
        constructor(t1, e1, i1){
            this.element = t1, this.type = 6, this._$AN = void 0, this._$AM = e1, this.options = i1;
        }
        get _$AU() {
            return this._$AM._$AU;
        }
        _$AI(t1) {
            P(this, t1);
        }
    }
    var z = window.litHtmlPolyfillSupport, l, o;
    null == z || z(E, N), (null !== (t = globalThis.litHtmlVersions) && void 0 !== t ? t : globalThis.litHtmlVersions = []).push("2.1.2");
    class s extends a$1 {
        constructor(){
            super(...arguments), this.renderOptions = {
                host: this
            }, this._$Dt = void 0;
        }
        createRenderRoot() {
            var t1, e1, i1 = super.createRenderRoot();
            return null !== (t1 = (e1 = this.renderOptions).renderBefore) && void 0 !== t1 || (e1.renderBefore = i1.firstChild), i1;
        }
        update(t1) {
            var e1 = this.render();
            this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t1), this._$Dt = x(e1, this.renderRoot, this.renderOptions);
        }
        connectedCallback() {
            var t1;
            super.connectedCallback(), null === (t1 = this._$Dt) || void 0 === t1 || t1.setConnected(!0);
        }
        disconnectedCallback() {
            var t1;
            super.disconnectedCallback(), null === (t1 = this._$Dt) || void 0 === t1 || t1.setConnected(!1);
        }
        render() {
            return b;
        }
    }
    s.finalized = !0, s._$litElement$ = !0, null === (l = globalThis.litElementHydrateSupport) || void 0 === l || l.call(globalThis, {
        LitElement: s
    });
    var n = globalThis.litElementPolyfillSupport;
    null == n || n({
        LitElement: s
    }), (null !== (o = globalThis.litElementVersions) && void 0 !== o ? o : globalThis.litElementVersions = []).push("3.1.2");
    var commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {}, lottie = {
        exports: {}
    }, _templateObject$2;
    (function(module, exports) {
        var factory;
        "undefined" != typeof navigator && (factory = function() {
            var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function(t1) {
                _useWebWorker = !!t1;
            }, getWebWorker = function() {
                return _useWebWorker;
            }, setLocationHref = function(t1) {
                locationHref = t1;
            }, getLocationHref = function() {
                return locationHref;
            };
            function createTag(t1) {
                return document.createElement(t1);
            }
            function extendPrototype(t1, e1) {
                var i1, r1, a1 = t1.length;
                for(i1 = 0; i1 < a1; i1 += 1)for(var s1 in r1 = t1[i1].prototype)Object.prototype.hasOwnProperty.call(r1, s1) && (e1.prototype[s1] = r1[s1]);
            }
            function getDescriptor(t1, e1) {
                return Object.getOwnPropertyDescriptor(t1, e1);
            }
            function createProxyFunction(t1) {
                function e1() {}
                return e1.prototype = t1, e1;
            }
            var audioControllerFactory = function() {
                function t1(t1) {
                    this.audios = [], this.audioFactory = t1, this._volume = 1, this._isMuted = !1;
                }
                return t1.prototype = {
                    addAudio: function(t1) {
                        this.audios.push(t1);
                    },
                    pause: function() {
                        var t1, e1 = this.audios.length;
                        for(t1 = 0; t1 < e1; t1 += 1)this.audios[t1].pause();
                    },
                    resume: function() {
                        var t1, e1 = this.audios.length;
                        for(t1 = 0; t1 < e1; t1 += 1)this.audios[t1].resume();
                    },
                    setRate: function(t1) {
                        var e1, i1 = this.audios.length;
                        for(e1 = 0; e1 < i1; e1 += 1)this.audios[e1].setRate(t1);
                    },
                    createAudio: function(t1) {
                        return this.audioFactory ? this.audioFactory(t1) : window.Howl ? new window.Howl({
                            src: [
                                t1
                            ]
                        }) : {
                            isPlaying: !1,
                            play: function() {
                                this.isPlaying = !0;
                            },
                            seek: function() {
                                this.isPlaying = !1;
                            },
                            playing: function() {},
                            rate: function() {},
                            setVolume: function() {}
                        };
                    },
                    setAudioFactory: function(t1) {
                        this.audioFactory = t1;
                    },
                    setVolume: function(t1) {
                        this._volume = t1, this._updateVolume();
                    },
                    mute: function() {
                        this._isMuted = !0, this._updateVolume();
                    },
                    unmute: function() {
                        this._isMuted = !1, this._updateVolume();
                    },
                    getVolume: function() {
                        return this._volume;
                    },
                    _updateVolume: function() {
                        var t1, e1 = this.audios.length;
                        for(t1 = 0; t1 < e1; t1 += 1)this.audios[t1].volume(this._volume * (this._isMuted ? 0 : 1));
                    }
                }, function() {
                    return new t1;
                };
            }(), createTypedArray = function() {
                function t1(t1, e1) {
                    var i1, r1 = 0, a1 = [];
                    switch(t1){
                        case "int16":
                        case "uint8c":
                            i1 = 1;
                            break;
                        default:
                            i1 = 1.1;
                    }
                    for(r1 = 0; r1 < e1; r1 += 1)a1.push(i1);
                    return a1;
                }
                return "function" == typeof Uint8ClampedArray && "function" == typeof Float32Array ? function(e1, i1) {
                    return "float32" === e1 ? new Float32Array(i1) : "int16" === e1 ? new Int16Array(i1) : "uint8c" === e1 ? new Uint8ClampedArray(i1) : t1(e1, i1);
                } : t1;
            }();
            function createSizedArray(t1) {
                return Array.apply(null, {
                    length: t1
                });
            }
            function _typeof$6(t1) {
                return _typeof$6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, _typeof$6(t1);
            }
            var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
            !function() {
                var t1, e1 = [
                    "abs",
                    "acos",
                    "acosh",
                    "asin",
                    "asinh",
                    "atan",
                    "atanh",
                    "atan2",
                    "ceil",
                    "cbrt",
                    "expm1",
                    "clz32",
                    "cos",
                    "cosh",
                    "exp",
                    "floor",
                    "fround",
                    "hypot",
                    "imul",
                    "log",
                    "log1p",
                    "log2",
                    "log10",
                    "max",
                    "min",
                    "pow",
                    "random",
                    "round",
                    "sign",
                    "sin",
                    "sinh",
                    "sqrt",
                    "tan",
                    "tanh",
                    "trunc",
                    "E",
                    "LN10",
                    "LN2",
                    "LOG10E",
                    "LOG2E",
                    "PI",
                    "SQRT1_2",
                    "SQRT2"
                ], i1 = e1.length;
                for(t1 = 0; t1 < i1; t1 += 1)BMMath[e1[t1]] = Math[e1[t1]];
            }(), BMMath.random = Math.random, BMMath.abs = function(t1) {
                if ("object" === _typeof$6(t1) && t1.length) {
                    var e1, i1 = createSizedArray(t1.length), r1 = t1.length;
                    for(e1 = 0; e1 < r1; e1 += 1)i1[e1] = Math.abs(t1[e1]);
                    return i1;
                }
                return Math.abs(t1);
            };
            var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = .5519;
            function styleDiv(t1) {
                t1.style.position = "absolute", t1.style.top = 0, t1.style.left = 0, t1.style.display = "block", t1.style.transformOrigin = "0 0", t1.style.webkitTransformOrigin = "0 0", t1.style.backfaceVisibility = "visible", t1.style.webkitBackfaceVisibility = "visible", t1.style.transformStyle = "preserve-3d", t1.style.webkitTransformStyle = "preserve-3d", t1.style.mozTransformStyle = "preserve-3d";
            }
            function BMEnterFrameEvent(t1, e1, i1, r1) {
                this.type = t1, this.currentTime = e1, this.totalTime = i1, this.direction = r1 < 0 ? -1 : 1;
            }
            function BMCompleteEvent(t1, e1) {
                this.type = t1, this.direction = e1 < 0 ? -1 : 1;
            }
            function BMCompleteLoopEvent(t1, e1, i1, r1) {
                this.type = t1, this.currentLoop = i1, this.totalLoops = e1, this.direction = r1 < 0 ? -1 : 1;
            }
            function BMSegmentStartEvent(t1, e1, i1) {
                this.type = t1, this.firstFrame = e1, this.totalFrames = i1;
            }
            function BMDestroyEvent(t1, e1) {
                this.type = t1, this.target = e1;
            }
            function BMRenderFrameErrorEvent(t1, e1) {
                this.type = "renderFrameError", this.nativeError = t1, this.currentTime = e1;
            }
            function BMConfigErrorEvent(t1) {
                this.type = "configError", this.nativeError = t1;
            }
            var createElementID = (_count = 0, function() {
                return idPrefix$1 + "__lottie_element_" + (_count += 1);
            }), _count;
            function HSVtoRGB(t1, e1, i1) {
                var r1, a1, s1, n1, o1, h1, l1, p1;
                switch(h1 = i1 * (1 - e1), l1 = i1 * (1 - (o1 = 6 * t1 - (n1 = Math.floor(6 * t1))) * e1), p1 = i1 * (1 - (1 - o1) * e1), n1 % 6){
                    case 0:
                        r1 = i1, a1 = p1, s1 = h1;
                        break;
                    case 1:
                        r1 = l1, a1 = i1, s1 = h1;
                        break;
                    case 2:
                        r1 = h1, a1 = i1, s1 = p1;
                        break;
                    case 3:
                        r1 = h1, a1 = l1, s1 = i1;
                        break;
                    case 4:
                        r1 = p1, a1 = h1, s1 = i1;
                        break;
                    case 5:
                        r1 = i1, a1 = h1, s1 = l1;
                }
                return [
                    r1,
                    a1,
                    s1
                ];
            }
            function RGBtoHSV(t1, e1, i1) {
                var r1, a1 = Math.max(t1, e1, i1), s1 = Math.min(t1, e1, i1), n1 = a1 - s1, o1 = 0 === a1 ? 0 : n1 / a1, h1 = a1 / 255;
                switch(a1){
                    case s1:
                        r1 = 0;
                        break;
                    case t1:
                        r1 = e1 - i1 + n1 * (e1 < i1 ? 6 : 0), r1 /= 6 * n1;
                        break;
                    case e1:
                        r1 = i1 - t1 + 2 * n1, r1 /= 6 * n1;
                        break;
                    case i1:
                        r1 = t1 - e1 + 4 * n1, r1 /= 6 * n1;
                }
                return [
                    r1,
                    o1,
                    h1
                ];
            }
            function addSaturationToRGB(t1, e1) {
                var i1 = RGBtoHSV(255 * t1[0], 255 * t1[1], 255 * t1[2]);
                return i1[1] += e1, i1[1] > 1 ? i1[1] = 1 : i1[1] <= 0 && (i1[1] = 0), HSVtoRGB(i1[0], i1[1], i1[2]);
            }
            function addBrightnessToRGB(t1, e1) {
                var i1 = RGBtoHSV(255 * t1[0], 255 * t1[1], 255 * t1[2]);
                return i1[2] += e1, i1[2] > 1 ? i1[2] = 1 : i1[2] < 0 && (i1[2] = 0), HSVtoRGB(i1[0], i1[1], i1[2]);
            }
            function addHueToRGB(t1, e1) {
                var i1 = RGBtoHSV(255 * t1[0], 255 * t1[1], 255 * t1[2]);
                return i1[0] += e1 / 360, i1[0] > 1 ? i1[0] -= 1 : i1[0] < 0 && (i1[0] += 1), HSVtoRGB(i1[0], i1[1], i1[2]);
            }
            var rgbToHex = function() {
                var t1, e1, i1 = [];
                for(t1 = 0; t1 < 256; t1 += 1)e1 = t1.toString(16), i1[t1] = 1 === e1.length ? "0" + e1 : e1;
                return function(t1, e1, r1) {
                    return t1 < 0 && (t1 = 0), e1 < 0 && (e1 = 0), r1 < 0 && (r1 = 0), "#" + i1[t1] + i1[e1] + i1[r1];
                };
            }(), setSubframeEnabled = function(t1) {
                subframeEnabled = !!t1;
            }, getSubframeEnabled = function() {
                return subframeEnabled;
            }, setExpressionsPlugin = function(t1) {
                expressionsPlugin = t1;
            }, getExpressionsPlugin = function() {
                return expressionsPlugin;
            }, setExpressionInterfaces = function(t1) {
                expressionsInterfaces = t1;
            }, getExpressionInterfaces = function() {
                return expressionsInterfaces;
            }, setDefaultCurveSegments = function(t1) {
                defaultCurveSegments = t1;
            }, getDefaultCurveSegments = function() {
                return defaultCurveSegments;
            }, setIdPrefix = function(t1) {
                idPrefix$1 = t1;
            };
            function createNS(t1) {
                return document.createElementNS(svgNS, t1);
            }
            function _typeof$5(t1) {
                return _typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, _typeof$5(t1);
            }
            var dataManager = function() {
                var t1, e1, i1 = 1, r1 = [], a1 = {
                    onmessage: function() {},
                    postMessage: function(e1) {
                        t1({
                            data: e1
                        });
                    }
                }, s1 = {
                    postMessage: function(t1) {
                        a1.onmessage({
                            data: t1
                        });
                    }
                };
                function n1() {
                    e1 || (e1 = function(e1) {
                        if (window.Worker && window.Blob && getWebWorker()) {
                            var i1 = new Blob([
                                "var _workerSelf = self; self.onmessage = ",
                                e1.toString()
                            ], {
                                type: "text/javascript"
                            }), r1 = URL.createObjectURL(i1);
                            return new Worker(r1);
                        }
                        return t1 = e1, a1;
                    }(function(t1) {
                        if (s1.dataManager || (s1.dataManager = function() {
                            function t1(a1, s1) {
                                var n1, o1, h1, l1, p1, d1, c1 = a1.length;
                                for(o1 = 0; o1 < c1; o1 += 1)if ("ks" in (n1 = a1[o1]) && !n1.completed) {
                                    if (n1.completed = !0, n1.hasMask) {
                                        var m1 = n1.masksProperties;
                                        for(l1 = m1.length, h1 = 0; h1 < l1; h1 += 1)if (m1[h1].pt.k.i) r1(m1[h1].pt.k);
                                        else for(d1 = m1[h1].pt.k.length, p1 = 0; p1 < d1; p1 += 1)m1[h1].pt.k[p1].s && r1(m1[h1].pt.k[p1].s[0]), m1[h1].pt.k[p1].e && r1(m1[h1].pt.k[p1].e[0]);
                                    }
                                    0 === n1.ty ? (n1.layers = e1(n1.refId, s1), t1(n1.layers, s1)) : 4 === n1.ty ? i1(n1.shapes) : 5 === n1.ty && f1(n1);
                                }
                            }
                            function e1(t1, e1) {
                                var i1 = function(t1, e1) {
                                    for(var i1 = 0, r1 = e1.length; i1 < r1;){
                                        if (e1[i1].id === t1) return e1[i1];
                                        i1 += 1;
                                    }
                                    return null;
                                }(t1, e1);
                                return i1 ? i1.layers.__used ? JSON.parse(JSON.stringify(i1.layers)) : (i1.layers.__used = !0, i1.layers) : null;
                            }
                            function i1(t1) {
                                var e1, a1, s1;
                                for(e1 = t1.length - 1; e1 >= 0; e1 -= 1)if ("sh" === t1[e1].ty) {
                                    if (t1[e1].ks.k.i) r1(t1[e1].ks.k);
                                    else for(s1 = t1[e1].ks.k.length, a1 = 0; a1 < s1; a1 += 1)t1[e1].ks.k[a1].s && r1(t1[e1].ks.k[a1].s[0]), t1[e1].ks.k[a1].e && r1(t1[e1].ks.k[a1].e[0]);
                                } else "gr" === t1[e1].ty && i1(t1[e1].it);
                            }
                            function r1(t1) {
                                var e1, i1 = t1.i.length;
                                for(e1 = 0; e1 < i1; e1 += 1)t1.i[e1][0] += t1.v[e1][0], t1.i[e1][1] += t1.v[e1][1], t1.o[e1][0] += t1.v[e1][0], t1.o[e1][1] += t1.v[e1][1];
                            }
                            function a1(t1, e1) {
                                var i1 = e1 ? e1.split(".") : [
                                    100,
                                    100,
                                    100
                                ];
                                return t1[0] > i1[0] || !(i1[0] > t1[0]) && (t1[1] > i1[1] || !(i1[1] > t1[1]) && (t1[2] > i1[2] || !(i1[2] > t1[2]) && null));
                            }
                            var s1, n1 = function() {
                                var t1 = [
                                    4,
                                    4,
                                    14
                                ];
                                function e1(t1) {
                                    var e1, i1, r1, a1 = t1.length;
                                    for(e1 = 0; e1 < a1; e1 += 1)5 === t1[e1].ty && (r1 = void 0, r1 = (i1 = t1[e1]).t.d, i1.t.d = {
                                        k: [
                                            {
                                                s: r1,
                                                t: 0
                                            }
                                        ]
                                    });
                                }
                                return function(i1) {
                                    if (a1(t1, i1.v) && (e1(i1.layers), i1.assets)) {
                                        var r1, s1 = i1.assets.length;
                                        for(r1 = 0; r1 < s1; r1 += 1)i1.assets[r1].layers && e1(i1.assets[r1].layers);
                                    }
                                };
                            }(), o1 = (s1 = [
                                4,
                                7,
                                99
                            ], function(t1) {
                                if (t1.chars && !a1(s1, t1.v)) {
                                    var e1, r1 = t1.chars.length;
                                    for(e1 = 0; e1 < r1; e1 += 1){
                                        var n1 = t1.chars[e1];
                                        n1.data && n1.data.shapes && (i1(n1.data.shapes), n1.data.ip = 0, n1.data.op = 99999, n1.data.st = 0, n1.data.sr = 1, n1.data.ks = {
                                            p: {
                                                k: [
                                                    0,
                                                    0
                                                ],
                                                a: 0
                                            },
                                            s: {
                                                k: [
                                                    100,
                                                    100
                                                ],
                                                a: 0
                                            },
                                            a: {
                                                k: [
                                                    0,
                                                    0
                                                ],
                                                a: 0
                                            },
                                            r: {
                                                k: 0,
                                                a: 0
                                            },
                                            o: {
                                                k: 100,
                                                a: 0
                                            }
                                        }, t1.chars[e1].t || (n1.data.shapes.push({
                                            ty: "no"
                                        }), n1.data.shapes[0].it.push({
                                            p: {
                                                k: [
                                                    0,
                                                    0
                                                ],
                                                a: 0
                                            },
                                            s: {
                                                k: [
                                                    100,
                                                    100
                                                ],
                                                a: 0
                                            },
                                            a: {
                                                k: [
                                                    0,
                                                    0
                                                ],
                                                a: 0
                                            },
                                            r: {
                                                k: 0,
                                                a: 0
                                            },
                                            o: {
                                                k: 100,
                                                a: 0
                                            },
                                            sk: {
                                                k: 0,
                                                a: 0
                                            },
                                            sa: {
                                                k: 0,
                                                a: 0
                                            },
                                            ty: "tr"
                                        })));
                                    }
                                }
                            }), h1 = function() {
                                var t1 = [
                                    5,
                                    7,
                                    15
                                ];
                                function e1(t1) {
                                    var e1, i1, r1 = t1.length;
                                    for(e1 = 0; e1 < r1; e1 += 1)5 === t1[e1].ty && (i1 = void 0, "number" == typeof (i1 = t1[e1].t.p).a && (i1.a = {
                                        a: 0,
                                        k: i1.a
                                    }), "number" == typeof i1.p && (i1.p = {
                                        a: 0,
                                        k: i1.p
                                    }), "number" == typeof i1.r && (i1.r = {
                                        a: 0,
                                        k: i1.r
                                    }));
                                }
                                return function(i1) {
                                    if (a1(t1, i1.v) && (e1(i1.layers), i1.assets)) {
                                        var r1, s1 = i1.assets.length;
                                        for(r1 = 0; r1 < s1; r1 += 1)i1.assets[r1].layers && e1(i1.assets[r1].layers);
                                    }
                                };
                            }(), l1 = function() {
                                var t1 = [
                                    4,
                                    1,
                                    9
                                ];
                                function e1(t1) {
                                    var i1, r1, a1, s1 = t1.length;
                                    for(i1 = 0; i1 < s1; i1 += 1)if ("gr" === t1[i1].ty) e1(t1[i1].it);
                                    else if ("fl" === t1[i1].ty || "st" === t1[i1].ty) {
                                        if (t1[i1].c.k && t1[i1].c.k[0].i) for(a1 = t1[i1].c.k.length, r1 = 0; r1 < a1; r1 += 1)t1[i1].c.k[r1].s && (t1[i1].c.k[r1].s[0] /= 255, t1[i1].c.k[r1].s[1] /= 255, t1[i1].c.k[r1].s[2] /= 255, t1[i1].c.k[r1].s[3] /= 255), t1[i1].c.k[r1].e && (t1[i1].c.k[r1].e[0] /= 255, t1[i1].c.k[r1].e[1] /= 255, t1[i1].c.k[r1].e[2] /= 255, t1[i1].c.k[r1].e[3] /= 255);
                                        else t1[i1].c.k[0] /= 255, t1[i1].c.k[1] /= 255, t1[i1].c.k[2] /= 255, t1[i1].c.k[3] /= 255;
                                    }
                                }
                                function i1(t1) {
                                    var i1, r1 = t1.length;
                                    for(i1 = 0; i1 < r1; i1 += 1)4 === t1[i1].ty && e1(t1[i1].shapes);
                                }
                                return function(e1) {
                                    if (a1(t1, e1.v) && (i1(e1.layers), e1.assets)) {
                                        var r1, s1 = e1.assets.length;
                                        for(r1 = 0; r1 < s1; r1 += 1)e1.assets[r1].layers && i1(e1.assets[r1].layers);
                                    }
                                };
                            }(), p1 = function() {
                                var t1 = [
                                    4,
                                    4,
                                    18
                                ];
                                function e1(t1) {
                                    var i1, r1, a1;
                                    for(i1 = t1.length - 1; i1 >= 0; i1 -= 1)if ("sh" === t1[i1].ty) {
                                        if (t1[i1].ks.k.i) t1[i1].ks.k.c = t1[i1].closed;
                                        else for(a1 = t1[i1].ks.k.length, r1 = 0; r1 < a1; r1 += 1)t1[i1].ks.k[r1].s && (t1[i1].ks.k[r1].s[0].c = t1[i1].closed), t1[i1].ks.k[r1].e && (t1[i1].ks.k[r1].e[0].c = t1[i1].closed);
                                    } else "gr" === t1[i1].ty && e1(t1[i1].it);
                                }
                                function i1(t1) {
                                    var i1, r1, a1, s1, n1, o1, h1 = t1.length;
                                    for(r1 = 0; r1 < h1; r1 += 1){
                                        if ((i1 = t1[r1]).hasMask) {
                                            var l1 = i1.masksProperties;
                                            for(s1 = l1.length, a1 = 0; a1 < s1; a1 += 1)if (l1[a1].pt.k.i) l1[a1].pt.k.c = l1[a1].cl;
                                            else for(o1 = l1[a1].pt.k.length, n1 = 0; n1 < o1; n1 += 1)l1[a1].pt.k[n1].s && (l1[a1].pt.k[n1].s[0].c = l1[a1].cl), l1[a1].pt.k[n1].e && (l1[a1].pt.k[n1].e[0].c = l1[a1].cl);
                                        }
                                        4 === i1.ty && e1(i1.shapes);
                                    }
                                }
                                return function(e1) {
                                    if (a1(t1, e1.v) && (i1(e1.layers), e1.assets)) {
                                        var r1, s1 = e1.assets.length;
                                        for(r1 = 0; r1 < s1; r1 += 1)e1.assets[r1].layers && i1(e1.assets[r1].layers);
                                    }
                                };
                            }();
                            function f1(t1) {
                                0 === t1.t.a.length && t1.t.p;
                            }
                            var d1 = {
                                completeData: function(i1) {
                                    i1.__complete || (l1(i1), n1(i1), o1(i1), h1(i1), p1(i1), t1(i1.layers, i1.assets), function(i1, r1) {
                                        if (i1) {
                                            var a1 = 0, s1 = i1.length;
                                            for(a1 = 0; a1 < s1; a1 += 1)1 === i1[a1].t && (i1[a1].data.layers = e1(i1[a1].data.refId, r1), t1(i1[a1].data.layers, r1));
                                        }
                                    }(i1.chars, i1.assets), i1.__complete = !0);
                                }
                            };
                            return d1.checkColors = l1, d1.checkChars = o1, d1.checkPathProperties = h1, d1.checkShapes = p1, d1.completeLayers = t1, d1;
                        }()), s1.assetLoader || (s1.assetLoader = function() {
                            function t1(t1) {
                                var e1 = t1.getResponseHeader("content-type");
                                return e1 && "json" === t1.responseType && -1 !== e1.indexOf("json") || t1.response && "object" === _typeof$5(t1.response) ? t1.response : t1.response && "string" == typeof t1.response ? JSON.parse(t1.response) : t1.responseText ? JSON.parse(t1.responseText) : null;
                            }
                            return {
                                load: function(e1, i1, r1, a1) {
                                    var s1, n1 = new XMLHttpRequest;
                                    try {
                                        n1.responseType = "json";
                                    } catch (t1) {}
                                    n1.onreadystatechange = function() {
                                        if (4 === n1.readyState) {
                                            if (200 === n1.status) s1 = t1(n1), r1(s1);
                                            else try {
                                                s1 = t1(n1), r1(s1);
                                            } catch (t1) {
                                                a1 && a1(t1);
                                            }
                                        }
                                    };
                                    try {
                                        n1.open([
                                            "G",
                                            "E",
                                            "T"
                                        ].join(""), e1, !0);
                                    } catch (t1) {
                                        n1.open([
                                            "G",
                                            "E",
                                            "T"
                                        ].join(""), i1 + "/" + e1, !0);
                                    }
                                    n1.send();
                                }
                            };
                        }()), "loadAnimation" === t1.data.type) s1.assetLoader.load(t1.data.path, t1.data.fullPath, function(e1) {
                            s1.dataManager.completeData(e1), s1.postMessage({
                                id: t1.data.id,
                                payload: e1,
                                status: "success"
                            });
                        }, function() {
                            s1.postMessage({
                                id: t1.data.id,
                                status: "error"
                            });
                        });
                        else if ("complete" === t1.data.type) {
                            var e1 = t1.data.animation;
                            s1.dataManager.completeData(e1), s1.postMessage({
                                id: t1.data.id,
                                payload: e1,
                                status: "success"
                            });
                        } else "loadData" === t1.data.type && s1.assetLoader.load(t1.data.path, t1.data.fullPath, function(e1) {
                            s1.postMessage({
                                id: t1.data.id,
                                payload: e1,
                                status: "success"
                            });
                        }, function() {
                            s1.postMessage({
                                id: t1.data.id,
                                status: "error"
                            });
                        });
                    }), e1.onmessage = function(t1) {
                        var e1 = t1.data, i1 = e1.id, a1 = r1[i1];
                        r1[i1] = null, "success" === e1.status ? a1.onComplete(e1.payload) : a1.onError && a1.onError();
                    });
                }
                function o1(t1, e1) {
                    var a1 = "processId_" + (i1 += 1);
                    return r1[a1] = {
                        onComplete: t1,
                        onError: e1
                    }, a1;
                }
                return {
                    loadAnimation: function(t1, i1, r1) {
                        n1();
                        var a1 = o1(i1, r1);
                        e1.postMessage({
                            type: "loadAnimation",
                            path: t1,
                            fullPath: window.location.origin + window.location.pathname,
                            id: a1
                        });
                    },
                    loadData: function(t1, i1, r1) {
                        n1();
                        var a1 = o1(i1, r1);
                        e1.postMessage({
                            type: "loadData",
                            path: t1,
                            fullPath: window.location.origin + window.location.pathname,
                            id: a1
                        });
                    },
                    completeAnimation: function(t1, i1, r1) {
                        n1();
                        var a1 = o1(i1, r1);
                        e1.postMessage({
                            type: "complete",
                            animation: t1,
                            id: a1
                        });
                    }
                };
            }(), ImagePreloader = function() {
                var t1 = function() {
                    var t1 = createTag("canvas");
                    t1.width = 1, t1.height = 1;
                    var e1 = t1.getContext("2d");
                    return e1.fillStyle = "rgba(0,0,0,0)", e1.fillRect(0, 0, 1, 1), t1;
                }();
                function e1() {
                    this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
                }
                function i1() {
                    this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
                }
                function r1(t1, e1, i1) {
                    var r1 = "";
                    if (t1.e) r1 = t1.p;
                    else if (e1) {
                        var a1 = t1.p;
                        -1 !== a1.indexOf("images/") && (a1 = a1.split("/")[1]), r1 = e1 + a1;
                    } else r1 = i1, r1 += t1.u ? t1.u : "", r1 += t1.p;
                    return r1;
                }
                function a1(t1) {
                    var e1 = 0, i1 = setInterval((function() {
                        (t1.getBBox().width || e1 > 500) && (this._imageLoaded(), clearInterval(i1)), e1 += 1;
                    }).bind(this), 50);
                }
                function s1(t1) {
                    var e1 = {
                        assetData: t1
                    }, i1 = r1(t1, this.assetsPath, this.path);
                    return dataManager.loadData(i1, (function(t1) {
                        e1.img = t1, this._footageLoaded();
                    }).bind(this), (function() {
                        e1.img = {}, this._footageLoaded();
                    }).bind(this)), e1;
                }
                function n1() {
                    this._imageLoaded = e1.bind(this), this._footageLoaded = i1.bind(this), this.testImageLoaded = a1.bind(this), this.createFootageData = s1.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
                }
                return n1.prototype = {
                    loadAssets: function(t1, e1) {
                        var i1;
                        this.imagesLoadedCb = e1;
                        var r1 = t1.length;
                        for(i1 = 0; i1 < r1; i1 += 1)t1[i1].layers || (t1[i1].t && "seq" !== t1[i1].t ? 3 === t1[i1].t && (this.totalFootages += 1, this.images.push(this.createFootageData(t1[i1]))) : (this.totalImages += 1, this.images.push(this._createImageData(t1[i1]))));
                    },
                    setAssetsPath: function(t1) {
                        this.assetsPath = t1 || "";
                    },
                    setPath: function(t1) {
                        this.path = t1 || "";
                    },
                    loadedImages: function() {
                        return this.totalImages === this.loadedAssets;
                    },
                    loadedFootages: function() {
                        return this.totalFootages === this.loadedFootagesCount;
                    },
                    destroy: function() {
                        this.imagesLoadedCb = null, this.images.length = 0;
                    },
                    getAsset: function(t1) {
                        for(var e1 = 0, i1 = this.images.length; e1 < i1;){
                            if (this.images[e1].assetData === t1) return this.images[e1].img;
                            e1 += 1;
                        }
                        return null;
                    },
                    createImgData: function(e1) {
                        var i1 = r1(e1, this.assetsPath, this.path), a1 = createTag("img");
                        a1.crossOrigin = "anonymous", a1.addEventListener("load", this._imageLoaded, !1), a1.addEventListener("error", (function() {
                            s1.img = t1, this._imageLoaded();
                        }).bind(this), !1), a1.src = i1;
                        var s1 = {
                            img: a1,
                            assetData: e1
                        };
                        return s1;
                    },
                    createImageData: function(e1) {
                        var i1 = r1(e1, this.assetsPath, this.path), a1 = createNS("image");
                        isSafari ? this.testImageLoaded(a1) : a1.addEventListener("load", this._imageLoaded, !1), a1.addEventListener("error", (function() {
                            s1.img = t1, this._imageLoaded();
                        }).bind(this), !1), a1.setAttributeNS("http://www.w3.org/1999/xlink", "href", i1), this._elementHelper.append ? this._elementHelper.append(a1) : this._elementHelper.appendChild(a1);
                        var s1 = {
                            img: a1,
                            assetData: e1
                        };
                        return s1;
                    },
                    imageLoaded: e1,
                    footageLoaded: i1,
                    setCacheType: function(t1, e1) {
                        "svg" === t1 ? (this._elementHelper = e1, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
                    }
                }, n1;
            }();
            function BaseEvent() {}
            BaseEvent.prototype = {
                triggerEvent: function(t1, e1) {
                    if (this._cbs[t1]) for(var i1 = this._cbs[t1], r1 = 0; r1 < i1.length; r1 += 1)i1[r1](e1);
                },
                addEventListener: function(t1, e1) {
                    return this._cbs[t1] || (this._cbs[t1] = []), this._cbs[t1].push(e1), (function() {
                        this.removeEventListener(t1, e1);
                    }).bind(this);
                },
                removeEventListener: function(t1, e1) {
                    if (e1) {
                        if (this._cbs[t1]) {
                            for(var i1 = 0, r1 = this._cbs[t1].length; i1 < r1;)this._cbs[t1][i1] === e1 && (this._cbs[t1].splice(i1, 1), i1 -= 1, r1 -= 1), i1 += 1;
                            this._cbs[t1].length || (this._cbs[t1] = null);
                        }
                    } else this._cbs[t1] = null;
                }
            };
            var markerParser = function() {
                function t1(t1) {
                    for(var e1, i1 = t1.split("\r\n"), r1 = {}, a1 = 0, s1 = 0; s1 < i1.length; s1 += 1)2 === (e1 = i1[s1].split(":")).length && (r1[e1[0]] = e1[1].trim(), a1 += 1);
                    if (0 === a1) throw new Error;
                    return r1;
                }
                return function(e1) {
                    for(var i1 = [], r1 = 0; r1 < e1.length; r1 += 1){
                        var a1 = e1[r1], s1 = {
                            time: a1.tm,
                            duration: a1.dr
                        };
                        try {
                            s1.payload = JSON.parse(e1[r1].cm);
                        } catch (i1) {
                            try {
                                s1.payload = t1(e1[r1].cm);
                            } catch (t1) {
                                s1.payload = {
                                    name: e1[r1].cm
                                };
                            }
                        }
                        i1.push(s1);
                    }
                    return i1;
                };
            }(), ProjectInterface = function() {
                function t1(t1) {
                    this.compositions.push(t1);
                }
                return function() {
                    function e1(t1) {
                        for(var e1 = 0, i1 = this.compositions.length; e1 < i1;){
                            if (this.compositions[e1].data && this.compositions[e1].data.nm === t1) return this.compositions[e1].prepareFrame && this.compositions[e1].data.xt && this.compositions[e1].prepareFrame(this.currentFrame), this.compositions[e1].compInterface;
                            e1 += 1;
                        }
                        return null;
                    }
                    return e1.compositions = [], e1.currentFrame = 0, e1.registerComposition = t1, e1;
                };
            }(), renderers = {}, registerRenderer = function(t1, e1) {
                renderers[t1] = e1;
            };
            function getRenderer(t1) {
                return renderers[t1];
            }
            function _typeof$4(t1) {
                return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, _typeof$4(t1);
            }
            var AnimationItem = function() {
                this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader, this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0);
            };
            extendPrototype([
                BaseEvent
            ], AnimationItem), AnimationItem.prototype.setParams = function(t1) {
                (t1.wrapper || t1.container) && (this.wrapper = t1.wrapper || t1.container);
                var e1 = "svg";
                t1.animType ? e1 = t1.animType : t1.renderer && (e1 = t1.renderer);
                var i1 = getRenderer(e1);
                this.renderer = new i1(this, t1.rendererSettings), this.imagePreloader.setCacheType(e1, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = e1, "" === t1.loop || null === t1.loop || void 0 === t1.loop || !0 === t1.loop ? this.loop = !0 : !1 === t1.loop ? this.loop = !1 : this.loop = parseInt(t1.loop, 10), this.autoplay = !("autoplay" in t1) || t1.autoplay, this.name = t1.name ? t1.name : "", this.autoloadSegments = !Object.prototype.hasOwnProperty.call(t1, "autoloadSegments") || t1.autoloadSegments, this.assetsPath = t1.assetsPath, this.initialSegment = t1.initialSegment, t1.audioFactory && this.audioController.setAudioFactory(t1.audioFactory), t1.animationData ? this.setupAnimation(t1.animationData) : t1.path && (-1 !== t1.path.lastIndexOf("\\") ? this.path = t1.path.substr(0, t1.path.lastIndexOf("\\") + 1) : this.path = t1.path.substr(0, t1.path.lastIndexOf("/") + 1), this.fileName = t1.path.substr(t1.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(t1.path, this.configAnimation, this.onSetupError));
            }, AnimationItem.prototype.onSetupError = function() {
                this.trigger("data_failed");
            }, AnimationItem.prototype.setupAnimation = function(t1) {
                dataManager.completeAnimation(t1, this.configAnimation);
            }, AnimationItem.prototype.setData = function(t1, e1) {
                e1 && "object" !== _typeof$4(e1) && (e1 = JSON.parse(e1));
                var i1 = {
                    wrapper: t1,
                    animationData: e1
                }, r1 = t1.attributes;
                i1.path = r1.getNamedItem("data-animation-path") ? r1.getNamedItem("data-animation-path").value : r1.getNamedItem("data-bm-path") ? r1.getNamedItem("data-bm-path").value : r1.getNamedItem("bm-path") ? r1.getNamedItem("bm-path").value : "", i1.animType = r1.getNamedItem("data-anim-type") ? r1.getNamedItem("data-anim-type").value : r1.getNamedItem("data-bm-type") ? r1.getNamedItem("data-bm-type").value : r1.getNamedItem("bm-type") ? r1.getNamedItem("bm-type").value : r1.getNamedItem("data-bm-renderer") ? r1.getNamedItem("data-bm-renderer").value : r1.getNamedItem("bm-renderer") ? r1.getNamedItem("bm-renderer").value : "canvas";
                var a1 = r1.getNamedItem("data-anim-loop") ? r1.getNamedItem("data-anim-loop").value : r1.getNamedItem("data-bm-loop") ? r1.getNamedItem("data-bm-loop").value : r1.getNamedItem("bm-loop") ? r1.getNamedItem("bm-loop").value : "";
                "false" === a1 ? i1.loop = !1 : "true" === a1 ? i1.loop = !0 : "" !== a1 && (i1.loop = parseInt(a1, 10));
                var s1 = r1.getNamedItem("data-anim-autoplay") ? r1.getNamedItem("data-anim-autoplay").value : r1.getNamedItem("data-bm-autoplay") ? r1.getNamedItem("data-bm-autoplay").value : !r1.getNamedItem("bm-autoplay") || r1.getNamedItem("bm-autoplay").value;
                i1.autoplay = "false" !== s1, i1.name = r1.getNamedItem("data-name") ? r1.getNamedItem("data-name").value : r1.getNamedItem("data-bm-name") ? r1.getNamedItem("data-bm-name").value : r1.getNamedItem("bm-name") ? r1.getNamedItem("bm-name").value : "", "false" === (r1.getNamedItem("data-anim-prerender") ? r1.getNamedItem("data-anim-prerender").value : r1.getNamedItem("data-bm-prerender") ? r1.getNamedItem("data-bm-prerender").value : r1.getNamedItem("bm-prerender") ? r1.getNamedItem("bm-prerender").value : "") && (i1.prerender = !1), this.setParams(i1);
            }, AnimationItem.prototype.includeLayers = function(t1) {
                t1.op > this.animationData.op && (this.animationData.op = t1.op, this.totalFrames = Math.floor(t1.op - this.animationData.ip));
                var e1, i1, r1 = this.animationData.layers, a1 = r1.length, s1 = t1.layers, n1 = s1.length;
                for(i1 = 0; i1 < n1; i1 += 1)for(e1 = 0; e1 < a1;){
                    if (r1[e1].id === s1[i1].id) {
                        r1[e1] = s1[i1];
                        break;
                    }
                    e1 += 1;
                }
                if ((t1.chars || t1.fonts) && (this.renderer.globalData.fontManager.addChars(t1.chars), this.renderer.globalData.fontManager.addFonts(t1.fonts, this.renderer.globalData.defs)), t1.assets) for(a1 = t1.assets.length, e1 = 0; e1 < a1; e1 += 1)this.animationData.assets.push(t1.assets[e1]);
                this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
            }, AnimationItem.prototype.onSegmentComplete = function(t1) {
                this.animationData = t1;
                var e1 = getExpressionsPlugin();
                e1 && e1.initExpressions(this), this.loadNextSegment();
            }, AnimationItem.prototype.loadNextSegment = function() {
                var t1 = this.animationData.segments;
                if (!t1 || 0 === t1.length || !this.autoloadSegments) return this.trigger("data_ready"), void (this.timeCompleted = this.totalFrames);
                var e1 = t1.shift();
                this.timeCompleted = e1.time * this.frameRate;
                var i1 = this.path + this.fileName + "_" + this.segmentPos + ".json";
                this.segmentPos += 1, dataManager.loadData(i1, this.includeLayers.bind(this), (function() {
                    this.trigger("data_failed");
                }).bind(this));
            }, AnimationItem.prototype.loadSegments = function() {
                this.animationData.segments || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
            }, AnimationItem.prototype.imagesLoaded = function() {
                this.trigger("loaded_images"), this.checkLoaded();
            }, AnimationItem.prototype.preloadImages = function() {
                this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
            }, AnimationItem.prototype.configAnimation = function(t1) {
                if (this.renderer) try {
                    this.animationData = t1, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(t1), t1.assets || (t1.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(t1.assets), this.markers = markerParser(t1.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
                } catch (t1) {
                    this.triggerConfigError(t1);
                }
            }, AnimationItem.prototype.waitForFontsLoaded = function() {
                this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
            }, AnimationItem.prototype.checkLoaded = function() {
                if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || "canvas" !== this.renderer.rendererType) && this.imagePreloader.loadedFootages()) {
                    this.isLoaded = !0;
                    var t1 = getExpressionsPlugin();
                    t1 && t1.initExpressions(this), this.renderer.initItems(), setTimeout((function() {
                        this.trigger("DOMLoaded");
                    }).bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
                }
            }, AnimationItem.prototype.resize = function(t1, e1) {
                var i1 = "number" == typeof t1 ? t1 : void 0, r1 = "number" == typeof e1 ? e1 : void 0;
                this.renderer.updateContainerSize(i1, r1);
            }, AnimationItem.prototype.setSubframe = function(t1) {
                this.isSubframeEnabled = !!t1;
            }, AnimationItem.prototype.gotoFrame = function() {
                this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
            }, AnimationItem.prototype.renderFrame = function() {
                if (!1 !== this.isLoaded && this.renderer) try {
                    this.renderer.renderFrame(this.currentFrame + this.firstFrame);
                } catch (t1) {
                    this.triggerRenderFrameError(t1);
                }
            }, AnimationItem.prototype.play = function(t1) {
                t1 && this.name !== t1 || !0 === this.isPaused && (this.isPaused = !1, this.trigger("_pause"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
            }, AnimationItem.prototype.pause = function(t1) {
                t1 && this.name !== t1 || !1 === this.isPaused && (this.isPaused = !0, this.trigger("_play"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
            }, AnimationItem.prototype.togglePause = function(t1) {
                t1 && this.name !== t1 || (!0 === this.isPaused ? this.play() : this.pause());
            }, AnimationItem.prototype.stop = function(t1) {
                t1 && this.name !== t1 || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
            }, AnimationItem.prototype.getMarkerData = function(t1) {
                for(var e1, i1 = 0; i1 < this.markers.length; i1 += 1)if ((e1 = this.markers[i1]).payload && e1.payload.name === t1) return e1;
                return null;
            }, AnimationItem.prototype.goToAndStop = function(t1, e1, i1) {
                if (!i1 || this.name === i1) {
                    var r1 = Number(t1);
                    if (isNaN(r1)) {
                        var a1 = this.getMarkerData(t1);
                        a1 && this.goToAndStop(a1.time, !0);
                    } else e1 ? this.setCurrentRawFrameValue(t1) : this.setCurrentRawFrameValue(t1 * this.frameModifier);
                    this.pause();
                }
            }, AnimationItem.prototype.goToAndPlay = function(t1, e1, i1) {
                if (!i1 || this.name === i1) {
                    var r1 = Number(t1);
                    if (isNaN(r1)) {
                        var a1 = this.getMarkerData(t1);
                        a1 && (a1.duration ? this.playSegments([
                            a1.time,
                            a1.time + a1.duration
                        ], !0) : this.goToAndStop(a1.time, !0));
                    } else this.goToAndStop(r1, e1, i1);
                    this.play();
                }
            }, AnimationItem.prototype.advanceTime = function(t1) {
                if (!0 !== this.isPaused && !1 !== this.isLoaded) {
                    var e1 = this.currentRawFrame + t1 * this.frameModifier, i1 = !1;
                    e1 >= this.totalFrames - 1 && this.frameModifier > 0 ? this.loop && this.playCount !== this.loop ? e1 >= this.totalFrames ? (this.playCount += 1, this.checkSegments(e1 % this.totalFrames) || (this.setCurrentRawFrameValue(e1 % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(e1) : this.checkSegments(e1 > this.totalFrames ? e1 % this.totalFrames : 0) || (i1 = !0, e1 = this.totalFrames - 1) : e1 < 0 ? this.checkSegments(e1 % this.totalFrames) || (!this.loop || this.playCount-- <= 0 && !0 !== this.loop ? (i1 = !0, e1 = 0) : (this.setCurrentRawFrameValue(this.totalFrames + e1 % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0)) : this.setCurrentRawFrameValue(e1), i1 && (this.setCurrentRawFrameValue(e1), this.pause(), this.trigger("complete"));
                }
            }, AnimationItem.prototype.adjustSegment = function(t1, e1) {
                this.playCount = 0, t1[1] < t1[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = t1[0] - t1[1], this.timeCompleted = this.totalFrames, this.firstFrame = t1[1], this.setCurrentRawFrameValue(this.totalFrames - .001 - e1)) : t1[1] > t1[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = t1[1] - t1[0], this.timeCompleted = this.totalFrames, this.firstFrame = t1[0], this.setCurrentRawFrameValue(.001 + e1)), this.trigger("segmentStart");
            }, AnimationItem.prototype.setSegment = function(t1, e1) {
                var i1 = -1;
                this.isPaused && (this.currentRawFrame + this.firstFrame < t1 ? i1 = t1 : this.currentRawFrame + this.firstFrame > e1 && (i1 = e1 - t1)), this.firstFrame = t1, this.totalFrames = e1 - t1, this.timeCompleted = this.totalFrames, -1 !== i1 && this.goToAndStop(i1, !0);
            }, AnimationItem.prototype.playSegments = function(t1, e1) {
                if (e1 && (this.segments.length = 0), "object" === _typeof$4(t1[0])) {
                    var i1, r1 = t1.length;
                    for(i1 = 0; i1 < r1; i1 += 1)this.segments.push(t1[i1]);
                } else this.segments.push(t1);
                this.segments.length && e1 && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
            }, AnimationItem.prototype.resetSegments = function(t1) {
                this.segments.length = 0, this.segments.push([
                    this.animationData.ip,
                    this.animationData.op
                ]), t1 && this.checkSegments(0);
            }, AnimationItem.prototype.checkSegments = function(t1) {
                return !!this.segments.length && (this.adjustSegment(this.segments.shift(), t1), !0);
            }, AnimationItem.prototype.destroy = function(t1) {
                t1 && this.name !== t1 || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.renderer = null, this.imagePreloader = null, this.projectInterface = null);
            }, AnimationItem.prototype.setCurrentRawFrameValue = function(t1) {
                this.currentRawFrame = t1, this.gotoFrame();
            }, AnimationItem.prototype.setSpeed = function(t1) {
                this.playSpeed = t1, this.updaFrameModifier();
            }, AnimationItem.prototype.setDirection = function(t1) {
                this.playDirection = t1 < 0 ? -1 : 1, this.updaFrameModifier();
            }, AnimationItem.prototype.setVolume = function(t1, e1) {
                e1 && this.name !== e1 || this.audioController.setVolume(t1);
            }, AnimationItem.prototype.getVolume = function() {
                return this.audioController.getVolume();
            }, AnimationItem.prototype.mute = function(t1) {
                t1 && this.name !== t1 || this.audioController.mute();
            }, AnimationItem.prototype.unmute = function(t1) {
                t1 && this.name !== t1 || this.audioController.unmute();
            }, AnimationItem.prototype.updaFrameModifier = function() {
                this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
            }, AnimationItem.prototype.getPath = function() {
                return this.path;
            }, AnimationItem.prototype.getAssetsPath = function(t1) {
                var e1 = "";
                if (t1.e) e1 = t1.p;
                else if (this.assetsPath) {
                    var i1 = t1.p;
                    -1 !== i1.indexOf("images/") && (i1 = i1.split("/")[1]), e1 = this.assetsPath + i1;
                } else e1 = this.path, e1 += t1.u ? t1.u : "", e1 += t1.p;
                return e1;
            }, AnimationItem.prototype.getAssetData = function(t1) {
                for(var e1 = 0, i1 = this.assets.length; e1 < i1;){
                    if (t1 === this.assets[e1].id) return this.assets[e1];
                    e1 += 1;
                }
                return null;
            }, AnimationItem.prototype.hide = function() {
                this.renderer.hide();
            }, AnimationItem.prototype.show = function() {
                this.renderer.show();
            }, AnimationItem.prototype.getDuration = function(t1) {
                return t1 ? this.totalFrames : this.totalFrames / this.frameRate;
            }, AnimationItem.prototype.updateDocumentData = function(t1, e1, i1) {
                try {
                    this.renderer.getElementByPath(t1).updateDocumentData(e1, i1);
                } catch (t1) {}
            }, AnimationItem.prototype.trigger = function(t1) {
                if (this._cbs && this._cbs[t1]) switch(t1){
                    case "enterFrame":
                        this.triggerEvent(t1, new BMEnterFrameEvent(t1, this.currentFrame, this.totalFrames, this.frameModifier));
                        break;
                    case "drawnFrame":
                        this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(t1, this.drawnFrameEvent);
                        break;
                    case "loopComplete":
                        this.triggerEvent(t1, new BMCompleteLoopEvent(t1, this.loop, this.playCount, this.frameMult));
                        break;
                    case "complete":
                        this.triggerEvent(t1, new BMCompleteEvent(t1, this.frameMult));
                        break;
                    case "segmentStart":
                        this.triggerEvent(t1, new BMSegmentStartEvent(t1, this.firstFrame, this.totalFrames));
                        break;
                    case "destroy":
                        this.triggerEvent(t1, new BMDestroyEvent(t1, this));
                        break;
                    default:
                        this.triggerEvent(t1);
                }
                "enterFrame" === t1 && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(t1, this.currentFrame, this.totalFrames, this.frameMult)), "loopComplete" === t1 && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(t1, this.loop, this.playCount, this.frameMult)), "complete" === t1 && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(t1, this.frameMult)), "segmentStart" === t1 && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(t1, this.firstFrame, this.totalFrames)), "destroy" === t1 && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(t1, this));
            }, AnimationItem.prototype.triggerRenderFrameError = function(t1) {
                var e1 = new BMRenderFrameErrorEvent(t1, this.currentFrame);
                this.triggerEvent("error", e1), this.onError && this.onError.call(this, e1);
            }, AnimationItem.prototype.triggerConfigError = function(t1) {
                var e1 = new BMConfigErrorEvent(t1, this.currentFrame);
                this.triggerEvent("error", e1), this.onError && this.onError.call(this, e1);
            };
            var animationManager = function() {
                var t1 = {}, e1 = [], i1 = 0, r1 = 0, a1 = 0, s1 = !0, n1 = !1;
                function o1(t1) {
                    for(var i1 = 0, a1 = t1.target; i1 < r1;)e1[i1].animation === a1 && (e1.splice(i1, 1), i1 -= 1, r1 -= 1, a1.isPaused || p1()), i1 += 1;
                }
                function h1(t1, i1) {
                    if (!t1) return null;
                    for(var a1 = 0; a1 < r1;){
                        if (e1[a1].elem === t1 && null !== e1[a1].elem) return e1[a1].animation;
                        a1 += 1;
                    }
                    var s1 = new AnimationItem;
                    return f1(s1, t1), s1.setData(t1, i1), s1;
                }
                function l1() {
                    a1 += 1, m1();
                }
                function p1() {
                    a1 -= 1;
                }
                function f1(t1, i1) {
                    t1.addEventListener("destroy", o1), t1.addEventListener("_active", l1), t1.addEventListener("_idle", p1), e1.push({
                        elem: i1,
                        animation: t1
                    }), r1 += 1;
                }
                function d1(t1) {
                    var o1, h1 = t1 - i1;
                    for(o1 = 0; o1 < r1; o1 += 1)e1[o1].animation.advanceTime(h1);
                    i1 = t1, a1 && !n1 ? window.requestAnimationFrame(d1) : s1 = !0;
                }
                function c1(t1) {
                    i1 = t1, window.requestAnimationFrame(d1);
                }
                function m1() {
                    !n1 && a1 && s1 && (window.requestAnimationFrame(c1), s1 = !1);
                }
                return t1.registerAnimation = h1, t1.loadAnimation = function(t1) {
                    var e1 = new AnimationItem;
                    return f1(e1, null), e1.setParams(t1), e1;
                }, t1.setSpeed = function(t1, i1) {
                    var a1;
                    for(a1 = 0; a1 < r1; a1 += 1)e1[a1].animation.setSpeed(t1, i1);
                }, t1.setDirection = function(t1, i1) {
                    var a1;
                    for(a1 = 0; a1 < r1; a1 += 1)e1[a1].animation.setDirection(t1, i1);
                }, t1.play = function(t1) {
                    var i1;
                    for(i1 = 0; i1 < r1; i1 += 1)e1[i1].animation.play(t1);
                }, t1.pause = function(t1) {
                    var i1;
                    for(i1 = 0; i1 < r1; i1 += 1)e1[i1].animation.pause(t1);
                }, t1.stop = function(t1) {
                    var i1;
                    for(i1 = 0; i1 < r1; i1 += 1)e1[i1].animation.stop(t1);
                }, t1.togglePause = function(t1) {
                    var i1;
                    for(i1 = 0; i1 < r1; i1 += 1)e1[i1].animation.togglePause(t1);
                }, t1.searchAnimations = function(t1, e1, i1) {
                    var r1, a1 = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), s1 = a1.length;
                    for(r1 = 0; r1 < s1; r1 += 1)i1 && a1[r1].setAttribute("data-bm-type", i1), h1(a1[r1], t1);
                    if (e1 && 0 === s1) {
                        i1 || (i1 = "svg");
                        var n1 = document.getElementsByTagName("body")[0];
                        n1.innerText = "";
                        var o1 = createTag("div");
                        o1.style.width = "100%", o1.style.height = "100%", o1.setAttribute("data-bm-type", i1), n1.appendChild(o1), h1(o1, t1);
                    }
                }, t1.resize = function() {
                    var t1;
                    for(t1 = 0; t1 < r1; t1 += 1)e1[t1].animation.resize();
                }, t1.goToAndStop = function(t1, i1, a1) {
                    var s1;
                    for(s1 = 0; s1 < r1; s1 += 1)e1[s1].animation.goToAndStop(t1, i1, a1);
                }, t1.destroy = function(t1) {
                    var i1;
                    for(i1 = r1 - 1; i1 >= 0; i1 -= 1)e1[i1].animation.destroy(t1);
                }, t1.freeze = function() {
                    n1 = !0;
                }, t1.unfreeze = function() {
                    n1 = !1, m1();
                }, t1.setVolume = function(t1, i1) {
                    var a1;
                    for(a1 = 0; a1 < r1; a1 += 1)e1[a1].animation.setVolume(t1, i1);
                }, t1.mute = function(t1) {
                    var i1;
                    for(i1 = 0; i1 < r1; i1 += 1)e1[i1].animation.mute(t1);
                }, t1.unmute = function(t1) {
                    var i1;
                    for(i1 = 0; i1 < r1; i1 += 1)e1[i1].animation.unmute(t1);
                }, t1.getRegisteredAnimations = function() {
                    var t1, i1 = e1.length, r1 = [];
                    for(t1 = 0; t1 < i1; t1 += 1)r1.push(e1[t1].animation);
                    return r1;
                }, t1;
            }(), BezierFactory = function() {
                var t1 = {
                    getBezierEasing: function(t1, i1, r1, a1, s1) {
                        var n1 = s1 || ("bez_" + t1 + "_" + i1 + "_" + r1 + "_" + a1).replace(/\./g, "p");
                        if (e1[n1]) return e1[n1];
                        var o1 = new l1([
                            t1,
                            i1,
                            r1,
                            a1
                        ]);
                        return e1[n1] = o1, o1;
                    }
                }, e1 = {}, i1 = .1, r1 = "function" == typeof Float32Array;
                function a1(t1, e1) {
                    return 1 - 3 * e1 + 3 * t1;
                }
                function s1(t1, e1) {
                    return 3 * e1 - 6 * t1;
                }
                function n1(t1) {
                    return 3 * t1;
                }
                function o1(t1, e1, i1) {
                    return ((a1(e1, i1) * t1 + s1(e1, i1)) * t1 + n1(e1)) * t1;
                }
                function h1(t1, e1, i1) {
                    return 3 * a1(e1, i1) * t1 * t1 + 2 * s1(e1, i1) * t1 + n1(e1);
                }
                function l1(t1) {
                    this._p = t1, this._mSampleValues = r1 ? new Float32Array(11) : new Array(11), this._precomputed = !1, this.get = this.get.bind(this);
                }
                return l1.prototype = {
                    get: function(t1) {
                        var e1 = this._p[0], i1 = this._p[1], r1 = this._p[2], a1 = this._p[3];
                        return this._precomputed || this._precompute(), e1 === i1 && r1 === a1 ? t1 : 0 === t1 ? 0 : 1 === t1 ? 1 : o1(this._getTForX(t1), i1, a1);
                    },
                    _precompute: function() {
                        var t1 = this._p[0], e1 = this._p[1], i1 = this._p[2], r1 = this._p[3];
                        this._precomputed = !0, t1 === e1 && i1 === r1 || this._calcSampleValues();
                    },
                    _calcSampleValues: function() {
                        for(var t1 = this._p[0], e1 = this._p[2], r1 = 0; r1 < 11; ++r1)this._mSampleValues[r1] = o1(r1 * i1, t1, e1);
                    },
                    _getTForX: function(t1) {
                        for(var e1 = this._p[0], r1 = this._p[2], a1 = this._mSampleValues, s1 = 0, n1 = 1; 10 !== n1 && a1[n1] <= t1; ++n1)s1 += i1;
                        var l1 = s1 + (t1 - a1[--n1]) / (a1[n1 + 1] - a1[n1]) * i1, p1 = h1(l1, e1, r1);
                        return p1 >= .001 ? function(t1, e1, i1, r1) {
                            for(var a1 = 0; a1 < 4; ++a1){
                                var s1 = h1(e1, i1, r1);
                                if (0 === s1) return e1;
                                e1 -= (o1(e1, i1, r1) - t1) / s1;
                            }
                            return e1;
                        }(t1, l1, e1, r1) : 0 === p1 ? l1 : function(t1, e1, i1, r1, a1) {
                            var s1, n1, h1 = 0;
                            do (s1 = o1(n1 = e1 + (i1 - e1) / 2, r1, a1) - t1) > 0 ? i1 = n1 : e1 = n1;
                            while (Math.abs(s1) > 1e-7 && ++h1 < 10);
                            return n1;
                        }(t1, s1, s1 + i1, e1, r1);
                    }
                }, t1;
            }(), pooling = {
                double: function(t1) {
                    return t1.concat(createSizedArray(t1.length));
                }
            }, poolFactory = function(t1, e1, i1) {
                var r1 = 0, a1 = t1, s1 = createSizedArray(a1);
                return {
                    newElement: function() {
                        return r1 ? s1[r1 -= 1] : e1();
                    },
                    release: function(t1) {
                        r1 === a1 && (s1 = pooling.double(s1), a1 *= 2), i1 && i1(t1), s1[r1] = t1, r1 += 1;
                    }
                };
            }, bezierLengthPool = poolFactory(8, function() {
                return {
                    addedLength: 0,
                    percents: createTypedArray("float32", getDefaultCurveSegments()),
                    lengths: createTypedArray("float32", getDefaultCurveSegments())
                };
            }), segmentsLengthPool = poolFactory(8, function() {
                return {
                    lengths: [],
                    totalLength: 0
                };
            }, function(t1) {
                var e1, i1 = t1.lengths.length;
                for(e1 = 0; e1 < i1; e1 += 1)bezierLengthPool.release(t1.lengths[e1]);
                t1.lengths.length = 0;
            });
            function bezFunction() {
                var t1 = Math;
                function e1(t1, e1, i1, r1, a1, s1) {
                    var n1 = t1 * r1 + e1 * a1 + i1 * s1 - a1 * r1 - s1 * t1 - i1 * e1;
                    return n1 > -0.001 && n1 < .001;
                }
                var i1 = function(t1, e1, i1, r1) {
                    var a1, s1, n1, o1, h1, l1, p1 = getDefaultCurveSegments(), f1 = 0, d1 = [], c1 = [], m1 = bezierLengthPool.newElement();
                    for(n1 = i1.length, a1 = 0; a1 < p1; a1 += 1){
                        for(h1 = a1 / (p1 - 1), l1 = 0, s1 = 0; s1 < n1; s1 += 1)o1 = bmPow(1 - h1, 3) * t1[s1] + 3 * bmPow(1 - h1, 2) * h1 * i1[s1] + 3 * (1 - h1) * bmPow(h1, 2) * r1[s1] + bmPow(h1, 3) * e1[s1], d1[s1] = o1, null !== c1[s1] && (l1 += bmPow(d1[s1] - c1[s1], 2)), c1[s1] = d1[s1];
                        l1 && (f1 += l1 = bmSqrt(l1)), m1.percents[a1] = h1, m1.lengths[a1] = f1;
                    }
                    return m1.addedLength = f1, m1;
                };
                function r1(t1) {
                    this.segmentLength = 0, this.points = new Array(t1);
                }
                function a1(t1, e1) {
                    this.partialLength = t1, this.point = e1;
                }
                var s1, n1 = (s1 = {}, function(t1, i1, n1, o1) {
                    var h1 = (t1[0] + "_" + t1[1] + "_" + i1[0] + "_" + i1[1] + "_" + n1[0] + "_" + n1[1] + "_" + o1[0] + "_" + o1[1]).replace(/\./g, "p");
                    if (!s1[h1]) {
                        var l1, p1, f1, d1, c1, m1, u1, y1 = getDefaultCurveSegments(), g1 = 0, _1 = null;
                        2 === t1.length && (t1[0] !== i1[0] || t1[1] !== i1[1]) && e1(t1[0], t1[1], i1[0], i1[1], t1[0] + n1[0], t1[1] + n1[1]) && e1(t1[0], t1[1], i1[0], i1[1], i1[0] + o1[0], i1[1] + o1[1]) && (y1 = 2);
                        var v1 = new r1(y1);
                        for(f1 = n1.length, l1 = 0; l1 < y1; l1 += 1){
                            for(u1 = createSizedArray(f1), c1 = l1 / (y1 - 1), m1 = 0, p1 = 0; p1 < f1; p1 += 1)d1 = bmPow(1 - c1, 3) * t1[p1] + 3 * bmPow(1 - c1, 2) * c1 * (t1[p1] + n1[p1]) + 3 * (1 - c1) * bmPow(c1, 2) * (i1[p1] + o1[p1]) + bmPow(c1, 3) * i1[p1], u1[p1] = d1, null !== _1 && (m1 += bmPow(u1[p1] - _1[p1], 2));
                            g1 += m1 = bmSqrt(m1), v1.points[l1] = new a1(m1, u1), _1 = u1;
                        }
                        v1.segmentLength = g1, s1[h1] = v1;
                    }
                    return s1[h1];
                });
                function o1(t1, e1) {
                    var i1 = e1.percents, r1 = e1.lengths, a1 = i1.length, s1 = bmFloor((a1 - 1) * t1), n1 = t1 * e1.addedLength, o1 = 0;
                    if (s1 === a1 - 1 || 0 === s1 || n1 === r1[s1]) return i1[s1];
                    for(var h1 = r1[s1] > n1 ? -1 : 1, l1 = !0; l1;)if (r1[s1] <= n1 && r1[s1 + 1] > n1 ? (o1 = (n1 - r1[s1]) / (r1[s1 + 1] - r1[s1]), l1 = !1) : s1 += h1, s1 < 0 || s1 >= a1 - 1) {
                        if (s1 === a1 - 1) return i1[s1];
                        l1 = !1;
                    }
                    return i1[s1] + (i1[s1 + 1] - i1[s1]) * o1;
                }
                var h1 = createTypedArray("float32", 8);
                return {
                    getSegmentsLength: function(t1) {
                        var e1, r1 = segmentsLengthPool.newElement(), a1 = t1.c, s1 = t1.v, n1 = t1.o, o1 = t1.i, h1 = t1._length, l1 = r1.lengths, p1 = 0;
                        for(e1 = 0; e1 < h1 - 1; e1 += 1)l1[e1] = i1(s1[e1], s1[e1 + 1], n1[e1], o1[e1 + 1]), p1 += l1[e1].addedLength;
                        return a1 && h1 && (l1[e1] = i1(s1[e1], s1[0], n1[e1], o1[0]), p1 += l1[e1].addedLength), r1.totalLength = p1, r1;
                    },
                    getNewSegment: function(e1, i1, r1, a1, s1, n1, l1) {
                        s1 < 0 ? s1 = 0 : s1 > 1 && (s1 = 1);
                        var p1, f1 = o1(s1, l1), d1 = o1(n1 = n1 > 1 ? 1 : n1, l1), c1 = e1.length, m1 = 1 - f1, u1 = 1 - d1, y1 = m1 * m1 * m1, g1 = f1 * m1 * m1 * 3, _1 = f1 * f1 * m1 * 3, v1 = f1 * f1 * f1, b1 = m1 * m1 * u1, E1 = f1 * m1 * u1 + m1 * f1 * u1 + m1 * m1 * d1, S1 = f1 * f1 * u1 + m1 * f1 * d1 + f1 * m1 * d1, A1 = f1 * f1 * d1, P1 = m1 * u1 * u1, x1 = f1 * u1 * u1 + m1 * d1 * u1 + m1 * u1 * d1, T1 = f1 * d1 * u1 + m1 * d1 * d1 + f1 * u1 * d1, w1 = f1 * d1 * d1, C1 = u1 * u1 * u1, k1 = d1 * u1 * u1 + u1 * d1 * u1 + u1 * u1 * d1, D1 = d1 * d1 * u1 + u1 * d1 * d1 + d1 * u1 * d1, M1 = d1 * d1 * d1;
                        for(p1 = 0; p1 < c1; p1 += 1)h1[4 * p1] = t1.round(1e3 * (y1 * e1[p1] + g1 * r1[p1] + _1 * a1[p1] + v1 * i1[p1])) / 1e3, h1[4 * p1 + 1] = t1.round(1e3 * (b1 * e1[p1] + E1 * r1[p1] + S1 * a1[p1] + A1 * i1[p1])) / 1e3, h1[4 * p1 + 2] = t1.round(1e3 * (P1 * e1[p1] + x1 * r1[p1] + T1 * a1[p1] + w1 * i1[p1])) / 1e3, h1[4 * p1 + 3] = t1.round(1e3 * (C1 * e1[p1] + k1 * r1[p1] + D1 * a1[p1] + M1 * i1[p1])) / 1e3;
                        return h1;
                    },
                    getPointInSegment: function(e1, i1, r1, a1, s1, n1) {
                        var h1 = o1(s1, n1), l1 = 1 - h1;
                        return [
                            t1.round(1e3 * (l1 * l1 * l1 * e1[0] + (h1 * l1 * l1 + l1 * h1 * l1 + l1 * l1 * h1) * r1[0] + (h1 * h1 * l1 + l1 * h1 * h1 + h1 * l1 * h1) * a1[0] + h1 * h1 * h1 * i1[0])) / 1e3,
                            t1.round(1e3 * (l1 * l1 * l1 * e1[1] + (h1 * l1 * l1 + l1 * h1 * l1 + l1 * l1 * h1) * r1[1] + (h1 * h1 * l1 + l1 * h1 * h1 + h1 * l1 * h1) * a1[1] + h1 * h1 * h1 * i1[1])) / 1e3
                        ];
                    },
                    buildBezierData: n1,
                    pointOnLine2D: e1,
                    pointOnLine3D: function(i1, r1, a1, s1, n1, o1, h1, l1, p1) {
                        if (0 === a1 && 0 === o1 && 0 === p1) return e1(i1, r1, s1, n1, h1, l1);
                        var f1, d1 = t1.sqrt(t1.pow(s1 - i1, 2) + t1.pow(n1 - r1, 2) + t1.pow(o1 - a1, 2)), c1 = t1.sqrt(t1.pow(h1 - i1, 2) + t1.pow(l1 - r1, 2) + t1.pow(p1 - a1, 2)), m1 = t1.sqrt(t1.pow(h1 - s1, 2) + t1.pow(l1 - n1, 2) + t1.pow(p1 - o1, 2));
                        return (f1 = d1 > c1 ? d1 > m1 ? d1 - c1 - m1 : m1 - c1 - d1 : m1 > c1 ? m1 - c1 - d1 : c1 - d1 - m1) > -0.0001 && f1 < 1e-4;
                    }
                };
            }
            var bez = bezFunction(), PropertyFactory = function() {
                var t1 = initialDefaultFrame, e1 = Math.abs;
                function i1(t1, e1) {
                    var i1, a1 = this.offsetTime;
                    "multidimensional" === this.propType && (i1 = createTypedArray("float32", this.pv.length));
                    for(var s1, n1, o1, h1, l1, p1, f1, d1, c1, m1 = e1.lastIndex, u1 = m1, y1 = this.keyframes.length - 1, g1 = !0; g1;){
                        if (s1 = this.keyframes[u1], n1 = this.keyframes[u1 + 1], u1 === y1 - 1 && t1 >= n1.t - a1) {
                            s1.h && (s1 = n1), m1 = 0;
                            break;
                        }
                        if (n1.t - a1 > t1) {
                            m1 = u1;
                            break;
                        }
                        u1 < y1 - 1 ? u1 += 1 : (m1 = 0, g1 = !1);
                    }
                    o1 = this.keyframesMetadata[u1] || {};
                    var _1, v1, b1, E1, S1, A1, P1, x1, T1, w1, C1 = n1.t - a1, k1 = s1.t - a1;
                    if (s1.to) {
                        o1.bezierData || (o1.bezierData = bez.buildBezierData(s1.s, n1.s || s1.e, s1.to, s1.ti));
                        var D1 = o1.bezierData;
                        if (t1 >= C1 || t1 < k1) {
                            var M1 = t1 >= C1 ? D1.points.length - 1 : 0;
                            for(l1 = D1.points[M1].point.length, h1 = 0; h1 < l1; h1 += 1)i1[h1] = D1.points[M1].point[h1];
                        } else {
                            o1.__fnct ? c1 = o1.__fnct : (c1 = BezierFactory.getBezierEasing(s1.o.x, s1.o.y, s1.i.x, s1.i.y, s1.n).get, o1.__fnct = c1), p1 = c1((t1 - k1) / (C1 - k1));
                            var I1, F1 = D1.segmentLength * p1, R1 = e1.lastFrame < t1 && e1._lastKeyframeIndex === u1 ? e1._lastAddedLength : 0;
                            for(d1 = e1.lastFrame < t1 && e1._lastKeyframeIndex === u1 ? e1._lastPoint : 0, g1 = !0, f1 = D1.points.length; g1;){
                                if (R1 += D1.points[d1].partialLength, 0 === F1 || 0 === p1 || d1 === D1.points.length - 1) {
                                    for(l1 = D1.points[d1].point.length, h1 = 0; h1 < l1; h1 += 1)i1[h1] = D1.points[d1].point[h1];
                                    break;
                                }
                                if (F1 >= R1 && F1 < R1 + D1.points[d1 + 1].partialLength) {
                                    for(I1 = (F1 - R1) / D1.points[d1 + 1].partialLength, l1 = D1.points[d1].point.length, h1 = 0; h1 < l1; h1 += 1)i1[h1] = D1.points[d1].point[h1] + (D1.points[d1 + 1].point[h1] - D1.points[d1].point[h1]) * I1;
                                    break;
                                }
                                d1 < f1 - 1 ? d1 += 1 : g1 = !1;
                            }
                            e1._lastPoint = d1, e1._lastAddedLength = R1 - D1.points[d1].partialLength, e1._lastKeyframeIndex = u1;
                        }
                    } else {
                        var B1, L1, O1, N1, $1;
                        if (y1 = s1.s.length, _1 = n1.s || s1.e, this.sh && 1 !== s1.h) {
                            if (t1 >= C1) i1[0] = _1[0], i1[1] = _1[1], i1[2] = _1[2];
                            else if (t1 <= k1) i1[0] = s1.s[0], i1[1] = s1.s[1], i1[2] = s1.s[2];
                            else {
                                var z1 = r1(s1.s), V1 = r1(_1);
                                v1 = i1, b1 = function(t1, e1, i1) {
                                    var r1, a1, s1, n1, o1, h1 = [], l1 = t1[0], p1 = t1[1], f1 = t1[2], d1 = t1[3], c1 = e1[0], m1 = e1[1], u1 = e1[2], y1 = e1[3];
                                    return (a1 = l1 * c1 + p1 * m1 + f1 * u1 + d1 * y1) < 0 && (a1 = -a1, c1 = -c1, m1 = -m1, u1 = -u1, y1 = -y1), 1 - a1 > 1e-6 ? (r1 = Math.acos(a1), s1 = Math.sin(r1), n1 = Math.sin((1 - i1) * r1) / s1, o1 = Math.sin(i1 * r1) / s1) : (n1 = 1 - i1, o1 = i1), h1[0] = n1 * l1 + o1 * c1, h1[1] = n1 * p1 + o1 * m1, h1[2] = n1 * f1 + o1 * u1, h1[3] = n1 * d1 + o1 * y1, h1;
                                }(z1, V1, (t1 - k1) / (C1 - k1)), E1 = b1[0], S1 = b1[1], A1 = b1[2], P1 = b1[3], x1 = Math.atan2(2 * S1 * P1 - 2 * E1 * A1, 1 - 2 * S1 * S1 - 2 * A1 * A1), T1 = Math.asin(2 * E1 * S1 + 2 * A1 * P1), w1 = Math.atan2(2 * E1 * P1 - 2 * S1 * A1, 1 - 2 * E1 * E1 - 2 * A1 * A1), v1[0] = x1 / degToRads, v1[1] = T1 / degToRads, v1[2] = w1 / degToRads;
                            }
                        } else for(u1 = 0; u1 < y1; u1 += 1)1 !== s1.h && (t1 >= C1 ? p1 = 1 : t1 < k1 ? p1 = 0 : (s1.o.x.constructor === Array ? (o1.__fnct || (o1.__fnct = []), o1.__fnct[u1] ? c1 = o1.__fnct[u1] : (B1 = void 0 === s1.o.x[u1] ? s1.o.x[0] : s1.o.x[u1], L1 = void 0 === s1.o.y[u1] ? s1.o.y[0] : s1.o.y[u1], O1 = void 0 === s1.i.x[u1] ? s1.i.x[0] : s1.i.x[u1], N1 = void 0 === s1.i.y[u1] ? s1.i.y[0] : s1.i.y[u1], c1 = BezierFactory.getBezierEasing(B1, L1, O1, N1).get, o1.__fnct[u1] = c1)) : o1.__fnct ? c1 = o1.__fnct : (B1 = s1.o.x, L1 = s1.o.y, O1 = s1.i.x, N1 = s1.i.y, c1 = BezierFactory.getBezierEasing(B1, L1, O1, N1).get, s1.keyframeMetadata = c1), p1 = c1((t1 - k1) / (C1 - k1)))), _1 = n1.s || s1.e, $1 = 1 === s1.h ? s1.s[u1] : s1.s[u1] + (_1[u1] - s1.s[u1]) * p1, "multidimensional" === this.propType ? i1[u1] = $1 : i1 = $1;
                    }
                    return e1.lastIndex = m1, i1;
                }
                function r1(t1) {
                    var e1 = t1[0] * degToRads, i1 = t1[1] * degToRads, r1 = t1[2] * degToRads, a1 = Math.cos(e1 / 2), s1 = Math.cos(i1 / 2), n1 = Math.cos(r1 / 2), o1 = Math.sin(e1 / 2), h1 = Math.sin(i1 / 2), l1 = Math.sin(r1 / 2);
                    return [
                        o1 * h1 * n1 + a1 * s1 * l1,
                        o1 * s1 * n1 + a1 * h1 * l1,
                        a1 * h1 * n1 - o1 * s1 * l1,
                        a1 * s1 * n1 - o1 * h1 * l1
                    ];
                }
                function a1() {
                    var e1 = this.comp.renderedFrame - this.offsetTime, i1 = this.keyframes[0].t - this.offsetTime, r1 = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
                    if (!(e1 === this._caching.lastFrame || this._caching.lastFrame !== t1 && (this._caching.lastFrame >= r1 && e1 >= r1 || this._caching.lastFrame < i1 && e1 < i1))) {
                        this._caching.lastFrame >= e1 && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
                        var a1 = this.interpolateValue(e1, this._caching);
                        this.pv = a1;
                    }
                    return this._caching.lastFrame = e1, this.pv;
                }
                function s1(t1) {
                    var i1;
                    if ("unidimensional" === this.propType) i1 = t1 * this.mult, e1(this.v - i1) > 1e-5 && (this.v = i1, this._mdf = !0);
                    else for(var r1 = 0, a1 = this.v.length; r1 < a1;)i1 = t1[r1] * this.mult, e1(this.v[r1] - i1) > 1e-5 && (this.v[r1] = i1, this._mdf = !0), r1 += 1;
                }
                function n1() {
                    if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length) {
                        if (this.lock) this.setVValue(this.pv);
                        else {
                            var t1;
                            this.lock = !0, this._mdf = this._isFirstFrame;
                            var e1 = this.effectsSequence.length, i1 = this.kf ? this.pv : this.data.k;
                            for(t1 = 0; t1 < e1; t1 += 1)i1 = this.effectsSequence[t1](i1);
                            this.setVValue(i1), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
                        }
                    }
                }
                function o1(t1) {
                    this.effectsSequence.push(t1), this.container.addDynamicProperty(this);
                }
                function h1(t1, e1, i1, r1) {
                    this.propType = "unidimensional", this.mult = i1 || 1, this.data = e1, this.v = i1 ? e1.k * i1 : e1.k, this.pv = e1.k, this._mdf = !1, this.elem = t1, this.container = r1, this.comp = t1.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = n1, this.setVValue = s1, this.addEffect = o1;
                }
                function l1(t1, e1, i1, r1) {
                    var a1;
                    this.propType = "multidimensional", this.mult = i1 || 1, this.data = e1, this._mdf = !1, this.elem = t1, this.container = r1, this.comp = t1.comp, this.k = !1, this.kf = !1, this.frameId = -1;
                    var h1 = e1.k.length;
                    for(this.v = createTypedArray("float32", h1), this.pv = createTypedArray("float32", h1), this.vel = createTypedArray("float32", h1), a1 = 0; a1 < h1; a1 += 1)this.v[a1] = e1.k[a1] * this.mult, this.pv[a1] = e1.k[a1];
                    this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = n1, this.setVValue = s1, this.addEffect = o1;
                }
                function p1(e1, r1, h1, l1) {
                    this.propType = "unidimensional", this.keyframes = r1.k, this.keyframesMetadata = [], this.offsetTime = e1.data.st, this.frameId = -1, this._caching = {
                        lastFrame: t1,
                        lastIndex: 0,
                        value: 0,
                        _lastKeyframeIndex: -1
                    }, this.k = !0, this.kf = !0, this.data = r1, this.mult = h1 || 1, this.elem = e1, this.container = l1, this.comp = e1.comp, this.v = t1, this.pv = t1, this._isFirstFrame = !0, this.getValue = n1, this.setVValue = s1, this.interpolateValue = i1, this.effectsSequence = [
                        a1.bind(this)
                    ], this.addEffect = o1;
                }
                function f1(e1, r1, h1, l1) {
                    var p1;
                    this.propType = "multidimensional";
                    var f1, d1, c1, m1, u1 = r1.k.length;
                    for(p1 = 0; p1 < u1 - 1; p1 += 1)r1.k[p1].to && r1.k[p1].s && r1.k[p1 + 1] && r1.k[p1 + 1].s && (f1 = r1.k[p1].s, d1 = r1.k[p1 + 1].s, c1 = r1.k[p1].to, m1 = r1.k[p1].ti, (2 === f1.length && (f1[0] !== d1[0] || f1[1] !== d1[1]) && bez.pointOnLine2D(f1[0], f1[1], d1[0], d1[1], f1[0] + c1[0], f1[1] + c1[1]) && bez.pointOnLine2D(f1[0], f1[1], d1[0], d1[1], d1[0] + m1[0], d1[1] + m1[1]) || 3 === f1.length && (f1[0] !== d1[0] || f1[1] !== d1[1] || f1[2] !== d1[2]) && bez.pointOnLine3D(f1[0], f1[1], f1[2], d1[0], d1[1], d1[2], f1[0] + c1[0], f1[1] + c1[1], f1[2] + c1[2]) && bez.pointOnLine3D(f1[0], f1[1], f1[2], d1[0], d1[1], d1[2], d1[0] + m1[0], d1[1] + m1[1], d1[2] + m1[2])) && (r1.k[p1].to = null, r1.k[p1].ti = null), f1[0] === d1[0] && f1[1] === d1[1] && 0 === c1[0] && 0 === c1[1] && 0 === m1[0] && 0 === m1[1] && (2 === f1.length || f1[2] === d1[2] && 0 === c1[2] && 0 === m1[2]) && (r1.k[p1].to = null, r1.k[p1].ti = null));
                    this.effectsSequence = [
                        a1.bind(this)
                    ], this.data = r1, this.keyframes = r1.k, this.keyframesMetadata = [], this.offsetTime = e1.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = h1 || 1, this.elem = e1, this.container = l1, this.comp = e1.comp, this.getValue = n1, this.setVValue = s1, this.interpolateValue = i1, this.frameId = -1;
                    var y1 = r1.k[0].s.length;
                    for(this.v = createTypedArray("float32", y1), this.pv = createTypedArray("float32", y1), p1 = 0; p1 < y1; p1 += 1)this.v[p1] = t1, this.pv[p1] = t1;
                    this._caching = {
                        lastFrame: t1,
                        lastIndex: 0,
                        value: createTypedArray("float32", y1)
                    }, this.addEffect = o1;
                }
                var d1 = {
                    getProp: function(t1, e1, i1, r1, a1) {
                        var s1;
                        if (e1.k.length) {
                            if ("number" == typeof e1.k[0]) s1 = new l1(t1, e1, r1, a1);
                            else switch(i1){
                                case 0:
                                    s1 = new p1(t1, e1, r1, a1);
                                    break;
                                case 1:
                                    s1 = new f1(t1, e1, r1, a1);
                            }
                        } else s1 = new h1(t1, e1, r1, a1);
                        return s1.effectsSequence.length && a1.addDynamicProperty(s1), s1;
                    }
                };
                return d1;
            }();
            function DynamicPropertyContainer() {}
            DynamicPropertyContainer.prototype = {
                addDynamicProperty: function(t1) {
                    -1 === this.dynamicProperties.indexOf(t1) && (this.dynamicProperties.push(t1), this.container.addDynamicProperty(this), this._isAnimated = !0);
                },
                iterateDynamicProperties: function() {
                    var t1;
                    this._mdf = !1;
                    var e1 = this.dynamicProperties.length;
                    for(t1 = 0; t1 < e1; t1 += 1)this.dynamicProperties[t1].getValue(), this.dynamicProperties[t1]._mdf && (this._mdf = !0);
                },
                initDynamicPropertyContainer: function(t1) {
                    this.container = t1, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
                }
            };
            var pointPool = poolFactory(8, function() {
                return createTypedArray("float32", 2);
            });
            function ShapePath() {
                this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
            }
            ShapePath.prototype.setPathData = function(t1, e1) {
                this.c = t1, this.setLength(e1);
                for(var i1 = 0; i1 < e1;)this.v[i1] = pointPool.newElement(), this.o[i1] = pointPool.newElement(), this.i[i1] = pointPool.newElement(), i1 += 1;
            }, ShapePath.prototype.setLength = function(t1) {
                for(; this._maxLength < t1;)this.doubleArrayLength();
                this._length = t1;
            }, ShapePath.prototype.doubleArrayLength = function() {
                this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
            }, ShapePath.prototype.setXYAt = function(t1, e1, i1, r1, a1) {
                var s1;
                switch(this._length = Math.max(this._length, r1 + 1), this._length >= this._maxLength && this.doubleArrayLength(), i1){
                    case "v":
                        s1 = this.v;
                        break;
                    case "i":
                        s1 = this.i;
                        break;
                    case "o":
                        s1 = this.o;
                        break;
                    default:
                        s1 = [];
                }
                (!s1[r1] || s1[r1] && !a1) && (s1[r1] = pointPool.newElement()), s1[r1][0] = t1, s1[r1][1] = e1;
            }, ShapePath.prototype.setTripleAt = function(t1, e1, i1, r1, a1, s1, n1, o1) {
                this.setXYAt(t1, e1, "v", n1, o1), this.setXYAt(i1, r1, "o", n1, o1), this.setXYAt(a1, s1, "i", n1, o1);
            }, ShapePath.prototype.reverse = function() {
                var t1 = new ShapePath;
                t1.setPathData(this.c, this._length);
                var e1 = this.v, i1 = this.o, r1 = this.i, a1 = 0;
                this.c && (t1.setTripleAt(e1[0][0], e1[0][1], r1[0][0], r1[0][1], i1[0][0], i1[0][1], 0, !1), a1 = 1);
                var s1, n1 = this._length - 1, o1 = this._length;
                for(s1 = a1; s1 < o1; s1 += 1)t1.setTripleAt(e1[n1][0], e1[n1][1], r1[n1][0], r1[n1][1], i1[n1][0], i1[n1][1], s1, !1), n1 -= 1;
                return t1;
            }, ShapePath.prototype.length = function() {
                return this._length;
            };
            var shapePool = (factory = poolFactory(4, function() {
                return new ShapePath;
            }, function(t1) {
                var e1, i1 = t1._length;
                for(e1 = 0; e1 < i1; e1 += 1)pointPool.release(t1.v[e1]), pointPool.release(t1.i[e1]), pointPool.release(t1.o[e1]), t1.v[e1] = null, t1.i[e1] = null, t1.o[e1] = null;
                t1._length = 0, t1.c = !1;
            }), factory.clone = function(t1) {
                var e1, i1 = factory.newElement(), r1 = void 0 === t1._length ? t1.v.length : t1._length;
                for(i1.setLength(r1), i1.c = t1.c, e1 = 0; e1 < r1; e1 += 1)i1.setTripleAt(t1.v[e1][0], t1.v[e1][1], t1.o[e1][0], t1.o[e1][1], t1.i[e1][0], t1.i[e1][1], e1);
                return i1;
            }, factory), factory;
            function ShapeCollection() {
                this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
            }
            ShapeCollection.prototype.addShape = function(t1) {
                this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = t1, this._length += 1;
            }, ShapeCollection.prototype.releaseShapes = function() {
                var t1;
                for(t1 = 0; t1 < this._length; t1 += 1)shapePool.release(this.shapes[t1]);
                this._length = 0;
            };
            var shapeCollectionPool = (ob = {
                newShapeCollection: function() {
                    return _length ? pool[_length -= 1] : new ShapeCollection;
                },
                release: function(t1) {
                    var e1, i1 = t1._length;
                    for(e1 = 0; e1 < i1; e1 += 1)shapePool.release(t1.shapes[e1]);
                    t1._length = 0, _length === _maxLength && (pool = pooling.double(pool), _maxLength *= 2), pool[_length] = t1, _length += 1;
                }
            }, _length = 0, _maxLength = 4, pool = createSizedArray(_maxLength), ob), ob, _length, _maxLength, pool, ShapePropertyFactory = function() {
                var t1 = -999999;
                function e1(t1, e1, i1) {
                    var r1, a1, s1, n1, o1, h1, l1, p1, f1, d1 = i1.lastIndex, c1 = this.keyframes;
                    if (t1 < c1[0].t - this.offsetTime) r1 = c1[0].s[0], s1 = !0, d1 = 0;
                    else if (t1 >= c1[c1.length - 1].t - this.offsetTime) r1 = c1[c1.length - 1].s ? c1[c1.length - 1].s[0] : c1[c1.length - 2].e[0], s1 = !0;
                    else {
                        for(var m1, u1, y1, g1 = d1, _1 = c1.length - 1, v1 = !0; v1 && (m1 = c1[g1], !((u1 = c1[g1 + 1]).t - this.offsetTime > t1));)g1 < _1 - 1 ? g1 += 1 : v1 = !1;
                        if (y1 = this.keyframesMetadata[g1] || {}, d1 = g1, !(s1 = 1 === m1.h)) {
                            if (t1 >= u1.t - this.offsetTime) p1 = 1;
                            else if (t1 < m1.t - this.offsetTime) p1 = 0;
                            else {
                                var b1;
                                y1.__fnct ? b1 = y1.__fnct : (b1 = BezierFactory.getBezierEasing(m1.o.x, m1.o.y, m1.i.x, m1.i.y).get, y1.__fnct = b1), p1 = b1((t1 - (m1.t - this.offsetTime)) / (u1.t - this.offsetTime - (m1.t - this.offsetTime)));
                            }
                            a1 = u1.s ? u1.s[0] : m1.e[0];
                        }
                        r1 = m1.s[0];
                    }
                    for(h1 = e1._length, l1 = r1.i[0].length, i1.lastIndex = d1, n1 = 0; n1 < h1; n1 += 1)for(o1 = 0; o1 < l1; o1 += 1)f1 = s1 ? r1.i[n1][o1] : r1.i[n1][o1] + (a1.i[n1][o1] - r1.i[n1][o1]) * p1, e1.i[n1][o1] = f1, f1 = s1 ? r1.o[n1][o1] : r1.o[n1][o1] + (a1.o[n1][o1] - r1.o[n1][o1]) * p1, e1.o[n1][o1] = f1, f1 = s1 ? r1.v[n1][o1] : r1.v[n1][o1] + (a1.v[n1][o1] - r1.v[n1][o1]) * p1, e1.v[n1][o1] = f1;
                }
                function i1() {
                    var e1 = this.comp.renderedFrame - this.offsetTime, i1 = this.keyframes[0].t - this.offsetTime, r1 = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, a1 = this._caching.lastFrame;
                    return a1 !== t1 && (a1 < i1 && e1 < i1 || a1 > r1 && e1 > r1) || (this._caching.lastIndex = a1 < e1 ? this._caching.lastIndex : 0, this.interpolateShape(e1, this.pv, this._caching)), this._caching.lastFrame = e1, this.pv;
                }
                function r1() {
                    this.paths = this.localShapeCollection;
                }
                function a1(t1) {
                    (function(t1, e1) {
                        if (t1._length !== e1._length || t1.c !== e1.c) return !1;
                        var i1, r1 = t1._length;
                        for(i1 = 0; i1 < r1; i1 += 1)if (t1.v[i1][0] !== e1.v[i1][0] || t1.v[i1][1] !== e1.v[i1][1] || t1.o[i1][0] !== e1.o[i1][0] || t1.o[i1][1] !== e1.o[i1][1] || t1.i[i1][0] !== e1.i[i1][0] || t1.i[i1][1] !== e1.i[i1][1]) return !1;
                        return !0;
                    })(this.v, t1) || (this.v = shapePool.clone(t1), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
                }
                function s1() {
                    if (this.elem.globalData.frameId !== this.frameId) {
                        if (this.effectsSequence.length) {
                            if (this.lock) this.setVValue(this.pv);
                            else {
                                var t1, e1;
                                this.lock = !0, this._mdf = !1, t1 = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k;
                                var i1 = this.effectsSequence.length;
                                for(e1 = 0; e1 < i1; e1 += 1)t1 = this.effectsSequence[e1](t1);
                                this.setVValue(t1), this.lock = !1, this.frameId = this.elem.globalData.frameId;
                            }
                        } else this._mdf = !1;
                    }
                }
                function n1(t1, e1, i1) {
                    this.propType = "shape", this.comp = t1.comp, this.container = t1, this.elem = t1, this.data = e1, this.k = !1, this.kf = !1, this._mdf = !1;
                    var a1 = 3 === i1 ? e1.pt.k : e1.ks.k;
                    this.v = shapePool.clone(a1), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = r1, this.effectsSequence = [];
                }
                function o1(t1) {
                    this.effectsSequence.push(t1), this.container.addDynamicProperty(this);
                }
                function h1(e1, a1, s1) {
                    this.propType = "shape", this.comp = e1.comp, this.elem = e1, this.container = e1, this.offsetTime = e1.data.st, this.keyframes = 3 === s1 ? a1.pt.k : a1.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
                    var n1 = this.keyframes[0].s[0].i.length;
                    this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, n1), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = t1, this.reset = r1, this._caching = {
                        lastFrame: t1,
                        lastIndex: 0
                    }, this.effectsSequence = [
                        i1.bind(this)
                    ];
                }
                n1.prototype.interpolateShape = e1, n1.prototype.getValue = s1, n1.prototype.setVValue = a1, n1.prototype.addEffect = o1, h1.prototype.getValue = s1, h1.prototype.interpolateShape = e1, h1.prototype.setVValue = a1, h1.prototype.addEffect = o1;
                var l1 = function() {
                    var t1 = roundCorner;
                    function e1(t1, e1) {
                        this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = e1.d, this.elem = t1, this.comp = t1.comp, this.frameId = -1, this.initDynamicPropertyContainer(t1), this.p = PropertyFactory.getProp(t1, e1.p, 1, 0, this), this.s = PropertyFactory.getProp(t1, e1.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
                    }
                    return e1.prototype = {
                        reset: r1,
                        getValue: function() {
                            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
                        },
                        convertEllToPath: function() {
                            var e1 = this.p.v[0], i1 = this.p.v[1], r1 = this.s.v[0] / 2, a1 = this.s.v[1] / 2, s1 = 3 !== this.d, n1 = this.v;
                            n1.v[0][0] = e1, n1.v[0][1] = i1 - a1, n1.v[1][0] = s1 ? e1 + r1 : e1 - r1, n1.v[1][1] = i1, n1.v[2][0] = e1, n1.v[2][1] = i1 + a1, n1.v[3][0] = s1 ? e1 - r1 : e1 + r1, n1.v[3][1] = i1, n1.i[0][0] = s1 ? e1 - r1 * t1 : e1 + r1 * t1, n1.i[0][1] = i1 - a1, n1.i[1][0] = s1 ? e1 + r1 : e1 - r1, n1.i[1][1] = i1 - a1 * t1, n1.i[2][0] = s1 ? e1 + r1 * t1 : e1 - r1 * t1, n1.i[2][1] = i1 + a1, n1.i[3][0] = s1 ? e1 - r1 : e1 + r1, n1.i[3][1] = i1 + a1 * t1, n1.o[0][0] = s1 ? e1 + r1 * t1 : e1 - r1 * t1, n1.o[0][1] = i1 - a1, n1.o[1][0] = s1 ? e1 + r1 : e1 - r1, n1.o[1][1] = i1 + a1 * t1, n1.o[2][0] = s1 ? e1 - r1 * t1 : e1 + r1 * t1, n1.o[2][1] = i1 + a1, n1.o[3][0] = s1 ? e1 - r1 : e1 + r1, n1.o[3][1] = i1 - a1 * t1;
                        }
                    }, extendPrototype([
                        DynamicPropertyContainer
                    ], e1), e1;
                }(), p1 = function() {
                    function t1(t1, e1) {
                        this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = t1, this.comp = t1.comp, this.data = e1, this.frameId = -1, this.d = e1.d, this.initDynamicPropertyContainer(t1), 1 === e1.sy ? (this.ir = PropertyFactory.getProp(t1, e1.ir, 0, 0, this), this.is = PropertyFactory.getProp(t1, e1.is, 0, .01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp(t1, e1.pt, 0, 0, this), this.p = PropertyFactory.getProp(t1, e1.p, 1, 0, this), this.r = PropertyFactory.getProp(t1, e1.r, 0, degToRads, this), this.or = PropertyFactory.getProp(t1, e1.or, 0, 0, this), this.os = PropertyFactory.getProp(t1, e1.os, 0, .01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
                    }
                    return t1.prototype = {
                        reset: r1,
                        getValue: function() {
                            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
                        },
                        convertStarToPath: function() {
                            var t1, e1, i1, r1, a1 = 2 * Math.floor(this.pt.v), s1 = 2 * Math.PI / a1, n1 = !0, o1 = this.or.v, h1 = this.ir.v, l1 = this.os.v, p1 = this.is.v, f1 = 2 * Math.PI * o1 / (2 * a1), d1 = 2 * Math.PI * h1 / (2 * a1), c1 = -Math.PI / 2;
                            c1 += this.r.v;
                            var m1 = 3 === this.data.d ? -1 : 1;
                            for(this.v._length = 0, t1 = 0; t1 < a1; t1 += 1){
                                i1 = n1 ? l1 : p1, r1 = n1 ? f1 : d1;
                                var u1 = (e1 = n1 ? o1 : h1) * Math.cos(c1), y1 = e1 * Math.sin(c1), g1 = 0 === u1 && 0 === y1 ? 0 : y1 / Math.sqrt(u1 * u1 + y1 * y1), _1 = 0 === u1 && 0 === y1 ? 0 : -u1 / Math.sqrt(u1 * u1 + y1 * y1);
                                u1 += +this.p.v[0], y1 += +this.p.v[1], this.v.setTripleAt(u1, y1, u1 - g1 * r1 * i1 * m1, y1 - _1 * r1 * i1 * m1, u1 + g1 * r1 * i1 * m1, y1 + _1 * r1 * i1 * m1, t1, !0), n1 = !n1, c1 += s1 * m1;
                            }
                        },
                        convertPolygonToPath: function() {
                            var t1, e1 = Math.floor(this.pt.v), i1 = 2 * Math.PI / e1, r1 = this.or.v, a1 = this.os.v, s1 = 2 * Math.PI * r1 / (4 * e1), n1 = .5 * -Math.PI, o1 = 3 === this.data.d ? -1 : 1;
                            for(n1 += this.r.v, this.v._length = 0, t1 = 0; t1 < e1; t1 += 1){
                                var h1 = r1 * Math.cos(n1), l1 = r1 * Math.sin(n1), p1 = 0 === h1 && 0 === l1 ? 0 : l1 / Math.sqrt(h1 * h1 + l1 * l1), f1 = 0 === h1 && 0 === l1 ? 0 : -h1 / Math.sqrt(h1 * h1 + l1 * l1);
                                h1 += +this.p.v[0], l1 += +this.p.v[1], this.v.setTripleAt(h1, l1, h1 - p1 * s1 * a1 * o1, l1 - f1 * s1 * a1 * o1, h1 + p1 * s1 * a1 * o1, l1 + f1 * s1 * a1 * o1, t1, !0), n1 += i1 * o1;
                            }
                            this.paths.length = 0, this.paths[0] = this.v;
                        }
                    }, extendPrototype([
                        DynamicPropertyContainer
                    ], t1), t1;
                }(), f1 = function() {
                    function t1(t1, e1) {
                        this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = t1, this.comp = t1.comp, this.frameId = -1, this.d = e1.d, this.initDynamicPropertyContainer(t1), this.p = PropertyFactory.getProp(t1, e1.p, 1, 0, this), this.s = PropertyFactory.getProp(t1, e1.s, 1, 0, this), this.r = PropertyFactory.getProp(t1, e1.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
                    }
                    return t1.prototype = {
                        convertRectToPath: function() {
                            var t1 = this.p.v[0], e1 = this.p.v[1], i1 = this.s.v[0] / 2, r1 = this.s.v[1] / 2, a1 = bmMin(i1, r1, this.r.v), s1 = a1 * (1 - roundCorner);
                            this.v._length = 0, 2 === this.d || 1 === this.d ? (this.v.setTripleAt(t1 + i1, e1 - r1 + a1, t1 + i1, e1 - r1 + a1, t1 + i1, e1 - r1 + s1, 0, !0), this.v.setTripleAt(t1 + i1, e1 + r1 - a1, t1 + i1, e1 + r1 - s1, t1 + i1, e1 + r1 - a1, 1, !0), 0 !== a1 ? (this.v.setTripleAt(t1 + i1 - a1, e1 + r1, t1 + i1 - a1, e1 + r1, t1 + i1 - s1, e1 + r1, 2, !0), this.v.setTripleAt(t1 - i1 + a1, e1 + r1, t1 - i1 + s1, e1 + r1, t1 - i1 + a1, e1 + r1, 3, !0), this.v.setTripleAt(t1 - i1, e1 + r1 - a1, t1 - i1, e1 + r1 - a1, t1 - i1, e1 + r1 - s1, 4, !0), this.v.setTripleAt(t1 - i1, e1 - r1 + a1, t1 - i1, e1 - r1 + s1, t1 - i1, e1 - r1 + a1, 5, !0), this.v.setTripleAt(t1 - i1 + a1, e1 - r1, t1 - i1 + a1, e1 - r1, t1 - i1 + s1, e1 - r1, 6, !0), this.v.setTripleAt(t1 + i1 - a1, e1 - r1, t1 + i1 - s1, e1 - r1, t1 + i1 - a1, e1 - r1, 7, !0)) : (this.v.setTripleAt(t1 - i1, e1 + r1, t1 - i1 + s1, e1 + r1, t1 - i1, e1 + r1, 2), this.v.setTripleAt(t1 - i1, e1 - r1, t1 - i1, e1 - r1 + s1, t1 - i1, e1 - r1, 3))) : (this.v.setTripleAt(t1 + i1, e1 - r1 + a1, t1 + i1, e1 - r1 + s1, t1 + i1, e1 - r1 + a1, 0, !0), 0 !== a1 ? (this.v.setTripleAt(t1 + i1 - a1, e1 - r1, t1 + i1 - a1, e1 - r1, t1 + i1 - s1, e1 - r1, 1, !0), this.v.setTripleAt(t1 - i1 + a1, e1 - r1, t1 - i1 + s1, e1 - r1, t1 - i1 + a1, e1 - r1, 2, !0), this.v.setTripleAt(t1 - i1, e1 - r1 + a1, t1 - i1, e1 - r1 + a1, t1 - i1, e1 - r1 + s1, 3, !0), this.v.setTripleAt(t1 - i1, e1 + r1 - a1, t1 - i1, e1 + r1 - s1, t1 - i1, e1 + r1 - a1, 4, !0), this.v.setTripleAt(t1 - i1 + a1, e1 + r1, t1 - i1 + a1, e1 + r1, t1 - i1 + s1, e1 + r1, 5, !0), this.v.setTripleAt(t1 + i1 - a1, e1 + r1, t1 + i1 - s1, e1 + r1, t1 + i1 - a1, e1 + r1, 6, !0), this.v.setTripleAt(t1 + i1, e1 + r1 - a1, t1 + i1, e1 + r1 - a1, t1 + i1, e1 + r1 - s1, 7, !0)) : (this.v.setTripleAt(t1 - i1, e1 - r1, t1 - i1 + s1, e1 - r1, t1 - i1, e1 - r1, 1, !0), this.v.setTripleAt(t1 - i1, e1 + r1, t1 - i1, e1 + r1 - s1, t1 - i1, e1 + r1, 2, !0), this.v.setTripleAt(t1 + i1, e1 + r1, t1 + i1 - s1, e1 + r1, t1 + i1, e1 + r1, 3, !0)));
                        },
                        getValue: function() {
                            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
                        },
                        reset: r1
                    }, extendPrototype([
                        DynamicPropertyContainer
                    ], t1), t1;
                }(), d1 = {
                    getShapeProp: function(t1, e1, i1) {
                        var r1;
                        return 3 === i1 || 4 === i1 ? r1 = (3 === i1 ? e1.pt : e1.ks).k.length ? new h1(t1, e1, i1) : new n1(t1, e1, i1) : 5 === i1 ? r1 = new f1(t1, e1) : 6 === i1 ? r1 = new l1(t1, e1) : 7 === i1 && (r1 = new p1(t1, e1)), r1.k && t1.addDynamicProperty(r1), r1;
                    },
                    getConstructorFunction: function() {
                        return n1;
                    },
                    getKeyframedConstructorFunction: function() {
                        return h1;
                    }
                };
                return d1;
            }(), Matrix = function() {
                var t1 = Math.cos, e1 = Math.sin, i1 = Math.tan, r1 = Math.round;
                function a1() {
                    return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
                }
                function s1(i1) {
                    if (0 === i1) return this;
                    var r1 = t1(i1), a1 = e1(i1);
                    return this._t(r1, -a1, 0, 0, a1, r1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                }
                function n1(i1) {
                    if (0 === i1) return this;
                    var r1 = t1(i1), a1 = e1(i1);
                    return this._t(1, 0, 0, 0, 0, r1, -a1, 0, 0, a1, r1, 0, 0, 0, 0, 1);
                }
                function o1(i1) {
                    if (0 === i1) return this;
                    var r1 = t1(i1), a1 = e1(i1);
                    return this._t(r1, 0, a1, 0, 0, 1, 0, 0, -a1, 0, r1, 0, 0, 0, 0, 1);
                }
                function h1(i1) {
                    if (0 === i1) return this;
                    var r1 = t1(i1), a1 = e1(i1);
                    return this._t(r1, -a1, 0, 0, a1, r1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                }
                function l1(t1, e1) {
                    return this._t(1, e1, t1, 1, 0, 0);
                }
                function p1(t1, e1) {
                    return this.shear(i1(t1), i1(e1));
                }
                function f1(r1, a1) {
                    var s1 = t1(a1), n1 = e1(a1);
                    return this._t(s1, n1, 0, 0, -n1, s1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, i1(r1), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(s1, -n1, 0, 0, n1, s1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                }
                function d1(t1, e1, i1) {
                    return i1 || 0 === i1 || (i1 = 1), 1 === t1 && 1 === e1 && 1 === i1 ? this : this._t(t1, 0, 0, 0, 0, e1, 0, 0, 0, 0, i1, 0, 0, 0, 0, 1);
                }
                function c1(t1, e1, i1, r1, a1, s1, n1, o1, h1, l1, p1, f1, d1, c1, m1, u1) {
                    return this.props[0] = t1, this.props[1] = e1, this.props[2] = i1, this.props[3] = r1, this.props[4] = a1, this.props[5] = s1, this.props[6] = n1, this.props[7] = o1, this.props[8] = h1, this.props[9] = l1, this.props[10] = p1, this.props[11] = f1, this.props[12] = d1, this.props[13] = c1, this.props[14] = m1, this.props[15] = u1, this;
                }
                function m1(t1, e1, i1) {
                    return i1 = i1 || 0, 0 !== t1 || 0 !== e1 || 0 !== i1 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t1, e1, i1, 1) : this;
                }
                function u1(t1, e1, i1, r1, a1, s1, n1, o1, h1, l1, p1, f1, d1, c1, m1, u1) {
                    var y1 = this.props;
                    if (1 === t1 && 0 === e1 && 0 === i1 && 0 === r1 && 0 === a1 && 1 === s1 && 0 === n1 && 0 === o1 && 0 === h1 && 0 === l1 && 1 === p1 && 0 === f1) return y1[12] = y1[12] * t1 + y1[15] * d1, y1[13] = y1[13] * s1 + y1[15] * c1, y1[14] = y1[14] * p1 + y1[15] * m1, y1[15] *= u1, this._identityCalculated = !1, this;
                    var g1 = y1[0], _1 = y1[1], v1 = y1[2], b1 = y1[3], E1 = y1[4], S1 = y1[5], A1 = y1[6], P1 = y1[7], x1 = y1[8], T1 = y1[9], w1 = y1[10], C1 = y1[11], k1 = y1[12], D1 = y1[13], M1 = y1[14], I1 = y1[15];
                    return y1[0] = g1 * t1 + _1 * a1 + v1 * h1 + b1 * d1, y1[1] = g1 * e1 + _1 * s1 + v1 * l1 + b1 * c1, y1[2] = g1 * i1 + _1 * n1 + v1 * p1 + b1 * m1, y1[3] = g1 * r1 + _1 * o1 + v1 * f1 + b1 * u1, y1[4] = E1 * t1 + S1 * a1 + A1 * h1 + P1 * d1, y1[5] = E1 * e1 + S1 * s1 + A1 * l1 + P1 * c1, y1[6] = E1 * i1 + S1 * n1 + A1 * p1 + P1 * m1, y1[7] = E1 * r1 + S1 * o1 + A1 * f1 + P1 * u1, y1[8] = x1 * t1 + T1 * a1 + w1 * h1 + C1 * d1, y1[9] = x1 * e1 + T1 * s1 + w1 * l1 + C1 * c1, y1[10] = x1 * i1 + T1 * n1 + w1 * p1 + C1 * m1, y1[11] = x1 * r1 + T1 * o1 + w1 * f1 + C1 * u1, y1[12] = k1 * t1 + D1 * a1 + M1 * h1 + I1 * d1, y1[13] = k1 * e1 + D1 * s1 + M1 * l1 + I1 * c1, y1[14] = k1 * i1 + D1 * n1 + M1 * p1 + I1 * m1, y1[15] = k1 * r1 + D1 * o1 + M1 * f1 + I1 * u1, this._identityCalculated = !1, this;
                }
                function y1() {
                    return this._identityCalculated || (this._identity = !(1 !== this.props[0] || 0 !== this.props[1] || 0 !== this.props[2] || 0 !== this.props[3] || 0 !== this.props[4] || 1 !== this.props[5] || 0 !== this.props[6] || 0 !== this.props[7] || 0 !== this.props[8] || 0 !== this.props[9] || 1 !== this.props[10] || 0 !== this.props[11] || 0 !== this.props[12] || 0 !== this.props[13] || 0 !== this.props[14] || 1 !== this.props[15]), this._identityCalculated = !0), this._identity;
                }
                function g1(t1) {
                    for(var e1 = 0; e1 < 16;){
                        if (t1.props[e1] !== this.props[e1]) return !1;
                        e1 += 1;
                    }
                    return !0;
                }
                function _1(t1) {
                    var e1;
                    for(e1 = 0; e1 < 16; e1 += 1)t1.props[e1] = this.props[e1];
                    return t1;
                }
                function v1(t1) {
                    var e1;
                    for(e1 = 0; e1 < 16; e1 += 1)this.props[e1] = t1[e1];
                }
                function b1(t1, e1, i1) {
                    return {
                        x: t1 * this.props[0] + e1 * this.props[4] + i1 * this.props[8] + this.props[12],
                        y: t1 * this.props[1] + e1 * this.props[5] + i1 * this.props[9] + this.props[13],
                        z: t1 * this.props[2] + e1 * this.props[6] + i1 * this.props[10] + this.props[14]
                    };
                }
                function E1(t1, e1, i1) {
                    return t1 * this.props[0] + e1 * this.props[4] + i1 * this.props[8] + this.props[12];
                }
                function S1(t1, e1, i1) {
                    return t1 * this.props[1] + e1 * this.props[5] + i1 * this.props[9] + this.props[13];
                }
                function A1(t1, e1, i1) {
                    return t1 * this.props[2] + e1 * this.props[6] + i1 * this.props[10] + this.props[14];
                }
                function P1() {
                    var t1 = this.props[0] * this.props[5] - this.props[1] * this.props[4], e1 = this.props[5] / t1, i1 = -this.props[1] / t1, r1 = -this.props[4] / t1, a1 = this.props[0] / t1, s1 = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / t1, n1 = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / t1, o1 = new Matrix;
                    return o1.props[0] = e1, o1.props[1] = i1, o1.props[4] = r1, o1.props[5] = a1, o1.props[12] = s1, o1.props[13] = n1, o1;
                }
                function x1(t1) {
                    return this.getInverseMatrix().applyToPointArray(t1[0], t1[1], t1[2] || 0);
                }
                function T1(t1) {
                    var e1, i1 = t1.length, r1 = [];
                    for(e1 = 0; e1 < i1; e1 += 1)r1[e1] = x1(t1[e1]);
                    return r1;
                }
                function w1(t1, e1, i1) {
                    var r1 = createTypedArray("float32", 6);
                    if (this.isIdentity()) r1[0] = t1[0], r1[1] = t1[1], r1[2] = e1[0], r1[3] = e1[1], r1[4] = i1[0], r1[5] = i1[1];
                    else {
                        var a1 = this.props[0], s1 = this.props[1], n1 = this.props[4], o1 = this.props[5], h1 = this.props[12], l1 = this.props[13];
                        r1[0] = t1[0] * a1 + t1[1] * n1 + h1, r1[1] = t1[0] * s1 + t1[1] * o1 + l1, r1[2] = e1[0] * a1 + e1[1] * n1 + h1, r1[3] = e1[0] * s1 + e1[1] * o1 + l1, r1[4] = i1[0] * a1 + i1[1] * n1 + h1, r1[5] = i1[0] * s1 + i1[1] * o1 + l1;
                    }
                    return r1;
                }
                function C1(t1, e1, i1) {
                    return this.isIdentity() ? [
                        t1,
                        e1,
                        i1
                    ] : [
                        t1 * this.props[0] + e1 * this.props[4] + i1 * this.props[8] + this.props[12],
                        t1 * this.props[1] + e1 * this.props[5] + i1 * this.props[9] + this.props[13],
                        t1 * this.props[2] + e1 * this.props[6] + i1 * this.props[10] + this.props[14]
                    ];
                }
                function k1(t1, e1) {
                    if (this.isIdentity()) return t1 + "," + e1;
                    var i1 = this.props;
                    return Math.round(100 * (t1 * i1[0] + e1 * i1[4] + i1[12])) / 100 + "," + Math.round(100 * (t1 * i1[1] + e1 * i1[5] + i1[13])) / 100;
                }
                function D1() {
                    for(var t1 = 0, e1 = this.props, i1 = "matrix3d("; t1 < 16;)i1 += r1(1e4 * e1[t1]) / 1e4, i1 += 15 === t1 ? ")" : ",", t1 += 1;
                    return i1;
                }
                function M1(t1) {
                    return t1 < 1e-6 && t1 > 0 || t1 > -0.000001 && t1 < 0 ? r1(1e4 * t1) / 1e4 : t1;
                }
                function I1() {
                    var t1 = this.props;
                    return "matrix(" + M1(t1[0]) + "," + M1(t1[1]) + "," + M1(t1[4]) + "," + M1(t1[5]) + "," + M1(t1[12]) + "," + M1(t1[13]) + ")";
                }
                return function() {
                    this.reset = a1, this.rotate = s1, this.rotateX = n1, this.rotateY = o1, this.rotateZ = h1, this.skew = p1, this.skewFromAxis = f1, this.shear = l1, this.scale = d1, this.setTransform = c1, this.translate = m1, this.transform = u1, this.applyToPoint = b1, this.applyToX = E1, this.applyToY = S1, this.applyToZ = A1, this.applyToPointArray = C1, this.applyToTriplePoints = w1, this.applyToPointStringified = k1, this.toCSS = D1, this.to2dCSS = I1, this.clone = _1, this.cloneFromProps = v1, this.equals = g1, this.inversePoints = T1, this.inversePoint = x1, this.getInverseMatrix = P1, this._t = this.transform, this.isIdentity = y1, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
                };
            }();
            function _typeof$3(t1) {
                return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, _typeof$3(t1);
            }
            var lottie = {};
            function setLocation(t1) {
                setLocationHref(t1);
            }
            function searchAnimations() {
                animationManager.searchAnimations();
            }
            function setSubframeRendering(t1) {
                setSubframeEnabled(t1);
            }
            function setPrefix(t1) {
                setIdPrefix(t1);
            }
            function loadAnimation(t1) {
                return animationManager.loadAnimation(t1);
            }
            function setQuality(t1) {
                if ("string" == typeof t1) switch(t1){
                    case "high":
                        setDefaultCurveSegments(200);
                        break;
                    default:
                    case "medium":
                        setDefaultCurveSegments(50);
                        break;
                    case "low":
                        setDefaultCurveSegments(10);
                }
                else !isNaN(t1) && t1 > 1 && setDefaultCurveSegments(t1);
            }
            function inBrowser() {
                return "undefined" != typeof navigator;
            }
            function installPlugin(t1, e1) {
                "expressions" === t1 && setExpressionsPlugin(e1);
            }
            function getFactory(t1) {
                switch(t1){
                    case "propertyFactory":
                        return PropertyFactory;
                    case "shapePropertyFactory":
                        return ShapePropertyFactory;
                    case "matrix":
                        return Matrix;
                    default:
                        return null;
                }
            }
            function checkReady() {
                "complete" === document.readyState && (clearInterval(readyStateCheckInterval), searchAnimations());
            }
            function getQueryVariable(t1) {
                for(var e1 = queryString.split("&"), i1 = 0; i1 < e1.length; i1 += 1){
                    var r1 = e1[i1].split("=");
                    if (decodeURIComponent(r1[0]) == t1) return decodeURIComponent(r1[1]);
                }
                return null;
            }
            lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.10.0";
            var queryString = "", scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || {
                src: ""
            };
            queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", getQueryVariable("renderer");
            var readyStateCheckInterval = setInterval(checkReady, 100);
            try {
                "object" !== _typeof$3(exports) && (window.bodymovin = lottie);
            } catch (t) {}
            var ShapeModifiers = function() {
                var t1 = {}, e1 = {};
                return t1.registerModifier = function(t1, i1) {
                    e1[t1] || (e1[t1] = i1);
                }, t1.getModifier = function(t1, i1, r1) {
                    return new e1[t1](i1, r1);
                }, t1;
            }();
            function ShapeModifier() {}
            function TrimModifier() {}
            function PuckerAndBloatModifier() {}
            ShapeModifier.prototype.initModifierProperties = function() {}, ShapeModifier.prototype.addShapeToModifier = function() {}, ShapeModifier.prototype.addShape = function(t1) {
                if (!this.closed) {
                    t1.sh.container.addDynamicProperty(t1.sh);
                    var e1 = {
                        shape: t1.sh,
                        data: t1,
                        localShapeCollection: shapeCollectionPool.newShapeCollection()
                    };
                    this.shapes.push(e1), this.addShapeToModifier(e1), this._isAnimated && t1.setAsAnimated();
                }
            }, ShapeModifier.prototype.init = function(t1, e1) {
                this.shapes = [], this.elem = t1, this.initDynamicPropertyContainer(t1), this.initModifierProperties(t1, e1), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
            }, ShapeModifier.prototype.processKeys = function() {
                this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
            }, extendPrototype([
                DynamicPropertyContainer
            ], ShapeModifier), extendPrototype([
                ShapeModifier
            ], TrimModifier), TrimModifier.prototype.initModifierProperties = function(t1, e1) {
                this.s = PropertyFactory.getProp(t1, e1.s, 0, .01, this), this.e = PropertyFactory.getProp(t1, e1.e, 0, .01, this), this.o = PropertyFactory.getProp(t1, e1.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = e1.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
            }, TrimModifier.prototype.addShapeToModifier = function(t1) {
                t1.pathsData = [];
            }, TrimModifier.prototype.calculateShapeEdges = function(t1, e1, i1, r1, a1) {
                var s1 = [];
                e1 <= 1 ? s1.push({
                    s: t1,
                    e: e1
                }) : t1 >= 1 ? s1.push({
                    s: t1 - 1,
                    e: e1 - 1
                }) : (s1.push({
                    s: t1,
                    e: 1
                }), s1.push({
                    s: 0,
                    e: e1 - 1
                }));
                var n1, o1, h1 = [], l1 = s1.length;
                for(n1 = 0; n1 < l1; n1 += 1){
                    var p1, f1;
                    (o1 = s1[n1]).e * a1 < r1 || o1.s * a1 > r1 + i1 || (p1 = o1.s * a1 <= r1 ? 0 : (o1.s * a1 - r1) / i1, f1 = o1.e * a1 >= r1 + i1 ? 1 : (o1.e * a1 - r1) / i1, h1.push([
                        p1,
                        f1
                    ]));
                }
                return h1.length || h1.push([
                    0,
                    0
                ]), h1;
            }, TrimModifier.prototype.releasePathsData = function(t1) {
                var e1, i1 = t1.length;
                for(e1 = 0; e1 < i1; e1 += 1)segmentsLengthPool.release(t1[e1]);
                return t1.length = 0, t1;
            }, TrimModifier.prototype.processShapes = function(t1) {
                var e1, i1, r1, a1;
                if (this._mdf || t1) {
                    var s1 = this.o.v % 360 / 360;
                    if (s1 < 0 && (s1 += 1), (e1 = this.s.v > 1 ? 1 + s1 : this.s.v < 0 ? 0 + s1 : this.s.v + s1) > (i1 = this.e.v > 1 ? 1 + s1 : this.e.v < 0 ? 0 + s1 : this.e.v + s1)) {
                        var n1 = e1;
                        e1 = i1, i1 = n1;
                    }
                    e1 = 1e-4 * Math.round(1e4 * e1), i1 = 1e-4 * Math.round(1e4 * i1), this.sValue = e1, this.eValue = i1;
                } else e1 = this.sValue, i1 = this.eValue;
                var o1, h1, l1, p1, f1, d1 = this.shapes.length, c1 = 0;
                if (i1 === e1) for(a1 = 0; a1 < d1; a1 += 1)this.shapes[a1].localShapeCollection.releaseShapes(), this.shapes[a1].shape._mdf = !0, this.shapes[a1].shape.paths = this.shapes[a1].localShapeCollection, this._mdf && (this.shapes[a1].pathsData.length = 0);
                else if (1 === i1 && 0 === e1 || 0 === i1 && 1 === e1) {
                    if (this._mdf) for(a1 = 0; a1 < d1; a1 += 1)this.shapes[a1].pathsData.length = 0, this.shapes[a1].shape._mdf = !0;
                } else {
                    var m1, u1, y1 = [];
                    for(a1 = 0; a1 < d1; a1 += 1)if ((m1 = this.shapes[a1]).shape._mdf || this._mdf || t1 || 2 === this.m) {
                        if (h1 = (r1 = m1.shape.paths)._length, f1 = 0, !m1.shape._mdf && m1.pathsData.length) f1 = m1.totalShapeLength;
                        else {
                            for(l1 = this.releasePathsData(m1.pathsData), o1 = 0; o1 < h1; o1 += 1)p1 = bez.getSegmentsLength(r1.shapes[o1]), l1.push(p1), f1 += p1.totalLength;
                            m1.totalShapeLength = f1, m1.pathsData = l1;
                        }
                        c1 += f1, m1.shape._mdf = !0;
                    } else m1.shape.paths = m1.localShapeCollection;
                    var g1, _1 = e1, v1 = i1, b1 = 0;
                    for(a1 = d1 - 1; a1 >= 0; a1 -= 1)if ((m1 = this.shapes[a1]).shape._mdf) {
                        for((u1 = m1.localShapeCollection).releaseShapes(), 2 === this.m && d1 > 1 ? (g1 = this.calculateShapeEdges(e1, i1, m1.totalShapeLength, b1, c1), b1 += m1.totalShapeLength) : g1 = [
                            [
                                _1,
                                v1
                            ]
                        ], h1 = g1.length, o1 = 0; o1 < h1; o1 += 1){
                            _1 = g1[o1][0], v1 = g1[o1][1], y1.length = 0, v1 <= 1 ? y1.push({
                                s: m1.totalShapeLength * _1,
                                e: m1.totalShapeLength * v1
                            }) : _1 >= 1 ? y1.push({
                                s: m1.totalShapeLength * (_1 - 1),
                                e: m1.totalShapeLength * (v1 - 1)
                            }) : (y1.push({
                                s: m1.totalShapeLength * _1,
                                e: m1.totalShapeLength
                            }), y1.push({
                                s: 0,
                                e: m1.totalShapeLength * (v1 - 1)
                            }));
                            var E1 = this.addShapes(m1, y1[0]);
                            if (y1[0].s !== y1[0].e) {
                                if (y1.length > 1) {
                                    if (m1.shape.paths.shapes[m1.shape.paths._length - 1].c) {
                                        var S1 = E1.pop();
                                        this.addPaths(E1, u1), E1 = this.addShapes(m1, y1[1], S1);
                                    } else this.addPaths(E1, u1), E1 = this.addShapes(m1, y1[1]);
                                }
                                this.addPaths(E1, u1);
                            }
                        }
                        m1.shape.paths = u1;
                    }
                }
            }, TrimModifier.prototype.addPaths = function(t1, e1) {
                var i1, r1 = t1.length;
                for(i1 = 0; i1 < r1; i1 += 1)e1.addShape(t1[i1]);
            }, TrimModifier.prototype.addSegment = function(t1, e1, i1, r1, a1, s1, n1) {
                a1.setXYAt(e1[0], e1[1], "o", s1), a1.setXYAt(i1[0], i1[1], "i", s1 + 1), n1 && a1.setXYAt(t1[0], t1[1], "v", s1), a1.setXYAt(r1[0], r1[1], "v", s1 + 1);
            }, TrimModifier.prototype.addSegmentFromArray = function(t1, e1, i1, r1) {
                e1.setXYAt(t1[1], t1[5], "o", i1), e1.setXYAt(t1[2], t1[6], "i", i1 + 1), r1 && e1.setXYAt(t1[0], t1[4], "v", i1), e1.setXYAt(t1[3], t1[7], "v", i1 + 1);
            }, TrimModifier.prototype.addShapes = function(t1, e1, i1) {
                var r1, a1, s1, n1, o1, h1, l1, p1, f1 = t1.pathsData, d1 = t1.shape.paths.shapes, c1 = t1.shape.paths._length, m1 = 0, u1 = [], y1 = !0;
                for(i1 ? (o1 = i1._length, p1 = i1._length) : (i1 = shapePool.newElement(), o1 = 0, p1 = 0), u1.push(i1), r1 = 0; r1 < c1; r1 += 1){
                    for(h1 = f1[r1].lengths, i1.c = d1[r1].c, s1 = d1[r1].c ? h1.length : h1.length + 1, a1 = 1; a1 < s1; a1 += 1)if (m1 + (n1 = h1[a1 - 1]).addedLength < e1.s) m1 += n1.addedLength, i1.c = !1;
                    else {
                        if (m1 > e1.e) {
                            i1.c = !1;
                            break;
                        }
                        e1.s <= m1 && e1.e >= m1 + n1.addedLength ? (this.addSegment(d1[r1].v[a1 - 1], d1[r1].o[a1 - 1], d1[r1].i[a1], d1[r1].v[a1], i1, o1, y1), y1 = !1) : (l1 = bez.getNewSegment(d1[r1].v[a1 - 1], d1[r1].v[a1], d1[r1].o[a1 - 1], d1[r1].i[a1], (e1.s - m1) / n1.addedLength, (e1.e - m1) / n1.addedLength, h1[a1 - 1]), this.addSegmentFromArray(l1, i1, o1, y1), y1 = !1, i1.c = !1), m1 += n1.addedLength, o1 += 1;
                    }
                    if (d1[r1].c && h1.length) {
                        if (n1 = h1[a1 - 1], m1 <= e1.e) {
                            var g1 = h1[a1 - 1].addedLength;
                            e1.s <= m1 && e1.e >= m1 + g1 ? (this.addSegment(d1[r1].v[a1 - 1], d1[r1].o[a1 - 1], d1[r1].i[0], d1[r1].v[0], i1, o1, y1), y1 = !1) : (l1 = bez.getNewSegment(d1[r1].v[a1 - 1], d1[r1].v[0], d1[r1].o[a1 - 1], d1[r1].i[0], (e1.s - m1) / g1, (e1.e - m1) / g1, h1[a1 - 1]), this.addSegmentFromArray(l1, i1, o1, y1), y1 = !1, i1.c = !1);
                        } else i1.c = !1;
                        m1 += n1.addedLength, o1 += 1;
                    }
                    if (i1._length && (i1.setXYAt(i1.v[p1][0], i1.v[p1][1], "i", p1), i1.setXYAt(i1.v[i1._length - 1][0], i1.v[i1._length - 1][1], "o", i1._length - 1)), m1 > e1.e) break;
                    r1 < c1 - 1 && (i1 = shapePool.newElement(), y1 = !0, u1.push(i1), o1 = 0);
                }
                return u1;
            }, extendPrototype([
                ShapeModifier
            ], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(t1, e1) {
                this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t1, e1.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
            }, PuckerAndBloatModifier.prototype.processPath = function(t1, e1) {
                var i1 = e1 / 100, r1 = [
                    0,
                    0
                ], a1 = t1._length, s1 = 0;
                for(s1 = 0; s1 < a1; s1 += 1)r1[0] += t1.v[s1][0], r1[1] += t1.v[s1][1];
                r1[0] /= a1, r1[1] /= a1;
                var n1, o1, h1, l1, p1, f1, d1 = shapePool.newElement();
                for(d1.c = t1.c, s1 = 0; s1 < a1; s1 += 1)n1 = t1.v[s1][0] + (r1[0] - t1.v[s1][0]) * i1, o1 = t1.v[s1][1] + (r1[1] - t1.v[s1][1]) * i1, h1 = t1.o[s1][0] + (r1[0] - t1.o[s1][0]) * -i1, l1 = t1.o[s1][1] + (r1[1] - t1.o[s1][1]) * -i1, p1 = t1.i[s1][0] + (r1[0] - t1.i[s1][0]) * -i1, f1 = t1.i[s1][1] + (r1[1] - t1.i[s1][1]) * -i1, d1.setTripleAt(n1, o1, h1, l1, p1, f1, s1);
                return d1;
            }, PuckerAndBloatModifier.prototype.processShapes = function(t1) {
                var e1, i1, r1, a1, s1, n1, o1 = this.shapes.length, h1 = this.amount.v;
                if (0 !== h1) for(i1 = 0; i1 < o1; i1 += 1){
                    if (n1 = (s1 = this.shapes[i1]).localShapeCollection, s1.shape._mdf || this._mdf || t1) for(n1.releaseShapes(), s1.shape._mdf = !0, e1 = s1.shape.paths.shapes, a1 = s1.shape.paths._length, r1 = 0; r1 < a1; r1 += 1)n1.addShape(this.processPath(e1[r1], h1));
                    s1.shape.paths = s1.localShapeCollection;
                }
                this.dynamicProperties.length || (this._mdf = !1);
            };
            var TransformPropertyFactory = function() {
                var t1 = [
                    0,
                    0
                ];
                function e1(t1, e1, i1) {
                    if (this.elem = t1, this.frameId = -1, this.propType = "transform", this.data = e1, this.v = new Matrix, this.pre = new Matrix, this.appliedTransformations = 0, this.initDynamicPropertyContainer(i1 || t1), e1.p && e1.p.s ? (this.px = PropertyFactory.getProp(t1, e1.p.x, 0, 0, this), this.py = PropertyFactory.getProp(t1, e1.p.y, 0, 0, this), e1.p.z && (this.pz = PropertyFactory.getProp(t1, e1.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(t1, e1.p || {
                        k: [
                            0,
                            0,
                            0
                        ]
                    }, 1, 0, this), e1.rx) {
                        if (this.rx = PropertyFactory.getProp(t1, e1.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(t1, e1.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(t1, e1.rz, 0, degToRads, this), e1.or.k[0].ti) {
                            var r1, a1 = e1.or.k.length;
                            for(r1 = 0; r1 < a1; r1 += 1)e1.or.k[r1].to = null, e1.or.k[r1].ti = null;
                        }
                        this.or = PropertyFactory.getProp(t1, e1.or, 1, degToRads, this), this.or.sh = !0;
                    } else this.r = PropertyFactory.getProp(t1, e1.r || {
                        k: 0
                    }, 0, degToRads, this);
                    e1.sk && (this.sk = PropertyFactory.getProp(t1, e1.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(t1, e1.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(t1, e1.a || {
                        k: [
                            0,
                            0,
                            0
                        ]
                    }, 1, 0, this), this.s = PropertyFactory.getProp(t1, e1.s || {
                        k: [
                            100,
                            100,
                            100
                        ]
                    }, 1, .01, this), e1.o ? this.o = PropertyFactory.getProp(t1, e1.o, 0, .01, t1) : this.o = {
                        _mdf: !1,
                        v: 1
                    }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
                }
                return e1.prototype = {
                    applyToMatrix: function(t1) {
                        var e1 = this._mdf;
                        this.iterateDynamicProperties(), this._mdf = this._mdf || e1, this.a && t1.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && t1.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && t1.skewFromAxis(-this.sk.v, this.sa.v), this.r ? t1.rotate(-this.r.v) : t1.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? t1.translate(this.px.v, this.py.v, -this.pz.v) : t1.translate(this.px.v, this.py.v, 0) : t1.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                    },
                    getValue: function(e1) {
                        if (this.elem.globalData.frameId !== this.frameId) {
                            if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || e1) {
                                var i1;
                                if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
                                    var r1, a1;
                                    if (i1 = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime) this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (r1 = this.p.getValueAtTime((this.p.keyframes[0].t + .01) / i1, 0), a1 = this.p.getValueAtTime(this.p.keyframes[0].t / i1, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (r1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / i1, 0), a1 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - .05) / i1, 0)) : (r1 = this.p.pv, a1 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - .01) / i1, this.p.offsetTime));
                                    else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                                        r1 = [], a1 = [];
                                        var s1 = this.px, n1 = this.py;
                                        s1._caching.lastFrame + s1.offsetTime <= s1.keyframes[0].t ? (r1[0] = s1.getValueAtTime((s1.keyframes[0].t + .01) / i1, 0), r1[1] = n1.getValueAtTime((n1.keyframes[0].t + .01) / i1, 0), a1[0] = s1.getValueAtTime(s1.keyframes[0].t / i1, 0), a1[1] = n1.getValueAtTime(n1.keyframes[0].t / i1, 0)) : s1._caching.lastFrame + s1.offsetTime >= s1.keyframes[s1.keyframes.length - 1].t ? (r1[0] = s1.getValueAtTime(s1.keyframes[s1.keyframes.length - 1].t / i1, 0), r1[1] = n1.getValueAtTime(n1.keyframes[n1.keyframes.length - 1].t / i1, 0), a1[0] = s1.getValueAtTime((s1.keyframes[s1.keyframes.length - 1].t - .01) / i1, 0), a1[1] = n1.getValueAtTime((n1.keyframes[n1.keyframes.length - 1].t - .01) / i1, 0)) : (r1 = [
                                            s1.pv,
                                            n1.pv
                                        ], a1[0] = s1.getValueAtTime((s1._caching.lastFrame + s1.offsetTime - .01) / i1, s1.offsetTime), a1[1] = n1.getValueAtTime((n1._caching.lastFrame + n1.offsetTime - .01) / i1, n1.offsetTime));
                                    } else r1 = a1 = t1;
                                    this.v.rotate(-Math.atan2(r1[1] - a1[1], r1[0] - a1[0]));
                                }
                                this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                            }
                            this.frameId = this.elem.globalData.frameId;
                        }
                    },
                    precalculateMatrix: function() {
                        if (!this.a.k && (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1, !this.s.effectsSequence.length)) {
                            if (this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2, this.sk) {
                                if (this.sk.effectsSequence.length || this.sa.effectsSequence.length) return;
                                this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
                            }
                            this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : this.rz.effectsSequence.length || this.ry.effectsSequence.length || this.rx.effectsSequence.length || this.or.effectsSequence.length || (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
                        }
                    },
                    autoOrient: function() {}
                }, extendPrototype([
                    DynamicPropertyContainer
                ], e1), e1.prototype.addDynamicProperty = function(t1) {
                    this._addDynamicProperty(t1), this.elem.addDynamicProperty(t1), this._isDirty = !0;
                }, e1.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty, {
                    getTransformProperty: function(t1, i1, r1) {
                        return new e1(t1, i1, r1);
                    }
                };
            }();
            function RepeaterModifier() {}
            function RoundCornersModifier() {}
            function floatEqual(t1, e1) {
                return 1e5 * Math.abs(t1 - e1) <= Math.min(Math.abs(t1), Math.abs(e1));
            }
            function floatZero(t1) {
                return Math.abs(t1) <= 1e-5;
            }
            function lerp(t1, e1, i1) {
                return t1 * (1 - i1) + e1 * i1;
            }
            function lerpPoint(t1, e1, i1) {
                return [
                    lerp(t1[0], e1[0], i1),
                    lerp(t1[1], e1[1], i1)
                ];
            }
            function quadRoots(t1, e1, i1) {
                if (0 === t1) return [];
                var r1 = e1 * e1 - 4 * t1 * i1;
                if (r1 < 0) return [];
                var a1 = -e1 / (2 * t1);
                if (0 === r1) return [
                    a1
                ];
                var s1 = Math.sqrt(r1) / (2 * t1);
                return [
                    a1 - s1,
                    a1 + s1
                ];
            }
            function polynomialCoefficients(t1, e1, i1, r1) {
                return [
                    3 * e1 - t1 - 3 * i1 + r1,
                    3 * t1 - 6 * e1 + 3 * i1,
                    -3 * t1 + 3 * e1,
                    t1
                ];
            }
            function singlePoint(t1) {
                return new PolynomialBezier(t1, t1, t1, t1, !1);
            }
            function PolynomialBezier(t1, e1, i1, r1, a1) {
                a1 && pointEqual(t1, e1) && (e1 = lerpPoint(t1, r1, 1 / 3)), a1 && pointEqual(i1, r1) && (i1 = lerpPoint(t1, r1, 2 / 3));
                var s1 = polynomialCoefficients(t1[0], e1[0], i1[0], r1[0]), n1 = polynomialCoefficients(t1[1], e1[1], i1[1], r1[1]);
                this.a = [
                    s1[0],
                    n1[0]
                ], this.b = [
                    s1[1],
                    n1[1]
                ], this.c = [
                    s1[2],
                    n1[2]
                ], this.d = [
                    s1[3],
                    n1[3]
                ], this.points = [
                    t1,
                    e1,
                    i1,
                    r1
                ];
            }
            function extrema(t1, e1) {
                var i1 = t1.points[0][e1], r1 = t1.points[t1.points.length - 1][e1];
                if (i1 > r1) {
                    var a1 = r1;
                    r1 = i1, i1 = a1;
                }
                for(var s1 = quadRoots(3 * t1.a[e1], 2 * t1.b[e1], t1.c[e1]), n1 = 0; n1 < s1.length; n1 += 1)if (s1[n1] > 0 && s1[n1] < 1) {
                    var o1 = t1.point(s1[n1])[e1];
                    o1 < i1 ? i1 = o1 : o1 > r1 && (r1 = o1);
                }
                return {
                    min: i1,
                    max: r1
                };
            }
            function intersectData(t1, e1, i1) {
                var r1 = t1.boundingBox();
                return {
                    cx: r1.cx,
                    cy: r1.cy,
                    width: r1.width,
                    height: r1.height,
                    bez: t1,
                    t: (e1 + i1) / 2,
                    t1: e1,
                    t2: i1
                };
            }
            function splitData(t1) {
                var e1 = t1.bez.split(.5);
                return [
                    intersectData(e1[0], t1.t1, t1.t),
                    intersectData(e1[1], t1.t, t1.t2)
                ];
            }
            function boxIntersect(t1, e1) {
                return 2 * Math.abs(t1.cx - e1.cx) < t1.width + e1.width && 2 * Math.abs(t1.cy - e1.cy) < t1.height + e1.height;
            }
            function intersectsImpl(t1, e1, i1, r1, a1, s1) {
                if (boxIntersect(t1, e1)) {
                    if (i1 >= s1 || t1.width <= r1 && t1.height <= r1 && e1.width <= r1 && e1.height <= r1) a1.push([
                        t1.t,
                        e1.t
                    ]);
                    else {
                        var n1 = splitData(t1), o1 = splitData(e1);
                        intersectsImpl(n1[0], o1[0], i1 + 1, r1, a1, s1), intersectsImpl(n1[0], o1[1], i1 + 1, r1, a1, s1), intersectsImpl(n1[1], o1[0], i1 + 1, r1, a1, s1), intersectsImpl(n1[1], o1[1], i1 + 1, r1, a1, s1);
                    }
                }
            }
            function crossProduct(t1, e1) {
                return [
                    t1[1] * e1[2] - t1[2] * e1[1],
                    t1[2] * e1[0] - t1[0] * e1[2],
                    t1[0] * e1[1] - t1[1] * e1[0]
                ];
            }
            function lineIntersection(t1, e1, i1, r1) {
                var a1 = [
                    t1[0],
                    t1[1],
                    1
                ], s1 = [
                    e1[0],
                    e1[1],
                    1
                ], n1 = [
                    i1[0],
                    i1[1],
                    1
                ], o1 = [
                    r1[0],
                    r1[1],
                    1
                ], h1 = crossProduct(crossProduct(a1, s1), crossProduct(n1, o1));
                return floatZero(h1[2]) ? null : [
                    h1[0] / h1[2],
                    h1[1] / h1[2]
                ];
            }
            function polarOffset(t1, e1, i1) {
                return [
                    t1[0] + Math.cos(e1) * i1,
                    t1[1] - Math.sin(e1) * i1
                ];
            }
            function pointDistance(t1, e1) {
                return Math.hypot(t1[0] - e1[0], t1[1] - e1[1]);
            }
            function pointEqual(t1, e1) {
                return floatEqual(t1[0], e1[0]) && floatEqual(t1[1], e1[1]);
            }
            function ZigZagModifier() {}
            function setPoint(t1, e1, i1, r1, a1, s1, n1) {
                var o1 = i1 - Math.PI / 2, h1 = i1 + Math.PI / 2, l1 = e1[0] + Math.cos(i1) * r1 * a1, p1 = e1[1] - Math.sin(i1) * r1 * a1;
                t1.setTripleAt(l1, p1, l1 + Math.cos(o1) * s1, p1 - Math.sin(o1) * s1, l1 + Math.cos(h1) * n1, p1 - Math.sin(h1) * n1, t1.length());
            }
            function getPerpendicularVector(t1, e1) {
                var i1 = [
                    e1[0] - t1[0],
                    e1[1] - t1[1]
                ], r1 = .5 * -Math.PI;
                return [
                    Math.cos(r1) * i1[0] - Math.sin(r1) * i1[1],
                    Math.sin(r1) * i1[0] + Math.cos(r1) * i1[1]
                ];
            }
            function getProjectingAngle(t1, e1) {
                var i1 = 0 === e1 ? t1.length() - 1 : e1 - 1, r1 = (e1 + 1) % t1.length(), a1 = getPerpendicularVector(t1.v[i1], t1.v[r1]);
                return Math.atan2(0, 1) - Math.atan2(a1[1], a1[0]);
            }
            function zigZagCorner(t1, e1, i1, r1, a1, s1, n1) {
                var o1 = getProjectingAngle(e1, i1), h1 = e1.v[i1 % e1._length], l1 = e1.v[0 === i1 ? e1._length - 1 : i1 - 1], p1 = e1.v[(i1 + 1) % e1._length], f1 = 2 === s1 ? Math.sqrt(Math.pow(h1[0] - l1[0], 2) + Math.pow(h1[1] - l1[1], 2)) : 0, d1 = 2 === s1 ? Math.sqrt(Math.pow(h1[0] - p1[0], 2) + Math.pow(h1[1] - p1[1], 2)) : 0;
                setPoint(t1, e1.v[i1 % e1._length], o1, n1, r1, d1 / (2 * (a1 + 1)), f1 / (2 * (a1 + 1)));
            }
            function zigZagSegment(t1, e1, i1, r1, a1, s1) {
                for(var n1 = 0; n1 < r1; n1 += 1){
                    var o1 = (n1 + 1) / (r1 + 1), h1 = 2 === a1 ? Math.sqrt(Math.pow(e1.points[3][0] - e1.points[0][0], 2) + Math.pow(e1.points[3][1] - e1.points[0][1], 2)) : 0, l1 = e1.normalAngle(o1);
                    setPoint(t1, e1.point(o1), l1, s1, i1, h1 / (2 * (r1 + 1)), h1 / (2 * (r1 + 1))), s1 = -s1;
                }
                return s1;
            }
            function linearOffset(t1, e1, i1) {
                var r1 = Math.atan2(e1[0] - t1[0], e1[1] - t1[1]);
                return [
                    polarOffset(t1, r1, i1),
                    polarOffset(e1, r1, i1)
                ];
            }
            function offsetSegment(t1, e1) {
                var i1, r1, a1, s1, n1, o1, h1;
                i1 = (h1 = linearOffset(t1.points[0], t1.points[1], e1))[0], r1 = h1[1], a1 = (h1 = linearOffset(t1.points[1], t1.points[2], e1))[0], s1 = h1[1], n1 = (h1 = linearOffset(t1.points[2], t1.points[3], e1))[0], o1 = h1[1];
                var l1 = lineIntersection(i1, r1, a1, s1);
                null === l1 && (l1 = r1);
                var p1 = lineIntersection(n1, o1, a1, s1);
                return null === p1 && (p1 = n1), new PolynomialBezier(i1, l1, p1, o1);
            }
            function joinLines(t1, e1, i1, r1, a1) {
                var s1 = e1.points[3], n1 = i1.points[0];
                if (3 === r1) return s1;
                if (pointEqual(s1, n1)) return s1;
                if (2 === r1) {
                    var o1 = -e1.tangentAngle(1), h1 = -i1.tangentAngle(0) + Math.PI, l1 = lineIntersection(s1, polarOffset(s1, o1 + Math.PI / 2, 100), n1, polarOffset(n1, o1 + Math.PI / 2, 100)), p1 = l1 ? pointDistance(l1, s1) : pointDistance(s1, n1) / 2, f1 = polarOffset(s1, o1, 2 * p1 * roundCorner);
                    return t1.setXYAt(f1[0], f1[1], "o", t1.length() - 1), f1 = polarOffset(n1, h1, 2 * p1 * roundCorner), t1.setTripleAt(n1[0], n1[1], n1[0], n1[1], f1[0], f1[1], t1.length()), n1;
                }
                var d1 = lineIntersection(pointEqual(s1, e1.points[2]) ? e1.points[0] : e1.points[2], s1, n1, pointEqual(n1, i1.points[1]) ? i1.points[3] : i1.points[1]);
                return d1 && pointDistance(d1, s1) < a1 ? (t1.setTripleAt(d1[0], d1[1], d1[0], d1[1], d1[0], d1[1], t1.length()), d1) : s1;
            }
            function getIntersection(t1, e1) {
                var i1 = t1.intersections(e1);
                return i1.length && floatEqual(i1[0][0], 1) && i1.shift(), i1.length ? i1[0] : null;
            }
            function pruneSegmentIntersection(t1, e1) {
                var i1 = t1.slice(), r1 = e1.slice(), a1 = getIntersection(t1[t1.length - 1], e1[0]);
                return a1 && (i1[t1.length - 1] = t1[t1.length - 1].split(a1[0])[0], r1[0] = e1[0].split(a1[1])[1]), t1.length > 1 && e1.length > 1 && (a1 = getIntersection(t1[0], e1[e1.length - 1])) ? [
                    [
                        t1[0].split(a1[0])[0]
                    ],
                    [
                        e1[e1.length - 1].split(a1[1])[1]
                    ]
                ] : [
                    i1,
                    r1
                ];
            }
            function pruneIntersections(t1) {
                for(var e1, i1 = 1; i1 < t1.length; i1 += 1)e1 = pruneSegmentIntersection(t1[i1 - 1], t1[i1]), t1[i1 - 1] = e1[0], t1[i1] = e1[1];
                return t1.length > 1 && (e1 = pruneSegmentIntersection(t1[t1.length - 1], t1[0]), t1[t1.length - 1] = e1[0], t1[0] = e1[1]), t1;
            }
            function offsetSegmentSplit(t1, e1) {
                var i1, r1, a1, s1, n1 = t1.inflectionPoints();
                if (0 === n1.length) return [
                    offsetSegment(t1, e1)
                ];
                if (1 === n1.length || floatEqual(n1[1], 1)) return i1 = (a1 = t1.split(n1[0]))[0], r1 = a1[1], [
                    offsetSegment(i1, e1),
                    offsetSegment(r1, e1)
                ];
                i1 = (a1 = t1.split(n1[0]))[0];
                var o1 = (n1[1] - n1[0]) / (1 - n1[0]);
                return s1 = (a1 = a1[1].split(o1))[0], r1 = a1[1], [
                    offsetSegment(i1, e1),
                    offsetSegment(s1, e1),
                    offsetSegment(r1, e1)
                ];
            }
            function OffsetPathModifier() {}
            function getFontProperties(t1) {
                for(var e1 = t1.fStyle ? t1.fStyle.split(" ") : [], i1 = "normal", r1 = "normal", a1 = e1.length, s1 = 0; s1 < a1; s1 += 1)switch(e1[s1].toLowerCase()){
                    case "italic":
                        r1 = "italic";
                        break;
                    case "bold":
                        i1 = "700";
                        break;
                    case "black":
                        i1 = "900";
                        break;
                    case "medium":
                        i1 = "500";
                        break;
                    case "regular":
                    case "normal":
                        i1 = "400";
                        break;
                    case "light":
                    case "thin":
                        i1 = "200";
                }
                return {
                    style: r1,
                    weight: t1.fWeight || i1
                };
            }
            extendPrototype([
                ShapeModifier
            ], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(t1, e1) {
                this.getValue = this.processKeys, this.c = PropertyFactory.getProp(t1, e1.c, 0, null, this), this.o = PropertyFactory.getProp(t1, e1.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(t1, e1.tr, this), this.so = PropertyFactory.getProp(t1, e1.tr.so, 0, .01, this), this.eo = PropertyFactory.getProp(t1, e1.tr.eo, 0, .01, this), this.data = e1, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix, this.rMatrix = new Matrix, this.sMatrix = new Matrix, this.tMatrix = new Matrix, this.matrix = new Matrix;
            }, RepeaterModifier.prototype.applyTransforms = function(t1, e1, i1, r1, a1, s1) {
                var n1 = s1 ? -1 : 1, o1 = r1.s.v[0] + (1 - r1.s.v[0]) * (1 - a1), h1 = r1.s.v[1] + (1 - r1.s.v[1]) * (1 - a1);
                t1.translate(r1.p.v[0] * n1 * a1, r1.p.v[1] * n1 * a1, r1.p.v[2]), e1.translate(-r1.a.v[0], -r1.a.v[1], r1.a.v[2]), e1.rotate(-r1.r.v * n1 * a1), e1.translate(r1.a.v[0], r1.a.v[1], r1.a.v[2]), i1.translate(-r1.a.v[0], -r1.a.v[1], r1.a.v[2]), i1.scale(s1 ? 1 / o1 : o1, s1 ? 1 / h1 : h1), i1.translate(r1.a.v[0], r1.a.v[1], r1.a.v[2]);
            }, RepeaterModifier.prototype.init = function(t1, e1, i1, r1) {
                for(this.elem = t1, this.arr = e1, this.pos = i1, this.elemsData = r1, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(t1), this.initModifierProperties(t1, e1[i1]); i1 > 0;)i1 -= 1, this._elements.unshift(e1[i1]);
                this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
            }, RepeaterModifier.prototype.resetElements = function(t1) {
                var e1, i1 = t1.length;
                for(e1 = 0; e1 < i1; e1 += 1)t1[e1]._processed = !1, "gr" === t1[e1].ty && this.resetElements(t1[e1].it);
            }, RepeaterModifier.prototype.cloneElements = function(t1) {
                var e1 = JSON.parse(JSON.stringify(t1));
                return this.resetElements(e1), e1;
            }, RepeaterModifier.prototype.changeGroupRender = function(t1, e1) {
                var i1, r1 = t1.length;
                for(i1 = 0; i1 < r1; i1 += 1)t1[i1]._render = e1, "gr" === t1[i1].ty && this.changeGroupRender(t1[i1].it, e1);
            }, RepeaterModifier.prototype.processShapes = function(t1) {
                var e1, i1, r1, a1, s1, n1 = !1;
                if (this._mdf || t1) {
                    var o1, h1 = Math.ceil(this.c.v);
                    if (this._groups.length < h1) {
                        for(; this._groups.length < h1;){
                            var l1 = {
                                it: this.cloneElements(this._elements),
                                ty: "gr"
                            };
                            l1.it.push({
                                a: {
                                    a: 0,
                                    ix: 1,
                                    k: [
                                        0,
                                        0
                                    ]
                                },
                                nm: "Transform",
                                o: {
                                    a: 0,
                                    ix: 7,
                                    k: 100
                                },
                                p: {
                                    a: 0,
                                    ix: 2,
                                    k: [
                                        0,
                                        0
                                    ]
                                },
                                r: {
                                    a: 1,
                                    ix: 6,
                                    k: [
                                        {
                                            s: 0,
                                            e: 0,
                                            t: 0
                                        },
                                        {
                                            s: 0,
                                            e: 0,
                                            t: 1
                                        }
                                    ]
                                },
                                s: {
                                    a: 0,
                                    ix: 3,
                                    k: [
                                        100,
                                        100
                                    ]
                                },
                                sa: {
                                    a: 0,
                                    ix: 5,
                                    k: 0
                                },
                                sk: {
                                    a: 0,
                                    ix: 4,
                                    k: 0
                                },
                                ty: "tr"
                            }), this.arr.splice(0, 0, l1), this._groups.splice(0, 0, l1), this._currentCopies += 1;
                        }
                        this.elem.reloadShapes(), n1 = !0;
                    }
                    for(s1 = 0, r1 = 0; r1 <= this._groups.length - 1; r1 += 1){
                        if (o1 = s1 < h1, this._groups[r1]._render = o1, this.changeGroupRender(this._groups[r1].it, o1), !o1) {
                            var p1 = this.elemsData[r1].it, f1 = p1[p1.length - 1];
                            0 !== f1.transform.op.v ? (f1.transform.op._mdf = !0, f1.transform.op.v = 0) : f1.transform.op._mdf = !1;
                        }
                        s1 += 1;
                    }
                    this._currentCopies = h1;
                    var d1 = this.o.v, c1 = d1 % 1, m1 = d1 > 0 ? Math.floor(d1) : Math.ceil(d1), u1 = this.pMatrix.props, y1 = this.rMatrix.props, g1 = this.sMatrix.props;
                    this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
                    var _1, v1, b1 = 0;
                    if (d1 > 0) {
                        for(; b1 < m1;)this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), b1 += 1;
                        c1 && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, c1, !1), b1 += c1);
                    } else if (d1 < 0) {
                        for(; b1 > m1;)this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), b1 -= 1;
                        c1 && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -c1, !0), b1 -= c1);
                    }
                    for(r1 = 1 === this.data.m ? 0 : this._currentCopies - 1, a1 = 1 === this.data.m ? 1 : -1, s1 = this._currentCopies; s1;){
                        if (v1 = (i1 = (e1 = this.elemsData[r1].it)[e1.length - 1].transform.mProps.v.props).length, e1[e1.length - 1].transform.mProps._mdf = !0, e1[e1.length - 1].transform.op._mdf = !0, e1[e1.length - 1].transform.op.v = 1 === this._currentCopies ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (r1 / (this._currentCopies - 1)), 0 !== b1) {
                            for((0 !== r1 && 1 === a1 || r1 !== this._currentCopies - 1 && -1 === a1) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(y1[0], y1[1], y1[2], y1[3], y1[4], y1[5], y1[6], y1[7], y1[8], y1[9], y1[10], y1[11], y1[12], y1[13], y1[14], y1[15]), this.matrix.transform(g1[0], g1[1], g1[2], g1[3], g1[4], g1[5], g1[6], g1[7], g1[8], g1[9], g1[10], g1[11], g1[12], g1[13], g1[14], g1[15]), this.matrix.transform(u1[0], u1[1], u1[2], u1[3], u1[4], u1[5], u1[6], u1[7], u1[8], u1[9], u1[10], u1[11], u1[12], u1[13], u1[14], u1[15]), _1 = 0; _1 < v1; _1 += 1)i1[_1] = this.matrix.props[_1];
                            this.matrix.reset();
                        } else for(this.matrix.reset(), _1 = 0; _1 < v1; _1 += 1)i1[_1] = this.matrix.props[_1];
                        b1 += 1, s1 -= 1, r1 += a1;
                    }
                } else for(s1 = this._currentCopies, r1 = 0, a1 = 1; s1;)i1 = (e1 = this.elemsData[r1].it)[e1.length - 1].transform.mProps.v.props, e1[e1.length - 1].transform.mProps._mdf = !1, e1[e1.length - 1].transform.op._mdf = !1, s1 -= 1, r1 += a1;
                return n1;
            }, RepeaterModifier.prototype.addShape = function() {}, extendPrototype([
                ShapeModifier
            ], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(t1, e1) {
                this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(t1, e1.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
            }, RoundCornersModifier.prototype.processPath = function(t1, e1) {
                var i1, r1 = shapePool.newElement();
                r1.c = t1.c;
                var a1, s1, n1, o1, h1, l1, p1, f1, d1, c1, m1, u1, y1 = t1._length, g1 = 0;
                for(i1 = 0; i1 < y1; i1 += 1)a1 = t1.v[i1], n1 = t1.o[i1], s1 = t1.i[i1], a1[0] === n1[0] && a1[1] === n1[1] && a1[0] === s1[0] && a1[1] === s1[1] ? 0 !== i1 && i1 !== y1 - 1 || t1.c ? (o1 = 0 === i1 ? t1.v[y1 - 1] : t1.v[i1 - 1], l1 = (h1 = Math.sqrt(Math.pow(a1[0] - o1[0], 2) + Math.pow(a1[1] - o1[1], 2))) ? Math.min(h1 / 2, e1) / h1 : 0, p1 = m1 = a1[0] + (o1[0] - a1[0]) * l1, f1 = u1 = a1[1] - (a1[1] - o1[1]) * l1, d1 = p1 - (p1 - a1[0]) * roundCorner, c1 = f1 - (f1 - a1[1]) * roundCorner, r1.setTripleAt(p1, f1, d1, c1, m1, u1, g1), g1 += 1, o1 = i1 === y1 - 1 ? t1.v[0] : t1.v[i1 + 1], l1 = (h1 = Math.sqrt(Math.pow(a1[0] - o1[0], 2) + Math.pow(a1[1] - o1[1], 2))) ? Math.min(h1 / 2, e1) / h1 : 0, p1 = d1 = a1[0] + (o1[0] - a1[0]) * l1, f1 = c1 = a1[1] + (o1[1] - a1[1]) * l1, m1 = p1 - (p1 - a1[0]) * roundCorner, u1 = f1 - (f1 - a1[1]) * roundCorner, r1.setTripleAt(p1, f1, d1, c1, m1, u1, g1), g1 += 1) : (r1.setTripleAt(a1[0], a1[1], n1[0], n1[1], s1[0], s1[1], g1), g1 += 1) : (r1.setTripleAt(t1.v[i1][0], t1.v[i1][1], t1.o[i1][0], t1.o[i1][1], t1.i[i1][0], t1.i[i1][1], g1), g1 += 1);
                return r1;
            }, RoundCornersModifier.prototype.processShapes = function(t1) {
                var e1, i1, r1, a1, s1, n1, o1 = this.shapes.length, h1 = this.rd.v;
                if (0 !== h1) for(i1 = 0; i1 < o1; i1 += 1){
                    if (n1 = (s1 = this.shapes[i1]).localShapeCollection, s1.shape._mdf || this._mdf || t1) for(n1.releaseShapes(), s1.shape._mdf = !0, e1 = s1.shape.paths.shapes, a1 = s1.shape.paths._length, r1 = 0; r1 < a1; r1 += 1)n1.addShape(this.processPath(e1[r1], h1));
                    s1.shape.paths = s1.localShapeCollection;
                }
                this.dynamicProperties.length || (this._mdf = !1);
            }, PolynomialBezier.prototype.point = function(t1) {
                return [
                    ((this.a[0] * t1 + this.b[0]) * t1 + this.c[0]) * t1 + this.d[0],
                    ((this.a[1] * t1 + this.b[1]) * t1 + this.c[1]) * t1 + this.d[1]
                ];
            }, PolynomialBezier.prototype.derivative = function(t1) {
                return [
                    (3 * t1 * this.a[0] + 2 * this.b[0]) * t1 + this.c[0],
                    (3 * t1 * this.a[1] + 2 * this.b[1]) * t1 + this.c[1]
                ];
            }, PolynomialBezier.prototype.tangentAngle = function(t1) {
                var e1 = this.derivative(t1);
                return Math.atan2(e1[1], e1[0]);
            }, PolynomialBezier.prototype.normalAngle = function(t1) {
                var e1 = this.derivative(t1);
                return Math.atan2(e1[0], e1[1]);
            }, PolynomialBezier.prototype.inflectionPoints = function() {
                var t1 = this.a[1] * this.b[0] - this.a[0] * this.b[1];
                if (floatZero(t1)) return [];
                var e1 = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / t1, i1 = e1 * e1 - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / t1;
                if (i1 < 0) return [];
                var r1 = Math.sqrt(i1);
                return floatZero(r1) ? r1 > 0 && r1 < 1 ? [
                    e1
                ] : [] : [
                    e1 - r1,
                    e1 + r1
                ].filter(function(t1) {
                    return t1 > 0 && t1 < 1;
                });
            }, PolynomialBezier.prototype.split = function(t1) {
                if (t1 <= 0) return [
                    singlePoint(this.points[0]),
                    this
                ];
                if (t1 >= 1) return [
                    this,
                    singlePoint(this.points[this.points.length - 1])
                ];
                var e1 = lerpPoint(this.points[0], this.points[1], t1), i1 = lerpPoint(this.points[1], this.points[2], t1), r1 = lerpPoint(this.points[2], this.points[3], t1), a1 = lerpPoint(e1, i1, t1), s1 = lerpPoint(i1, r1, t1), n1 = lerpPoint(a1, s1, t1);
                return [
                    new PolynomialBezier(this.points[0], e1, a1, n1, !0),
                    new PolynomialBezier(n1, s1, r1, this.points[3], !0)
                ];
            }, PolynomialBezier.prototype.bounds = function() {
                return {
                    x: extrema(this, 0),
                    y: extrema(this, 1)
                };
            }, PolynomialBezier.prototype.boundingBox = function() {
                var t1 = this.bounds();
                return {
                    left: t1.x.min,
                    right: t1.x.max,
                    top: t1.y.min,
                    bottom: t1.y.max,
                    width: t1.x.max - t1.x.min,
                    height: t1.y.max - t1.y.min,
                    cx: (t1.x.max + t1.x.min) / 2,
                    cy: (t1.y.max + t1.y.min) / 2
                };
            }, PolynomialBezier.prototype.intersections = function(t1, e1, i1) {
                void 0 === e1 && (e1 = 2), void 0 === i1 && (i1 = 7);
                var r1 = [];
                return intersectsImpl(intersectData(this, 0, 1), intersectData(t1, 0, 1), 0, e1, r1, i1), r1;
            }, PolynomialBezier.shapeSegment = function(t1, e1) {
                var i1 = (e1 + 1) % t1.length();
                return new PolynomialBezier(t1.v[e1], t1.o[e1], t1.i[i1], t1.v[i1], !0);
            }, PolynomialBezier.shapeSegmentInverted = function(t1, e1) {
                var i1 = (e1 + 1) % t1.length();
                return new PolynomialBezier(t1.v[i1], t1.i[i1], t1.o[e1], t1.v[e1], !0);
            }, extendPrototype([
                ShapeModifier
            ], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(t1, e1) {
                this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(t1, e1.s, 0, null, this), this.frequency = PropertyFactory.getProp(t1, e1.r, 0, null, this), this.pointsType = PropertyFactory.getProp(t1, e1.pt, 0, null, this), this._isAnimated = 0 !== this.amplitude.effectsSequence.length || 0 !== this.frequency.effectsSequence.length || 0 !== this.pointsType.effectsSequence.length;
            }, ZigZagModifier.prototype.processPath = function(t1, e1, i1, r1) {
                var a1 = t1._length, s1 = shapePool.newElement();
                if (s1.c = t1.c, t1.c || (a1 -= 1), 0 === a1) return s1;
                var n1 = -1, o1 = PolynomialBezier.shapeSegment(t1, 0);
                zigZagCorner(s1, t1, 0, e1, i1, r1, n1);
                for(var h1 = 0; h1 < a1; h1 += 1)n1 = zigZagSegment(s1, o1, e1, i1, r1, -n1), o1 = h1 !== a1 - 1 || t1.c ? PolynomialBezier.shapeSegment(t1, (h1 + 1) % a1) : null, zigZagCorner(s1, t1, h1 + 1, e1, i1, r1, n1);
                return s1;
            }, ZigZagModifier.prototype.processShapes = function(t1) {
                var e1, i1, r1, a1, s1, n1, o1 = this.shapes.length, h1 = this.amplitude.v, l1 = Math.max(0, Math.round(this.frequency.v)), p1 = this.pointsType.v;
                if (0 !== h1) for(i1 = 0; i1 < o1; i1 += 1){
                    if (n1 = (s1 = this.shapes[i1]).localShapeCollection, s1.shape._mdf || this._mdf || t1) for(n1.releaseShapes(), s1.shape._mdf = !0, e1 = s1.shape.paths.shapes, a1 = s1.shape.paths._length, r1 = 0; r1 < a1; r1 += 1)n1.addShape(this.processPath(e1[r1], h1, l1, p1));
                    s1.shape.paths = s1.localShapeCollection;
                }
                this.dynamicProperties.length || (this._mdf = !1);
            }, extendPrototype([
                ShapeModifier
            ], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(t1, e1) {
                this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t1, e1.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(t1, e1.ml, 0, null, this), this.lineJoin = e1.lj, this._isAnimated = 0 !== this.amount.effectsSequence.length;
            }, OffsetPathModifier.prototype.processPath = function(t1, e1, i1, r1) {
                var a1 = shapePool.newElement();
                a1.c = t1.c;
                var s1, n1, o1, h1 = t1.length();
                t1.c || (h1 -= 1);
                var l1 = [];
                for(s1 = 0; s1 < h1; s1 += 1)o1 = PolynomialBezier.shapeSegment(t1, s1), l1.push(offsetSegmentSplit(o1, e1));
                if (!t1.c) for(s1 = h1 - 1; s1 >= 0; s1 -= 1)o1 = PolynomialBezier.shapeSegmentInverted(t1, s1), l1.push(offsetSegmentSplit(o1, e1));
                l1 = pruneIntersections(l1);
                var p1 = null, f1 = null;
                for(s1 = 0; s1 < l1.length; s1 += 1){
                    var d1 = l1[s1];
                    for(f1 && (p1 = joinLines(a1, f1, d1[0], i1, r1)), f1 = d1[d1.length - 1], n1 = 0; n1 < d1.length; n1 += 1)o1 = d1[n1], p1 && pointEqual(o1.points[0], p1) ? a1.setXYAt(o1.points[1][0], o1.points[1][1], "o", a1.length() - 1) : a1.setTripleAt(o1.points[0][0], o1.points[0][1], o1.points[1][0], o1.points[1][1], o1.points[0][0], o1.points[0][1], a1.length()), a1.setTripleAt(o1.points[3][0], o1.points[3][1], o1.points[3][0], o1.points[3][1], o1.points[2][0], o1.points[2][1], a1.length()), p1 = o1.points[3];
                }
                return l1.length && joinLines(a1, f1, l1[0][0], i1, r1), a1;
            }, OffsetPathModifier.prototype.processShapes = function(t1) {
                var e1, i1, r1, a1, s1, n1, o1 = this.shapes.length, h1 = this.amount.v, l1 = this.miterLimit.v, p1 = this.lineJoin;
                if (0 !== h1) for(i1 = 0; i1 < o1; i1 += 1){
                    if (n1 = (s1 = this.shapes[i1]).localShapeCollection, s1.shape._mdf || this._mdf || t1) for(n1.releaseShapes(), s1.shape._mdf = !0, e1 = s1.shape.paths.shapes, a1 = s1.shape.paths._length, r1 = 0; r1 < a1; r1 += 1)n1.addShape(this.processPath(e1[r1], h1, p1, l1));
                    s1.shape.paths = s1.localShapeCollection;
                }
                this.dynamicProperties.length || (this._mdf = !1);
            };
            var FontManager = function() {
                var t1 = {
                    w: 0,
                    size: 0,
                    shapes: [],
                    data: {
                        shapes: []
                    }
                }, e1 = [];
                e1 = e1.concat([
                    2304,
                    2305,
                    2306,
                    2307,
                    2362,
                    2363,
                    2364,
                    2364,
                    2366,
                    2367,
                    2368,
                    2369,
                    2370,
                    2371,
                    2372,
                    2373,
                    2374,
                    2375,
                    2376,
                    2377,
                    2378,
                    2379,
                    2380,
                    2381,
                    2382,
                    2383,
                    2387,
                    2388,
                    2389,
                    2390,
                    2391,
                    2402,
                    2403
                ]);
                var i1 = [
                    "d83cdffb",
                    "d83cdffc",
                    "d83cdffd",
                    "d83cdffe",
                    "d83cdfff"
                ], r1 = [
                    65039,
                    8205
                ];
                function a1(t1, e1) {
                    var i1 = createTag("span");
                    i1.setAttribute("aria-hidden", !0), i1.style.fontFamily = e1;
                    var r1 = createTag("span");
                    r1.innerText = "giItT1WQy@!-/#", i1.style.position = "absolute", i1.style.left = "-10000px", i1.style.top = "-10000px", i1.style.fontSize = "300px", i1.style.fontVariant = "normal", i1.style.fontStyle = "normal", i1.style.fontWeight = "normal", i1.style.letterSpacing = "0", i1.appendChild(r1), document.body.appendChild(i1);
                    var a1 = r1.offsetWidth;
                    return r1.style.fontFamily = function(t1) {
                        var e1, i1 = t1.split(","), r1 = i1.length, a1 = [];
                        for(e1 = 0; e1 < r1; e1 += 1)"sans-serif" !== i1[e1] && "monospace" !== i1[e1] && a1.push(i1[e1]);
                        return a1.join(",");
                    }(t1) + ", " + e1, {
                        node: r1,
                        w: a1,
                        parent: i1
                    };
                }
                function s1(t1, e1) {
                    var i1, r1 = document.body && e1 ? "svg" : "canvas", a1 = getFontProperties(t1);
                    if ("svg" === r1) {
                        var s1 = createNS("text");
                        s1.style.fontSize = "100px", s1.setAttribute("font-family", t1.fFamily), s1.setAttribute("font-style", a1.style), s1.setAttribute("font-weight", a1.weight), s1.textContent = "1", t1.fClass ? (s1.style.fontFamily = "inherit", s1.setAttribute("class", t1.fClass)) : s1.style.fontFamily = t1.fFamily, e1.appendChild(s1), i1 = s1;
                    } else {
                        var n1 = new OffscreenCanvas(500, 500).getContext("2d");
                        n1.font = a1.style + " " + a1.weight + " 100px " + t1.fFamily, i1 = n1;
                    }
                    return {
                        measureText: function(t1) {
                            return "svg" === r1 ? (i1.textContent = t1, i1.getComputedTextLength()) : i1.measureText(t1).width;
                        }
                    };
                }
                var n1 = function() {
                    this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
                };
                n1.isModifier = function(t1, e1) {
                    var r1 = t1.toString(16) + e1.toString(16);
                    return -1 !== i1.indexOf(r1);
                }, n1.isZeroWidthJoiner = function(t1, e1) {
                    return e1 ? t1 === r1[0] && e1 === r1[1] : t1 === r1[1];
                }, n1.isCombinedCharacter = function(t1) {
                    return -1 !== e1.indexOf(t1);
                };
                var o1 = {
                    addChars: function(t1) {
                        if (t1) {
                            var e1;
                            this.chars || (this.chars = []);
                            var i1, r1, a1 = t1.length, s1 = this.chars.length;
                            for(e1 = 0; e1 < a1; e1 += 1){
                                for(i1 = 0, r1 = !1; i1 < s1;)this.chars[i1].style === t1[e1].style && this.chars[i1].fFamily === t1[e1].fFamily && this.chars[i1].ch === t1[e1].ch && (r1 = !0), i1 += 1;
                                r1 || (this.chars.push(t1[e1]), s1 += 1);
                            }
                        }
                    },
                    addFonts: function(t1, e1) {
                        if (t1) {
                            if (this.chars) return this.isLoaded = !0, void (this.fonts = t1.list);
                            if (!document.body) return this.isLoaded = !0, t1.list.forEach(function(t1) {
                                t1.helper = s1(t1), t1.cache = {};
                            }), void (this.fonts = t1.list);
                            var i1, r1 = t1.list, n1 = r1.length, o1 = n1;
                            for(i1 = 0; i1 < n1; i1 += 1){
                                var h1, l1, p1 = !0;
                                if (r1[i1].loaded = !1, r1[i1].monoCase = a1(r1[i1].fFamily, "monospace"), r1[i1].sansCase = a1(r1[i1].fFamily, "sans-serif"), r1[i1].fPath) {
                                    if ("p" === r1[i1].fOrigin || 3 === r1[i1].origin) {
                                        if ((h1 = document.querySelectorAll('style[f-forigin="p"][f-family="' + r1[i1].fFamily + '"], style[f-origin="3"][f-family="' + r1[i1].fFamily + '"]')).length > 0 && (p1 = !1), p1) {
                                            var f1 = createTag("style");
                                            f1.setAttribute("f-forigin", r1[i1].fOrigin), f1.setAttribute("f-origin", r1[i1].origin), f1.setAttribute("f-family", r1[i1].fFamily), f1.type = "text/css", f1.innerText = "@font-face {font-family: " + r1[i1].fFamily + "; font-style: normal; src: url('" + r1[i1].fPath + "');}", e1.appendChild(f1);
                                        }
                                    } else if ("g" === r1[i1].fOrigin || 1 === r1[i1].origin) {
                                        for(h1 = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), l1 = 0; l1 < h1.length; l1 += 1)-1 !== h1[l1].href.indexOf(r1[i1].fPath) && (p1 = !1);
                                        if (p1) {
                                            var d1 = createTag("link");
                                            d1.setAttribute("f-forigin", r1[i1].fOrigin), d1.setAttribute("f-origin", r1[i1].origin), d1.type = "text/css", d1.rel = "stylesheet", d1.href = r1[i1].fPath, document.body.appendChild(d1);
                                        }
                                    } else if ("t" === r1[i1].fOrigin || 2 === r1[i1].origin) {
                                        for(h1 = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), l1 = 0; l1 < h1.length; l1 += 1)r1[i1].fPath === h1[l1].src && (p1 = !1);
                                        if (p1) {
                                            var c1 = createTag("link");
                                            c1.setAttribute("f-forigin", r1[i1].fOrigin), c1.setAttribute("f-origin", r1[i1].origin), c1.setAttribute("rel", "stylesheet"), c1.setAttribute("href", r1[i1].fPath), e1.appendChild(c1);
                                        }
                                    }
                                } else r1[i1].loaded = !0, o1 -= 1;
                                r1[i1].helper = s1(r1[i1], e1), r1[i1].cache = {}, this.fonts.push(r1[i1]);
                            }
                            0 === o1 ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
                        } else this.isLoaded = !0;
                    },
                    getCharData: function(e1, i1, r1) {
                        for(var a1 = 0, s1 = this.chars.length; a1 < s1;){
                            if (this.chars[a1].ch === e1 && this.chars[a1].style === i1 && this.chars[a1].fFamily === r1) return this.chars[a1];
                            a1 += 1;
                        }
                        return ("string" == typeof e1 && 13 !== e1.charCodeAt(0) || !e1) && console && console.warn && !this._warned && (this._warned = !0, console.warn("Missing character from exported characters list: ", e1, i1, r1)), t1;
                    },
                    getFontByName: function(t1) {
                        for(var e1 = 0, i1 = this.fonts.length; e1 < i1;){
                            if (this.fonts[e1].fName === t1) return this.fonts[e1];
                            e1 += 1;
                        }
                        return this.fonts[0];
                    },
                    measureText: function(t1, e1, i1) {
                        var r1 = this.getFontByName(e1), a1 = t1.charCodeAt(0);
                        if (!r1.cache[a1 + 1]) {
                            var s1 = r1.helper;
                            if (" " === t1) {
                                var n1 = s1.measureText("|" + t1 + "|"), o1 = s1.measureText("||");
                                r1.cache[a1 + 1] = (n1 - o1) / 100;
                            } else r1.cache[a1 + 1] = s1.measureText(t1) / 100;
                        }
                        return r1.cache[a1 + 1] * i1;
                    },
                    checkLoadedFonts: function() {
                        var t1, e1, i1, r1 = this.fonts.length, a1 = r1;
                        for(t1 = 0; t1 < r1; t1 += 1)this.fonts[t1].loaded ? a1 -= 1 : "n" === this.fonts[t1].fOrigin || 0 === this.fonts[t1].origin ? this.fonts[t1].loaded = !0 : (e1 = this.fonts[t1].monoCase.node, i1 = this.fonts[t1].monoCase.w, e1.offsetWidth !== i1 ? (a1 -= 1, this.fonts[t1].loaded = !0) : (e1 = this.fonts[t1].sansCase.node, i1 = this.fonts[t1].sansCase.w, e1.offsetWidth !== i1 && (a1 -= 1, this.fonts[t1].loaded = !0)), this.fonts[t1].loaded && (this.fonts[t1].sansCase.parent.parentNode.removeChild(this.fonts[t1].sansCase.parent), this.fonts[t1].monoCase.parent.parentNode.removeChild(this.fonts[t1].monoCase.parent)));
                        0 !== a1 && Date.now() - this.initTime < 5e3 ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
                    },
                    setIsLoaded: function() {
                        this.isLoaded = !0;
                    }
                };
                return n1.prototype = o1, n1;
            }();
            function RenderableElement() {}
            RenderableElement.prototype = {
                initRenderable: function() {
                    this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
                },
                addRenderableComponent: function(t1) {
                    -1 === this.renderableComponents.indexOf(t1) && this.renderableComponents.push(t1);
                },
                removeRenderableComponent: function(t1) {
                    -1 !== this.renderableComponents.indexOf(t1) && this.renderableComponents.splice(this.renderableComponents.indexOf(t1), 1);
                },
                prepareRenderableFrame: function(t1) {
                    this.checkLayerLimits(t1);
                },
                checkTransparency: function() {
                    this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
                },
                checkLayerLimits: function(t1) {
                    this.data.ip - this.data.st <= t1 && this.data.op - this.data.st > t1 ? !0 !== this.isInRange && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : !1 !== this.isInRange && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
                },
                renderRenderable: function() {
                    var t1, e1 = this.renderableComponents.length;
                    for(t1 = 0; t1 < e1; t1 += 1)this.renderableComponents[t1].renderFrame(this._isFirstFrame);
                },
                sourceRectAtTime: function() {
                    return {
                        top: 0,
                        left: 0,
                        width: 100,
                        height: 100
                    };
                },
                getLayerSize: function() {
                    return 5 === this.data.ty ? {
                        w: this.data.textData.width,
                        h: this.data.textData.height
                    } : {
                        w: this.data.width,
                        h: this.data.height
                    };
                }
            };
            var getBlendMode = (blendModeEnums = {
                0: "source-over",
                1: "multiply",
                2: "screen",
                3: "overlay",
                4: "darken",
                5: "lighten",
                6: "color-dodge",
                7: "color-burn",
                8: "hard-light",
                9: "soft-light",
                10: "difference",
                11: "exclusion",
                12: "hue",
                13: "saturation",
                14: "color",
                15: "luminosity"
            }, function(t1) {
                return blendModeEnums[t1] || "";
            }), blendModeEnums;
            function SliderEffect(t1, e1, i1) {
                this.p = PropertyFactory.getProp(e1, t1.v, 0, 0, i1);
            }
            function AngleEffect(t1, e1, i1) {
                this.p = PropertyFactory.getProp(e1, t1.v, 0, 0, i1);
            }
            function ColorEffect(t1, e1, i1) {
                this.p = PropertyFactory.getProp(e1, t1.v, 1, 0, i1);
            }
            function PointEffect(t1, e1, i1) {
                this.p = PropertyFactory.getProp(e1, t1.v, 1, 0, i1);
            }
            function LayerIndexEffect(t1, e1, i1) {
                this.p = PropertyFactory.getProp(e1, t1.v, 0, 0, i1);
            }
            function MaskIndexEffect(t1, e1, i1) {
                this.p = PropertyFactory.getProp(e1, t1.v, 0, 0, i1);
            }
            function CheckboxEffect(t1, e1, i1) {
                this.p = PropertyFactory.getProp(e1, t1.v, 0, 0, i1);
            }
            function NoValueEffect() {
                this.p = {};
            }
            function EffectsManager(t1, e1) {
                var i1, r1 = t1.ef || [];
                this.effectElements = [];
                var a1, s1 = r1.length;
                for(i1 = 0; i1 < s1; i1 += 1)a1 = new GroupEffect(r1[i1], e1), this.effectElements.push(a1);
            }
            function GroupEffect(t1, e1) {
                this.init(t1, e1);
            }
            function BaseElement() {}
            function FrameElement() {}
            function FootageElement(t1, e1, i1) {
                this.initFrame(), this.initRenderable(), this.assetData = e1.getAssetData(t1.refId), this.footageData = e1.imageLoader.getAsset(this.assetData), this.initBaseData(t1, e1, i1);
            }
            function AudioElement(t1, e1, i1) {
                this.initFrame(), this.initRenderable(), this.assetData = e1.getAssetData(t1.refId), this.initBaseData(t1, e1, i1), this._isPlaying = !1, this._canPlay = !1;
                var r1 = this.globalData.getAssetsPath(this.assetData);
                this.audio = this.globalData.audioController.createAudio(r1), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = t1.tm ? PropertyFactory.getProp(this, t1.tm, 0, e1.frameRate, this) : {
                    _placeholder: !0
                }, this.lv = PropertyFactory.getProp(this, t1.au && t1.au.lv ? t1.au.lv : {
                    k: [
                        100
                    ]
                }, 1, .01, this);
            }
            function BaseRenderer() {}
            function TransformElement() {}
            function MaskElement(t1, e1, i1) {
                this.data = t1, this.element = e1, this.globalData = i1, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
                var r1, a1, s1 = this.globalData.defs, n1 = this.masksProperties ? this.masksProperties.length : 0;
                this.viewData = createSizedArray(n1), this.solidPath = "";
                var o1, h1, l1, p1, f1, d1, c1 = this.masksProperties, m1 = 0, u1 = [], y1 = createElementID(), g1 = "clipPath", _1 = "clip-path";
                for(r1 = 0; r1 < n1; r1 += 1)if (("a" !== c1[r1].mode && "n" !== c1[r1].mode || c1[r1].inv || 100 !== c1[r1].o.k || c1[r1].o.x) && (g1 = "mask", _1 = "mask"), "s" !== c1[r1].mode && "i" !== c1[r1].mode || 0 !== m1 ? l1 = null : ((l1 = createNS("rect")).setAttribute("fill", "#ffffff"), l1.setAttribute("width", this.element.comp.data.w || 0), l1.setAttribute("height", this.element.comp.data.h || 0), u1.push(l1)), a1 = createNS("path"), "n" === c1[r1].mode) this.viewData[r1] = {
                    op: PropertyFactory.getProp(this.element, c1[r1].o, 0, .01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, c1[r1], 3),
                    elem: a1,
                    lastPath: ""
                }, s1.appendChild(a1);
                else {
                    var v1;
                    if (m1 += 1, a1.setAttribute("fill", "s" === c1[r1].mode ? "#000000" : "#ffffff"), a1.setAttribute("clip-rule", "nonzero"), 0 !== c1[r1].x.k ? (g1 = "mask", _1 = "mask", d1 = PropertyFactory.getProp(this.element, c1[r1].x, 0, null, this.element), v1 = createElementID(), (p1 = createNS("filter")).setAttribute("id", v1), (f1 = createNS("feMorphology")).setAttribute("operator", "erode"), f1.setAttribute("in", "SourceGraphic"), f1.setAttribute("radius", "0"), p1.appendChild(f1), s1.appendChild(p1), a1.setAttribute("stroke", "s" === c1[r1].mode ? "#000000" : "#ffffff")) : (f1 = null, d1 = null), this.storedData[r1] = {
                        elem: a1,
                        x: d1,
                        expan: f1,
                        lastPath: "",
                        lastOperator: "",
                        filterId: v1,
                        lastRadius: 0
                    }, "i" === c1[r1].mode) {
                        h1 = u1.length;
                        var b1 = createNS("g");
                        for(o1 = 0; o1 < h1; o1 += 1)b1.appendChild(u1[o1]);
                        var E1 = createNS("mask");
                        E1.setAttribute("mask-type", "alpha"), E1.setAttribute("id", y1 + "_" + m1), E1.appendChild(a1), s1.appendChild(E1), b1.setAttribute("mask", "url(" + getLocationHref() + "#" + y1 + "_" + m1 + ")"), u1.length = 0, u1.push(b1);
                    } else u1.push(a1);
                    c1[r1].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[r1] = {
                        elem: a1,
                        lastPath: "",
                        op: PropertyFactory.getProp(this.element, c1[r1].o, 0, .01, this.element),
                        prop: ShapePropertyFactory.getShapeProp(this.element, c1[r1], 3),
                        invRect: l1
                    }, this.viewData[r1].prop.k || this.drawPath(c1[r1], this.viewData[r1].prop.v, this.viewData[r1]);
                }
                for(this.maskElement = createNS(g1), n1 = u1.length, r1 = 0; r1 < n1; r1 += 1)this.maskElement.appendChild(u1[r1]);
                m1 > 0 && (this.maskElement.setAttribute("id", y1), this.element.maskedElement.setAttribute(_1, "url(" + getLocationHref() + "#" + y1 + ")"), s1.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
            }
            extendPrototype([
                DynamicPropertyContainer
            ], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(t1, e1) {
                var i1;
                this.data = t1, this.effectElements = [], this.initDynamicPropertyContainer(e1);
                var r1, a1 = this.data.ef.length, s1 = this.data.ef;
                for(i1 = 0; i1 < a1; i1 += 1){
                    switch(r1 = null, s1[i1].ty){
                        case 0:
                            r1 = new SliderEffect(s1[i1], e1, this);
                            break;
                        case 1:
                            r1 = new AngleEffect(s1[i1], e1, this);
                            break;
                        case 2:
                            r1 = new ColorEffect(s1[i1], e1, this);
                            break;
                        case 3:
                            r1 = new PointEffect(s1[i1], e1, this);
                            break;
                        case 4:
                        case 7:
                            r1 = new CheckboxEffect(s1[i1], e1, this);
                            break;
                        case 10:
                            r1 = new LayerIndexEffect(s1[i1], e1, this);
                            break;
                        case 11:
                            r1 = new MaskIndexEffect(s1[i1], e1, this);
                            break;
                        case 5:
                            r1 = new EffectsManager(s1[i1], e1, this);
                            break;
                        default:
                            r1 = new NoValueEffect(s1[i1], e1, this);
                    }
                    r1 && this.effectElements.push(r1);
                }
            }, BaseElement.prototype = {
                checkMasks: function() {
                    if (!this.data.hasMask) return !1;
                    for(var t1 = 0, e1 = this.data.masksProperties.length; t1 < e1;){
                        if ("n" !== this.data.masksProperties[t1].mode && !1 !== this.data.masksProperties[t1].cl) return !0;
                        t1 += 1;
                    }
                    return !1;
                },
                initExpressions: function() {
                    var t1 = getExpressionInterfaces();
                    if (t1) {
                        var e1 = t1("layer"), i1 = t1("effects"), r1 = t1("shape"), a1 = t1("text"), s1 = t1("comp");
                        this.layerInterface = e1(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
                        var n1 = i1.createEffectsInterface(this, this.layerInterface);
                        this.layerInterface.registerEffectsInterface(n1), 0 === this.data.ty || this.data.xt ? this.compInterface = s1(this) : 4 === this.data.ty ? (this.layerInterface.shapeInterface = r1(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : 5 === this.data.ty && (this.layerInterface.textInterface = a1(this), this.layerInterface.text = this.layerInterface.textInterface);
                    }
                },
                setBlendMode: function() {
                    var t1 = getBlendMode(this.data.bm);
                    (this.baseElement || this.layerElement).style["mix-blend-mode"] = t1;
                },
                initBaseData: function(t1, e1, i1) {
                    this.globalData = e1, this.comp = i1, this.data = t1, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
                },
                getType: function() {
                    return this.type;
                },
                sourceRectAtTime: function() {}
            }, FrameElement.prototype = {
                initFrame: function() {
                    this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
                },
                prepareProperties: function(t1, e1) {
                    var i1, r1 = this.dynamicProperties.length;
                    for(i1 = 0; i1 < r1; i1 += 1)(e1 || this._isParent && "transform" === this.dynamicProperties[i1].propType) && (this.dynamicProperties[i1].getValue(), this.dynamicProperties[i1]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
                },
                addDynamicProperty: function(t1) {
                    -1 === this.dynamicProperties.indexOf(t1) && this.dynamicProperties.push(t1);
                }
            }, FootageElement.prototype.prepareFrame = function() {}, extendPrototype([
                RenderableElement,
                BaseElement,
                FrameElement
            ], FootageElement), FootageElement.prototype.getBaseElement = function() {
                return null;
            }, FootageElement.prototype.renderFrame = function() {}, FootageElement.prototype.destroy = function() {}, FootageElement.prototype.initExpressions = function() {
                var t1 = getExpressionInterfaces();
                if (t1) {
                    var e1 = t1("footage");
                    this.layerInterface = e1(this);
                }
            }, FootageElement.prototype.getFootageData = function() {
                return this.footageData;
            }, AudioElement.prototype.prepareFrame = function(t1) {
                if (this.prepareRenderableFrame(t1, !0), this.prepareProperties(t1, !0), this.tm._placeholder) this._currentTime = t1 / this.data.sr;
                else {
                    var e1 = this.tm.v;
                    this._currentTime = e1;
                }
                this._volume = this.lv.v[0];
                var i1 = this._volume * this._volumeMultiplier;
                this._previousVolume !== i1 && (this._previousVolume = i1, this.audio.volume(i1));
            }, extendPrototype([
                RenderableElement,
                BaseElement,
                FrameElement
            ], AudioElement), AudioElement.prototype.renderFrame = function() {
                this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > .1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
            }, AudioElement.prototype.show = function() {}, AudioElement.prototype.hide = function() {
                this.audio.pause(), this._isPlaying = !1;
            }, AudioElement.prototype.pause = function() {
                this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
            }, AudioElement.prototype.resume = function() {
                this._canPlay = !0;
            }, AudioElement.prototype.setRate = function(t1) {
                this.audio.rate(t1);
            }, AudioElement.prototype.volume = function(t1) {
                this._volumeMultiplier = t1, this._previousVolume = t1 * this._volume, this.audio.volume(this._previousVolume);
            }, AudioElement.prototype.getBaseElement = function() {
                return null;
            }, AudioElement.prototype.destroy = function() {}, AudioElement.prototype.sourceRectAtTime = function() {}, AudioElement.prototype.initExpressions = function() {}, BaseRenderer.prototype.checkLayers = function(t1) {
                var e1, i1, r1 = this.layers.length;
                for(this.completeLayers = !0, e1 = r1 - 1; e1 >= 0; e1 -= 1)this.elements[e1] || (i1 = this.layers[e1]).ip - i1.st <= t1 - this.layers[e1].st && i1.op - i1.st > t1 - this.layers[e1].st && this.buildItem(e1), this.completeLayers = !!this.elements[e1] && this.completeLayers;
                this.checkPendingElements();
            }, BaseRenderer.prototype.createItem = function(t1) {
                switch(t1.ty){
                    case 2:
                        return this.createImage(t1);
                    case 0:
                        return this.createComp(t1);
                    case 1:
                        return this.createSolid(t1);
                    case 3:
                    default:
                        return this.createNull(t1);
                    case 4:
                        return this.createShape(t1);
                    case 5:
                        return this.createText(t1);
                    case 6:
                        return this.createAudio(t1);
                    case 13:
                        return this.createCamera(t1);
                    case 15:
                        return this.createFootage(t1);
                }
            }, BaseRenderer.prototype.createCamera = function() {
                throw new Error("You're using a 3d camera. Try the html renderer.");
            }, BaseRenderer.prototype.createAudio = function(t1) {
                return new AudioElement(t1, this.globalData, this);
            }, BaseRenderer.prototype.createFootage = function(t1) {
                return new FootageElement(t1, this.globalData, this);
            }, BaseRenderer.prototype.buildAllItems = function() {
                var t1, e1 = this.layers.length;
                for(t1 = 0; t1 < e1; t1 += 1)this.buildItem(t1);
                this.checkPendingElements();
            }, BaseRenderer.prototype.includeLayers = function(t1) {
                var e1;
                this.completeLayers = !1;
                var i1, r1 = t1.length, a1 = this.layers.length;
                for(e1 = 0; e1 < r1; e1 += 1)for(i1 = 0; i1 < a1;){
                    if (this.layers[i1].id === t1[e1].id) {
                        this.layers[i1] = t1[e1];
                        break;
                    }
                    i1 += 1;
                }
            }, BaseRenderer.prototype.setProjectInterface = function(t1) {
                this.globalData.projectInterface = t1;
            }, BaseRenderer.prototype.initItems = function() {
                this.globalData.progressiveLoad || this.buildAllItems();
            }, BaseRenderer.prototype.buildElementParenting = function(t1, e1, i1) {
                for(var r1 = this.elements, a1 = this.layers, s1 = 0, n1 = a1.length; s1 < n1;)a1[s1].ind == e1 && (r1[s1] && !0 !== r1[s1] ? (i1.push(r1[s1]), r1[s1].setAsParent(), void 0 !== a1[s1].parent ? this.buildElementParenting(t1, a1[s1].parent, i1) : t1.setHierarchy(i1)) : (this.buildItem(s1), this.addPendingElement(t1))), s1 += 1;
            }, BaseRenderer.prototype.addPendingElement = function(t1) {
                this.pendingElements.push(t1);
            }, BaseRenderer.prototype.searchExtraCompositions = function(t1) {
                var e1, i1 = t1.length;
                for(e1 = 0; e1 < i1; e1 += 1)if (t1[e1].xt) {
                    var r1 = this.createComp(t1[e1]);
                    r1.initExpressions(), this.globalData.projectInterface.registerComposition(r1);
                }
            }, BaseRenderer.prototype.getElementByPath = function(t1) {
                var e1, i1 = t1.shift();
                if ("number" == typeof i1) e1 = this.elements[i1];
                else {
                    var r1, a1 = this.elements.length;
                    for(r1 = 0; r1 < a1; r1 += 1)if (this.elements[r1].data.nm === i1) {
                        e1 = this.elements[r1];
                        break;
                    }
                }
                return 0 === t1.length ? e1 : e1.getElementByPath(t1);
            }, BaseRenderer.prototype.setupGlobalData = function(t1, e1) {
                this.globalData.fontManager = new FontManager, this.globalData.fontManager.addChars(t1.chars), this.globalData.fontManager.addFonts(t1.fonts, e1), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = t1.fr, this.globalData.nm = t1.nm, this.globalData.compSize = {
                    w: t1.w,
                    h: t1.h
                };
            }, TransformElement.prototype = {
                initTransform: function() {
                    this.finalTransform = {
                        mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                            o: 0
                        },
                        _matMdf: !1,
                        _opMdf: !1,
                        mat: new Matrix
                    }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
                },
                renderTransform: function() {
                    if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
                        var t1, e1 = this.finalTransform.mat, i1 = 0, r1 = this.hierarchy.length;
                        if (!this.finalTransform._matMdf) for(; i1 < r1;){
                            if (this.hierarchy[i1].finalTransform.mProp._mdf) {
                                this.finalTransform._matMdf = !0;
                                break;
                            }
                            i1 += 1;
                        }
                        if (this.finalTransform._matMdf) for(t1 = this.finalTransform.mProp.v.props, e1.cloneFromProps(t1), i1 = 0; i1 < r1; i1 += 1)t1 = this.hierarchy[i1].finalTransform.mProp.v.props, e1.transform(t1[0], t1[1], t1[2], t1[3], t1[4], t1[5], t1[6], t1[7], t1[8], t1[9], t1[10], t1[11], t1[12], t1[13], t1[14], t1[15]);
                    }
                },
                globalToLocal: function(t1) {
                    var e1 = [];
                    e1.push(this.finalTransform);
                    for(var i1, r1 = !0, a1 = this.comp; r1;)a1.finalTransform ? (a1.data.hasMask && e1.splice(0, 0, a1.finalTransform), a1 = a1.comp) : r1 = !1;
                    var s1, n1 = e1.length;
                    for(i1 = 0; i1 < n1; i1 += 1)s1 = e1[i1].mat.applyToPointArray(0, 0, 0), t1 = [
                        t1[0] - s1[0],
                        t1[1] - s1[1],
                        0
                    ];
                    return t1;
                },
                mHelper: new Matrix
            }, MaskElement.prototype.getMaskProperty = function(t1) {
                return this.viewData[t1].prop;
            }, MaskElement.prototype.renderFrame = function(t1) {
                var e1, i1 = this.element.finalTransform.mat, r1 = this.masksProperties.length;
                for(e1 = 0; e1 < r1; e1 += 1)if ((this.viewData[e1].prop._mdf || t1) && this.drawPath(this.masksProperties[e1], this.viewData[e1].prop.v, this.viewData[e1]), (this.viewData[e1].op._mdf || t1) && this.viewData[e1].elem.setAttribute("fill-opacity", this.viewData[e1].op.v), "n" !== this.masksProperties[e1].mode && (this.viewData[e1].invRect && (this.element.finalTransform.mProp._mdf || t1) && this.viewData[e1].invRect.setAttribute("transform", i1.getInverseMatrix().to2dCSS()), this.storedData[e1].x && (this.storedData[e1].x._mdf || t1))) {
                    var a1 = this.storedData[e1].expan;
                    this.storedData[e1].x.v < 0 ? ("erode" !== this.storedData[e1].lastOperator && (this.storedData[e1].lastOperator = "erode", this.storedData[e1].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[e1].filterId + ")")), a1.setAttribute("radius", -this.storedData[e1].x.v)) : ("dilate" !== this.storedData[e1].lastOperator && (this.storedData[e1].lastOperator = "dilate", this.storedData[e1].elem.setAttribute("filter", null)), this.storedData[e1].elem.setAttribute("stroke-width", 2 * this.storedData[e1].x.v));
                }
            }, MaskElement.prototype.getMaskelement = function() {
                return this.maskElement;
            }, MaskElement.prototype.createLayerSolidPath = function() {
                var t1 = "M0,0 ";
                return t1 += " h" + this.globalData.compSize.w, t1 += " v" + this.globalData.compSize.h, t1 += " h-" + this.globalData.compSize.w, t1 += " v-" + this.globalData.compSize.h + " ";
            }, MaskElement.prototype.drawPath = function(t1, e1, i1) {
                var r1, a1, s1 = " M" + e1.v[0][0] + "," + e1.v[0][1];
                for(a1 = e1._length, r1 = 1; r1 < a1; r1 += 1)s1 += " C" + e1.o[r1 - 1][0] + "," + e1.o[r1 - 1][1] + " " + e1.i[r1][0] + "," + e1.i[r1][1] + " " + e1.v[r1][0] + "," + e1.v[r1][1];
                if (e1.c && a1 > 1 && (s1 += " C" + e1.o[r1 - 1][0] + "," + e1.o[r1 - 1][1] + " " + e1.i[0][0] + "," + e1.i[0][1] + " " + e1.v[0][0] + "," + e1.v[0][1]), i1.lastPath !== s1) {
                    var n1 = "";
                    i1.elem && (e1.c && (n1 = t1.inv ? this.solidPath + s1 : s1), i1.elem.setAttribute("d", n1)), i1.lastPath = s1;
                }
            }, MaskElement.prototype.destroy = function() {
                this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
            };
            var filtersFactory = function() {
                var t1 = {
                    createFilter: function(t1, e1) {
                        var i1 = createNS("filter");
                        return i1.setAttribute("id", t1), !0 !== e1 && (i1.setAttribute("filterUnits", "objectBoundingBox"), i1.setAttribute("x", "0%"), i1.setAttribute("y", "0%"), i1.setAttribute("width", "100%"), i1.setAttribute("height", "100%")), i1;
                    },
                    createAlphaToLuminanceFilter: function() {
                        var t1 = createNS("feColorMatrix");
                        return t1.setAttribute("type", "matrix"), t1.setAttribute("color-interpolation-filters", "sRGB"), t1.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), t1;
                    }
                };
                return t1;
            }(), featureSupport = function() {
                var t1 = {
                    maskType: !0
                };
                return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (t1.maskType = !1), t1;
            }(), registeredEffects = {}, idPrefix = "filter_result_";
            function SVGEffects(t1) {
                var e1, i1, r1 = "SourceGraphic", a1 = t1.data.ef ? t1.data.ef.length : 0, s1 = createElementID(), n1 = filtersFactory.createFilter(s1, !0), o1 = 0;
                for(this.filters = [], e1 = 0; e1 < a1; e1 += 1){
                    i1 = null;
                    var h1 = t1.data.ef[e1].ty;
                    registeredEffects[h1] && (i1 = new registeredEffects[h1].effect(n1, t1.effectsManager.effectElements[e1], t1, idPrefix + o1, r1), r1 = idPrefix + o1, registeredEffects[h1].countsAsEffect && (o1 += 1)), i1 && this.filters.push(i1);
                }
                o1 && (t1.globalData.defs.appendChild(n1), t1.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + s1 + ")")), this.filters.length && t1.addRenderableComponent(this);
            }
            function registerEffect(t1, e1, i1) {
                registeredEffects[t1] = {
                    effect: e1,
                    countsAsEffect: i1
                };
            }
            function SVGBaseElement() {}
            function HierarchyElement() {}
            function RenderableDOMElement() {}
            function IImageElement(t1, e1, i1) {
                this.assetData = e1.getAssetData(t1.refId), this.initElement(t1, e1, i1), this.sourceRect = {
                    top: 0,
                    left: 0,
                    width: this.assetData.w,
                    height: this.assetData.h
                };
            }
            function ProcessedElement(t1, e1) {
                this.elem = t1, this.pos = e1;
            }
            function IShapeElement() {}
            SVGEffects.prototype.renderFrame = function(t1) {
                var e1, i1 = this.filters.length;
                for(e1 = 0; e1 < i1; e1 += 1)this.filters[e1].renderFrame(t1);
            }, SVGBaseElement.prototype = {
                initRendererElement: function() {
                    this.layerElement = createNS("g");
                },
                createContainerElements: function() {
                    this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
                    var t1 = null;
                    if (this.data.td) {
                        this.matteMasks = {};
                        var e1 = createNS("symbol");
                        e1.setAttribute("id", this.layerId);
                        var i1 = createNS("g");
                        i1.appendChild(this.layerElement), e1.appendChild(i1), t1 = i1, this.globalData.defs.appendChild(e1);
                    } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), t1 = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
                    if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 === this.data.ty && !this.data.hd) {
                        var r1 = createNS("clipPath"), a1 = createNS("path");
                        a1.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
                        var s1 = createElementID();
                        if (r1.setAttribute("id", s1), r1.appendChild(a1), this.globalData.defs.appendChild(r1), this.checkMasks()) {
                            var n1 = createNS("g");
                            n1.setAttribute("clip-path", "url(" + getLocationHref() + "#" + s1 + ")"), n1.appendChild(this.layerElement), this.transformedElement = n1, t1 ? t1.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
                        } else this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + s1 + ")");
                    }
                    0 !== this.data.bm && this.setBlendMode();
                },
                renderElement: function() {
                    this.finalTransform._matMdf && this.transformedElement.setAttribute("transform", this.finalTransform.mat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.mProp.o.v);
                },
                destroyBaseElement: function() {
                    this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
                },
                getBaseElement: function() {
                    return this.data.hd ? null : this.baseElement;
                },
                createRenderableComponents: function() {
                    this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this);
                },
                getMatte: function(t1) {
                    if (!this.matteMasks[t1]) {
                        var e1, i1, r1, a1, s1 = this.layerId + "_" + t1;
                        if (1 === t1 || 3 === t1) {
                            var n1 = createNS("mask");
                            n1.setAttribute("id", s1), n1.setAttribute("mask-type", 3 === t1 ? "luminance" : "alpha"), (r1 = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), n1.appendChild(r1), this.globalData.defs.appendChild(n1), featureSupport.maskType || 1 !== t1 || (n1.setAttribute("mask-type", "luminance"), e1 = createElementID(), i1 = filtersFactory.createFilter(e1), this.globalData.defs.appendChild(i1), i1.appendChild(filtersFactory.createAlphaToLuminanceFilter()), (a1 = createNS("g")).appendChild(r1), n1.appendChild(a1), a1.setAttribute("filter", "url(" + getLocationHref() + "#" + e1 + ")"));
                        } else if (2 === t1) {
                            var o1 = createNS("mask");
                            o1.setAttribute("id", s1), o1.setAttribute("mask-type", "alpha");
                            var h1 = createNS("g");
                            o1.appendChild(h1), e1 = createElementID(), i1 = filtersFactory.createFilter(e1);
                            var l1 = createNS("feComponentTransfer");
                            l1.setAttribute("in", "SourceGraphic"), i1.appendChild(l1);
                            var p1 = createNS("feFuncA");
                            p1.setAttribute("type", "table"), p1.setAttribute("tableValues", "1.0 0.0"), l1.appendChild(p1), this.globalData.defs.appendChild(i1);
                            var f1 = createNS("rect");
                            f1.setAttribute("width", this.comp.data.w), f1.setAttribute("height", this.comp.data.h), f1.setAttribute("x", "0"), f1.setAttribute("y", "0"), f1.setAttribute("fill", "#ffffff"), f1.setAttribute("opacity", "0"), h1.setAttribute("filter", "url(" + getLocationHref() + "#" + e1 + ")"), h1.appendChild(f1), (r1 = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), h1.appendChild(r1), featureSupport.maskType || (o1.setAttribute("mask-type", "luminance"), i1.appendChild(filtersFactory.createAlphaToLuminanceFilter()), a1 = createNS("g"), h1.appendChild(f1), a1.appendChild(this.layerElement), h1.appendChild(a1)), this.globalData.defs.appendChild(o1);
                        }
                        this.matteMasks[t1] = s1;
                    }
                    return this.matteMasks[t1];
                },
                setMatte: function(t1) {
                    this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + t1 + ")");
                }
            }, HierarchyElement.prototype = {
                initHierarchy: function() {
                    this.hierarchy = [], this._isParent = !1, this.checkParenting();
                },
                setHierarchy: function(t1) {
                    this.hierarchy = t1;
                },
                setAsParent: function() {
                    this._isParent = !0;
                },
                checkParenting: function() {
                    void 0 !== this.data.parent && this.comp.buildElementParenting(this, this.data.parent, []);
                }
            }, extendPrototype([
                RenderableElement,
                createProxyFunction({
                    initElement: function(t1, e1, i1) {
                        this.initFrame(), this.initBaseData(t1, e1, i1), this.initTransform(t1, e1, i1), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
                    },
                    hide: function() {
                        this.hidden || this.isInRange && !this.isTransparent || ((this.baseElement || this.layerElement).style.display = "none", this.hidden = !0);
                    },
                    show: function() {
                        this.isInRange && !this.isTransparent && (this.data.hd || ((this.baseElement || this.layerElement).style.display = "block"), this.hidden = !1, this._isFirstFrame = !0);
                    },
                    renderFrame: function() {
                        this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
                    },
                    renderInnerContent: function() {},
                    prepareFrame: function(t1) {
                        this._mdf = !1, this.prepareRenderableFrame(t1), this.prepareProperties(t1, this.isInRange), this.checkTransparency();
                    },
                    destroy: function() {
                        this.innerElem = null, this.destroyBaseElement();
                    }
                })
            ], RenderableDOMElement), extendPrototype([
                BaseElement,
                TransformElement,
                SVGBaseElement,
                HierarchyElement,
                FrameElement,
                RenderableDOMElement
            ], IImageElement), IImageElement.prototype.createContent = function() {
                var t1 = this.globalData.getAssetsPath(this.assetData);
                this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t1), this.layerElement.appendChild(this.innerElem);
            }, IImageElement.prototype.sourceRectAtTime = function() {
                return this.sourceRect;
            }, IShapeElement.prototype = {
                addShapeToModifiers: function(t1) {
                    var e1, i1 = this.shapeModifiers.length;
                    for(e1 = 0; e1 < i1; e1 += 1)this.shapeModifiers[e1].addShape(t1);
                },
                isShapeInAnimatedModifiers: function(t1) {
                    for(var e1 = this.shapeModifiers.length; 0 < e1;)if (this.shapeModifiers[0].isAnimatedWithShape(t1)) return !0;
                    return !1;
                },
                renderModifiers: function() {
                    if (this.shapeModifiers.length) {
                        var t1, e1 = this.shapes.length;
                        for(t1 = 0; t1 < e1; t1 += 1)this.shapes[t1].sh.reset();
                        for(t1 = (e1 = this.shapeModifiers.length) - 1; t1 >= 0 && !this.shapeModifiers[t1].processShapes(this._isFirstFrame); t1 -= 1);
                    }
                },
                searchProcessedElement: function(t1) {
                    for(var e1 = this.processedElements, i1 = 0, r1 = e1.length; i1 < r1;){
                        if (e1[i1].elem === t1) return e1[i1].pos;
                        i1 += 1;
                    }
                    return 0;
                },
                addProcessedElement: function(t1, e1) {
                    for(var i1 = this.processedElements, r1 = i1.length; r1;)if (i1[r1 -= 1].elem === t1) return void (i1[r1].pos = e1);
                    i1.push(new ProcessedElement(t1, e1));
                },
                prepareFrame: function(t1) {
                    this.prepareRenderableFrame(t1), this.prepareProperties(t1, this.isInRange);
                }
            };
            var lineCapEnum = {
                1: "butt",
                2: "round",
                3: "square"
            }, lineJoinEnum = {
                1: "miter",
                2: "round",
                3: "bevel"
            };
            function SVGShapeData(t1, e1, i1) {
                this.caches = [], this.styles = [], this.transformers = t1, this.lStr = "", this.sh = i1, this.lvl = e1, this._isAnimated = !!i1.k;
                for(var r1 = 0, a1 = t1.length; r1 < a1;){
                    if (t1[r1].mProps.dynamicProperties.length) {
                        this._isAnimated = !0;
                        break;
                    }
                    r1 += 1;
                }
            }
            function SVGStyleData(t1, e1) {
                this.data = t1, this.type = t1.ty, this.d = "", this.lvl = e1, this._mdf = !1, this.closed = !0 === t1.hd, this.pElem = createNS("path"), this.msElem = null;
            }
            function DashProperty(t1, e1, i1, r1) {
                var a1;
                this.elem = t1, this.frameId = -1, this.dataProps = createSizedArray(e1.length), this.renderer = i1, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", e1.length ? e1.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(r1);
                var s1, n1 = e1.length || 0;
                for(a1 = 0; a1 < n1; a1 += 1)s1 = PropertyFactory.getProp(t1, e1[a1].v, 0, 0, this), this.k = s1.k || this.k, this.dataProps[a1] = {
                    n: e1[a1].n,
                    p: s1
                };
                this.k || this.getValue(!0), this._isAnimated = this.k;
            }
            function SVGStrokeStyleData(t1, e1, i1) {
                this.initDynamicPropertyContainer(t1), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t1, e1.o, 0, .01, this), this.w = PropertyFactory.getProp(t1, e1.w, 0, null, this), this.d = new DashProperty(t1, e1.d || {}, "svg", this), this.c = PropertyFactory.getProp(t1, e1.c, 1, 255, this), this.style = i1, this._isAnimated = !!this._isAnimated;
            }
            function SVGFillStyleData(t1, e1, i1) {
                this.initDynamicPropertyContainer(t1), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t1, e1.o, 0, .01, this), this.c = PropertyFactory.getProp(t1, e1.c, 1, 255, this), this.style = i1;
            }
            function SVGNoStyleData(t1, e1, i1) {
                this.initDynamicPropertyContainer(t1), this.getValue = this.iterateDynamicProperties, this.style = i1;
            }
            function GradientProperty(t1, e1, i1) {
                this.data = e1, this.c = createTypedArray("uint8c", 4 * e1.p);
                var r1 = e1.k.k[0].s ? e1.k.k[0].s.length - 4 * e1.p : e1.k.k.length - 4 * e1.p;
                this.o = createTypedArray("float32", r1), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = r1, this.initDynamicPropertyContainer(i1), this.prop = PropertyFactory.getProp(t1, e1.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
            }
            function SVGGradientFillStyleData(t1, e1, i1) {
                this.initDynamicPropertyContainer(t1), this.getValue = this.iterateDynamicProperties, this.initGradientData(t1, e1, i1);
            }
            function SVGGradientStrokeStyleData(t1, e1, i1) {
                this.initDynamicPropertyContainer(t1), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(t1, e1.w, 0, null, this), this.d = new DashProperty(t1, e1.d || {}, "svg", this), this.initGradientData(t1, e1, i1), this._isAnimated = !!this._isAnimated;
            }
            function ShapeGroupData() {
                this.it = [], this.prevViewData = [], this.gr = createNS("g");
            }
            function SVGTransformData(t1, e1, i1) {
                this.transform = {
                    mProps: t1,
                    op: e1,
                    container: i1
                }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
            }
            SVGShapeData.prototype.setAsAnimated = function() {
                this._isAnimated = !0;
            }, SVGStyleData.prototype.reset = function() {
                this.d = "", this._mdf = !1;
            }, DashProperty.prototype.getValue = function(t1) {
                if ((this.elem.globalData.frameId !== this.frameId || t1) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || t1, this._mdf)) {
                    var e1 = 0, i1 = this.dataProps.length;
                    for("svg" === this.renderer && (this.dashStr = ""), e1 = 0; e1 < i1; e1 += 1)"o" !== this.dataProps[e1].n ? "svg" === this.renderer ? this.dashStr += " " + this.dataProps[e1].p.v : this.dashArray[e1] = this.dataProps[e1].p.v : this.dashoffset[0] = this.dataProps[e1].p.v;
                }
            }, extendPrototype([
                DynamicPropertyContainer
            ], DashProperty), extendPrototype([
                DynamicPropertyContainer
            ], SVGStrokeStyleData), extendPrototype([
                DynamicPropertyContainer
            ], SVGFillStyleData), extendPrototype([
                DynamicPropertyContainer
            ], SVGNoStyleData), GradientProperty.prototype.comparePoints = function(t1, e1) {
                for(var i1 = 0, r1 = this.o.length / 2; i1 < r1;){
                    if (Math.abs(t1[4 * i1] - t1[4 * e1 + 2 * i1]) > .01) return !1;
                    i1 += 1;
                }
                return !0;
            }, GradientProperty.prototype.checkCollapsable = function() {
                if (this.o.length / 2 != this.c.length / 4) return !1;
                if (this.data.k.k[0].s) for(var t1 = 0, e1 = this.data.k.k.length; t1 < e1;){
                    if (!this.comparePoints(this.data.k.k[t1].s, this.data.p)) return !1;
                    t1 += 1;
                }
                else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
                return !0;
            }, GradientProperty.prototype.getValue = function(t1) {
                if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || t1) {
                    var e1, i1, r1, a1 = 4 * this.data.p;
                    for(e1 = 0; e1 < a1; e1 += 1)i1 = e1 % 4 == 0 ? 100 : 255, r1 = Math.round(this.prop.v[e1] * i1), this.c[e1] !== r1 && (this.c[e1] = r1, this._cmdf = !t1);
                    if (this.o.length) for(a1 = this.prop.v.length, e1 = 4 * this.data.p; e1 < a1; e1 += 1)i1 = e1 % 2 == 0 ? 100 : 1, r1 = e1 % 2 == 0 ? Math.round(100 * this.prop.v[e1]) : this.prop.v[e1], this.o[e1 - 4 * this.data.p] !== r1 && (this.o[e1 - 4 * this.data.p] = r1, this._omdf = !t1);
                    this._mdf = !t1;
                }
            }, extendPrototype([
                DynamicPropertyContainer
            ], GradientProperty), SVGGradientFillStyleData.prototype.initGradientData = function(t1, e1, i1) {
                this.o = PropertyFactory.getProp(t1, e1.o, 0, .01, this), this.s = PropertyFactory.getProp(t1, e1.s, 1, null, this), this.e = PropertyFactory.getProp(t1, e1.e, 1, null, this), this.h = PropertyFactory.getProp(t1, e1.h || {
                    k: 0
                }, 0, .01, this), this.a = PropertyFactory.getProp(t1, e1.a || {
                    k: 0
                }, 0, degToRads, this), this.g = new GradientProperty(t1, e1.g, this), this.style = i1, this.stops = [], this.setGradientData(i1.pElem, e1), this.setGradientOpacity(e1, i1), this._isAnimated = !!this._isAnimated;
            }, SVGGradientFillStyleData.prototype.setGradientData = function(t1, e1) {
                var i1 = createElementID(), r1 = createNS(1 === e1.t ? "linearGradient" : "radialGradient");
                r1.setAttribute("id", i1), r1.setAttribute("spreadMethod", "pad"), r1.setAttribute("gradientUnits", "userSpaceOnUse");
                var a1, s1, n1, o1 = [];
                for(n1 = 4 * e1.g.p, s1 = 0; s1 < n1; s1 += 4)a1 = createNS("stop"), r1.appendChild(a1), o1.push(a1);
                t1.setAttribute("gf" === e1.ty ? "fill" : "stroke", "url(" + getLocationHref() + "#" + i1 + ")"), this.gf = r1, this.cst = o1;
            }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(t1, e1) {
                if (this.g._hasOpacity && !this.g._collapsable) {
                    var i1, r1, a1, s1 = createNS("mask"), n1 = createNS("path");
                    s1.appendChild(n1);
                    var o1 = createElementID(), h1 = createElementID();
                    s1.setAttribute("id", h1);
                    var l1 = createNS(1 === t1.t ? "linearGradient" : "radialGradient");
                    l1.setAttribute("id", o1), l1.setAttribute("spreadMethod", "pad"), l1.setAttribute("gradientUnits", "userSpaceOnUse"), a1 = t1.g.k.k[0].s ? t1.g.k.k[0].s.length : t1.g.k.k.length;
                    var p1 = this.stops;
                    for(r1 = 4 * t1.g.p; r1 < a1; r1 += 2)(i1 = createNS("stop")).setAttribute("stop-color", "rgb(255,255,255)"), l1.appendChild(i1), p1.push(i1);
                    n1.setAttribute("gf" === t1.ty ? "fill" : "stroke", "url(" + getLocationHref() + "#" + o1 + ")"), "gs" === t1.ty && (n1.setAttribute("stroke-linecap", lineCapEnum[t1.lc || 2]), n1.setAttribute("stroke-linejoin", lineJoinEnum[t1.lj || 2]), 1 === t1.lj && n1.setAttribute("stroke-miterlimit", t1.ml)), this.of = l1, this.ms = s1, this.ost = p1, this.maskId = h1, e1.msElem = n1;
                }
            }, extendPrototype([
                DynamicPropertyContainer
            ], SVGGradientFillStyleData), extendPrototype([
                SVGGradientFillStyleData,
                DynamicPropertyContainer
            ], SVGGradientStrokeStyleData);
            var buildShapeString = function(t1, e1, i1, r1) {
                if (0 === e1) return "";
                var a1, s1 = t1.o, n1 = t1.i, o1 = t1.v, h1 = " M" + r1.applyToPointStringified(o1[0][0], o1[0][1]);
                for(a1 = 1; a1 < e1; a1 += 1)h1 += " C" + r1.applyToPointStringified(s1[a1 - 1][0], s1[a1 - 1][1]) + " " + r1.applyToPointStringified(n1[a1][0], n1[a1][1]) + " " + r1.applyToPointStringified(o1[a1][0], o1[a1][1]);
                return i1 && e1 && (h1 += " C" + r1.applyToPointStringified(s1[a1 - 1][0], s1[a1 - 1][1]) + " " + r1.applyToPointStringified(n1[0][0], n1[0][1]) + " " + r1.applyToPointStringified(o1[0][0], o1[0][1]), h1 += "z"), h1;
            }, SVGElementsRenderer = function() {
                var t1 = new Matrix, e1 = new Matrix;
                function i1(t1, e1, i1) {
                    (i1 || e1.transform.op._mdf) && e1.transform.container.setAttribute("opacity", e1.transform.op.v), (i1 || e1.transform.mProps._mdf) && e1.transform.container.setAttribute("transform", e1.transform.mProps.v.to2dCSS());
                }
                function r1() {}
                function a1(i1, r1, a1) {
                    var s1, n1, o1, h1, l1, p1, f1, d1, c1, m1, u1, y1 = r1.styles.length, g1 = r1.lvl;
                    for(p1 = 0; p1 < y1; p1 += 1){
                        if (h1 = r1.sh._mdf || a1, r1.styles[p1].lvl < g1) {
                            for(d1 = e1.reset(), m1 = g1 - r1.styles[p1].lvl, u1 = r1.transformers.length - 1; !h1 && m1 > 0;)h1 = r1.transformers[u1].mProps._mdf || h1, m1 -= 1, u1 -= 1;
                            if (h1) for(m1 = g1 - r1.styles[p1].lvl, u1 = r1.transformers.length - 1; m1 > 0;)c1 = r1.transformers[u1].mProps.v.props, d1.transform(c1[0], c1[1], c1[2], c1[3], c1[4], c1[5], c1[6], c1[7], c1[8], c1[9], c1[10], c1[11], c1[12], c1[13], c1[14], c1[15]), m1 -= 1, u1 -= 1;
                        } else d1 = t1;
                        if (n1 = (f1 = r1.sh.paths)._length, h1) {
                            for(o1 = "", s1 = 0; s1 < n1; s1 += 1)(l1 = f1.shapes[s1]) && l1._length && (o1 += buildShapeString(l1, l1._length, l1.c, d1));
                            r1.caches[p1] = o1;
                        } else o1 = r1.caches[p1];
                        r1.styles[p1].d += !0 === i1.hd ? "" : o1, r1.styles[p1]._mdf = h1 || r1.styles[p1]._mdf;
                    }
                }
                function s1(t1, e1, i1) {
                    var r1 = e1.style;
                    (e1.c._mdf || i1) && r1.pElem.setAttribute("fill", "rgb(" + bmFloor(e1.c.v[0]) + "," + bmFloor(e1.c.v[1]) + "," + bmFloor(e1.c.v[2]) + ")"), (e1.o._mdf || i1) && r1.pElem.setAttribute("fill-opacity", e1.o.v);
                }
                function n1(t1, e1, i1) {
                    o1(t1, e1, i1), h1(0, e1, i1);
                }
                function o1(t1, e1, i1) {
                    var r1, a1, s1, n1, o1, h1 = e1.gf, l1 = e1.g._hasOpacity, p1 = e1.s.v, f1 = e1.e.v;
                    if (e1.o._mdf || i1) {
                        var d1 = "gf" === t1.ty ? "fill-opacity" : "stroke-opacity";
                        e1.style.pElem.setAttribute(d1, e1.o.v);
                    }
                    if (e1.s._mdf || i1) {
                        var c1 = 1 === t1.t ? "x1" : "cx", m1 = "x1" === c1 ? "y1" : "cy";
                        h1.setAttribute(c1, p1[0]), h1.setAttribute(m1, p1[1]), l1 && !e1.g._collapsable && (e1.of.setAttribute(c1, p1[0]), e1.of.setAttribute(m1, p1[1]));
                    }
                    if (e1.g._cmdf || i1) {
                        r1 = e1.cst;
                        var u1 = e1.g.c;
                        for(s1 = r1.length, a1 = 0; a1 < s1; a1 += 1)(n1 = r1[a1]).setAttribute("offset", u1[4 * a1] + "%"), n1.setAttribute("stop-color", "rgb(" + u1[4 * a1 + 1] + "," + u1[4 * a1 + 2] + "," + u1[4 * a1 + 3] + ")");
                    }
                    if (l1 && (e1.g._omdf || i1)) {
                        var y1 = e1.g.o;
                        for(s1 = (r1 = e1.g._collapsable ? e1.cst : e1.ost).length, a1 = 0; a1 < s1; a1 += 1)n1 = r1[a1], e1.g._collapsable || n1.setAttribute("offset", y1[2 * a1] + "%"), n1.setAttribute("stop-opacity", y1[2 * a1 + 1]);
                    }
                    if (1 === t1.t) (e1.e._mdf || i1) && (h1.setAttribute("x2", f1[0]), h1.setAttribute("y2", f1[1]), l1 && !e1.g._collapsable && (e1.of.setAttribute("x2", f1[0]), e1.of.setAttribute("y2", f1[1])));
                    else if ((e1.s._mdf || e1.e._mdf || i1) && (o1 = Math.sqrt(Math.pow(p1[0] - f1[0], 2) + Math.pow(p1[1] - f1[1], 2)), h1.setAttribute("r", o1), l1 && !e1.g._collapsable && e1.of.setAttribute("r", o1)), e1.e._mdf || e1.h._mdf || e1.a._mdf || i1) {
                        o1 || (o1 = Math.sqrt(Math.pow(p1[0] - f1[0], 2) + Math.pow(p1[1] - f1[1], 2)));
                        var g1 = Math.atan2(f1[1] - p1[1], f1[0] - p1[0]), _1 = e1.h.v;
                        _1 >= 1 ? _1 = .99 : _1 <= -1 && (_1 = -0.99);
                        var v1 = o1 * _1, b1 = Math.cos(g1 + e1.a.v) * v1 + p1[0], E1 = Math.sin(g1 + e1.a.v) * v1 + p1[1];
                        h1.setAttribute("fx", b1), h1.setAttribute("fy", E1), l1 && !e1.g._collapsable && (e1.of.setAttribute("fx", b1), e1.of.setAttribute("fy", E1));
                    }
                }
                function h1(t1, e1, i1) {
                    var r1 = e1.style, a1 = e1.d;
                    a1 && (a1._mdf || i1) && a1.dashStr && (r1.pElem.setAttribute("stroke-dasharray", a1.dashStr), r1.pElem.setAttribute("stroke-dashoffset", a1.dashoffset[0])), e1.c && (e1.c._mdf || i1) && r1.pElem.setAttribute("stroke", "rgb(" + bmFloor(e1.c.v[0]) + "," + bmFloor(e1.c.v[1]) + "," + bmFloor(e1.c.v[2]) + ")"), (e1.o._mdf || i1) && r1.pElem.setAttribute("stroke-opacity", e1.o.v), (e1.w._mdf || i1) && (r1.pElem.setAttribute("stroke-width", e1.w.v), r1.msElem && r1.msElem.setAttribute("stroke-width", e1.w.v));
                }
                return {
                    createRenderFunction: function(t1) {
                        switch(t1.ty){
                            case "fl":
                                return s1;
                            case "gf":
                                return o1;
                            case "gs":
                                return n1;
                            case "st":
                                return h1;
                            case "sh":
                            case "el":
                            case "rc":
                            case "sr":
                                return a1;
                            case "tr":
                                return i1;
                            case "no":
                                return r1;
                            default:
                                return null;
                        }
                    }
                };
            }();
            function SVGShapeElement(t1, e1, i1) {
                this.shapes = [], this.shapesData = t1.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(t1, e1, i1), this.prevViewData = [];
            }
            function LetterProps(t1, e1, i1, r1, a1, s1) {
                this.o = t1, this.sw = e1, this.sc = i1, this.fc = r1, this.m = a1, this.p = s1, this._mdf = {
                    o: !0,
                    sw: !!e1,
                    sc: !!i1,
                    fc: !!r1,
                    m: !0,
                    p: !0
                };
            }
            function TextProperty(t1, e1) {
                this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, this.data = e1, this.elem = t1, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
                    ascent: 0,
                    boxWidth: this.defaultBoxWidth,
                    f: "",
                    fStyle: "",
                    fWeight: "",
                    fc: "",
                    j: "",
                    justifyOffset: "",
                    l: [],
                    lh: 0,
                    lineWidths: [],
                    ls: "",
                    of: "",
                    s: "",
                    sc: "",
                    sw: 0,
                    t: 0,
                    tr: 0,
                    sz: 0,
                    ps: null,
                    fillColorAnim: !1,
                    strokeColorAnim: !1,
                    strokeWidthAnim: !1,
                    yOffset: 0,
                    finalSize: 0,
                    finalText: [],
                    finalLineHeight: 0,
                    __complete: !1
                }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
            }
            extendPrototype([
                BaseElement,
                TransformElement,
                SVGBaseElement,
                IShapeElement,
                HierarchyElement,
                FrameElement,
                RenderableDOMElement
            ], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {}, SVGShapeElement.prototype.identityMatrix = new Matrix, SVGShapeElement.prototype.buildExpressionInterface = function() {}, SVGShapeElement.prototype.createContent = function() {
                this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
            }, SVGShapeElement.prototype.filterUniqueShapes = function() {
                var t1, e1, i1, r1, a1 = this.shapes.length, s1 = this.stylesList.length, n1 = [], o1 = !1;
                for(i1 = 0; i1 < s1; i1 += 1){
                    for(r1 = this.stylesList[i1], o1 = !1, n1.length = 0, t1 = 0; t1 < a1; t1 += 1)-1 !== (e1 = this.shapes[t1]).styles.indexOf(r1) && (n1.push(e1), o1 = e1._isAnimated || o1);
                    n1.length > 1 && o1 && this.setShapesAsAnimated(n1);
                }
            }, SVGShapeElement.prototype.setShapesAsAnimated = function(t1) {
                var e1, i1 = t1.length;
                for(e1 = 0; e1 < i1; e1 += 1)t1[e1].setAsAnimated();
            }, SVGShapeElement.prototype.createStyleElement = function(t1, e1) {
                var i1, r1 = new SVGStyleData(t1, e1), a1 = r1.pElem;
                return "st" === t1.ty ? i1 = new SVGStrokeStyleData(this, t1, r1) : "fl" === t1.ty ? i1 = new SVGFillStyleData(this, t1, r1) : "gf" === t1.ty || "gs" === t1.ty ? (i1 = new ("gf" === t1.ty ? SVGGradientFillStyleData : SVGGradientStrokeStyleData)(this, t1, r1), this.globalData.defs.appendChild(i1.gf), i1.maskId && (this.globalData.defs.appendChild(i1.ms), this.globalData.defs.appendChild(i1.of), a1.setAttribute("mask", "url(" + getLocationHref() + "#" + i1.maskId + ")"))) : "no" === t1.ty && (i1 = new SVGNoStyleData(this, t1, r1)), "st" !== t1.ty && "gs" !== t1.ty || (a1.setAttribute("stroke-linecap", lineCapEnum[t1.lc || 2]), a1.setAttribute("stroke-linejoin", lineJoinEnum[t1.lj || 2]), a1.setAttribute("fill-opacity", "0"), 1 === t1.lj && a1.setAttribute("stroke-miterlimit", t1.ml)), 2 === t1.r && a1.setAttribute("fill-rule", "evenodd"), t1.ln && a1.setAttribute("id", t1.ln), t1.cl && a1.setAttribute("class", t1.cl), t1.bm && (a1.style["mix-blend-mode"] = getBlendMode(t1.bm)), this.stylesList.push(r1), this.addToAnimatedContents(t1, i1), i1;
            }, SVGShapeElement.prototype.createGroupElement = function(t1) {
                var e1 = new ShapeGroupData;
                return t1.ln && e1.gr.setAttribute("id", t1.ln), t1.cl && e1.gr.setAttribute("class", t1.cl), t1.bm && (e1.gr.style["mix-blend-mode"] = getBlendMode(t1.bm)), e1;
            }, SVGShapeElement.prototype.createTransformElement = function(t1, e1) {
                var i1 = TransformPropertyFactory.getTransformProperty(this, t1, this), r1 = new SVGTransformData(i1, i1.o, e1);
                return this.addToAnimatedContents(t1, r1), r1;
            }, SVGShapeElement.prototype.createShapeElement = function(t1, e1, i1) {
                var r1 = 4;
                "rc" === t1.ty ? r1 = 5 : "el" === t1.ty ? r1 = 6 : "sr" === t1.ty && (r1 = 7);
                var a1 = new SVGShapeData(e1, i1, ShapePropertyFactory.getShapeProp(this, t1, r1, this));
                return this.shapes.push(a1), this.addShapeToModifiers(a1), this.addToAnimatedContents(t1, a1), a1;
            }, SVGShapeElement.prototype.addToAnimatedContents = function(t1, e1) {
                for(var i1 = 0, r1 = this.animatedContents.length; i1 < r1;){
                    if (this.animatedContents[i1].element === e1) return;
                    i1 += 1;
                }
                this.animatedContents.push({
                    fn: SVGElementsRenderer.createRenderFunction(t1),
                    element: e1,
                    data: t1
                });
            }, SVGShapeElement.prototype.setElementStyles = function(t1) {
                var e1, i1 = t1.styles, r1 = this.stylesList.length;
                for(e1 = 0; e1 < r1; e1 += 1)this.stylesList[e1].closed || i1.push(this.stylesList[e1]);
            }, SVGShapeElement.prototype.reloadShapes = function() {
                var t1;
                this._isFirstFrame = !0;
                var e1 = this.itemsData.length;
                for(t1 = 0; t1 < e1; t1 += 1)this.prevViewData[t1] = this.itemsData[t1];
                for(this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), e1 = this.dynamicProperties.length, t1 = 0; t1 < e1; t1 += 1)this.dynamicProperties[t1].getValue();
                this.renderModifiers();
            }, SVGShapeElement.prototype.searchShapes = function(t1, e1, i1, r1, a1, s1, n1) {
                var o1, h1, l1, p1, f1, d1, c1 = [].concat(s1), m1 = t1.length - 1, u1 = [], y1 = [];
                for(o1 = m1; o1 >= 0; o1 -= 1){
                    if ((d1 = this.searchProcessedElement(t1[o1])) ? e1[o1] = i1[d1 - 1] : t1[o1]._render = n1, "fl" === t1[o1].ty || "st" === t1[o1].ty || "gf" === t1[o1].ty || "gs" === t1[o1].ty || "no" === t1[o1].ty) d1 ? e1[o1].style.closed = !1 : e1[o1] = this.createStyleElement(t1[o1], a1), t1[o1]._render && e1[o1].style.pElem.parentNode !== r1 && r1.appendChild(e1[o1].style.pElem), u1.push(e1[o1].style);
                    else if ("gr" === t1[o1].ty) {
                        if (d1) for(l1 = e1[o1].it.length, h1 = 0; h1 < l1; h1 += 1)e1[o1].prevViewData[h1] = e1[o1].it[h1];
                        else e1[o1] = this.createGroupElement(t1[o1]);
                        this.searchShapes(t1[o1].it, e1[o1].it, e1[o1].prevViewData, e1[o1].gr, a1 + 1, c1, n1), t1[o1]._render && e1[o1].gr.parentNode !== r1 && r1.appendChild(e1[o1].gr);
                    } else "tr" === t1[o1].ty ? (d1 || (e1[o1] = this.createTransformElement(t1[o1], r1)), p1 = e1[o1].transform, c1.push(p1)) : "sh" === t1[o1].ty || "rc" === t1[o1].ty || "el" === t1[o1].ty || "sr" === t1[o1].ty ? (d1 || (e1[o1] = this.createShapeElement(t1[o1], c1, a1)), this.setElementStyles(e1[o1])) : "tm" === t1[o1].ty || "rd" === t1[o1].ty || "ms" === t1[o1].ty || "pb" === t1[o1].ty || "zz" === t1[o1].ty || "op" === t1[o1].ty ? (d1 ? (f1 = e1[o1]).closed = !1 : ((f1 = ShapeModifiers.getModifier(t1[o1].ty)).init(this, t1[o1]), e1[o1] = f1, this.shapeModifiers.push(f1)), y1.push(f1)) : "rp" === t1[o1].ty && (d1 ? (f1 = e1[o1]).closed = !0 : (f1 = ShapeModifiers.getModifier(t1[o1].ty), e1[o1] = f1, f1.init(this, t1, o1, e1), this.shapeModifiers.push(f1), n1 = !1), y1.push(f1));
                    this.addProcessedElement(t1[o1], o1 + 1);
                }
                for(m1 = u1.length, o1 = 0; o1 < m1; o1 += 1)u1[o1].closed = !0;
                for(m1 = y1.length, o1 = 0; o1 < m1; o1 += 1)y1[o1].closed = !0;
            }, SVGShapeElement.prototype.renderInnerContent = function() {
                var t1;
                this.renderModifiers();
                var e1 = this.stylesList.length;
                for(t1 = 0; t1 < e1; t1 += 1)this.stylesList[t1].reset();
                for(this.renderShape(), t1 = 0; t1 < e1; t1 += 1)(this.stylesList[t1]._mdf || this._isFirstFrame) && (this.stylesList[t1].msElem && (this.stylesList[t1].msElem.setAttribute("d", this.stylesList[t1].d), this.stylesList[t1].d = "M0 0" + this.stylesList[t1].d), this.stylesList[t1].pElem.setAttribute("d", this.stylesList[t1].d || "M0 0"));
            }, SVGShapeElement.prototype.renderShape = function() {
                var t1, e1, i1 = this.animatedContents.length;
                for(t1 = 0; t1 < i1; t1 += 1)e1 = this.animatedContents[t1], (this._isFirstFrame || e1.element._isAnimated) && !0 !== e1.data && e1.fn(e1.data, e1.element, this._isFirstFrame);
            }, SVGShapeElement.prototype.destroy = function() {
                this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
            }, LetterProps.prototype.update = function(t1, e1, i1, r1, a1, s1) {
                this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
                var n1 = !1;
                return this.o !== t1 && (this.o = t1, this._mdf.o = !0, n1 = !0), this.sw !== e1 && (this.sw = e1, this._mdf.sw = !0, n1 = !0), this.sc !== i1 && (this.sc = i1, this._mdf.sc = !0, n1 = !0), this.fc !== r1 && (this.fc = r1, this._mdf.fc = !0, n1 = !0), this.m !== a1 && (this.m = a1, this._mdf.m = !0, n1 = !0), !s1.length || this.p[0] === s1[0] && this.p[1] === s1[1] && this.p[4] === s1[4] && this.p[5] === s1[5] && this.p[12] === s1[12] && this.p[13] === s1[13] || (this.p = s1, this._mdf.p = !0, n1 = !0), n1;
            }, TextProperty.prototype.defaultBoxWidth = [
                0,
                0
            ], TextProperty.prototype.copyData = function(t1, e1) {
                for(var i1 in e1)Object.prototype.hasOwnProperty.call(e1, i1) && (t1[i1] = e1[i1]);
                return t1;
            }, TextProperty.prototype.setCurrentData = function(t1) {
                t1.__complete || this.completeTextData(t1), this.currentData = t1, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
            }, TextProperty.prototype.searchProperty = function() {
                return this.searchKeyframes();
            }, TextProperty.prototype.searchKeyframes = function() {
                return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
            }, TextProperty.prototype.addEffect = function(t1) {
                this.effectsSequence.push(t1), this.elem.addDynamicProperty(this);
            }, TextProperty.prototype.getValue = function(t1) {
                if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length || t1) {
                    this.currentData.t = this.data.d.k[this.keysIndex].s.t;
                    var e1 = this.currentData, i1 = this.keysIndex;
                    if (this.lock) this.setCurrentData(this.currentData);
                    else {
                        var r1;
                        this.lock = !0, this._mdf = !1;
                        var a1 = this.effectsSequence.length, s1 = t1 || this.data.d.k[this.keysIndex].s;
                        for(r1 = 0; r1 < a1; r1 += 1)s1 = i1 !== this.keysIndex ? this.effectsSequence[r1](s1, s1.t) : this.effectsSequence[r1](this.currentData, s1.t);
                        e1 !== s1 && this.setCurrentData(s1), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
                    }
                }
            }, TextProperty.prototype.getKeyframeValue = function() {
                for(var t1 = this.data.d.k, e1 = this.elem.comp.renderedFrame, i1 = 0, r1 = t1.length; i1 <= r1 - 1 && !(i1 === r1 - 1 || t1[i1 + 1].t > e1);)i1 += 1;
                return this.keysIndex !== i1 && (this.keysIndex = i1), this.data.d.k[this.keysIndex].s;
            }, TextProperty.prototype.buildFinalText = function(t1) {
                for(var e1, i1, r1 = [], a1 = 0, s1 = t1.length, n1 = !1; a1 < s1;)e1 = t1.charCodeAt(a1), FontManager.isCombinedCharacter(e1) ? r1[r1.length - 1] += t1.charAt(a1) : e1 >= 55296 && e1 <= 56319 ? (i1 = t1.charCodeAt(a1 + 1)) >= 56320 && i1 <= 57343 ? (n1 || FontManager.isModifier(e1, i1) ? (r1[r1.length - 1] += t1.substr(a1, 2), n1 = !1) : r1.push(t1.substr(a1, 2)), a1 += 1) : r1.push(t1.charAt(a1)) : e1 > 56319 ? (i1 = t1.charCodeAt(a1 + 1), FontManager.isZeroWidthJoiner(e1, i1) ? (n1 = !0, r1[r1.length - 1] += t1.substr(a1, 2), a1 += 1) : r1.push(t1.charAt(a1))) : FontManager.isZeroWidthJoiner(e1) ? (r1[r1.length - 1] += t1.charAt(a1), n1 = !0) : r1.push(t1.charAt(a1)), a1 += 1;
                return r1;
            }, TextProperty.prototype.completeTextData = function(t1) {
                t1.__complete = !0;
                var e1, i1, r1, a1, s1, n1, o1, h1 = this.elem.globalData.fontManager, l1 = this.data, p1 = [], f1 = 0, d1 = l1.m.g, c1 = 0, m1 = 0, u1 = 0, y1 = [], g1 = 0, _1 = 0, v1 = h1.getFontByName(t1.f), b1 = 0, E1 = getFontProperties(v1);
                t1.fWeight = E1.weight, t1.fStyle = E1.style, t1.finalSize = t1.s, t1.finalText = this.buildFinalText(t1.t), i1 = t1.finalText.length, t1.finalLineHeight = t1.lh;
                var S1, A1 = t1.tr / 1e3 * t1.finalSize;
                if (t1.sz) for(var P1, x1, T1 = !0, w1 = t1.sz[0], C1 = t1.sz[1]; T1;){
                    P1 = 0, g1 = 0, i1 = (x1 = this.buildFinalText(t1.t)).length, A1 = t1.tr / 1e3 * t1.finalSize;
                    var k1 = -1;
                    for(e1 = 0; e1 < i1; e1 += 1)S1 = x1[e1].charCodeAt(0), r1 = !1, " " === x1[e1] ? k1 = e1 : 13 !== S1 && 3 !== S1 || (g1 = 0, r1 = !0, P1 += t1.finalLineHeight || 1.2 * t1.finalSize), h1.chars ? (o1 = h1.getCharData(x1[e1], v1.fStyle, v1.fFamily), b1 = r1 ? 0 : o1.w * t1.finalSize / 100) : b1 = h1.measureText(x1[e1], t1.f, t1.finalSize), g1 + b1 > w1 && " " !== x1[e1] ? (-1 === k1 ? i1 += 1 : e1 = k1, P1 += t1.finalLineHeight || 1.2 * t1.finalSize, x1.splice(e1, k1 === e1 ? 1 : 0, "\r"), k1 = -1, g1 = 0) : (g1 += b1, g1 += A1);
                    P1 += v1.ascent * t1.finalSize / 100, this.canResize && t1.finalSize > this.minimumFontSize && C1 < P1 ? (t1.finalSize -= 1, t1.finalLineHeight = t1.finalSize * t1.lh / t1.s) : (t1.finalText = x1, i1 = t1.finalText.length, T1 = !1);
                }
                g1 = -A1, b1 = 0;
                var D1, M1 = 0;
                for(e1 = 0; e1 < i1; e1 += 1)if (r1 = !1, 13 === (S1 = (D1 = t1.finalText[e1]).charCodeAt(0)) || 3 === S1 ? (M1 = 0, y1.push(g1), _1 = g1 > _1 ? g1 : _1, g1 = -2 * A1, a1 = "", r1 = !0, u1 += 1) : a1 = D1, h1.chars ? (o1 = h1.getCharData(D1, v1.fStyle, h1.getFontByName(t1.f).fFamily), b1 = r1 ? 0 : o1.w * t1.finalSize / 100) : b1 = h1.measureText(a1, t1.f, t1.finalSize), " " === D1 ? M1 += b1 + A1 : (g1 += b1 + A1 + M1, M1 = 0), p1.push({
                    l: b1,
                    an: b1,
                    add: c1,
                    n: r1,
                    anIndexes: [],
                    val: a1,
                    line: u1,
                    animatorJustifyOffset: 0
                }), 2 == d1) {
                    if (c1 += b1, "" === a1 || " " === a1 || e1 === i1 - 1) {
                        for("" !== a1 && " " !== a1 || (c1 -= b1); m1 <= e1;)p1[m1].an = c1, p1[m1].ind = f1, p1[m1].extra = b1, m1 += 1;
                        f1 += 1, c1 = 0;
                    }
                } else if (3 == d1) {
                    if (c1 += b1, "" === a1 || e1 === i1 - 1) {
                        for("" === a1 && (c1 -= b1); m1 <= e1;)p1[m1].an = c1, p1[m1].ind = f1, p1[m1].extra = b1, m1 += 1;
                        c1 = 0, f1 += 1;
                    }
                } else p1[f1].ind = f1, p1[f1].extra = 0, f1 += 1;
                if (t1.l = p1, _1 = g1 > _1 ? g1 : _1, y1.push(g1), t1.sz) t1.boxWidth = t1.sz[0], t1.justifyOffset = 0;
                else switch(t1.boxWidth = _1, t1.j){
                    case 1:
                        t1.justifyOffset = -t1.boxWidth;
                        break;
                    case 2:
                        t1.justifyOffset = -t1.boxWidth / 2;
                        break;
                    default:
                        t1.justifyOffset = 0;
                }
                t1.lineWidths = y1;
                var I1, F1, R1, B1, L1 = l1.a;
                n1 = L1.length;
                var O1 = [];
                for(s1 = 0; s1 < n1; s1 += 1){
                    for((I1 = L1[s1]).a.sc && (t1.strokeColorAnim = !0), I1.a.sw && (t1.strokeWidthAnim = !0), (I1.a.fc || I1.a.fh || I1.a.fs || I1.a.fb) && (t1.fillColorAnim = !0), B1 = 0, R1 = I1.s.b, e1 = 0; e1 < i1; e1 += 1)(F1 = p1[e1]).anIndexes[s1] = B1, (1 == R1 && "" !== F1.val || 2 == R1 && "" !== F1.val && " " !== F1.val || 3 == R1 && (F1.n || " " == F1.val || e1 == i1 - 1) || 4 == R1 && (F1.n || e1 == i1 - 1)) && (1 === I1.s.rn && O1.push(B1), B1 += 1);
                    l1.a[s1].s.totalChars = B1;
                    var N1, $1 = -1;
                    if (1 === I1.s.rn) for(e1 = 0; e1 < i1; e1 += 1)$1 != (F1 = p1[e1]).anIndexes[s1] && ($1 = F1.anIndexes[s1], N1 = O1.splice(Math.floor(Math.random() * O1.length), 1)[0]), F1.anIndexes[s1] = N1;
                }
                t1.yOffset = t1.finalLineHeight || 1.2 * t1.finalSize, t1.ls = t1.ls || 0, t1.ascent = v1.ascent * t1.finalSize / 100;
            }, TextProperty.prototype.updateDocumentData = function(t1, e1) {
                e1 = void 0 === e1 ? this.keysIndex : e1;
                var i1 = this.copyData({}, this.data.d.k[e1].s);
                i1 = this.copyData(i1, t1), this.data.d.k[e1].s = i1, this.recalculate(e1), this.elem.addDynamicProperty(this);
            }, TextProperty.prototype.recalculate = function(t1) {
                var e1 = this.data.d.k[t1].s;
                e1.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(e1);
            }, TextProperty.prototype.canResizeFont = function(t1) {
                this.canResize = t1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
            }, TextProperty.prototype.setMinimumFontSize = function(t1) {
                this.minimumFontSize = Math.floor(t1) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
            };
            var TextSelectorProp = function() {
                var t1 = Math.max, e1 = Math.min, i1 = Math.floor;
                function r1(t1, e1) {
                    this._currentTextLength = -1, this.k = !1, this.data = e1, this.elem = t1, this.comp = t1.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(t1), this.s = PropertyFactory.getProp(t1, e1.s || {
                        k: 0
                    }, 0, 0, this), this.e = "e" in e1 ? PropertyFactory.getProp(t1, e1.e, 0, 0, this) : {
                        v: 100
                    }, this.o = PropertyFactory.getProp(t1, e1.o || {
                        k: 0
                    }, 0, 0, this), this.xe = PropertyFactory.getProp(t1, e1.xe || {
                        k: 0
                    }, 0, 0, this), this.ne = PropertyFactory.getProp(t1, e1.ne || {
                        k: 0
                    }, 0, 0, this), this.sm = PropertyFactory.getProp(t1, e1.sm || {
                        k: 100
                    }, 0, 0, this), this.a = PropertyFactory.getProp(t1, e1.a, 0, .01, this), this.dynamicProperties.length || this.getValue();
                }
                return r1.prototype = {
                    getMult: function(r1) {
                        this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
                        var a1 = 0, s1 = 0, n1 = 1, o1 = 1;
                        this.ne.v > 0 ? a1 = this.ne.v / 100 : s1 = -this.ne.v / 100, this.xe.v > 0 ? n1 = 1 - this.xe.v / 100 : o1 = 1 + this.xe.v / 100;
                        var h1 = BezierFactory.getBezierEasing(a1, s1, n1, o1).get, l1 = 0, p1 = this.finalS, f1 = this.finalE, d1 = this.data.sh;
                        if (2 === d1) l1 = h1(l1 = f1 === p1 ? r1 >= f1 ? 1 : 0 : t1(0, e1(.5 / (f1 - p1) + (r1 - p1) / (f1 - p1), 1)));
                        else if (3 === d1) l1 = h1(l1 = f1 === p1 ? r1 >= f1 ? 0 : 1 : 1 - t1(0, e1(.5 / (f1 - p1) + (r1 - p1) / (f1 - p1), 1)));
                        else if (4 === d1) f1 === p1 ? l1 = 0 : (l1 = t1(0, e1(.5 / (f1 - p1) + (r1 - p1) / (f1 - p1), 1))) < .5 ? l1 *= 2 : l1 = 1 - 2 * (l1 - .5), l1 = h1(l1);
                        else if (5 === d1) {
                            if (f1 === p1) l1 = 0;
                            else {
                                var c1 = f1 - p1, m1 = -c1 / 2 + (r1 = e1(t1(0, r1 + .5 - p1), f1 - p1)), u1 = c1 / 2;
                                l1 = Math.sqrt(1 - m1 * m1 / (u1 * u1));
                            }
                            l1 = h1(l1);
                        } else 6 === d1 ? (f1 === p1 ? l1 = 0 : (r1 = e1(t1(0, r1 + .5 - p1), f1 - p1), l1 = (1 + Math.cos(Math.PI + 2 * Math.PI * r1 / (f1 - p1))) / 2), l1 = h1(l1)) : (r1 >= i1(p1) && (l1 = t1(0, e1(r1 - p1 < 0 ? e1(f1, 1) - (p1 - r1) : f1 - r1, 1))), l1 = h1(l1));
                        if (100 !== this.sm.v) {
                            var y1 = .01 * this.sm.v;
                            0 === y1 && (y1 = 1e-8);
                            var g1 = .5 - .5 * y1;
                            l1 < g1 ? l1 = 0 : (l1 = (l1 - g1) / y1) > 1 && (l1 = 1);
                        }
                        return l1 * this.a.v;
                    },
                    getValue: function(t1) {
                        this.iterateDynamicProperties(), this._mdf = t1 || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, t1 && 2 === this.data.r && (this.e.v = this._currentTextLength);
                        var e1 = 2 === this.data.r ? 1 : 100 / this.data.totalChars, i1 = this.o.v / e1, r1 = this.s.v / e1 + i1, a1 = this.e.v / e1 + i1;
                        if (r1 > a1) {
                            var s1 = r1;
                            r1 = a1, a1 = s1;
                        }
                        this.finalS = r1, this.finalE = a1;
                    }
                }, extendPrototype([
                    DynamicPropertyContainer
                ], r1), {
                    getTextSelectorProp: function(t1, e1, i1) {
                        return new r1(t1, e1, i1);
                    }
                };
            }();
            function TextAnimatorDataProperty(t1, e1, i1) {
                var r1 = {
                    propType: !1
                }, a1 = PropertyFactory.getProp, s1 = e1.a;
                this.a = {
                    r: s1.r ? a1(t1, s1.r, 0, degToRads, i1) : r1,
                    rx: s1.rx ? a1(t1, s1.rx, 0, degToRads, i1) : r1,
                    ry: s1.ry ? a1(t1, s1.ry, 0, degToRads, i1) : r1,
                    sk: s1.sk ? a1(t1, s1.sk, 0, degToRads, i1) : r1,
                    sa: s1.sa ? a1(t1, s1.sa, 0, degToRads, i1) : r1,
                    s: s1.s ? a1(t1, s1.s, 1, .01, i1) : r1,
                    a: s1.a ? a1(t1, s1.a, 1, 0, i1) : r1,
                    o: s1.o ? a1(t1, s1.o, 0, .01, i1) : r1,
                    p: s1.p ? a1(t1, s1.p, 1, 0, i1) : r1,
                    sw: s1.sw ? a1(t1, s1.sw, 0, 0, i1) : r1,
                    sc: s1.sc ? a1(t1, s1.sc, 1, 0, i1) : r1,
                    fc: s1.fc ? a1(t1, s1.fc, 1, 0, i1) : r1,
                    fh: s1.fh ? a1(t1, s1.fh, 0, 0, i1) : r1,
                    fs: s1.fs ? a1(t1, s1.fs, 0, .01, i1) : r1,
                    fb: s1.fb ? a1(t1, s1.fb, 0, .01, i1) : r1,
                    t: s1.t ? a1(t1, s1.t, 0, 0, i1) : r1
                }, this.s = TextSelectorProp.getTextSelectorProp(t1, e1.s, i1), this.s.t = e1.s.t;
            }
            function TextAnimatorProperty(t1, e1, i1) {
                this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = t1, this._renderType = e1, this._elem = i1, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = {
                    alignment: {}
                }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(i1);
            }
            function ITextElement() {}
            TextAnimatorProperty.prototype.searchProperties = function() {
                var t1, e1, i1 = this._textData.a.length, r1 = PropertyFactory.getProp;
                for(t1 = 0; t1 < i1; t1 += 1)e1 = this._textData.a[t1], this._animatorsData[t1] = new TextAnimatorDataProperty(this._elem, e1, this);
                this._textData.p && "m" in this._textData.p ? (this._pathData = {
                    a: r1(this._elem, this._textData.p.a, 0, 0, this),
                    f: r1(this._elem, this._textData.p.f, 0, 0, this),
                    l: r1(this._elem, this._textData.p.l, 0, 0, this),
                    r: r1(this._elem, this._textData.p.r, 0, 0, this),
                    p: r1(this._elem, this._textData.p.p, 0, 0, this),
                    m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
                }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = r1(this._elem, this._textData.m.a, 1, 0, this);
            }, TextAnimatorProperty.prototype.getMeasures = function(t1, e1) {
                if (this.lettersChangedFlag = e1, this._mdf || this._isFirstFrame || e1 || this._hasMaskedPath && this._pathData.m._mdf) {
                    this._isFirstFrame = !1;
                    var i1, r1, a1, s1, n1, o1, h1, l1, p1, f1, d1, c1, m1, u1, y1, g1, _1, v1, b1, E1 = this._moreOptions.alignment.v, S1 = this._animatorsData, A1 = this._textData, P1 = this.mHelper, x1 = this._renderType, T1 = this.renderedLetters.length, w1 = t1.l;
                    if (this._hasMaskedPath) {
                        if (b1 = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
                            var C1, k1 = b1.v;
                            for(this._pathData.r.v && (k1 = k1.reverse()), n1 = {
                                tLength: 0,
                                segments: []
                            }, s1 = k1._length - 1, g1 = 0, a1 = 0; a1 < s1; a1 += 1)C1 = bez.buildBezierData(k1.v[a1], k1.v[a1 + 1], [
                                k1.o[a1][0] - k1.v[a1][0],
                                k1.o[a1][1] - k1.v[a1][1]
                            ], [
                                k1.i[a1 + 1][0] - k1.v[a1 + 1][0],
                                k1.i[a1 + 1][1] - k1.v[a1 + 1][1]
                            ]), n1.tLength += C1.segmentLength, n1.segments.push(C1), g1 += C1.segmentLength;
                            a1 = s1, b1.v.c && (C1 = bez.buildBezierData(k1.v[a1], k1.v[0], [
                                k1.o[a1][0] - k1.v[a1][0],
                                k1.o[a1][1] - k1.v[a1][1]
                            ], [
                                k1.i[0][0] - k1.v[0][0],
                                k1.i[0][1] - k1.v[0][1]
                            ]), n1.tLength += C1.segmentLength, n1.segments.push(C1), g1 += C1.segmentLength), this._pathData.pi = n1;
                        }
                        if (n1 = this._pathData.pi, o1 = this._pathData.f.v, d1 = 0, f1 = 1, l1 = 0, p1 = !0, u1 = n1.segments, o1 < 0 && b1.v.c) for(n1.tLength < Math.abs(o1) && (o1 = -Math.abs(o1) % n1.tLength), f1 = (m1 = u1[d1 = u1.length - 1].points).length - 1; o1 < 0;)o1 += m1[f1].partialLength, (f1 -= 1) < 0 && (f1 = (m1 = u1[d1 -= 1].points).length - 1);
                        c1 = (m1 = u1[d1].points)[f1 - 1], y1 = (h1 = m1[f1]).partialLength;
                    }
                    s1 = w1.length, i1 = 0, r1 = 0;
                    var D1, M1, I1, F1, R1, B1 = 1.2 * t1.finalSize * .714, L1 = !0;
                    I1 = S1.length;
                    var O1, N1, $1, z1, V1, H1, G1, Z1, U1, j1, q1, K1, Y1 = -1, W1 = o1, X1 = d1, J1 = f1, Q1 = -1, tt1 = "", et1 = this.defaultPropsArray;
                    if (2 === t1.j || 1 === t1.j) {
                        var it1 = 0, rt1 = 0, at1 = 2 === t1.j ? -0.5 : -1, st1 = 0, nt1 = !0;
                        for(a1 = 0; a1 < s1; a1 += 1)if (w1[a1].n) {
                            for(it1 && (it1 += rt1); st1 < a1;)w1[st1].animatorJustifyOffset = it1, st1 += 1;
                            it1 = 0, nt1 = !0;
                        } else {
                            for(M1 = 0; M1 < I1; M1 += 1)(D1 = S1[M1].a).t.propType && (nt1 && 2 === t1.j && (rt1 += D1.t.v * at1), (R1 = S1[M1].s.getMult(w1[a1].anIndexes[M1], A1.a[M1].s.totalChars)).length ? it1 += D1.t.v * R1[0] * at1 : it1 += D1.t.v * R1 * at1);
                            nt1 = !1;
                        }
                        for(it1 && (it1 += rt1); st1 < a1;)w1[st1].animatorJustifyOffset = it1, st1 += 1;
                    }
                    for(a1 = 0; a1 < s1; a1 += 1){
                        if (P1.reset(), z1 = 1, w1[a1].n) i1 = 0, r1 += t1.yOffset, r1 += L1 ? 1 : 0, o1 = W1, L1 = !1, this._hasMaskedPath && (f1 = J1, c1 = (m1 = u1[d1 = X1].points)[f1 - 1], y1 = (h1 = m1[f1]).partialLength, l1 = 0), tt1 = "", q1 = "", U1 = "", K1 = "", et1 = this.defaultPropsArray;
                        else {
                            if (this._hasMaskedPath) {
                                if (Q1 !== w1[a1].line) {
                                    switch(t1.j){
                                        case 1:
                                            o1 += g1 - t1.lineWidths[w1[a1].line];
                                            break;
                                        case 2:
                                            o1 += (g1 - t1.lineWidths[w1[a1].line]) / 2;
                                    }
                                    Q1 = w1[a1].line;
                                }
                                Y1 !== w1[a1].ind && (w1[Y1] && (o1 += w1[Y1].extra), o1 += w1[a1].an / 2, Y1 = w1[a1].ind), o1 += E1[0] * w1[a1].an * .005;
                                var ot1 = 0;
                                for(M1 = 0; M1 < I1; M1 += 1)(D1 = S1[M1].a).p.propType && ((R1 = S1[M1].s.getMult(w1[a1].anIndexes[M1], A1.a[M1].s.totalChars)).length ? ot1 += D1.p.v[0] * R1[0] : ot1 += D1.p.v[0] * R1), D1.a.propType && ((R1 = S1[M1].s.getMult(w1[a1].anIndexes[M1], A1.a[M1].s.totalChars)).length ? ot1 += D1.a.v[0] * R1[0] : ot1 += D1.a.v[0] * R1);
                                for(p1 = !0, this._pathData.a.v && (o1 = .5 * w1[0].an + (g1 - this._pathData.f.v - .5 * w1[0].an - .5 * w1[w1.length - 1].an) * Y1 / (s1 - 1), o1 += this._pathData.f.v); p1;)l1 + y1 >= o1 + ot1 || !m1 ? (_1 = (o1 + ot1 - l1) / h1.partialLength, N1 = c1.point[0] + (h1.point[0] - c1.point[0]) * _1, $1 = c1.point[1] + (h1.point[1] - c1.point[1]) * _1, P1.translate(-E1[0] * w1[a1].an * .005, -E1[1] * B1 * .01), p1 = !1) : m1 && (l1 += h1.partialLength, (f1 += 1) >= m1.length && (f1 = 0, u1[d1 += 1] ? m1 = u1[d1].points : b1.v.c ? (f1 = 0, m1 = u1[d1 = 0].points) : (l1 -= h1.partialLength, m1 = null)), m1 && (c1 = h1, y1 = (h1 = m1[f1]).partialLength));
                                O1 = w1[a1].an / 2 - w1[a1].add, P1.translate(-O1, 0, 0);
                            } else O1 = w1[a1].an / 2 - w1[a1].add, P1.translate(-O1, 0, 0), P1.translate(-E1[0] * w1[a1].an * .005, -E1[1] * B1 * .01, 0);
                            for(M1 = 0; M1 < I1; M1 += 1)(D1 = S1[M1].a).t.propType && (R1 = S1[M1].s.getMult(w1[a1].anIndexes[M1], A1.a[M1].s.totalChars), 0 === i1 && 0 === t1.j || (this._hasMaskedPath ? R1.length ? o1 += D1.t.v * R1[0] : o1 += D1.t.v * R1 : R1.length ? i1 += D1.t.v * R1[0] : i1 += D1.t.v * R1));
                            for(t1.strokeWidthAnim && (H1 = t1.sw || 0), t1.strokeColorAnim && (V1 = t1.sc ? [
                                t1.sc[0],
                                t1.sc[1],
                                t1.sc[2]
                            ] : [
                                0,
                                0,
                                0
                            ]), t1.fillColorAnim && t1.fc && (G1 = [
                                t1.fc[0],
                                t1.fc[1],
                                t1.fc[2]
                            ]), M1 = 0; M1 < I1; M1 += 1)(D1 = S1[M1].a).a.propType && ((R1 = S1[M1].s.getMult(w1[a1].anIndexes[M1], A1.a[M1].s.totalChars)).length ? P1.translate(-D1.a.v[0] * R1[0], -D1.a.v[1] * R1[1], D1.a.v[2] * R1[2]) : P1.translate(-D1.a.v[0] * R1, -D1.a.v[1] * R1, D1.a.v[2] * R1));
                            for(M1 = 0; M1 < I1; M1 += 1)(D1 = S1[M1].a).s.propType && ((R1 = S1[M1].s.getMult(w1[a1].anIndexes[M1], A1.a[M1].s.totalChars)).length ? P1.scale(1 + (D1.s.v[0] - 1) * R1[0], 1 + (D1.s.v[1] - 1) * R1[1], 1) : P1.scale(1 + (D1.s.v[0] - 1) * R1, 1 + (D1.s.v[1] - 1) * R1, 1));
                            for(M1 = 0; M1 < I1; M1 += 1){
                                if (D1 = S1[M1].a, R1 = S1[M1].s.getMult(w1[a1].anIndexes[M1], A1.a[M1].s.totalChars), D1.sk.propType && (R1.length ? P1.skewFromAxis(-D1.sk.v * R1[0], D1.sa.v * R1[1]) : P1.skewFromAxis(-D1.sk.v * R1, D1.sa.v * R1)), D1.r.propType && (R1.length ? P1.rotateZ(-D1.r.v * R1[2]) : P1.rotateZ(-D1.r.v * R1)), D1.ry.propType && (R1.length ? P1.rotateY(D1.ry.v * R1[1]) : P1.rotateY(D1.ry.v * R1)), D1.rx.propType && (R1.length ? P1.rotateX(D1.rx.v * R1[0]) : P1.rotateX(D1.rx.v * R1)), D1.o.propType && (R1.length ? z1 += (D1.o.v * R1[0] - z1) * R1[0] : z1 += (D1.o.v * R1 - z1) * R1), t1.strokeWidthAnim && D1.sw.propType && (R1.length ? H1 += D1.sw.v * R1[0] : H1 += D1.sw.v * R1), t1.strokeColorAnim && D1.sc.propType) for(Z1 = 0; Z1 < 3; Z1 += 1)R1.length ? V1[Z1] += (D1.sc.v[Z1] - V1[Z1]) * R1[0] : V1[Z1] += (D1.sc.v[Z1] - V1[Z1]) * R1;
                                if (t1.fillColorAnim && t1.fc) {
                                    if (D1.fc.propType) for(Z1 = 0; Z1 < 3; Z1 += 1)R1.length ? G1[Z1] += (D1.fc.v[Z1] - G1[Z1]) * R1[0] : G1[Z1] += (D1.fc.v[Z1] - G1[Z1]) * R1;
                                    D1.fh.propType && (G1 = R1.length ? addHueToRGB(G1, D1.fh.v * R1[0]) : addHueToRGB(G1, D1.fh.v * R1)), D1.fs.propType && (G1 = R1.length ? addSaturationToRGB(G1, D1.fs.v * R1[0]) : addSaturationToRGB(G1, D1.fs.v * R1)), D1.fb.propType && (G1 = R1.length ? addBrightnessToRGB(G1, D1.fb.v * R1[0]) : addBrightnessToRGB(G1, D1.fb.v * R1));
                                }
                            }
                            for(M1 = 0; M1 < I1; M1 += 1)(D1 = S1[M1].a).p.propType && (R1 = S1[M1].s.getMult(w1[a1].anIndexes[M1], A1.a[M1].s.totalChars), this._hasMaskedPath ? R1.length ? P1.translate(0, D1.p.v[1] * R1[0], -D1.p.v[2] * R1[1]) : P1.translate(0, D1.p.v[1] * R1, -D1.p.v[2] * R1) : R1.length ? P1.translate(D1.p.v[0] * R1[0], D1.p.v[1] * R1[1], -D1.p.v[2] * R1[2]) : P1.translate(D1.p.v[0] * R1, D1.p.v[1] * R1, -D1.p.v[2] * R1));
                            if (t1.strokeWidthAnim && (U1 = H1 < 0 ? 0 : H1), t1.strokeColorAnim && (j1 = "rgb(" + Math.round(255 * V1[0]) + "," + Math.round(255 * V1[1]) + "," + Math.round(255 * V1[2]) + ")"), t1.fillColorAnim && t1.fc && (q1 = "rgb(" + Math.round(255 * G1[0]) + "," + Math.round(255 * G1[1]) + "," + Math.round(255 * G1[2]) + ")"), this._hasMaskedPath) {
                                if (P1.translate(0, -t1.ls), P1.translate(0, E1[1] * B1 * .01 + r1, 0), this._pathData.p.v) {
                                    v1 = (h1.point[1] - c1.point[1]) / (h1.point[0] - c1.point[0]);
                                    var ht1 = 180 * Math.atan(v1) / Math.PI;
                                    h1.point[0] < c1.point[0] && (ht1 += 180), P1.rotate(-ht1 * Math.PI / 180);
                                }
                                P1.translate(N1, $1, 0), o1 -= E1[0] * w1[a1].an * .005, w1[a1 + 1] && Y1 !== w1[a1 + 1].ind && (o1 += w1[a1].an / 2, o1 += .001 * t1.tr * t1.finalSize);
                            } else {
                                switch(P1.translate(i1, r1, 0), t1.ps && P1.translate(t1.ps[0], t1.ps[1] + t1.ascent, 0), t1.j){
                                    case 1:
                                        P1.translate(w1[a1].animatorJustifyOffset + t1.justifyOffset + (t1.boxWidth - t1.lineWidths[w1[a1].line]), 0, 0);
                                        break;
                                    case 2:
                                        P1.translate(w1[a1].animatorJustifyOffset + t1.justifyOffset + (t1.boxWidth - t1.lineWidths[w1[a1].line]) / 2, 0, 0);
                                }
                                P1.translate(0, -t1.ls), P1.translate(O1, 0, 0), P1.translate(E1[0] * w1[a1].an * .005, E1[1] * B1 * .01, 0), i1 += w1[a1].l + .001 * t1.tr * t1.finalSize;
                            }
                            "html" === x1 ? tt1 = P1.toCSS() : "svg" === x1 ? tt1 = P1.to2dCSS() : et1 = [
                                P1.props[0],
                                P1.props[1],
                                P1.props[2],
                                P1.props[3],
                                P1.props[4],
                                P1.props[5],
                                P1.props[6],
                                P1.props[7],
                                P1.props[8],
                                P1.props[9],
                                P1.props[10],
                                P1.props[11],
                                P1.props[12],
                                P1.props[13],
                                P1.props[14],
                                P1.props[15]
                            ], K1 = z1;
                        }
                        T1 <= a1 ? (F1 = new LetterProps(K1, U1, j1, q1, tt1, et1), this.renderedLetters.push(F1), T1 += 1, this.lettersChangedFlag = !0) : (F1 = this.renderedLetters[a1], this.lettersChangedFlag = F1.update(K1, U1, j1, q1, tt1, et1) || this.lettersChangedFlag);
                    }
                }
            }, TextAnimatorProperty.prototype.getValue = function() {
                this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
            }, TextAnimatorProperty.prototype.mHelper = new Matrix, TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([
                DynamicPropertyContainer
            ], TextAnimatorProperty), ITextElement.prototype.initElement = function(t1, e1, i1) {
                this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(t1, e1, i1), this.textProperty = new TextProperty(this, t1.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(t1.t, this.renderType, this), this.initTransform(t1, e1, i1), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
            }, ITextElement.prototype.prepareFrame = function(t1) {
                this._mdf = !1, this.prepareRenderableFrame(t1), this.prepareProperties(t1, this.isInRange), (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
            }, ITextElement.prototype.createPathShape = function(t1, e1) {
                var i1, r1, a1 = e1.length, s1 = "";
                for(i1 = 0; i1 < a1; i1 += 1)"sh" === e1[i1].ty && (r1 = e1[i1].ks.k, s1 += buildShapeString(r1, r1.i.length, !0, t1));
                return s1;
            }, ITextElement.prototype.updateDocumentData = function(t1, e1) {
                this.textProperty.updateDocumentData(t1, e1);
            }, ITextElement.prototype.canResizeFont = function(t1) {
                this.textProperty.canResizeFont(t1);
            }, ITextElement.prototype.setMinimumFontSize = function(t1) {
                this.textProperty.setMinimumFontSize(t1);
            }, ITextElement.prototype.applyTextPropertiesToMatrix = function(t1, e1, i1, r1, a1) {
                switch(t1.ps && e1.translate(t1.ps[0], t1.ps[1] + t1.ascent, 0), e1.translate(0, -t1.ls, 0), t1.j){
                    case 1:
                        e1.translate(t1.justifyOffset + (t1.boxWidth - t1.lineWidths[i1]), 0, 0);
                        break;
                    case 2:
                        e1.translate(t1.justifyOffset + (t1.boxWidth - t1.lineWidths[i1]) / 2, 0, 0);
                }
                e1.translate(r1, a1, 0);
            }, ITextElement.prototype.buildColor = function(t1) {
                return "rgb(" + Math.round(255 * t1[0]) + "," + Math.round(255 * t1[1]) + "," + Math.round(255 * t1[2]) + ")";
            }, ITextElement.prototype.emptyProp = new LetterProps, ITextElement.prototype.destroy = function() {};
            var emptyShapeData = {
                shapes: []
            };
            function SVGTextLottieElement(t1, e1, i1) {
                this.textSpans = [], this.renderType = "svg", this.initElement(t1, e1, i1);
            }
            function ISolidElement(t1, e1, i1) {
                this.initElement(t1, e1, i1);
            }
            function NullElement(t1, e1, i1) {
                this.initFrame(), this.initBaseData(t1, e1, i1), this.initFrame(), this.initTransform(t1, e1, i1), this.initHierarchy();
            }
            function SVGRendererBase() {}
            function ICompElement() {}
            function SVGCompElement(t1, e1, i1) {
                this.layers = t1.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t1, e1, i1), this.tm = t1.tm ? PropertyFactory.getProp(this, t1.tm, 0, e1.frameRate, this) : {
                    _placeholder: !0
                };
            }
            function SVGRenderer(t1, e1) {
                this.animationItem = t1, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
                var i1 = "";
                if (e1 && e1.title) {
                    var r1 = createNS("title"), a1 = createElementID();
                    r1.setAttribute("id", a1), r1.textContent = e1.title, this.svgElement.appendChild(r1), i1 += a1;
                }
                if (e1 && e1.description) {
                    var s1 = createNS("desc"), n1 = createElementID();
                    s1.setAttribute("id", n1), s1.textContent = e1.description, this.svgElement.appendChild(s1), i1 += " " + n1;
                }
                i1 && this.svgElement.setAttribute("aria-labelledby", i1);
                var o1 = createNS("defs");
                this.svgElement.appendChild(o1);
                var h1 = createNS("g");
                this.svgElement.appendChild(h1), this.layerElement = h1, this.renderConfig = {
                    preserveAspectRatio: e1 && e1.preserveAspectRatio || "xMidYMid meet",
                    imagePreserveAspectRatio: e1 && e1.imagePreserveAspectRatio || "xMidYMid slice",
                    contentVisibility: e1 && e1.contentVisibility || "visible",
                    progressiveLoad: e1 && e1.progressiveLoad || !1,
                    hideOnTransparent: !(e1 && !1 === e1.hideOnTransparent),
                    viewBoxOnly: e1 && e1.viewBoxOnly || !1,
                    viewBoxSize: e1 && e1.viewBoxSize || !1,
                    className: e1 && e1.className || "",
                    id: e1 && e1.id || "",
                    focusable: e1 && e1.focusable,
                    filterSize: {
                        width: e1 && e1.filterSize && e1.filterSize.width || "100%",
                        height: e1 && e1.filterSize && e1.filterSize.height || "100%",
                        x: e1 && e1.filterSize && e1.filterSize.x || "0%",
                        y: e1 && e1.filterSize && e1.filterSize.y || "0%"
                    },
                    width: e1 && e1.width,
                    height: e1 && e1.height,
                    runExpressions: !e1 || void 0 === e1.runExpressions || e1.runExpressions
                }, this.globalData = {
                    _mdf: !1,
                    frameNum: -1,
                    defs: o1,
                    renderConfig: this.renderConfig
                }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
            }
            function CVContextData() {
                var t1;
                for(this.saved = [], this.cArrPos = 0, this.cTr = new Matrix, this.cO = 1, this.savedOp = createTypedArray("float32", 15), t1 = 0; t1 < 15; t1 += 1)this.saved[t1] = createTypedArray("float32", 16);
                this._length = 15;
            }
            function ShapeTransformManager() {
                this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
            }
            function CVEffects() {}
            function CVMaskElement(t1, e1) {
                var i1;
                this.data = t1, this.element = e1, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
                var r1 = this.masksProperties.length, a1 = !1;
                for(i1 = 0; i1 < r1; i1 += 1)"n" !== this.masksProperties[i1].mode && (a1 = !0), this.viewData[i1] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i1], 3);
                this.hasMasks = a1, a1 && this.element.addRenderableComponent(this);
            }
            function CVBaseElement() {}
            function CVShapeData(t1, e1, i1, r1) {
                this.styledShapes = [], this.tr = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                var a1, s1 = 4;
                "rc" === e1.ty ? s1 = 5 : "el" === e1.ty ? s1 = 6 : "sr" === e1.ty && (s1 = 7), this.sh = ShapePropertyFactory.getShapeProp(t1, e1, s1, t1);
                var n1, o1 = i1.length;
                for(a1 = 0; a1 < o1; a1 += 1)i1[a1].closed || (n1 = {
                    transforms: r1.addTransformSequence(i1[a1].transforms),
                    trNodes: []
                }, this.styledShapes.push(n1), i1[a1].elements.push(n1));
            }
            function CVShapeElement(t1, e1, i1) {
                this.shapes = [], this.shapesData = t1.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager, this.initElement(t1, e1, i1);
            }
            function CVTextElement(t1, e1, i1) {
                this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
                    fill: "rgba(0,0,0,0)",
                    stroke: "rgba(0,0,0,0)",
                    sWidth: 0,
                    fValue: ""
                }, this.initElement(t1, e1, i1);
            }
            function CVImageElement(t1, e1, i1) {
                this.assetData = e1.getAssetData(t1.refId), this.img = e1.imageLoader.getAsset(this.assetData), this.initElement(t1, e1, i1);
            }
            function CVSolidElement(t1, e1, i1) {
                this.initElement(t1, e1, i1);
            }
            function CanvasRendererBase(t1, e1) {
                this.animationItem = t1, this.renderConfig = {
                    clearCanvas: !e1 || void 0 === e1.clearCanvas || e1.clearCanvas,
                    context: e1 && e1.context || null,
                    progressiveLoad: e1 && e1.progressiveLoad || !1,
                    preserveAspectRatio: e1 && e1.preserveAspectRatio || "xMidYMid meet",
                    imagePreserveAspectRatio: e1 && e1.imagePreserveAspectRatio || "xMidYMid slice",
                    contentVisibility: e1 && e1.contentVisibility || "visible",
                    className: e1 && e1.className || "",
                    id: e1 && e1.id || ""
                }, this.renderConfig.dpr = e1 && e1.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = e1 && e1.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
                    frameNum: -1,
                    _mdf: !1,
                    renderConfig: this.renderConfig,
                    currentGlobalAlpha: -1
                }, this.contextData = new CVContextData, this.elements = [], this.pendingElements = [], this.transformMat = new Matrix, this.completeLayers = !1, this.rendererType = "canvas";
            }
            function CVCompElement(t1, e1, i1) {
                this.completeLayers = !1, this.layers = t1.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(t1, e1, i1), this.tm = t1.tm ? PropertyFactory.getProp(this, t1.tm, 0, e1.frameRate, this) : {
                    _placeholder: !0
                };
            }
            function CanvasRenderer(t1, e1) {
                this.animationItem = t1, this.renderConfig = {
                    clearCanvas: !e1 || void 0 === e1.clearCanvas || e1.clearCanvas,
                    context: e1 && e1.context || null,
                    progressiveLoad: e1 && e1.progressiveLoad || !1,
                    preserveAspectRatio: e1 && e1.preserveAspectRatio || "xMidYMid meet",
                    imagePreserveAspectRatio: e1 && e1.imagePreserveAspectRatio || "xMidYMid slice",
                    contentVisibility: e1 && e1.contentVisibility || "visible",
                    className: e1 && e1.className || "",
                    id: e1 && e1.id || "",
                    runExpressions: !e1 || void 0 === e1.runExpressions || e1.runExpressions
                }, this.renderConfig.dpr = e1 && e1.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = e1 && e1.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
                    frameNum: -1,
                    _mdf: !1,
                    renderConfig: this.renderConfig,
                    currentGlobalAlpha: -1
                }, this.contextData = new CVContextData, this.elements = [], this.pendingElements = [], this.transformMat = new Matrix, this.completeLayers = !1, this.rendererType = "canvas";
            }
            function HBaseElement() {}
            function HSolidElement(t1, e1, i1) {
                this.initElement(t1, e1, i1);
            }
            function HShapeElement(t1, e1, i1) {
                this.shapes = [], this.shapesData = t1.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(t1, e1, i1), this.prevViewData = [], this.currentBBox = {
                    x: 999999,
                    y: -999999,
                    h: 0,
                    w: 0
                };
            }
            function HTextElement(t1, e1, i1) {
                this.textSpans = [], this.textPaths = [], this.currentBBox = {
                    x: 999999,
                    y: -999999,
                    h: 0,
                    w: 0
                }, this.renderType = "svg", this.isMasked = !1, this.initElement(t1, e1, i1);
            }
            function HCameraElement(t1, e1, i1) {
                this.initFrame(), this.initBaseData(t1, e1, i1), this.initHierarchy();
                var r1 = PropertyFactory.getProp;
                if (this.pe = r1(this, t1.pe, 0, 0, this), t1.ks.p.s ? (this.px = r1(this, t1.ks.p.x, 1, 0, this), this.py = r1(this, t1.ks.p.y, 1, 0, this), this.pz = r1(this, t1.ks.p.z, 1, 0, this)) : this.p = r1(this, t1.ks.p, 1, 0, this), t1.ks.a && (this.a = r1(this, t1.ks.a, 1, 0, this)), t1.ks.or.k.length && t1.ks.or.k[0].to) {
                    var a1, s1 = t1.ks.or.k.length;
                    for(a1 = 0; a1 < s1; a1 += 1)t1.ks.or.k[a1].to = null, t1.ks.or.k[a1].ti = null;
                }
                this.or = r1(this, t1.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = r1(this, t1.ks.rx, 0, degToRads, this), this.ry = r1(this, t1.ks.ry, 0, degToRads, this), this.rz = r1(this, t1.ks.rz, 0, degToRads, this), this.mat = new Matrix, this._prevMat = new Matrix, this._isFirstFrame = !0, this.finalTransform = {
                    mProp: this
                };
            }
            function HImageElement(t1, e1, i1) {
                this.assetData = e1.getAssetData(t1.refId), this.initElement(t1, e1, i1);
            }
            function HybridRendererBase(t1, e1) {
                this.animationItem = t1, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
                    className: e1 && e1.className || "",
                    imagePreserveAspectRatio: e1 && e1.imagePreserveAspectRatio || "xMidYMid slice",
                    hideOnTransparent: !(e1 && !1 === e1.hideOnTransparent),
                    filterSize: {
                        width: e1 && e1.filterSize && e1.filterSize.width || "400%",
                        height: e1 && e1.filterSize && e1.filterSize.height || "400%",
                        x: e1 && e1.filterSize && e1.filterSize.x || "-100%",
                        y: e1 && e1.filterSize && e1.filterSize.y || "-100%"
                    }
                }, this.globalData = {
                    _mdf: !1,
                    frameNum: -1,
                    renderConfig: this.renderConfig
                }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
            }
            function HCompElement(t1, e1, i1) {
                this.layers = t1.layers, this.supports3d = !t1.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t1, e1, i1), this.tm = t1.tm ? PropertyFactory.getProp(this, t1.tm, 0, e1.frameRate, this) : {
                    _placeholder: !0
                };
            }
            function HybridRenderer(t1, e1) {
                this.animationItem = t1, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
                    className: e1 && e1.className || "",
                    imagePreserveAspectRatio: e1 && e1.imagePreserveAspectRatio || "xMidYMid slice",
                    hideOnTransparent: !(e1 && !1 === e1.hideOnTransparent),
                    filterSize: {
                        width: e1 && e1.filterSize && e1.filterSize.width || "400%",
                        height: e1 && e1.filterSize && e1.filterSize.height || "400%",
                        x: e1 && e1.filterSize && e1.filterSize.x || "-100%",
                        y: e1 && e1.filterSize && e1.filterSize.y || "-100%"
                    },
                    runExpressions: !e1 || void 0 === e1.runExpressions || e1.runExpressions
                }, this.globalData = {
                    _mdf: !1,
                    frameNum: -1,
                    renderConfig: this.renderConfig
                }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
            }
            extendPrototype([
                BaseElement,
                TransformElement,
                SVGBaseElement,
                HierarchyElement,
                FrameElement,
                RenderableDOMElement,
                ITextElement
            ], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
                this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
            }, SVGTextLottieElement.prototype.buildTextContents = function(t1) {
                for(var e1 = 0, i1 = t1.length, r1 = [], a1 = ""; e1 < i1;)t1[e1] === String.fromCharCode(13) || t1[e1] === String.fromCharCode(3) ? (r1.push(a1), a1 = "") : a1 += t1[e1], e1 += 1;
                return r1.push(a1), r1;
            }, SVGTextLottieElement.prototype.buildShapeData = function(t1, e1) {
                if (t1.shapes && t1.shapes.length) {
                    var i1 = t1.shapes[0];
                    if (i1.it) {
                        var r1 = i1.it[i1.it.length - 1];
                        r1.s && (r1.s.k[0] = e1, r1.s.k[1] = e1);
                    }
                }
                return t1;
            }, SVGTextLottieElement.prototype.buildNewText = function() {
                var t1, e1;
                this.addDynamicProperty(this);
                var i1 = this.textProperty.currentData;
                this.renderedLetters = createSizedArray(i1 ? i1.l.length : 0), i1.fc ? this.layerElement.setAttribute("fill", this.buildColor(i1.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), i1.sc && (this.layerElement.setAttribute("stroke", this.buildColor(i1.sc)), this.layerElement.setAttribute("stroke-width", i1.sw)), this.layerElement.setAttribute("font-size", i1.finalSize);
                var r1 = this.globalData.fontManager.getFontByName(i1.f);
                if (r1.fClass) this.layerElement.setAttribute("class", r1.fClass);
                else {
                    this.layerElement.setAttribute("font-family", r1.fFamily);
                    var a1 = i1.fWeight, s1 = i1.fStyle;
                    this.layerElement.setAttribute("font-style", s1), this.layerElement.setAttribute("font-weight", a1);
                }
                this.layerElement.setAttribute("aria-label", i1.t);
                var n1, o1 = i1.l || [], h1 = !!this.globalData.fontManager.chars;
                e1 = o1.length;
                var l1 = this.mHelper, p1 = this.data.singleShape, f1 = 0, d1 = 0, c1 = !0, m1 = .001 * i1.tr * i1.finalSize;
                if (!p1 || h1 || i1.sz) {
                    var u1, y1 = this.textSpans.length;
                    for(t1 = 0; t1 < e1; t1 += 1){
                        if (this.textSpans[t1] || (this.textSpans[t1] = {
                            span: null,
                            childSpan: null,
                            glyph: null
                        }), !h1 || !p1 || 0 === t1) {
                            if (n1 = y1 > t1 ? this.textSpans[t1].span : createNS(h1 ? "g" : "text"), y1 <= t1) {
                                if (n1.setAttribute("stroke-linecap", "butt"), n1.setAttribute("stroke-linejoin", "round"), n1.setAttribute("stroke-miterlimit", "4"), this.textSpans[t1].span = n1, h1) {
                                    var g1 = createNS("g");
                                    n1.appendChild(g1), this.textSpans[t1].childSpan = g1;
                                }
                                this.textSpans[t1].span = n1, this.layerElement.appendChild(n1);
                            }
                            n1.style.display = "inherit";
                        }
                        if (l1.reset(), p1 && (o1[t1].n && (f1 = -m1, d1 += i1.yOffset, d1 += c1 ? 1 : 0, c1 = !1), this.applyTextPropertiesToMatrix(i1, l1, o1[t1].line, f1, d1), f1 += o1[t1].l || 0, f1 += m1), h1) {
                            var _1;
                            if (1 === (u1 = this.globalData.fontManager.getCharData(i1.finalText[t1], r1.fStyle, this.globalData.fontManager.getFontByName(i1.f).fFamily)).t) _1 = new SVGCompElement(u1.data, this.globalData, this);
                            else {
                                var v1 = emptyShapeData;
                                u1.data && u1.data.shapes && (v1 = this.buildShapeData(u1.data, i1.finalSize)), _1 = new SVGShapeElement(v1, this.globalData, this);
                            }
                            if (this.textSpans[t1].glyph) {
                                var b1 = this.textSpans[t1].glyph;
                                this.textSpans[t1].childSpan.removeChild(b1.layerElement), b1.destroy();
                            }
                            this.textSpans[t1].glyph = _1, _1._debug = !0, _1.prepareFrame(0), _1.renderFrame(), this.textSpans[t1].childSpan.appendChild(_1.layerElement), 1 === u1.t && this.textSpans[t1].childSpan.setAttribute("transform", "scale(" + i1.finalSize / 100 + "," + i1.finalSize / 100 + ")");
                        } else p1 && n1.setAttribute("transform", "translate(" + l1.props[12] + "," + l1.props[13] + ")"), n1.textContent = o1[t1].val, n1.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
                    }
                    p1 && n1 && n1.setAttribute("d", "");
                } else {
                    var E1 = this.textContainer, S1 = "start";
                    switch(i1.j){
                        case 1:
                            S1 = "end";
                            break;
                        case 2:
                            S1 = "middle";
                            break;
                        default:
                            S1 = "start";
                    }
                    E1.setAttribute("text-anchor", S1), E1.setAttribute("letter-spacing", m1);
                    var A1 = this.buildTextContents(i1.finalText);
                    for(e1 = A1.length, d1 = i1.ps ? i1.ps[1] + i1.ascent : 0, t1 = 0; t1 < e1; t1 += 1)(n1 = this.textSpans[t1].span || createNS("tspan")).textContent = A1[t1], n1.setAttribute("x", 0), n1.setAttribute("y", d1), n1.style.display = "inherit", E1.appendChild(n1), this.textSpans[t1] || (this.textSpans[t1] = {
                        span: null,
                        glyph: null
                    }), this.textSpans[t1].span = n1, d1 += i1.finalLineHeight;
                    this.layerElement.appendChild(E1);
                }
                for(; t1 < this.textSpans.length;)this.textSpans[t1].span.style.display = "none", t1 += 1;
                this._sizeChanged = !0;
            }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
                if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
                    this._sizeChanged = !1;
                    var t1 = this.layerElement.getBBox();
                    this.bbox = {
                        top: t1.y,
                        left: t1.x,
                        width: t1.width,
                        height: t1.height
                    };
                }
                return this.bbox;
            }, SVGTextLottieElement.prototype.getValue = function() {
                var t1, e1, i1 = this.textSpans.length;
                for(this.renderedFrame = this.comp.renderedFrame, t1 = 0; t1 < i1; t1 += 1)(e1 = this.textSpans[t1].glyph) && (e1.prepareFrame(this.comp.renderedFrame - this.data.st), e1._mdf && (this._mdf = !0));
            }, SVGTextLottieElement.prototype.renderInnerContent = function() {
                if ((!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
                    var t1, e1;
                    this._sizeChanged = !0;
                    var i1, r1, a1, s1 = this.textAnimator.renderedLetters, n1 = this.textProperty.currentData.l;
                    for(e1 = n1.length, t1 = 0; t1 < e1; t1 += 1)n1[t1].n || (i1 = s1[t1], r1 = this.textSpans[t1].span, (a1 = this.textSpans[t1].glyph) && a1.renderFrame(), i1._mdf.m && r1.setAttribute("transform", i1.m), i1._mdf.o && r1.setAttribute("opacity", i1.o), i1._mdf.sw && r1.setAttribute("stroke-width", i1.sw), i1._mdf.sc && r1.setAttribute("stroke", i1.sc), i1._mdf.fc && r1.setAttribute("fill", i1.fc));
                }
            }, extendPrototype([
                IImageElement
            ], ISolidElement), ISolidElement.prototype.createContent = function() {
                var t1 = createNS("rect");
                t1.setAttribute("width", this.data.sw), t1.setAttribute("height", this.data.sh), t1.setAttribute("fill", this.data.sc), this.layerElement.appendChild(t1);
            }, NullElement.prototype.prepareFrame = function(t1) {
                this.prepareProperties(t1, !0);
            }, NullElement.prototype.renderFrame = function() {}, NullElement.prototype.getBaseElement = function() {
                return null;
            }, NullElement.prototype.destroy = function() {}, NullElement.prototype.sourceRectAtTime = function() {}, NullElement.prototype.hide = function() {}, extendPrototype([
                BaseElement,
                TransformElement,
                HierarchyElement,
                FrameElement
            ], NullElement), extendPrototype([
                BaseRenderer
            ], SVGRendererBase), SVGRendererBase.prototype.createNull = function(t1) {
                return new NullElement(t1, this.globalData, this);
            }, SVGRendererBase.prototype.createShape = function(t1) {
                return new SVGShapeElement(t1, this.globalData, this);
            }, SVGRendererBase.prototype.createText = function(t1) {
                return new SVGTextLottieElement(t1, this.globalData, this);
            }, SVGRendererBase.prototype.createImage = function(t1) {
                return new IImageElement(t1, this.globalData, this);
            }, SVGRendererBase.prototype.createSolid = function(t1) {
                return new ISolidElement(t1, this.globalData, this);
            }, SVGRendererBase.prototype.configAnimation = function(t1) {
                this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + t1.w + " " + t1.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", t1.w), this.svgElement.setAttribute("height", t1.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), void 0 !== this.renderConfig.focusable && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
                var e1 = this.globalData.defs;
                this.setupGlobalData(t1, e1), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = t1;
                var i1 = createNS("clipPath"), r1 = createNS("rect");
                r1.setAttribute("width", t1.w), r1.setAttribute("height", t1.h), r1.setAttribute("x", 0), r1.setAttribute("y", 0);
                var a1 = createElementID();
                i1.setAttribute("id", a1), i1.appendChild(r1), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a1 + ")"), e1.appendChild(i1), this.layers = t1.layers, this.elements = createSizedArray(t1.layers.length);
            }, SVGRendererBase.prototype.destroy = function() {
                var t1;
                this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
                var e1 = this.layers ? this.layers.length : 0;
                for(t1 = 0; t1 < e1; t1 += 1)this.elements[t1] && this.elements[t1].destroy();
                this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
            }, SVGRendererBase.prototype.updateContainerSize = function() {}, SVGRendererBase.prototype.findIndexByInd = function(t1) {
                var e1 = 0, i1 = this.layers.length;
                for(e1 = 0; e1 < i1; e1 += 1)if (this.layers[e1].ind === t1) return e1;
                return -1;
            }, SVGRendererBase.prototype.buildItem = function(t1) {
                var e1 = this.elements;
                if (!e1[t1] && 99 !== this.layers[t1].ty) {
                    e1[t1] = !0;
                    var i1 = this.createItem(this.layers[t1]);
                    if (e1[t1] = i1, getExpressionsPlugin() && (0 === this.layers[t1].ty && this.globalData.projectInterface.registerComposition(i1), i1.initExpressions()), this.appendElementInPos(i1, t1), this.layers[t1].tt) {
                        var r1 = "tp" in this.layers[t1] ? this.findIndexByInd(this.layers[t1].tp) : t1 - 1;
                        if (-1 === r1) return;
                        if (this.elements[r1] && !0 !== this.elements[r1]) {
                            var a1 = e1[r1].getMatte(this.layers[t1].tt);
                            i1.setMatte(a1);
                        } else this.buildItem(r1), this.addPendingElement(i1);
                    }
                }
            }, SVGRendererBase.prototype.checkPendingElements = function() {
                for(; this.pendingElements.length;){
                    var t1 = this.pendingElements.pop();
                    if (t1.checkParenting(), t1.data.tt) for(var e1 = 0, i1 = this.elements.length; e1 < i1;){
                        if (this.elements[e1] === t1) {
                            var r1 = "tp" in t1.data ? this.findIndexByInd(t1.data.tp) : e1 - 1, a1 = this.elements[r1].getMatte(this.layers[e1].tt);
                            t1.setMatte(a1);
                            break;
                        }
                        e1 += 1;
                    }
                }
            }, SVGRendererBase.prototype.renderFrame = function(t1) {
                if (this.renderedFrame !== t1 && !this.destroyed) {
                    var e1;
                    null === t1 ? t1 = this.renderedFrame : this.renderedFrame = t1, this.globalData.frameNum = t1, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = t1, this.globalData._mdf = !1;
                    var i1 = this.layers.length;
                    for(this.completeLayers || this.checkLayers(t1), e1 = i1 - 1; e1 >= 0; e1 -= 1)(this.completeLayers || this.elements[e1]) && this.elements[e1].prepareFrame(t1 - this.layers[e1].st);
                    if (this.globalData._mdf) for(e1 = 0; e1 < i1; e1 += 1)(this.completeLayers || this.elements[e1]) && this.elements[e1].renderFrame();
                }
            }, SVGRendererBase.prototype.appendElementInPos = function(t1, e1) {
                var i1 = t1.getBaseElement();
                if (i1) {
                    for(var r1, a1 = 0; a1 < e1;)this.elements[a1] && !0 !== this.elements[a1] && this.elements[a1].getBaseElement() && (r1 = this.elements[a1].getBaseElement()), a1 += 1;
                    r1 ? this.layerElement.insertBefore(i1, r1) : this.layerElement.appendChild(i1);
                }
            }, SVGRendererBase.prototype.hide = function() {
                this.layerElement.style.display = "none";
            }, SVGRendererBase.prototype.show = function() {
                this.layerElement.style.display = "block";
            }, extendPrototype([
                BaseElement,
                TransformElement,
                HierarchyElement,
                FrameElement,
                RenderableDOMElement
            ], ICompElement), ICompElement.prototype.initElement = function(t1, e1, i1) {
                this.initFrame(), this.initBaseData(t1, e1, i1), this.initTransform(t1, e1, i1), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), !this.data.xt && e1.progressiveLoad || this.buildAllItems(), this.hide();
            }, ICompElement.prototype.prepareFrame = function(t1) {
                if (this._mdf = !1, this.prepareRenderableFrame(t1), this.prepareProperties(t1, this.isInRange), this.isInRange || this.data.xt) {
                    if (this.tm._placeholder) this.renderedFrame = t1 / this.data.sr;
                    else {
                        var e1 = this.tm.v;
                        e1 === this.data.op && (e1 = this.data.op - 1), this.renderedFrame = e1;
                    }
                    var i1, r1 = this.elements.length;
                    for(this.completeLayers || this.checkLayers(this.renderedFrame), i1 = r1 - 1; i1 >= 0; i1 -= 1)(this.completeLayers || this.elements[i1]) && (this.elements[i1].prepareFrame(this.renderedFrame - this.layers[i1].st), this.elements[i1]._mdf && (this._mdf = !0));
                }
            }, ICompElement.prototype.renderInnerContent = function() {
                var t1, e1 = this.layers.length;
                for(t1 = 0; t1 < e1; t1 += 1)(this.completeLayers || this.elements[t1]) && this.elements[t1].renderFrame();
            }, ICompElement.prototype.setElements = function(t1) {
                this.elements = t1;
            }, ICompElement.prototype.getElements = function() {
                return this.elements;
            }, ICompElement.prototype.destroyElements = function() {
                var t1, e1 = this.layers.length;
                for(t1 = 0; t1 < e1; t1 += 1)this.elements[t1] && this.elements[t1].destroy();
            }, ICompElement.prototype.destroy = function() {
                this.destroyElements(), this.destroyBaseElement();
            }, extendPrototype([
                SVGRendererBase,
                ICompElement,
                SVGBaseElement
            ], SVGCompElement), SVGCompElement.prototype.createComp = function(t1) {
                return new SVGCompElement(t1, this.globalData, this);
            }, extendPrototype([
                SVGRendererBase
            ], SVGRenderer), SVGRenderer.prototype.createComp = function(t1) {
                return new SVGCompElement(t1, this.globalData, this);
            }, CVContextData.prototype.duplicate = function() {
                var t1 = 2 * this._length, e1 = this.savedOp;
                this.savedOp = createTypedArray("float32", t1), this.savedOp.set(e1);
                var i1 = 0;
                for(i1 = this._length; i1 < t1; i1 += 1)this.saved[i1] = createTypedArray("float32", 16);
                this._length = t1;
            }, CVContextData.prototype.reset = function() {
                this.cArrPos = 0, this.cTr.reset(), this.cO = 1;
            }, ShapeTransformManager.prototype = {
                addTransformSequence: function(t1) {
                    var e1, i1 = t1.length, r1 = "_";
                    for(e1 = 0; e1 < i1; e1 += 1)r1 += t1[e1].transform.key + "_";
                    var a1 = this.sequences[r1];
                    return a1 || (a1 = {
                        transforms: [].concat(t1),
                        finalTransform: new Matrix,
                        _mdf: !1
                    }, this.sequences[r1] = a1, this.sequenceList.push(a1)), a1;
                },
                processSequence: function(t1, e1) {
                    for(var i1, r1 = 0, a1 = t1.transforms.length, s1 = e1; r1 < a1 && !e1;){
                        if (t1.transforms[r1].transform.mProps._mdf) {
                            s1 = !0;
                            break;
                        }
                        r1 += 1;
                    }
                    if (s1) for(t1.finalTransform.reset(), r1 = a1 - 1; r1 >= 0; r1 -= 1)i1 = t1.transforms[r1].transform.mProps.v.props, t1.finalTransform.transform(i1[0], i1[1], i1[2], i1[3], i1[4], i1[5], i1[6], i1[7], i1[8], i1[9], i1[10], i1[11], i1[12], i1[13], i1[14], i1[15]);
                    t1._mdf = s1;
                },
                processSequences: function(t1) {
                    var e1, i1 = this.sequenceList.length;
                    for(e1 = 0; e1 < i1; e1 += 1)this.processSequence(this.sequenceList[e1], t1);
                },
                getNewKey: function() {
                    return this.transform_key_count += 1, "_" + this.transform_key_count;
                }
            }, CVEffects.prototype.renderFrame = function() {}, CVMaskElement.prototype.renderFrame = function() {
                if (this.hasMasks) {
                    var t1, e1, i1, r1, a1 = this.element.finalTransform.mat, s1 = this.element.canvasContext, n1 = this.masksProperties.length;
                    for(s1.beginPath(), t1 = 0; t1 < n1; t1 += 1)if ("n" !== this.masksProperties[t1].mode) {
                        var o1;
                        this.masksProperties[t1].inv && (s1.moveTo(0, 0), s1.lineTo(this.element.globalData.compSize.w, 0), s1.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), s1.lineTo(0, this.element.globalData.compSize.h), s1.lineTo(0, 0)), r1 = this.viewData[t1].v, e1 = a1.applyToPointArray(r1.v[0][0], r1.v[0][1], 0), s1.moveTo(e1[0], e1[1]);
                        var h1 = r1._length;
                        for(o1 = 1; o1 < h1; o1 += 1)i1 = a1.applyToTriplePoints(r1.o[o1 - 1], r1.i[o1], r1.v[o1]), s1.bezierCurveTo(i1[0], i1[1], i1[2], i1[3], i1[4], i1[5]);
                        i1 = a1.applyToTriplePoints(r1.o[o1 - 1], r1.i[0], r1.v[0]), s1.bezierCurveTo(i1[0], i1[1], i1[2], i1[3], i1[4], i1[5]);
                    }
                    this.element.globalData.renderer.save(!0), s1.clip();
                }
            }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
                this.element = null;
            }, CVBaseElement.prototype = {
                createElements: function() {},
                initRendererElement: function() {},
                createContainerElements: function() {
                    this.canvasContext = this.globalData.canvasContext, this.renderableEffectsManager = new CVEffects(this);
                },
                createContent: function() {},
                setBlendMode: function() {
                    var t1 = this.globalData;
                    if (t1.blendMode !== this.data.bm) {
                        t1.blendMode = this.data.bm;
                        var e1 = getBlendMode(this.data.bm);
                        t1.canvasContext.globalCompositeOperation = e1;
                    }
                },
                createRenderableComponents: function() {
                    this.maskManager = new CVMaskElement(this.data, this);
                },
                hideElement: function() {
                    this.hidden || this.isInRange && !this.isTransparent || (this.hidden = !0);
                },
                showElement: function() {
                    this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
                },
                renderFrame: function() {
                    if (!this.hidden && !this.data.hd) {
                        this.renderTransform(), this.renderRenderable(), this.setBlendMode();
                        var t1 = 0 === this.data.ty;
                        this.globalData.renderer.save(t1), this.globalData.renderer.ctxTransform(this.finalTransform.mat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.mProp.o.v), this.renderInnerContent(), this.globalData.renderer.restore(t1), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
                    }
                },
                destroy: function() {
                    this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
                },
                mHelper: new Matrix
            }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement, CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated, extendPrototype([
                BaseElement,
                TransformElement,
                CVBaseElement,
                IShapeElement,
                HierarchyElement,
                FrameElement,
                RenderableElement
            ], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = {
                opacity: 1,
                _opMdf: !1
            }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
                this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
            }, CVShapeElement.prototype.createStyleElement = function(t1, e1) {
                var i1 = {
                    data: t1,
                    type: t1.ty,
                    preTransforms: this.transformsManager.addTransformSequence(e1),
                    transforms: [],
                    elements: [],
                    closed: !0 === t1.hd
                }, r1 = {};
                if ("fl" === t1.ty || "st" === t1.ty ? (r1.c = PropertyFactory.getProp(this, t1.c, 1, 255, this), r1.c.k || (i1.co = "rgb(" + bmFloor(r1.c.v[0]) + "," + bmFloor(r1.c.v[1]) + "," + bmFloor(r1.c.v[2]) + ")")) : "gf" !== t1.ty && "gs" !== t1.ty || (r1.s = PropertyFactory.getProp(this, t1.s, 1, null, this), r1.e = PropertyFactory.getProp(this, t1.e, 1, null, this), r1.h = PropertyFactory.getProp(this, t1.h || {
                    k: 0
                }, 0, .01, this), r1.a = PropertyFactory.getProp(this, t1.a || {
                    k: 0
                }, 0, degToRads, this), r1.g = new GradientProperty(this, t1.g, this)), r1.o = PropertyFactory.getProp(this, t1.o, 0, .01, this), "st" === t1.ty || "gs" === t1.ty) {
                    if (i1.lc = lineCapEnum[t1.lc || 2], i1.lj = lineJoinEnum[t1.lj || 2], 1 == t1.lj && (i1.ml = t1.ml), r1.w = PropertyFactory.getProp(this, t1.w, 0, null, this), r1.w.k || (i1.wi = r1.w.v), t1.d) {
                        var a1 = new DashProperty(this, t1.d, "canvas", this);
                        r1.d = a1, r1.d.k || (i1.da = r1.d.dashArray, i1.do = r1.d.dashoffset[0]);
                    }
                } else i1.r = 2 === t1.r ? "evenodd" : "nonzero";
                return this.stylesList.push(i1), r1.style = i1, r1;
            }, CVShapeElement.prototype.createGroupElement = function() {
                return {
                    it: [],
                    prevViewData: []
                };
            }, CVShapeElement.prototype.createTransformElement = function(t1) {
                return {
                    transform: {
                        opacity: 1,
                        _opMdf: !1,
                        key: this.transformsManager.getNewKey(),
                        op: PropertyFactory.getProp(this, t1.o, 0, .01, this),
                        mProps: TransformPropertyFactory.getTransformProperty(this, t1, this)
                    }
                };
            }, CVShapeElement.prototype.createShapeElement = function(t1) {
                var e1 = new CVShapeData(this, t1, this.stylesList, this.transformsManager);
                return this.shapes.push(e1), this.addShapeToModifiers(e1), e1;
            }, CVShapeElement.prototype.reloadShapes = function() {
                var t1;
                this._isFirstFrame = !0;
                var e1 = this.itemsData.length;
                for(t1 = 0; t1 < e1; t1 += 1)this.prevViewData[t1] = this.itemsData[t1];
                for(this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), e1 = this.dynamicProperties.length, t1 = 0; t1 < e1; t1 += 1)this.dynamicProperties[t1].getValue();
                this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
            }, CVShapeElement.prototype.addTransformToStyleList = function(t1) {
                var e1, i1 = this.stylesList.length;
                for(e1 = 0; e1 < i1; e1 += 1)this.stylesList[e1].closed || this.stylesList[e1].transforms.push(t1);
            }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
                var t1, e1 = this.stylesList.length;
                for(t1 = 0; t1 < e1; t1 += 1)this.stylesList[t1].closed || this.stylesList[t1].transforms.pop();
            }, CVShapeElement.prototype.closeStyles = function(t1) {
                var e1, i1 = t1.length;
                for(e1 = 0; e1 < i1; e1 += 1)t1[e1].closed = !0;
            }, CVShapeElement.prototype.searchShapes = function(t1, e1, i1, r1, a1) {
                var s1, n1, o1, h1, l1, p1, f1 = t1.length - 1, d1 = [], c1 = [], m1 = [].concat(a1);
                for(s1 = f1; s1 >= 0; s1 -= 1){
                    if ((h1 = this.searchProcessedElement(t1[s1])) ? e1[s1] = i1[h1 - 1] : t1[s1]._shouldRender = r1, "fl" === t1[s1].ty || "st" === t1[s1].ty || "gf" === t1[s1].ty || "gs" === t1[s1].ty) h1 ? e1[s1].style.closed = !1 : e1[s1] = this.createStyleElement(t1[s1], m1), d1.push(e1[s1].style);
                    else if ("gr" === t1[s1].ty) {
                        if (h1) for(o1 = e1[s1].it.length, n1 = 0; n1 < o1; n1 += 1)e1[s1].prevViewData[n1] = e1[s1].it[n1];
                        else e1[s1] = this.createGroupElement(t1[s1]);
                        this.searchShapes(t1[s1].it, e1[s1].it, e1[s1].prevViewData, r1, m1);
                    } else "tr" === t1[s1].ty ? (h1 || (p1 = this.createTransformElement(t1[s1]), e1[s1] = p1), m1.push(e1[s1]), this.addTransformToStyleList(e1[s1])) : "sh" === t1[s1].ty || "rc" === t1[s1].ty || "el" === t1[s1].ty || "sr" === t1[s1].ty ? h1 || (e1[s1] = this.createShapeElement(t1[s1])) : "tm" === t1[s1].ty || "rd" === t1[s1].ty || "pb" === t1[s1].ty || "zz" === t1[s1].ty || "op" === t1[s1].ty ? (h1 ? (l1 = e1[s1]).closed = !1 : ((l1 = ShapeModifiers.getModifier(t1[s1].ty)).init(this, t1[s1]), e1[s1] = l1, this.shapeModifiers.push(l1)), c1.push(l1)) : "rp" === t1[s1].ty && (h1 ? (l1 = e1[s1]).closed = !0 : (l1 = ShapeModifiers.getModifier(t1[s1].ty), e1[s1] = l1, l1.init(this, t1, s1, e1), this.shapeModifiers.push(l1), r1 = !1), c1.push(l1));
                    this.addProcessedElement(t1[s1], s1 + 1);
                }
                for(this.removeTransformFromStyleList(), this.closeStyles(d1), f1 = c1.length, s1 = 0; s1 < f1; s1 += 1)c1[s1].closed = !0;
            }, CVShapeElement.prototype.renderInnerContent = function() {
                this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
            }, CVShapeElement.prototype.renderShapeTransform = function(t1, e1) {
                (t1._opMdf || e1.op._mdf || this._isFirstFrame) && (e1.opacity = t1.opacity, e1.opacity *= e1.op.v, e1._opMdf = !0);
            }, CVShapeElement.prototype.drawLayer = function() {
                var t1, e1, i1, r1, a1, s1, n1, o1, h1, l1 = this.stylesList.length, p1 = this.globalData.renderer, f1 = this.globalData.canvasContext;
                for(t1 = 0; t1 < l1; t1 += 1)if (("st" !== (o1 = (h1 = this.stylesList[t1]).type) && "gs" !== o1 || 0 !== h1.wi) && h1.data._shouldRender && 0 !== h1.coOp && 0 !== this.globalData.currentGlobalAlpha) {
                    for(p1.save(), s1 = h1.elements, "st" === o1 || "gs" === o1 ? (f1.strokeStyle = "st" === o1 ? h1.co : h1.grd, f1.lineWidth = h1.wi, f1.lineCap = h1.lc, f1.lineJoin = h1.lj, f1.miterLimit = h1.ml || 0) : f1.fillStyle = "fl" === o1 ? h1.co : h1.grd, p1.ctxOpacity(h1.coOp), "st" !== o1 && "gs" !== o1 && f1.beginPath(), p1.ctxTransform(h1.preTransforms.finalTransform.props), i1 = s1.length, e1 = 0; e1 < i1; e1 += 1){
                        for("st" !== o1 && "gs" !== o1 || (f1.beginPath(), h1.da && (f1.setLineDash(h1.da), f1.lineDashOffset = h1.do)), a1 = (n1 = s1[e1].trNodes).length, r1 = 0; r1 < a1; r1 += 1)"m" === n1[r1].t ? f1.moveTo(n1[r1].p[0], n1[r1].p[1]) : "c" === n1[r1].t ? f1.bezierCurveTo(n1[r1].pts[0], n1[r1].pts[1], n1[r1].pts[2], n1[r1].pts[3], n1[r1].pts[4], n1[r1].pts[5]) : f1.closePath();
                        "st" !== o1 && "gs" !== o1 || (f1.stroke(), h1.da && f1.setLineDash(this.dashResetter));
                    }
                    "st" !== o1 && "gs" !== o1 && f1.fill(h1.r), p1.restore();
                }
            }, CVShapeElement.prototype.renderShape = function(t1, e1, i1, r1) {
                var a1, s1;
                for(s1 = t1, a1 = e1.length - 1; a1 >= 0; a1 -= 1)"tr" === e1[a1].ty ? (s1 = i1[a1].transform, this.renderShapeTransform(t1, s1)) : "sh" === e1[a1].ty || "el" === e1[a1].ty || "rc" === e1[a1].ty || "sr" === e1[a1].ty ? this.renderPath(e1[a1], i1[a1]) : "fl" === e1[a1].ty ? this.renderFill(e1[a1], i1[a1], s1) : "st" === e1[a1].ty ? this.renderStroke(e1[a1], i1[a1], s1) : "gf" === e1[a1].ty || "gs" === e1[a1].ty ? this.renderGradientFill(e1[a1], i1[a1], s1) : "gr" === e1[a1].ty ? this.renderShape(s1, e1[a1].it, i1[a1].it) : e1[a1].ty;
                r1 && this.drawLayer();
            }, CVShapeElement.prototype.renderStyledShape = function(t1, e1) {
                if (this._isFirstFrame || e1._mdf || t1.transforms._mdf) {
                    var i1, r1, a1, s1 = t1.trNodes, n1 = e1.paths, o1 = n1._length;
                    s1.length = 0;
                    var h1 = t1.transforms.finalTransform;
                    for(a1 = 0; a1 < o1; a1 += 1){
                        var l1 = n1.shapes[a1];
                        if (l1 && l1.v) {
                            for(r1 = l1._length, i1 = 1; i1 < r1; i1 += 1)1 === i1 && s1.push({
                                t: "m",
                                p: h1.applyToPointArray(l1.v[0][0], l1.v[0][1], 0)
                            }), s1.push({
                                t: "c",
                                pts: h1.applyToTriplePoints(l1.o[i1 - 1], l1.i[i1], l1.v[i1])
                            });
                            1 === r1 && s1.push({
                                t: "m",
                                p: h1.applyToPointArray(l1.v[0][0], l1.v[0][1], 0)
                            }), l1.c && r1 && (s1.push({
                                t: "c",
                                pts: h1.applyToTriplePoints(l1.o[i1 - 1], l1.i[0], l1.v[0])
                            }), s1.push({
                                t: "z"
                            }));
                        }
                    }
                    t1.trNodes = s1;
                }
            }, CVShapeElement.prototype.renderPath = function(t1, e1) {
                if (!0 !== t1.hd && t1._shouldRender) {
                    var i1, r1 = e1.styledShapes.length;
                    for(i1 = 0; i1 < r1; i1 += 1)this.renderStyledShape(e1.styledShapes[i1], e1.sh);
                }
            }, CVShapeElement.prototype.renderFill = function(t1, e1, i1) {
                var r1 = e1.style;
                (e1.c._mdf || this._isFirstFrame) && (r1.co = "rgb(" + bmFloor(e1.c.v[0]) + "," + bmFloor(e1.c.v[1]) + "," + bmFloor(e1.c.v[2]) + ")"), (e1.o._mdf || i1._opMdf || this._isFirstFrame) && (r1.coOp = e1.o.v * i1.opacity);
            }, CVShapeElement.prototype.renderGradientFill = function(t1, e1, i1) {
                var r1, a1 = e1.style;
                if (!a1.grd || e1.g._mdf || e1.s._mdf || e1.e._mdf || 1 !== t1.t && (e1.h._mdf || e1.a._mdf)) {
                    var s1, n1 = this.globalData.canvasContext, o1 = e1.s.v, h1 = e1.e.v;
                    if (1 === t1.t) r1 = n1.createLinearGradient(o1[0], o1[1], h1[0], h1[1]);
                    else {
                        var l1 = Math.sqrt(Math.pow(o1[0] - h1[0], 2) + Math.pow(o1[1] - h1[1], 2)), p1 = Math.atan2(h1[1] - o1[1], h1[0] - o1[0]), f1 = e1.h.v;
                        f1 >= 1 ? f1 = .99 : f1 <= -1 && (f1 = -0.99);
                        var d1 = l1 * f1, c1 = Math.cos(p1 + e1.a.v) * d1 + o1[0], m1 = Math.sin(p1 + e1.a.v) * d1 + o1[1];
                        r1 = n1.createRadialGradient(c1, m1, 0, o1[0], o1[1], l1);
                    }
                    var u1 = t1.g.p, y1 = e1.g.c, g1 = 1;
                    for(s1 = 0; s1 < u1; s1 += 1)e1.g._hasOpacity && e1.g._collapsable && (g1 = e1.g.o[2 * s1 + 1]), r1.addColorStop(y1[4 * s1] / 100, "rgba(" + y1[4 * s1 + 1] + "," + y1[4 * s1 + 2] + "," + y1[4 * s1 + 3] + "," + g1 + ")");
                    a1.grd = r1;
                }
                a1.coOp = e1.o.v * i1.opacity;
            }, CVShapeElement.prototype.renderStroke = function(t1, e1, i1) {
                var r1 = e1.style, a1 = e1.d;
                a1 && (a1._mdf || this._isFirstFrame) && (r1.da = a1.dashArray, r1.do = a1.dashoffset[0]), (e1.c._mdf || this._isFirstFrame) && (r1.co = "rgb(" + bmFloor(e1.c.v[0]) + "," + bmFloor(e1.c.v[1]) + "," + bmFloor(e1.c.v[2]) + ")"), (e1.o._mdf || i1._opMdf || this._isFirstFrame) && (r1.coOp = e1.o.v * i1.opacity), (e1.w._mdf || this._isFirstFrame) && (r1.wi = e1.w.v);
            }, CVShapeElement.prototype.destroy = function() {
                this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
            }, extendPrototype([
                BaseElement,
                TransformElement,
                CVBaseElement,
                HierarchyElement,
                FrameElement,
                RenderableElement,
                ITextElement
            ], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
                var t1 = this.textProperty.currentData;
                this.renderedLetters = createSizedArray(t1.l ? t1.l.length : 0);
                var e1 = !1;
                t1.fc ? (e1 = !0, this.values.fill = this.buildColor(t1.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = e1;
                var i1 = !1;
                t1.sc && (i1 = !0, this.values.stroke = this.buildColor(t1.sc), this.values.sWidth = t1.sw);
                var r1, a1, s1, n1, o1, h1, l1, p1, f1, d1, c1, m1, u1 = this.globalData.fontManager.getFontByName(t1.f), y1 = t1.l, g1 = this.mHelper;
                this.stroke = i1, this.values.fValue = t1.finalSize + "px " + this.globalData.fontManager.getFontByName(t1.f).fFamily, a1 = t1.finalText.length;
                var _1 = this.data.singleShape, v1 = .001 * t1.tr * t1.finalSize, b1 = 0, E1 = 0, S1 = !0, A1 = 0;
                for(r1 = 0; r1 < a1; r1 += 1){
                    n1 = (s1 = this.globalData.fontManager.getCharData(t1.finalText[r1], u1.fStyle, this.globalData.fontManager.getFontByName(t1.f).fFamily)) && s1.data || {}, g1.reset(), _1 && y1[r1].n && (b1 = -v1, E1 += t1.yOffset, E1 += S1 ? 1 : 0, S1 = !1), f1 = (l1 = n1.shapes ? n1.shapes[0].it : []).length, g1.scale(t1.finalSize / 100, t1.finalSize / 100), _1 && this.applyTextPropertiesToMatrix(t1, g1, y1[r1].line, b1, E1), c1 = createSizedArray(f1 - 1);
                    var P1 = 0;
                    for(p1 = 0; p1 < f1; p1 += 1)if ("sh" === l1[p1].ty) {
                        for(h1 = l1[p1].ks.k.i.length, d1 = l1[p1].ks.k, m1 = [], o1 = 1; o1 < h1; o1 += 1)1 === o1 && m1.push(g1.applyToX(d1.v[0][0], d1.v[0][1], 0), g1.applyToY(d1.v[0][0], d1.v[0][1], 0)), m1.push(g1.applyToX(d1.o[o1 - 1][0], d1.o[o1 - 1][1], 0), g1.applyToY(d1.o[o1 - 1][0], d1.o[o1 - 1][1], 0), g1.applyToX(d1.i[o1][0], d1.i[o1][1], 0), g1.applyToY(d1.i[o1][0], d1.i[o1][1], 0), g1.applyToX(d1.v[o1][0], d1.v[o1][1], 0), g1.applyToY(d1.v[o1][0], d1.v[o1][1], 0));
                        m1.push(g1.applyToX(d1.o[o1 - 1][0], d1.o[o1 - 1][1], 0), g1.applyToY(d1.o[o1 - 1][0], d1.o[o1 - 1][1], 0), g1.applyToX(d1.i[0][0], d1.i[0][1], 0), g1.applyToY(d1.i[0][0], d1.i[0][1], 0), g1.applyToX(d1.v[0][0], d1.v[0][1], 0), g1.applyToY(d1.v[0][0], d1.v[0][1], 0)), c1[P1] = m1, P1 += 1;
                    }
                    _1 && (b1 += y1[r1].l, b1 += v1), this.textSpans[A1] ? this.textSpans[A1].elem = c1 : this.textSpans[A1] = {
                        elem: c1
                    }, A1 += 1;
                }
            }, CVTextElement.prototype.renderInnerContent = function() {
                var t1, e1, i1, r1, a1, s1, n1 = this.canvasContext;
                n1.font = this.values.fValue, n1.lineCap = "butt", n1.lineJoin = "miter", n1.miterLimit = 4, this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
                var o1, h1 = this.textAnimator.renderedLetters, l1 = this.textProperty.currentData.l;
                e1 = l1.length;
                var p1, f1, d1 = null, c1 = null, m1 = null;
                for(t1 = 0; t1 < e1; t1 += 1)if (!l1[t1].n) {
                    if ((o1 = h1[t1]) && (this.globalData.renderer.save(), this.globalData.renderer.ctxTransform(o1.p), this.globalData.renderer.ctxOpacity(o1.o)), this.fill) {
                        for(o1 && o1.fc ? d1 !== o1.fc && (d1 = o1.fc, n1.fillStyle = o1.fc) : d1 !== this.values.fill && (d1 = this.values.fill, n1.fillStyle = this.values.fill), r1 = (p1 = this.textSpans[t1].elem).length, this.globalData.canvasContext.beginPath(), i1 = 0; i1 < r1; i1 += 1)for(s1 = (f1 = p1[i1]).length, this.globalData.canvasContext.moveTo(f1[0], f1[1]), a1 = 2; a1 < s1; a1 += 6)this.globalData.canvasContext.bezierCurveTo(f1[a1], f1[a1 + 1], f1[a1 + 2], f1[a1 + 3], f1[a1 + 4], f1[a1 + 5]);
                        this.globalData.canvasContext.closePath(), this.globalData.canvasContext.fill();
                    }
                    if (this.stroke) {
                        for(o1 && o1.sw ? m1 !== o1.sw && (m1 = o1.sw, n1.lineWidth = o1.sw) : m1 !== this.values.sWidth && (m1 = this.values.sWidth, n1.lineWidth = this.values.sWidth), o1 && o1.sc ? c1 !== o1.sc && (c1 = o1.sc, n1.strokeStyle = o1.sc) : c1 !== this.values.stroke && (c1 = this.values.stroke, n1.strokeStyle = this.values.stroke), r1 = (p1 = this.textSpans[t1].elem).length, this.globalData.canvasContext.beginPath(), i1 = 0; i1 < r1; i1 += 1)for(s1 = (f1 = p1[i1]).length, this.globalData.canvasContext.moveTo(f1[0], f1[1]), a1 = 2; a1 < s1; a1 += 6)this.globalData.canvasContext.bezierCurveTo(f1[a1], f1[a1 + 1], f1[a1 + 2], f1[a1 + 3], f1[a1 + 4], f1[a1 + 5]);
                        this.globalData.canvasContext.closePath(), this.globalData.canvasContext.stroke();
                    }
                    o1 && this.globalData.renderer.restore();
                }
            }, extendPrototype([
                BaseElement,
                TransformElement,
                CVBaseElement,
                HierarchyElement,
                FrameElement,
                RenderableElement
            ], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
                if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
                    var t1 = createTag("canvas");
                    t1.width = this.assetData.w, t1.height = this.assetData.h;
                    var e1, i1, r1 = t1.getContext("2d"), a1 = this.img.width, s1 = this.img.height, n1 = a1 / s1, o1 = this.assetData.w / this.assetData.h, h1 = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
                    n1 > o1 && "xMidYMid slice" === h1 || n1 < o1 && "xMidYMid slice" !== h1 ? e1 = (i1 = s1) * o1 : i1 = (e1 = a1) / o1, r1.drawImage(this.img, (a1 - e1) / 2, (s1 - i1) / 2, e1, i1, 0, 0, this.assetData.w, this.assetData.h), this.img = t1;
                }
            }, CVImageElement.prototype.renderInnerContent = function() {
                this.canvasContext.drawImage(this.img, 0, 0);
            }, CVImageElement.prototype.destroy = function() {
                this.img = null;
            }, extendPrototype([
                BaseElement,
                TransformElement,
                CVBaseElement,
                HierarchyElement,
                FrameElement,
                RenderableElement
            ], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
                var t1 = this.canvasContext;
                t1.fillStyle = this.data.sc, t1.fillRect(0, 0, this.data.sw, this.data.sh);
            }, extendPrototype([
                BaseRenderer
            ], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(t1) {
                return new CVShapeElement(t1, this.globalData, this);
            }, CanvasRendererBase.prototype.createText = function(t1) {
                return new CVTextElement(t1, this.globalData, this);
            }, CanvasRendererBase.prototype.createImage = function(t1) {
                return new CVImageElement(t1, this.globalData, this);
            }, CanvasRendererBase.prototype.createSolid = function(t1) {
                return new CVSolidElement(t1, this.globalData, this);
            }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(t1) {
                if (1 !== t1[0] || 0 !== t1[1] || 0 !== t1[4] || 1 !== t1[5] || 0 !== t1[12] || 0 !== t1[13]) {
                    if (this.renderConfig.clearCanvas) {
                        this.transformMat.cloneFromProps(t1);
                        var e1 = this.contextData.cTr.props;
                        this.transformMat.transform(e1[0], e1[1], e1[2], e1[3], e1[4], e1[5], e1[6], e1[7], e1[8], e1[9], e1[10], e1[11], e1[12], e1[13], e1[14], e1[15]), this.contextData.cTr.cloneFromProps(this.transformMat.props);
                        var i1 = this.contextData.cTr.props;
                        this.canvasContext.setTransform(i1[0], i1[1], i1[4], i1[5], i1[12], i1[13]);
                    } else this.canvasContext.transform(t1[0], t1[1], t1[4], t1[5], t1[12], t1[13]);
                }
            }, CanvasRendererBase.prototype.ctxOpacity = function(t1) {
                if (!this.renderConfig.clearCanvas) return this.canvasContext.globalAlpha *= t1 < 0 ? 0 : t1, void (this.globalData.currentGlobalAlpha = this.contextData.cO);
                this.contextData.cO *= t1 < 0 ? 0 : t1, this.globalData.currentGlobalAlpha !== this.contextData.cO && (this.canvasContext.globalAlpha = this.contextData.cO, this.globalData.currentGlobalAlpha = this.contextData.cO);
            }, CanvasRendererBase.prototype.reset = function() {
                this.renderConfig.clearCanvas ? this.contextData.reset() : this.canvasContext.restore();
            }, CanvasRendererBase.prototype.save = function(t1) {
                if (this.renderConfig.clearCanvas) {
                    t1 && this.canvasContext.save();
                    var e1, i1 = this.contextData.cTr.props;
                    this.contextData._length <= this.contextData.cArrPos && this.contextData.duplicate();
                    var r1 = this.contextData.saved[this.contextData.cArrPos];
                    for(e1 = 0; e1 < 16; e1 += 1)r1[e1] = i1[e1];
                    this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO, this.contextData.cArrPos += 1;
                } else this.canvasContext.save();
            }, CanvasRendererBase.prototype.restore = function(t1) {
                if (this.renderConfig.clearCanvas) {
                    t1 && (this.canvasContext.restore(), this.globalData.blendMode = "source-over"), this.contextData.cArrPos -= 1;
                    var e1, i1 = this.contextData.saved[this.contextData.cArrPos], r1 = this.contextData.cTr.props;
                    for(e1 = 0; e1 < 16; e1 += 1)r1[e1] = i1[e1];
                    this.canvasContext.setTransform(i1[0], i1[1], i1[4], i1[5], i1[12], i1[13]), i1 = this.contextData.savedOp[this.contextData.cArrPos], this.contextData.cO = i1, this.globalData.currentGlobalAlpha !== i1 && (this.canvasContext.globalAlpha = i1, this.globalData.currentGlobalAlpha = i1);
                } else this.canvasContext.restore();
            }, CanvasRendererBase.prototype.configAnimation = function(t1) {
                if (this.animationItem.wrapper) {
                    this.animationItem.container = createTag("canvas");
                    var e1 = this.animationItem.container.style;
                    e1.width = "100%", e1.height = "100%";
                    var i1 = "0px 0px 0px";
                    e1.transformOrigin = i1, e1.mozTransformOrigin = i1, e1.webkitTransformOrigin = i1, e1["-webkit-transform"] = i1, e1.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
                } else this.canvasContext = this.renderConfig.context;
                this.data = t1, this.layers = t1.layers, this.transformCanvas = {
                    w: t1.w,
                    h: t1.h,
                    sx: 0,
                    sy: 0,
                    tx: 0,
                    ty: 0
                }, this.setupGlobalData(t1, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(t1.layers.length), this.updateContainerSize();
            }, CanvasRendererBase.prototype.updateContainerSize = function(t1, e1) {
                var i1, r1, a1, s1;
                if (this.reset(), t1 ? (i1 = t1, r1 = e1, this.canvasContext.canvas.width = i1, this.canvasContext.canvas.height = r1) : (this.animationItem.wrapper && this.animationItem.container ? (i1 = this.animationItem.wrapper.offsetWidth, r1 = this.animationItem.wrapper.offsetHeight) : (i1 = this.canvasContext.canvas.width, r1 = this.canvasContext.canvas.height), this.canvasContext.canvas.width = i1 * this.renderConfig.dpr, this.canvasContext.canvas.height = r1 * this.renderConfig.dpr), -1 !== this.renderConfig.preserveAspectRatio.indexOf("meet") || -1 !== this.renderConfig.preserveAspectRatio.indexOf("slice")) {
                    var n1 = this.renderConfig.preserveAspectRatio.split(" "), o1 = n1[1] || "meet", h1 = n1[0] || "xMidYMid", l1 = h1.substr(0, 4), p1 = h1.substr(4);
                    a1 = i1 / r1, (s1 = this.transformCanvas.w / this.transformCanvas.h) > a1 && "meet" === o1 || s1 < a1 && "slice" === o1 ? (this.transformCanvas.sx = i1 / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = i1 / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = r1 / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = r1 / (this.transformCanvas.h / this.renderConfig.dpr)), this.transformCanvas.tx = "xMid" === l1 && (s1 < a1 && "meet" === o1 || s1 > a1 && "slice" === o1) ? (i1 - this.transformCanvas.w * (r1 / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : "xMax" === l1 && (s1 < a1 && "meet" === o1 || s1 > a1 && "slice" === o1) ? (i1 - this.transformCanvas.w * (r1 / this.transformCanvas.h)) * this.renderConfig.dpr : 0, this.transformCanvas.ty = "YMid" === p1 && (s1 > a1 && "meet" === o1 || s1 < a1 && "slice" === o1) ? (r1 - this.transformCanvas.h * (i1 / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : "YMax" === p1 && (s1 > a1 && "meet" === o1 || s1 < a1 && "slice" === o1) ? (r1 - this.transformCanvas.h * (i1 / this.transformCanvas.w)) * this.renderConfig.dpr : 0;
                } else "none" === this.renderConfig.preserveAspectRatio ? (this.transformCanvas.sx = i1 / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = r1 / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
                this.transformCanvas.props = [
                    this.transformCanvas.sx,
                    0,
                    0,
                    0,
                    0,
                    this.transformCanvas.sy,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    this.transformCanvas.tx,
                    this.transformCanvas.ty,
                    0,
                    1
                ], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
            }, CanvasRendererBase.prototype.destroy = function() {
                var t1;
                for(this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), t1 = (this.layers ? this.layers.length : 0) - 1; t1 >= 0; t1 -= 1)this.elements[t1] && this.elements[t1].destroy();
                this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
            }, CanvasRendererBase.prototype.renderFrame = function(t1, e1) {
                if ((this.renderedFrame !== t1 || !0 !== this.renderConfig.clearCanvas || e1) && !this.destroyed && -1 !== t1) {
                    var i1;
                    this.renderedFrame = t1, this.globalData.frameNum = t1 - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || e1, this.globalData.projectInterface.currentFrame = t1;
                    var r1 = this.layers.length;
                    for(this.completeLayers || this.checkLayers(t1), i1 = 0; i1 < r1; i1 += 1)(this.completeLayers || this.elements[i1]) && this.elements[i1].prepareFrame(t1 - this.layers[i1].st);
                    if (this.globalData._mdf) {
                        for(!0 === this.renderConfig.clearCanvas ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), i1 = r1 - 1; i1 >= 0; i1 -= 1)(this.completeLayers || this.elements[i1]) && this.elements[i1].renderFrame();
                        !0 !== this.renderConfig.clearCanvas && this.restore();
                    }
                }
            }, CanvasRendererBase.prototype.buildItem = function(t1) {
                var e1 = this.elements;
                if (!e1[t1] && 99 !== this.layers[t1].ty) {
                    var i1 = this.createItem(this.layers[t1], this, this.globalData);
                    e1[t1] = i1, i1.initExpressions();
                }
            }, CanvasRendererBase.prototype.checkPendingElements = function() {
                for(; this.pendingElements.length;)this.pendingElements.pop().checkParenting();
            }, CanvasRendererBase.prototype.hide = function() {
                this.animationItem.container.style.display = "none";
            }, CanvasRendererBase.prototype.show = function() {
                this.animationItem.container.style.display = "block";
            }, extendPrototype([
                CanvasRendererBase,
                ICompElement,
                CVBaseElement
            ], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
                var t1, e1 = this.canvasContext;
                for(e1.beginPath(), e1.moveTo(0, 0), e1.lineTo(this.data.w, 0), e1.lineTo(this.data.w, this.data.h), e1.lineTo(0, this.data.h), e1.lineTo(0, 0), e1.clip(), t1 = this.layers.length - 1; t1 >= 0; t1 -= 1)(this.completeLayers || this.elements[t1]) && this.elements[t1].renderFrame();
            }, CVCompElement.prototype.destroy = function() {
                var t1;
                for(t1 = this.layers.length - 1; t1 >= 0; t1 -= 1)this.elements[t1] && this.elements[t1].destroy();
                this.layers = null, this.elements = null;
            }, CVCompElement.prototype.createComp = function(t1) {
                return new CVCompElement(t1, this.globalData, this);
            }, extendPrototype([
                CanvasRendererBase
            ], CanvasRenderer), CanvasRenderer.prototype.createComp = function(t1) {
                return new CVCompElement(t1, this.globalData, this);
            }, HBaseElement.prototype = {
                checkBlendMode: function() {},
                initRendererElement: function() {
                    this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
                },
                createContainerElements: function() {
                    this.renderableEffectsManager = new CVEffects(this), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 !== this.data.bm && this.setBlendMode();
                },
                renderElement: function() {
                    var t1 = this.transformedElement ? this.transformedElement.style : {};
                    if (this.finalTransform._matMdf) {
                        var e1 = this.finalTransform.mat.toCSS();
                        t1.transform = e1, t1.webkitTransform = e1;
                    }
                    this.finalTransform._opMdf && (t1.opacity = this.finalTransform.mProp.o.v);
                },
                renderFrame: function() {
                    this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
                },
                destroy: function() {
                    this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
                },
                createRenderableComponents: function() {
                    this.maskManager = new MaskElement(this.data, this, this.globalData);
                },
                addEffects: function() {},
                setMatte: function() {}
            }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting, extendPrototype([
                BaseElement,
                TransformElement,
                HBaseElement,
                HierarchyElement,
                FrameElement,
                RenderableDOMElement
            ], HSolidElement), HSolidElement.prototype.createContent = function() {
                var t1;
                this.data.hasMask ? ((t1 = createNS("rect")).setAttribute("width", this.data.sw), t1.setAttribute("height", this.data.sh), t1.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : ((t1 = createTag("div")).style.width = this.data.sw + "px", t1.style.height = this.data.sh + "px", t1.style.backgroundColor = this.data.sc), this.layerElement.appendChild(t1);
            }, extendPrototype([
                BaseElement,
                TransformElement,
                HSolidElement,
                SVGShapeElement,
                HBaseElement,
                HierarchyElement,
                FrameElement,
                RenderableElement
            ], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
                var t1;
                if (this.baseElement.style.fontSize = 0, this.data.hasMask) this.layerElement.appendChild(this.shapesContainer), t1 = this.svgElement;
                else {
                    t1 = createNS("svg");
                    var e1 = this.comp.data ? this.comp.data : this.globalData.compSize;
                    t1.setAttribute("width", e1.w), t1.setAttribute("height", e1.h), t1.appendChild(this.shapesContainer), this.layerElement.appendChild(t1);
                }
                this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = t1;
            }, HShapeElement.prototype.getTransformedPoint = function(t1, e1) {
                var i1, r1 = t1.length;
                for(i1 = 0; i1 < r1; i1 += 1)e1 = t1[i1].mProps.v.applyToPointArray(e1[0], e1[1], 0);
                return e1;
            }, HShapeElement.prototype.calculateShapeBoundingBox = function(t1, e1) {
                var i1, r1, a1, s1, n1, o1 = t1.sh.v, h1 = t1.transformers, l1 = o1._length;
                if (!(l1 <= 1)) {
                    for(i1 = 0; i1 < l1 - 1; i1 += 1)r1 = this.getTransformedPoint(h1, o1.v[i1]), a1 = this.getTransformedPoint(h1, o1.o[i1]), s1 = this.getTransformedPoint(h1, o1.i[i1 + 1]), n1 = this.getTransformedPoint(h1, o1.v[i1 + 1]), this.checkBounds(r1, a1, s1, n1, e1);
                    o1.c && (r1 = this.getTransformedPoint(h1, o1.v[i1]), a1 = this.getTransformedPoint(h1, o1.o[i1]), s1 = this.getTransformedPoint(h1, o1.i[0]), n1 = this.getTransformedPoint(h1, o1.v[0]), this.checkBounds(r1, a1, s1, n1, e1));
                }
            }, HShapeElement.prototype.checkBounds = function(t1, e1, i1, r1, a1) {
                this.getBoundsOfCurve(t1, e1, i1, r1);
                var s1 = this.shapeBoundingBox;
                a1.x = bmMin(s1.left, a1.x), a1.xMax = bmMax(s1.right, a1.xMax), a1.y = bmMin(s1.top, a1.y), a1.yMax = bmMax(s1.bottom, a1.yMax);
            }, HShapeElement.prototype.shapeBoundingBox = {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }, HShapeElement.prototype.tempBoundingBox = {
                x: 0,
                xMax: 0,
                y: 0,
                yMax: 0,
                width: 0,
                height: 0
            }, HShapeElement.prototype.getBoundsOfCurve = function(t1, e1, i1, r1) {
                for(var a1, s1, n1, o1, h1, l1, p1, f1 = [
                    [
                        t1[0],
                        r1[0]
                    ],
                    [
                        t1[1],
                        r1[1]
                    ]
                ], d1 = 0; d1 < 2; ++d1)s1 = 6 * t1[d1] - 12 * e1[d1] + 6 * i1[d1], a1 = -3 * t1[d1] + 9 * e1[d1] - 9 * i1[d1] + 3 * r1[d1], n1 = 3 * e1[d1] - 3 * t1[d1], s1 |= 0, n1 |= 0, 0 == (a1 |= 0) && 0 === s1 || (0 === a1 ? (o1 = -n1 / s1) > 0 && o1 < 1 && f1[d1].push(this.calculateF(o1, t1, e1, i1, r1, d1)) : (h1 = s1 * s1 - 4 * n1 * a1) >= 0 && ((l1 = (-s1 + bmSqrt(h1)) / (2 * a1)) > 0 && l1 < 1 && f1[d1].push(this.calculateF(l1, t1, e1, i1, r1, d1)), (p1 = (-s1 - bmSqrt(h1)) / (2 * a1)) > 0 && p1 < 1 && f1[d1].push(this.calculateF(p1, t1, e1, i1, r1, d1))));
                this.shapeBoundingBox.left = bmMin.apply(null, f1[0]), this.shapeBoundingBox.top = bmMin.apply(null, f1[1]), this.shapeBoundingBox.right = bmMax.apply(null, f1[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, f1[1]);
            }, HShapeElement.prototype.calculateF = function(t1, e1, i1, r1, a1, s1) {
                return bmPow(1 - t1, 3) * e1[s1] + 3 * bmPow(1 - t1, 2) * t1 * i1[s1] + 3 * (1 - t1) * bmPow(t1, 2) * r1[s1] + bmPow(t1, 3) * a1[s1];
            }, HShapeElement.prototype.calculateBoundingBox = function(t1, e1) {
                var i1, r1 = t1.length;
                for(i1 = 0; i1 < r1; i1 += 1)t1[i1] && t1[i1].sh ? this.calculateShapeBoundingBox(t1[i1], e1) : t1[i1] && t1[i1].it ? this.calculateBoundingBox(t1[i1].it, e1) : t1[i1] && t1[i1].style && t1[i1].w && this.expandStrokeBoundingBox(t1[i1].w, e1);
            }, HShapeElement.prototype.expandStrokeBoundingBox = function(t1, e1) {
                var i1 = 0;
                if (t1.keyframes) {
                    for(var r1 = 0; r1 < t1.keyframes.length; r1 += 1){
                        var a1 = t1.keyframes[r1].s;
                        a1 > i1 && (i1 = a1);
                    }
                    i1 *= t1.mult;
                } else i1 = t1.v * t1.mult;
                e1.x -= i1, e1.xMax += i1, e1.y -= i1, e1.yMax += i1;
            }, HShapeElement.prototype.currentBoxContains = function(t1) {
                return this.currentBBox.x <= t1.x && this.currentBBox.y <= t1.y && this.currentBBox.width + this.currentBBox.x >= t1.x + t1.width && this.currentBBox.height + this.currentBBox.y >= t1.y + t1.height;
            }, HShapeElement.prototype.renderInnerContent = function() {
                if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
                    var t1 = this.tempBoundingBox, e1 = 999999;
                    if (t1.x = e1, t1.xMax = -e1, t1.y = e1, t1.yMax = -e1, this.calculateBoundingBox(this.itemsData, t1), t1.width = t1.xMax < t1.x ? 0 : t1.xMax - t1.x, t1.height = t1.yMax < t1.y ? 0 : t1.yMax - t1.y, this.currentBoxContains(t1)) return;
                    var i1 = !1;
                    if (this.currentBBox.w !== t1.width && (this.currentBBox.w = t1.width, this.shapeCont.setAttribute("width", t1.width), i1 = !0), this.currentBBox.h !== t1.height && (this.currentBBox.h = t1.height, this.shapeCont.setAttribute("height", t1.height), i1 = !0), i1 || this.currentBBox.x !== t1.x || this.currentBBox.y !== t1.y) {
                        this.currentBBox.w = t1.width, this.currentBBox.h = t1.height, this.currentBBox.x = t1.x, this.currentBBox.y = t1.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
                        var r1 = this.shapeCont.style, a1 = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                        r1.transform = a1, r1.webkitTransform = a1;
                    }
                }
            }, extendPrototype([
                BaseElement,
                TransformElement,
                HBaseElement,
                HierarchyElement,
                FrameElement,
                RenderableDOMElement,
                ITextElement
            ], HTextElement), HTextElement.prototype.createContent = function() {
                if (this.isMasked = this.checkMasks(), this.isMasked) {
                    this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
                    var t1 = createNS("g");
                    this.maskedElement.appendChild(t1), this.innerElem = t1;
                } else this.renderType = "html", this.innerElem = this.layerElement;
                this.checkParenting();
            }, HTextElement.prototype.buildNewText = function() {
                var t1 = this.textProperty.currentData;
                this.renderedLetters = createSizedArray(t1.l ? t1.l.length : 0);
                var e1 = this.innerElem.style, i1 = t1.fc ? this.buildColor(t1.fc) : "rgba(0,0,0,0)";
                e1.fill = i1, e1.color = i1, t1.sc && (e1.stroke = this.buildColor(t1.sc), e1.strokeWidth = t1.sw + "px");
                var r1, a1, s1 = this.globalData.fontManager.getFontByName(t1.f);
                if (!this.globalData.fontManager.chars) {
                    if (e1.fontSize = t1.finalSize + "px", e1.lineHeight = t1.finalSize + "px", s1.fClass) this.innerElem.className = s1.fClass;
                    else {
                        e1.fontFamily = s1.fFamily;
                        var n1 = t1.fWeight, o1 = t1.fStyle;
                        e1.fontStyle = o1, e1.fontWeight = n1;
                    }
                }
                var h1, l1, p1, f1 = t1.l;
                a1 = f1.length;
                var d1, c1 = this.mHelper, m1 = "", u1 = 0;
                for(r1 = 0; r1 < a1; r1 += 1){
                    if (this.globalData.fontManager.chars ? (this.textPaths[u1] ? h1 = this.textPaths[u1] : ((h1 = createNS("path")).setAttribute("stroke-linecap", lineCapEnum[1]), h1.setAttribute("stroke-linejoin", lineJoinEnum[2]), h1.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[u1] ? p1 = (l1 = this.textSpans[u1]).children[0] : ((l1 = createTag("div")).style.lineHeight = 0, (p1 = createNS("svg")).appendChild(h1), styleDiv(l1)))) : this.isMasked ? h1 = this.textPaths[u1] ? this.textPaths[u1] : createNS("text") : this.textSpans[u1] ? (l1 = this.textSpans[u1], h1 = this.textPaths[u1]) : (styleDiv(l1 = createTag("span")), styleDiv(h1 = createTag("span")), l1.appendChild(h1)), this.globalData.fontManager.chars) {
                        var y1, g1 = this.globalData.fontManager.getCharData(t1.finalText[r1], s1.fStyle, this.globalData.fontManager.getFontByName(t1.f).fFamily);
                        if (y1 = g1 ? g1.data : null, c1.reset(), y1 && y1.shapes && y1.shapes.length && (d1 = y1.shapes[0].it, c1.scale(t1.finalSize / 100, t1.finalSize / 100), m1 = this.createPathShape(c1, d1), h1.setAttribute("d", m1)), this.isMasked) this.innerElem.appendChild(h1);
                        else {
                            if (this.innerElem.appendChild(l1), y1 && y1.shapes) {
                                document.body.appendChild(p1);
                                var _1 = p1.getBBox();
                                p1.setAttribute("width", _1.width + 2), p1.setAttribute("height", _1.height + 2), p1.setAttribute("viewBox", _1.x - 1 + " " + (_1.y - 1) + " " + (_1.width + 2) + " " + (_1.height + 2));
                                var v1 = p1.style, b1 = "translate(" + (_1.x - 1) + "px," + (_1.y - 1) + "px)";
                                v1.transform = b1, v1.webkitTransform = b1, f1[r1].yOffset = _1.y - 1;
                            } else p1.setAttribute("width", 1), p1.setAttribute("height", 1);
                            l1.appendChild(p1);
                        }
                    } else if (h1.textContent = f1[r1].val, h1.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked) this.innerElem.appendChild(h1);
                    else {
                        this.innerElem.appendChild(l1);
                        var E1 = h1.style, S1 = "translate3d(0," + -t1.finalSize / 1.2 + "px,0)";
                        E1.transform = S1, E1.webkitTransform = S1;
                    }
                    this.isMasked ? this.textSpans[u1] = h1 : this.textSpans[u1] = l1, this.textSpans[u1].style.display = "block", this.textPaths[u1] = h1, u1 += 1;
                }
                for(; u1 < this.textSpans.length;)this.textSpans[u1].style.display = "none", u1 += 1;
            }, HTextElement.prototype.renderInnerContent = function() {
                var t1;
                if (this.data.singleShape) {
                    if (!this._isFirstFrame && !this.lettersChangedFlag) return;
                    if (this.isMasked && this.finalTransform._matMdf) {
                        this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), t1 = this.svgElement.style;
                        var e1 = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
                        t1.transform = e1, t1.webkitTransform = e1;
                    }
                }
                if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                    var i1, r1, a1, s1, n1, o1 = 0, h1 = this.textAnimator.renderedLetters, l1 = this.textProperty.currentData.l;
                    for(r1 = l1.length, i1 = 0; i1 < r1; i1 += 1)l1[i1].n ? o1 += 1 : (s1 = this.textSpans[i1], n1 = this.textPaths[i1], a1 = h1[o1], o1 += 1, a1._mdf.m && (this.isMasked ? s1.setAttribute("transform", a1.m) : (s1.style.webkitTransform = a1.m, s1.style.transform = a1.m)), s1.style.opacity = a1.o, a1.sw && a1._mdf.sw && n1.setAttribute("stroke-width", a1.sw), a1.sc && a1._mdf.sc && n1.setAttribute("stroke", a1.sc), a1.fc && a1._mdf.fc && (n1.setAttribute("fill", a1.fc), n1.style.color = a1.fc));
                    if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
                        var p1 = this.innerElem.getBBox();
                        if (this.currentBBox.w !== p1.width && (this.currentBBox.w = p1.width, this.svgElement.setAttribute("width", p1.width)), this.currentBBox.h !== p1.height && (this.currentBBox.h = p1.height, this.svgElement.setAttribute("height", p1.height)), this.currentBBox.w !== p1.width + 2 || this.currentBBox.h !== p1.height + 2 || this.currentBBox.x !== p1.x - 1 || this.currentBBox.y !== p1.y - 1) {
                            this.currentBBox.w = p1.width + 2, this.currentBBox.h = p1.height + 2, this.currentBBox.x = p1.x - 1, this.currentBBox.y = p1.y - 1, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), t1 = this.svgElement.style;
                            var f1 = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                            t1.transform = f1, t1.webkitTransform = f1;
                        }
                    }
                }
            }, extendPrototype([
                BaseElement,
                FrameElement,
                HierarchyElement
            ], HCameraElement), HCameraElement.prototype.setup = function() {
                var t1, e1, i1, r1, a1 = this.comp.threeDElements.length;
                for(t1 = 0; t1 < a1; t1 += 1)if ("3d" === (e1 = this.comp.threeDElements[t1]).type) {
                    i1 = e1.perspectiveElem.style, r1 = e1.container.style;
                    var s1 = this.pe.v + "px", n1 = "0px 0px 0px", o1 = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                    i1.perspective = s1, i1.webkitPerspective = s1, r1.transformOrigin = n1, r1.mozTransformOrigin = n1, r1.webkitTransformOrigin = n1, i1.transform = o1, i1.webkitTransform = o1;
                }
            }, HCameraElement.prototype.createElements = function() {}, HCameraElement.prototype.hide = function() {}, HCameraElement.prototype.renderFrame = function() {
                var t1, e1, i1 = this._isFirstFrame;
                if (this.hierarchy) for(e1 = this.hierarchy.length, t1 = 0; t1 < e1; t1 += 1)i1 = this.hierarchy[t1].finalTransform.mProp._mdf || i1;
                if (i1 || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
                    if (this.mat.reset(), this.hierarchy) for(t1 = e1 = this.hierarchy.length - 1; t1 >= 0; t1 -= 1){
                        var r1 = this.hierarchy[t1].finalTransform.mProp;
                        this.mat.translate(-r1.p.v[0], -r1.p.v[1], r1.p.v[2]), this.mat.rotateX(-r1.or.v[0]).rotateY(-r1.or.v[1]).rotateZ(r1.or.v[2]), this.mat.rotateX(-r1.rx.v).rotateY(-r1.ry.v).rotateZ(r1.rz.v), this.mat.scale(1 / r1.s.v[0], 1 / r1.s.v[1], 1 / r1.s.v[2]), this.mat.translate(r1.a.v[0], r1.a.v[1], r1.a.v[2]);
                    }
                    if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
                        var a1;
                        a1 = this.p ? [
                            this.p.v[0] - this.a.v[0],
                            this.p.v[1] - this.a.v[1],
                            this.p.v[2] - this.a.v[2]
                        ] : [
                            this.px.v - this.a.v[0],
                            this.py.v - this.a.v[1],
                            this.pz.v - this.a.v[2]
                        ];
                        var s1 = Math.sqrt(Math.pow(a1[0], 2) + Math.pow(a1[1], 2) + Math.pow(a1[2], 2)), n1 = [
                            a1[0] / s1,
                            a1[1] / s1,
                            a1[2] / s1
                        ], o1 = Math.sqrt(n1[2] * n1[2] + n1[0] * n1[0]), h1 = Math.atan2(n1[1], o1), l1 = Math.atan2(n1[0], -n1[2]);
                        this.mat.rotateY(l1).rotateX(-h1);
                    }
                    this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
                    var p1 = !this._prevMat.equals(this.mat);
                    if ((p1 || this.pe._mdf) && this.comp.threeDElements) {
                        var f1, d1, c1;
                        for(e1 = this.comp.threeDElements.length, t1 = 0; t1 < e1; t1 += 1)if ("3d" === (f1 = this.comp.threeDElements[t1]).type) {
                            if (p1) {
                                var m1 = this.mat.toCSS();
                                (c1 = f1.container.style).transform = m1, c1.webkitTransform = m1;
                            }
                            this.pe._mdf && ((d1 = f1.perspectiveElem.style).perspective = this.pe.v + "px", d1.webkitPerspective = this.pe.v + "px");
                        }
                        this.mat.clone(this._prevMat);
                    }
                }
                this._isFirstFrame = !1;
            }, HCameraElement.prototype.prepareFrame = function(t1) {
                this.prepareProperties(t1, !0);
            }, HCameraElement.prototype.destroy = function() {}, HCameraElement.prototype.getBaseElement = function() {
                return null;
            }, extendPrototype([
                BaseElement,
                TransformElement,
                HBaseElement,
                HSolidElement,
                HierarchyElement,
                FrameElement,
                RenderableElement
            ], HImageElement), HImageElement.prototype.createContent = function() {
                var t1 = this.globalData.getAssetsPath(this.assetData), e1 = new Image;
                this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t1), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(e1), e1.crossOrigin = "anonymous", e1.src = t1, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
            }, extendPrototype([
                BaseRenderer
            ], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
                for(; this.pendingElements.length;)this.pendingElements.pop().checkParenting();
            }, HybridRendererBase.prototype.appendElementInPos = function(t1, e1) {
                var i1 = t1.getBaseElement();
                if (i1) {
                    var r1 = this.layers[e1];
                    if (r1.ddd && this.supports3d) this.addTo3dContainer(i1, e1);
                    else if (this.threeDElements) this.addTo3dContainer(i1, e1);
                    else {
                        for(var a1, s1, n1 = 0; n1 < e1;)this.elements[n1] && !0 !== this.elements[n1] && this.elements[n1].getBaseElement && (s1 = this.elements[n1], a1 = (this.layers[n1].ddd ? this.getThreeDContainerByPos(n1) : s1.getBaseElement()) || a1), n1 += 1;
                        a1 ? r1.ddd && this.supports3d || this.layerElement.insertBefore(i1, a1) : r1.ddd && this.supports3d || this.layerElement.appendChild(i1);
                    }
                }
            }, HybridRendererBase.prototype.createShape = function(t1) {
                return this.supports3d ? new HShapeElement(t1, this.globalData, this) : new SVGShapeElement(t1, this.globalData, this);
            }, HybridRendererBase.prototype.createText = function(t1) {
                return this.supports3d ? new HTextElement(t1, this.globalData, this) : new SVGTextLottieElement(t1, this.globalData, this);
            }, HybridRendererBase.prototype.createCamera = function(t1) {
                return this.camera = new HCameraElement(t1, this.globalData, this), this.camera;
            }, HybridRendererBase.prototype.createImage = function(t1) {
                return this.supports3d ? new HImageElement(t1, this.globalData, this) : new IImageElement(t1, this.globalData, this);
            }, HybridRendererBase.prototype.createSolid = function(t1) {
                return this.supports3d ? new HSolidElement(t1, this.globalData, this) : new ISolidElement(t1, this.globalData, this);
            }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(t1) {
                for(var e1 = 0, i1 = this.threeDElements.length; e1 < i1;){
                    if (this.threeDElements[e1].startPos <= t1 && this.threeDElements[e1].endPos >= t1) return this.threeDElements[e1].perspectiveElem;
                    e1 += 1;
                }
                return null;
            }, HybridRendererBase.prototype.createThreeDContainer = function(t1, e1) {
                var i1, r1, a1 = createTag("div");
                styleDiv(a1);
                var s1 = createTag("div");
                if (styleDiv(s1), "3d" === e1) {
                    (i1 = a1.style).width = this.globalData.compSize.w + "px", i1.height = this.globalData.compSize.h + "px";
                    var n1 = "50% 50%";
                    i1.webkitTransformOrigin = n1, i1.mozTransformOrigin = n1, i1.transformOrigin = n1;
                    var o1 = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                    (r1 = s1.style).transform = o1, r1.webkitTransform = o1;
                }
                a1.appendChild(s1);
                var h1 = {
                    container: s1,
                    perspectiveElem: a1,
                    startPos: t1,
                    endPos: t1,
                    type: e1
                };
                return this.threeDElements.push(h1), h1;
            }, HybridRendererBase.prototype.build3dContainers = function() {
                var t1, e1, i1 = this.layers.length, r1 = "";
                for(t1 = 0; t1 < i1; t1 += 1)this.layers[t1].ddd && 3 !== this.layers[t1].ty ? ("3d" !== r1 && (r1 = "3d", e1 = this.createThreeDContainer(t1, "3d")), e1.endPos = Math.max(e1.endPos, t1)) : ("2d" !== r1 && (r1 = "2d", e1 = this.createThreeDContainer(t1, "2d")), e1.endPos = Math.max(e1.endPos, t1));
                for(t1 = (i1 = this.threeDElements.length) - 1; t1 >= 0; t1 -= 1)this.resizerElem.appendChild(this.threeDElements[t1].perspectiveElem);
            }, HybridRendererBase.prototype.addTo3dContainer = function(t1, e1) {
                for(var i1 = 0, r1 = this.threeDElements.length; i1 < r1;){
                    if (e1 <= this.threeDElements[i1].endPos) {
                        for(var a1, s1 = this.threeDElements[i1].startPos; s1 < e1;)this.elements[s1] && this.elements[s1].getBaseElement && (a1 = this.elements[s1].getBaseElement()), s1 += 1;
                        a1 ? this.threeDElements[i1].container.insertBefore(t1, a1) : this.threeDElements[i1].container.appendChild(t1);
                        break;
                    }
                    i1 += 1;
                }
            }, HybridRendererBase.prototype.configAnimation = function(t1) {
                var e1 = createTag("div"), i1 = this.animationItem.wrapper, r1 = e1.style;
                r1.width = t1.w + "px", r1.height = t1.h + "px", this.resizerElem = e1, styleDiv(e1), r1.transformStyle = "flat", r1.mozTransformStyle = "flat", r1.webkitTransformStyle = "flat", this.renderConfig.className && e1.setAttribute("class", this.renderConfig.className), i1.appendChild(e1), r1.overflow = "hidden";
                var a1 = createNS("svg");
                a1.setAttribute("width", "1"), a1.setAttribute("height", "1"), styleDiv(a1), this.resizerElem.appendChild(a1);
                var s1 = createNS("defs");
                a1.appendChild(s1), this.data = t1, this.setupGlobalData(t1, a1), this.globalData.defs = s1, this.layers = t1.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
            }, HybridRendererBase.prototype.destroy = function() {
                var t1;
                this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
                var e1 = this.layers ? this.layers.length : 0;
                for(t1 = 0; t1 < e1; t1 += 1)this.elements[t1].destroy();
                this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
            }, HybridRendererBase.prototype.updateContainerSize = function() {
                var t1, e1, i1, r1, a1 = this.animationItem.wrapper.offsetWidth, s1 = this.animationItem.wrapper.offsetHeight, n1 = a1 / s1;
                this.globalData.compSize.w / this.globalData.compSize.h > n1 ? (t1 = a1 / this.globalData.compSize.w, e1 = a1 / this.globalData.compSize.w, i1 = 0, r1 = (s1 - this.globalData.compSize.h * (a1 / this.globalData.compSize.w)) / 2) : (t1 = s1 / this.globalData.compSize.h, e1 = s1 / this.globalData.compSize.h, i1 = (a1 - this.globalData.compSize.w * (s1 / this.globalData.compSize.h)) / 2, r1 = 0);
                var o1 = this.resizerElem.style;
                o1.webkitTransform = "matrix3d(" + t1 + ",0,0,0,0," + e1 + ",0,0,0,0,1,0," + i1 + "," + r1 + ",0,1)", o1.transform = o1.webkitTransform;
            }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
                this.resizerElem.style.display = "none";
            }, HybridRendererBase.prototype.show = function() {
                this.resizerElem.style.display = "block";
            }, HybridRendererBase.prototype.initItems = function() {
                if (this.buildAllItems(), this.camera) this.camera.setup();
                else {
                    var t1, e1 = this.globalData.compSize.w, i1 = this.globalData.compSize.h, r1 = this.threeDElements.length;
                    for(t1 = 0; t1 < r1; t1 += 1){
                        var a1 = this.threeDElements[t1].perspectiveElem.style;
                        a1.webkitPerspective = Math.sqrt(Math.pow(e1, 2) + Math.pow(i1, 2)) + "px", a1.perspective = a1.webkitPerspective;
                    }
                }
            }, HybridRendererBase.prototype.searchExtraCompositions = function(t1) {
                var e1, i1 = t1.length, r1 = createTag("div");
                for(e1 = 0; e1 < i1; e1 += 1)if (t1[e1].xt) {
                    var a1 = this.createComp(t1[e1], r1, this.globalData.comp, null);
                    a1.initExpressions(), this.globalData.projectInterface.registerComposition(a1);
                }
            }, extendPrototype([
                HybridRendererBase,
                ICompElement,
                HBaseElement
            ], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
                this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
            }, HCompElement.prototype.addTo3dContainer = function(t1, e1) {
                for(var i1, r1 = 0; r1 < e1;)this.elements[r1] && this.elements[r1].getBaseElement && (i1 = this.elements[r1].getBaseElement()), r1 += 1;
                i1 ? this.layerElement.insertBefore(t1, i1) : this.layerElement.appendChild(t1);
            }, HCompElement.prototype.createComp = function(t1) {
                return this.supports3d ? new HCompElement(t1, this.globalData, this) : new SVGCompElement(t1, this.globalData, this);
            }, extendPrototype([
                HybridRendererBase
            ], HybridRenderer), HybridRenderer.prototype.createComp = function(t1) {
                return this.supports3d ? new HCompElement(t1, this.globalData, this) : new SVGCompElement(t1, this.globalData, this);
            };
            var CompExpressionInterface = function(t1) {
                function e1(e1) {
                    for(var i1 = 0, r1 = t1.layers.length; i1 < r1;){
                        if (t1.layers[i1].nm === e1 || t1.layers[i1].ind === e1) return t1.elements[i1].layerInterface;
                        i1 += 1;
                    }
                    return null;
                }
                return Object.defineProperty(e1, "_name", {
                    value: t1.data.nm
                }), e1.layer = e1, e1.pixelAspect = 1, e1.height = t1.data.h || t1.globalData.compSize.h, e1.width = t1.data.w || t1.globalData.compSize.w, e1.pixelAspect = 1, e1.frameDuration = 1 / t1.globalData.frameRate, e1.displayStartTime = 0, e1.numLayers = t1.layers.length, e1;
            }, Expressions = function() {
                var t1 = {
                    initExpressions: function(t1) {
                        var e1 = 0, i1 = [];
                        t1.renderer.compInterface = CompExpressionInterface(t1.renderer), t1.renderer.globalData.projectInterface.registerComposition(t1.renderer), t1.renderer.globalData.pushExpression = function() {
                            e1 += 1;
                        }, t1.renderer.globalData.popExpression = function() {
                            0 == (e1 -= 1) && function() {
                                var t1, e1 = i1.length;
                                for(t1 = 0; t1 < e1; t1 += 1)i1[t1].release();
                                i1.length = 0;
                            }();
                        }, t1.renderer.globalData.registerExpressionProperty = function(t1) {
                            -1 === i1.indexOf(t1) && i1.push(t1);
                        };
                    }
                };
                return t1;
            }(), MaskManagerInterface = function() {
                function t1(t1, e1) {
                    this._mask = t1, this._data = e1;
                }
                return Object.defineProperty(t1.prototype, "maskPath", {
                    get: function() {
                        return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
                    }
                }), Object.defineProperty(t1.prototype, "maskOpacity", {
                    get: function() {
                        return this._mask.op.k && this._mask.op.getValue(), 100 * this._mask.op.v;
                    }
                }), function(e1) {
                    var i1, r1 = createSizedArray(e1.viewData.length), a1 = e1.viewData.length;
                    for(i1 = 0; i1 < a1; i1 += 1)r1[i1] = new t1(e1.viewData[i1], e1.masksProperties[i1]);
                    return function(t1) {
                        for(i1 = 0; i1 < a1;){
                            if (e1.masksProperties[i1].nm === t1) return r1[i1];
                            i1 += 1;
                        }
                        return null;
                    };
                };
            }(), ExpressionPropertyInterface = function() {
                var t1 = {
                    pv: 0,
                    v: 0,
                    mult: 1
                }, e1 = {
                    pv: [
                        0,
                        0,
                        0
                    ],
                    v: [
                        0,
                        0,
                        0
                    ],
                    mult: 1
                };
                function i1(t1, e1, i1) {
                    Object.defineProperty(t1, "velocity", {
                        get: function() {
                            return e1.getVelocityAtTime(e1.comp.currentFrame);
                        }
                    }), t1.numKeys = e1.keyframes ? e1.keyframes.length : 0, t1.key = function(r1) {
                        if (!t1.numKeys) return 0;
                        var a1 = "";
                        a1 = "s" in e1.keyframes[r1 - 1] ? e1.keyframes[r1 - 1].s : "e" in e1.keyframes[r1 - 2] ? e1.keyframes[r1 - 2].e : e1.keyframes[r1 - 2].s;
                        var s1 = "unidimensional" === i1 ? new Number(a1) : Object.assign({}, a1);
                        return s1.time = e1.keyframes[r1 - 1].t / e1.elem.comp.globalData.frameRate, s1.value = "unidimensional" === i1 ? a1[0] : a1, s1;
                    }, t1.valueAtTime = e1.getValueAtTime, t1.speedAtTime = e1.getSpeedAtTime, t1.velocityAtTime = e1.getVelocityAtTime, t1.propertyGroup = e1.propertyGroup;
                }
                function r1() {
                    return t1;
                }
                return function(a1) {
                    return a1 ? "unidimensional" === a1.propType ? function(e1) {
                        e1 && "pv" in e1 || (e1 = t1);
                        var r1 = 1 / e1.mult, a1 = e1.pv * r1, s1 = new Number(a1);
                        return s1.value = a1, i1(s1, e1, "unidimensional"), function() {
                            return e1.k && e1.getValue(), a1 = e1.v * r1, s1.value !== a1 && ((s1 = new Number(a1)).value = a1, i1(s1, e1, "unidimensional")), s1;
                        };
                    }(a1) : function(t1) {
                        t1 && "pv" in t1 || (t1 = e1);
                        var r1 = 1 / t1.mult, a1 = t1.data && t1.data.l || t1.pv.length, s1 = createTypedArray("float32", a1), n1 = createTypedArray("float32", a1);
                        return s1.value = n1, i1(s1, t1, "multidimensional"), function() {
                            t1.k && t1.getValue();
                            for(var e1 = 0; e1 < a1; e1 += 1)n1[e1] = t1.v[e1] * r1, s1[e1] = n1[e1];
                            return s1;
                        };
                    }(a1) : r1;
                };
            }(), TransformExpressionInterface = function(t1) {
                function e1(t1) {
                    switch(t1){
                        case "scale":
                        case "Scale":
                        case "ADBE Scale":
                        case 6:
                            return e1.scale;
                        case "rotation":
                        case "Rotation":
                        case "ADBE Rotation":
                        case "ADBE Rotate Z":
                        case 10:
                            return e1.rotation;
                        case "ADBE Rotate X":
                            return e1.xRotation;
                        case "ADBE Rotate Y":
                            return e1.yRotation;
                        case "position":
                        case "Position":
                        case "ADBE Position":
                        case 2:
                            return e1.position;
                        case "ADBE Position_0":
                            return e1.xPosition;
                        case "ADBE Position_1":
                            return e1.yPosition;
                        case "ADBE Position_2":
                            return e1.zPosition;
                        case "anchorPoint":
                        case "AnchorPoint":
                        case "Anchor Point":
                        case "ADBE AnchorPoint":
                        case 1:
                            return e1.anchorPoint;
                        case "opacity":
                        case "Opacity":
                        case 11:
                            return e1.opacity;
                        default:
                            return null;
                    }
                }
                var i1, r1, a1, s1;
                return Object.defineProperty(e1, "rotation", {
                    get: ExpressionPropertyInterface(t1.r || t1.rz)
                }), Object.defineProperty(e1, "zRotation", {
                    get: ExpressionPropertyInterface(t1.rz || t1.r)
                }), Object.defineProperty(e1, "xRotation", {
                    get: ExpressionPropertyInterface(t1.rx)
                }), Object.defineProperty(e1, "yRotation", {
                    get: ExpressionPropertyInterface(t1.ry)
                }), Object.defineProperty(e1, "scale", {
                    get: ExpressionPropertyInterface(t1.s)
                }), t1.p ? s1 = ExpressionPropertyInterface(t1.p) : (i1 = ExpressionPropertyInterface(t1.px), r1 = ExpressionPropertyInterface(t1.py), t1.pz && (a1 = ExpressionPropertyInterface(t1.pz))), Object.defineProperty(e1, "position", {
                    get: function() {
                        return t1.p ? s1() : [
                            i1(),
                            r1(),
                            a1 ? a1() : 0
                        ];
                    }
                }), Object.defineProperty(e1, "xPosition", {
                    get: ExpressionPropertyInterface(t1.px)
                }), Object.defineProperty(e1, "yPosition", {
                    get: ExpressionPropertyInterface(t1.py)
                }), Object.defineProperty(e1, "zPosition", {
                    get: ExpressionPropertyInterface(t1.pz)
                }), Object.defineProperty(e1, "anchorPoint", {
                    get: ExpressionPropertyInterface(t1.a)
                }), Object.defineProperty(e1, "opacity", {
                    get: ExpressionPropertyInterface(t1.o)
                }), Object.defineProperty(e1, "skew", {
                    get: ExpressionPropertyInterface(t1.sk)
                }), Object.defineProperty(e1, "skewAxis", {
                    get: ExpressionPropertyInterface(t1.sa)
                }), Object.defineProperty(e1, "orientation", {
                    get: ExpressionPropertyInterface(t1.or)
                }), e1;
            }, LayerExpressionInterface = function() {
                function t1(t1) {
                    var e1 = new Matrix;
                    return void 0 !== t1 ? this._elem.finalTransform.mProp.getValueAtTime(t1).clone(e1) : this._elem.finalTransform.mProp.applyToMatrix(e1), e1;
                }
                function e1(t1, e1) {
                    var i1 = this.getMatrix(e1);
                    return i1.props[12] = 0, i1.props[13] = 0, i1.props[14] = 0, this.applyPoint(i1, t1);
                }
                function i1(t1, e1) {
                    var i1 = this.getMatrix(e1);
                    return this.applyPoint(i1, t1);
                }
                function r1(t1, e1) {
                    var i1 = this.getMatrix(e1);
                    return i1.props[12] = 0, i1.props[13] = 0, i1.props[14] = 0, this.invertPoint(i1, t1);
                }
                function a1(t1, e1) {
                    var i1 = this.getMatrix(e1);
                    return this.invertPoint(i1, t1);
                }
                function s1(t1, e1) {
                    if (this._elem.hierarchy && this._elem.hierarchy.length) {
                        var i1, r1 = this._elem.hierarchy.length;
                        for(i1 = 0; i1 < r1; i1 += 1)this._elem.hierarchy[i1].finalTransform.mProp.applyToMatrix(t1);
                    }
                    return t1.applyToPointArray(e1[0], e1[1], e1[2] || 0);
                }
                function n1(t1, e1) {
                    if (this._elem.hierarchy && this._elem.hierarchy.length) {
                        var i1, r1 = this._elem.hierarchy.length;
                        for(i1 = 0; i1 < r1; i1 += 1)this._elem.hierarchy[i1].finalTransform.mProp.applyToMatrix(t1);
                    }
                    return t1.inversePoint(e1);
                }
                function o1(t1) {
                    var e1 = new Matrix;
                    if (e1.reset(), this._elem.finalTransform.mProp.applyToMatrix(e1), this._elem.hierarchy && this._elem.hierarchy.length) {
                        var i1, r1 = this._elem.hierarchy.length;
                        for(i1 = 0; i1 < r1; i1 += 1)this._elem.hierarchy[i1].finalTransform.mProp.applyToMatrix(e1);
                        return e1.inversePoint(t1);
                    }
                    return e1.inversePoint(t1);
                }
                function h1() {
                    return [
                        1,
                        1,
                        1,
                        1
                    ];
                }
                return function(l1) {
                    var p1;
                    function f1(t1) {
                        switch(t1){
                            case "ADBE Root Vectors Group":
                            case "Contents":
                            case 2:
                                return f1.shapeInterface;
                            case 1:
                            case 6:
                            case "Transform":
                            case "transform":
                            case "ADBE Transform Group":
                                return p1;
                            case 4:
                            case "ADBE Effect Parade":
                            case "effects":
                            case "Effects":
                                return f1.effect;
                            case "ADBE Text Properties":
                                return f1.textInterface;
                            default:
                                return null;
                        }
                    }
                    f1.getMatrix = t1, f1.invertPoint = n1, f1.applyPoint = s1, f1.toWorld = i1, f1.toWorldVec = e1, f1.fromWorld = a1, f1.fromWorldVec = r1, f1.toComp = i1, f1.fromComp = o1, f1.sampleImage = h1, f1.sourceRectAtTime = l1.sourceRectAtTime.bind(l1), f1._elem = l1;
                    var d1 = getDescriptor(p1 = TransformExpressionInterface(l1.finalTransform.mProp), "anchorPoint");
                    return Object.defineProperties(f1, {
                        hasParent: {
                            get: function() {
                                return l1.hierarchy.length;
                            }
                        },
                        parent: {
                            get: function() {
                                return l1.hierarchy[0].layerInterface;
                            }
                        },
                        rotation: getDescriptor(p1, "rotation"),
                        scale: getDescriptor(p1, "scale"),
                        position: getDescriptor(p1, "position"),
                        opacity: getDescriptor(p1, "opacity"),
                        anchorPoint: d1,
                        anchor_point: d1,
                        transform: {
                            get: function() {
                                return p1;
                            }
                        },
                        active: {
                            get: function() {
                                return l1.isInRange;
                            }
                        }
                    }), f1.startTime = l1.data.st, f1.index = l1.data.ind, f1.source = l1.data.refId, f1.height = 0 === l1.data.ty ? l1.data.h : 100, f1.width = 0 === l1.data.ty ? l1.data.w : 100, f1.inPoint = l1.data.ip / l1.comp.globalData.frameRate, f1.outPoint = l1.data.op / l1.comp.globalData.frameRate, f1._name = l1.data.nm, f1.registerMaskInterface = function(t1) {
                        f1.mask = new MaskManagerInterface(t1, l1);
                    }, f1.registerEffectsInterface = function(t1) {
                        f1.effect = t1;
                    }, f1;
                };
            }(), propertyGroupFactory = function(t1, e1) {
                return function(i1) {
                    return (i1 = void 0 === i1 ? 1 : i1) <= 0 ? t1 : e1(i1 - 1);
                };
            }, PropertyInterface = function(t1, e1) {
                var i1 = {
                    _name: t1
                };
                return function(t1) {
                    return (t1 = void 0 === t1 ? 1 : t1) <= 0 ? i1 : e1(t1 - 1);
                };
            }, EffectsExpressionInterface = function() {
                var t1 = {
                    createEffectsInterface: function(t1, i1) {
                        if (t1.effectsManager) {
                            var r1, a1 = [], s1 = t1.data.ef, n1 = t1.effectsManager.effectElements.length;
                            for(r1 = 0; r1 < n1; r1 += 1)a1.push(e1(s1[r1], t1.effectsManager.effectElements[r1], i1, t1));
                            var o1 = t1.data.ef || [], h1 = function(t1) {
                                for(r1 = 0, n1 = o1.length; r1 < n1;){
                                    if (t1 === o1[r1].nm || t1 === o1[r1].mn || t1 === o1[r1].ix) return a1[r1];
                                    r1 += 1;
                                }
                                return null;
                            };
                            return Object.defineProperty(h1, "numProperties", {
                                get: function() {
                                    return o1.length;
                                }
                            }), h1;
                        }
                        return null;
                    }
                };
                function e1(t1, r1, a1, s1) {
                    function n1(e1) {
                        for(var i1 = t1.ef, r1 = 0, a1 = i1.length; r1 < a1;){
                            if (e1 === i1[r1].nm || e1 === i1[r1].mn || e1 === i1[r1].ix) return 5 === i1[r1].ty ? l1[r1] : l1[r1]();
                            r1 += 1;
                        }
                        throw new Error;
                    }
                    var o1, h1 = propertyGroupFactory(n1, a1), l1 = [], p1 = t1.ef.length;
                    for(o1 = 0; o1 < p1; o1 += 1)5 === t1.ef[o1].ty ? l1.push(e1(t1.ef[o1], r1.effectElements[o1], r1.effectElements[o1].propertyGroup, s1)) : l1.push(i1(r1.effectElements[o1], t1.ef[o1].ty, s1, h1));
                    return "ADBE Color Control" === t1.mn && Object.defineProperty(n1, "color", {
                        get: function() {
                            return l1[0]();
                        }
                    }), Object.defineProperties(n1, {
                        numProperties: {
                            get: function() {
                                return t1.np;
                            }
                        },
                        _name: {
                            value: t1.nm
                        },
                        propertyGroup: {
                            value: h1
                        }
                    }), n1.enabled = 0 !== t1.en, n1.active = n1.enabled, n1;
                }
                function i1(t1, e1, i1, r1) {
                    var a1 = ExpressionPropertyInterface(t1.p);
                    return t1.p.setGroupProperty && t1.p.setGroupProperty(PropertyInterface("", r1)), function() {
                        return 10 === e1 ? i1.comp.compInterface(t1.p.v) : a1();
                    };
                }
                return t1;
            }(), ShapePathInterface = function(t1, e1, i1) {
                var r1 = e1.sh;
                function a1(t1) {
                    return "Shape" === t1 || "shape" === t1 || "Path" === t1 || "path" === t1 || "ADBE Vector Shape" === t1 || 2 === t1 ? a1.path : null;
                }
                var s1 = propertyGroupFactory(a1, i1);
                return r1.setGroupProperty(PropertyInterface("Path", s1)), Object.defineProperties(a1, {
                    path: {
                        get: function() {
                            return r1.k && r1.getValue(), r1;
                        }
                    },
                    shape: {
                        get: function() {
                            return r1.k && r1.getValue(), r1;
                        }
                    },
                    _name: {
                        value: t1.nm
                    },
                    ix: {
                        value: t1.ix
                    },
                    propertyIndex: {
                        value: t1.ix
                    },
                    mn: {
                        value: t1.mn
                    },
                    propertyGroup: {
                        value: i1
                    }
                }), a1;
            }, ShapeExpressionInterface = function() {
                function t1(t1, n1, d1) {
                    var c1, m1 = [], u1 = t1 ? t1.length : 0;
                    for(c1 = 0; c1 < u1; c1 += 1)"gr" === t1[c1].ty ? m1.push(e1(t1[c1], n1[c1], d1)) : "fl" === t1[c1].ty ? m1.push(i1(t1[c1], n1[c1], d1)) : "st" === t1[c1].ty ? m1.push(a1(t1[c1], n1[c1], d1)) : "tm" === t1[c1].ty ? m1.push(s1(t1[c1], n1[c1], d1)) : "tr" === t1[c1].ty || ("el" === t1[c1].ty ? m1.push(o1(t1[c1], n1[c1], d1)) : "sr" === t1[c1].ty ? m1.push(h1(t1[c1], n1[c1], d1)) : "sh" === t1[c1].ty ? m1.push(ShapePathInterface(t1[c1], n1[c1], d1)) : "rc" === t1[c1].ty ? m1.push(l1(t1[c1], n1[c1], d1)) : "rd" === t1[c1].ty ? m1.push(p1(t1[c1], n1[c1], d1)) : "rp" === t1[c1].ty ? m1.push(f1(t1[c1], n1[c1], d1)) : "gf" === t1[c1].ty ? m1.push(r1(t1[c1], n1[c1], d1)) : m1.push((t1[c1], n1[c1], function() {
                        return null;
                    })));
                    return m1;
                }
                function e1(e1, i1, r1) {
                    var a1 = function(t1) {
                        switch(t1){
                            case "ADBE Vectors Group":
                            case "Contents":
                            case 2:
                                return a1.content;
                            default:
                                return a1.transform;
                        }
                    };
                    a1.propertyGroup = propertyGroupFactory(a1, r1);
                    var s1 = function(e1, i1, r1) {
                        var a1, s1 = function(t1) {
                            for(var e1 = 0, i1 = a1.length; e1 < i1;){
                                if (a1[e1]._name === t1 || a1[e1].mn === t1 || a1[e1].propertyIndex === t1 || a1[e1].ix === t1 || a1[e1].ind === t1) return a1[e1];
                                e1 += 1;
                            }
                            return "number" == typeof t1 ? a1[t1 - 1] : null;
                        };
                        s1.propertyGroup = propertyGroupFactory(s1, r1), a1 = t1(e1.it, i1.it, s1.propertyGroup), s1.numProperties = a1.length;
                        var o1 = n1(e1.it[e1.it.length - 1], i1.it[i1.it.length - 1], s1.propertyGroup);
                        return s1.transform = o1, s1.propertyIndex = e1.cix, s1._name = e1.nm, s1;
                    }(e1, i1, a1.propertyGroup), o1 = n1(e1.it[e1.it.length - 1], i1.it[i1.it.length - 1], a1.propertyGroup);
                    return a1.content = s1, a1.transform = o1, Object.defineProperty(a1, "_name", {
                        get: function() {
                            return e1.nm;
                        }
                    }), a1.numProperties = e1.np, a1.propertyIndex = e1.ix, a1.nm = e1.nm, a1.mn = e1.mn, a1;
                }
                function i1(t1, e1, i1) {
                    function r1(t1) {
                        return "Color" === t1 || "color" === t1 ? r1.color : "Opacity" === t1 || "opacity" === t1 ? r1.opacity : null;
                    }
                    return Object.defineProperties(r1, {
                        color: {
                            get: ExpressionPropertyInterface(e1.c)
                        },
                        opacity: {
                            get: ExpressionPropertyInterface(e1.o)
                        },
                        _name: {
                            value: t1.nm
                        },
                        mn: {
                            value: t1.mn
                        }
                    }), e1.c.setGroupProperty(PropertyInterface("Color", i1)), e1.o.setGroupProperty(PropertyInterface("Opacity", i1)), r1;
                }
                function r1(t1, e1, i1) {
                    function r1(t1) {
                        return "Start Point" === t1 || "start point" === t1 ? r1.startPoint : "End Point" === t1 || "end point" === t1 ? r1.endPoint : "Opacity" === t1 || "opacity" === t1 ? r1.opacity : null;
                    }
                    return Object.defineProperties(r1, {
                        startPoint: {
                            get: ExpressionPropertyInterface(e1.s)
                        },
                        endPoint: {
                            get: ExpressionPropertyInterface(e1.e)
                        },
                        opacity: {
                            get: ExpressionPropertyInterface(e1.o)
                        },
                        type: {
                            get: function() {
                                return "a";
                            }
                        },
                        _name: {
                            value: t1.nm
                        },
                        mn: {
                            value: t1.mn
                        }
                    }), e1.s.setGroupProperty(PropertyInterface("Start Point", i1)), e1.e.setGroupProperty(PropertyInterface("End Point", i1)), e1.o.setGroupProperty(PropertyInterface("Opacity", i1)), r1;
                }
                function a1(t1, e1, i1) {
                    var r1, a1 = propertyGroupFactory(l1, i1), s1 = propertyGroupFactory(h1, a1);
                    function n1(i1) {
                        Object.defineProperty(h1, t1.d[i1].nm, {
                            get: ExpressionPropertyInterface(e1.d.dataProps[i1].p)
                        });
                    }
                    var o1 = t1.d ? t1.d.length : 0, h1 = {};
                    for(r1 = 0; r1 < o1; r1 += 1)n1(r1), e1.d.dataProps[r1].p.setGroupProperty(s1);
                    function l1(t1) {
                        return "Color" === t1 || "color" === t1 ? l1.color : "Opacity" === t1 || "opacity" === t1 ? l1.opacity : "Stroke Width" === t1 || "stroke width" === t1 ? l1.strokeWidth : null;
                    }
                    return Object.defineProperties(l1, {
                        color: {
                            get: ExpressionPropertyInterface(e1.c)
                        },
                        opacity: {
                            get: ExpressionPropertyInterface(e1.o)
                        },
                        strokeWidth: {
                            get: ExpressionPropertyInterface(e1.w)
                        },
                        dash: {
                            get: function() {
                                return h1;
                            }
                        },
                        _name: {
                            value: t1.nm
                        },
                        mn: {
                            value: t1.mn
                        }
                    }), e1.c.setGroupProperty(PropertyInterface("Color", a1)), e1.o.setGroupProperty(PropertyInterface("Opacity", a1)), e1.w.setGroupProperty(PropertyInterface("Stroke Width", a1)), l1;
                }
                function s1(t1, e1, i1) {
                    function r1(e1) {
                        return e1 === t1.e.ix || "End" === e1 || "end" === e1 ? r1.end : e1 === t1.s.ix ? r1.start : e1 === t1.o.ix ? r1.offset : null;
                    }
                    var a1 = propertyGroupFactory(r1, i1);
                    return r1.propertyIndex = t1.ix, e1.s.setGroupProperty(PropertyInterface("Start", a1)), e1.e.setGroupProperty(PropertyInterface("End", a1)), e1.o.setGroupProperty(PropertyInterface("Offset", a1)), r1.propertyIndex = t1.ix, r1.propertyGroup = i1, Object.defineProperties(r1, {
                        start: {
                            get: ExpressionPropertyInterface(e1.s)
                        },
                        end: {
                            get: ExpressionPropertyInterface(e1.e)
                        },
                        offset: {
                            get: ExpressionPropertyInterface(e1.o)
                        },
                        _name: {
                            value: t1.nm
                        }
                    }), r1.mn = t1.mn, r1;
                }
                function n1(t1, e1, i1) {
                    function r1(e1) {
                        return t1.a.ix === e1 || "Anchor Point" === e1 ? r1.anchorPoint : t1.o.ix === e1 || "Opacity" === e1 ? r1.opacity : t1.p.ix === e1 || "Position" === e1 ? r1.position : t1.r.ix === e1 || "Rotation" === e1 || "ADBE Vector Rotation" === e1 ? r1.rotation : t1.s.ix === e1 || "Scale" === e1 ? r1.scale : t1.sk && t1.sk.ix === e1 || "Skew" === e1 ? r1.skew : t1.sa && t1.sa.ix === e1 || "Skew Axis" === e1 ? r1.skewAxis : null;
                    }
                    var a1 = propertyGroupFactory(r1, i1);
                    return e1.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", a1)), e1.transform.mProps.p.setGroupProperty(PropertyInterface("Position", a1)), e1.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", a1)), e1.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", a1)), e1.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", a1)), e1.transform.mProps.sk && (e1.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", a1)), e1.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", a1))), e1.transform.op.setGroupProperty(PropertyInterface("Opacity", a1)), Object.defineProperties(r1, {
                        opacity: {
                            get: ExpressionPropertyInterface(e1.transform.mProps.o)
                        },
                        position: {
                            get: ExpressionPropertyInterface(e1.transform.mProps.p)
                        },
                        anchorPoint: {
                            get: ExpressionPropertyInterface(e1.transform.mProps.a)
                        },
                        scale: {
                            get: ExpressionPropertyInterface(e1.transform.mProps.s)
                        },
                        rotation: {
                            get: ExpressionPropertyInterface(e1.transform.mProps.r)
                        },
                        skew: {
                            get: ExpressionPropertyInterface(e1.transform.mProps.sk)
                        },
                        skewAxis: {
                            get: ExpressionPropertyInterface(e1.transform.mProps.sa)
                        },
                        _name: {
                            value: t1.nm
                        }
                    }), r1.ty = "tr", r1.mn = t1.mn, r1.propertyGroup = i1, r1;
                }
                function o1(t1, e1, i1) {
                    function r1(e1) {
                        return t1.p.ix === e1 ? r1.position : t1.s.ix === e1 ? r1.size : null;
                    }
                    var a1 = propertyGroupFactory(r1, i1);
                    r1.propertyIndex = t1.ix;
                    var s1 = "tm" === e1.sh.ty ? e1.sh.prop : e1.sh;
                    return s1.s.setGroupProperty(PropertyInterface("Size", a1)), s1.p.setGroupProperty(PropertyInterface("Position", a1)), Object.defineProperties(r1, {
                        size: {
                            get: ExpressionPropertyInterface(s1.s)
                        },
                        position: {
                            get: ExpressionPropertyInterface(s1.p)
                        },
                        _name: {
                            value: t1.nm
                        }
                    }), r1.mn = t1.mn, r1;
                }
                function h1(t1, e1, i1) {
                    function r1(e1) {
                        return t1.p.ix === e1 ? r1.position : t1.r.ix === e1 ? r1.rotation : t1.pt.ix === e1 ? r1.points : t1.or.ix === e1 || "ADBE Vector Star Outer Radius" === e1 ? r1.outerRadius : t1.os.ix === e1 ? r1.outerRoundness : !t1.ir || t1.ir.ix !== e1 && "ADBE Vector Star Inner Radius" !== e1 ? t1.is && t1.is.ix === e1 ? r1.innerRoundness : null : r1.innerRadius;
                    }
                    var a1 = propertyGroupFactory(r1, i1), s1 = "tm" === e1.sh.ty ? e1.sh.prop : e1.sh;
                    return r1.propertyIndex = t1.ix, s1.or.setGroupProperty(PropertyInterface("Outer Radius", a1)), s1.os.setGroupProperty(PropertyInterface("Outer Roundness", a1)), s1.pt.setGroupProperty(PropertyInterface("Points", a1)), s1.p.setGroupProperty(PropertyInterface("Position", a1)), s1.r.setGroupProperty(PropertyInterface("Rotation", a1)), t1.ir && (s1.ir.setGroupProperty(PropertyInterface("Inner Radius", a1)), s1.is.setGroupProperty(PropertyInterface("Inner Roundness", a1))), Object.defineProperties(r1, {
                        position: {
                            get: ExpressionPropertyInterface(s1.p)
                        },
                        rotation: {
                            get: ExpressionPropertyInterface(s1.r)
                        },
                        points: {
                            get: ExpressionPropertyInterface(s1.pt)
                        },
                        outerRadius: {
                            get: ExpressionPropertyInterface(s1.or)
                        },
                        outerRoundness: {
                            get: ExpressionPropertyInterface(s1.os)
                        },
                        innerRadius: {
                            get: ExpressionPropertyInterface(s1.ir)
                        },
                        innerRoundness: {
                            get: ExpressionPropertyInterface(s1.is)
                        },
                        _name: {
                            value: t1.nm
                        }
                    }), r1.mn = t1.mn, r1;
                }
                function l1(t1, e1, i1) {
                    function r1(e1) {
                        return t1.p.ix === e1 ? r1.position : t1.r.ix === e1 ? r1.roundness : t1.s.ix === e1 || "Size" === e1 || "ADBE Vector Rect Size" === e1 ? r1.size : null;
                    }
                    var a1 = propertyGroupFactory(r1, i1), s1 = "tm" === e1.sh.ty ? e1.sh.prop : e1.sh;
                    return r1.propertyIndex = t1.ix, s1.p.setGroupProperty(PropertyInterface("Position", a1)), s1.s.setGroupProperty(PropertyInterface("Size", a1)), s1.r.setGroupProperty(PropertyInterface("Rotation", a1)), Object.defineProperties(r1, {
                        position: {
                            get: ExpressionPropertyInterface(s1.p)
                        },
                        roundness: {
                            get: ExpressionPropertyInterface(s1.r)
                        },
                        size: {
                            get: ExpressionPropertyInterface(s1.s)
                        },
                        _name: {
                            value: t1.nm
                        }
                    }), r1.mn = t1.mn, r1;
                }
                function p1(t1, e1, i1) {
                    function r1(e1) {
                        return t1.r.ix === e1 || "Round Corners 1" === e1 ? r1.radius : null;
                    }
                    var a1 = propertyGroupFactory(r1, i1), s1 = e1;
                    return r1.propertyIndex = t1.ix, s1.rd.setGroupProperty(PropertyInterface("Radius", a1)), Object.defineProperties(r1, {
                        radius: {
                            get: ExpressionPropertyInterface(s1.rd)
                        },
                        _name: {
                            value: t1.nm
                        }
                    }), r1.mn = t1.mn, r1;
                }
                function f1(t1, e1, i1) {
                    function r1(e1) {
                        return t1.c.ix === e1 || "Copies" === e1 ? r1.copies : t1.o.ix === e1 || "Offset" === e1 ? r1.offset : null;
                    }
                    var a1 = propertyGroupFactory(r1, i1), s1 = e1;
                    return r1.propertyIndex = t1.ix, s1.c.setGroupProperty(PropertyInterface("Copies", a1)), s1.o.setGroupProperty(PropertyInterface("Offset", a1)), Object.defineProperties(r1, {
                        copies: {
                            get: ExpressionPropertyInterface(s1.c)
                        },
                        offset: {
                            get: ExpressionPropertyInterface(s1.o)
                        },
                        _name: {
                            value: t1.nm
                        }
                    }), r1.mn = t1.mn, r1;
                }
                return function(e1, i1, r1) {
                    var a1;
                    function s1(t1) {
                        if ("number" == typeof t1) return 0 === (t1 = void 0 === t1 ? 1 : t1) ? r1 : a1[t1 - 1];
                        for(var e1 = 0, i1 = a1.length; e1 < i1;){
                            if (a1[e1]._name === t1) return a1[e1];
                            e1 += 1;
                        }
                        return null;
                    }
                    return s1.propertyGroup = propertyGroupFactory(s1, function() {
                        return r1;
                    }), a1 = t1(e1, i1, s1.propertyGroup), s1.numProperties = a1.length, s1._name = "Contents", s1;
                };
            }(), TextExpressionInterface = function(t1) {
                var e1, i1;
                function r1(t1) {
                    return "ADBE Text Document" === t1 ? r1.sourceText : null;
                }
                return Object.defineProperty(r1, "sourceText", {
                    get: function() {
                        t1.textProperty.getValue();
                        var r1 = t1.textProperty.currentData.t;
                        return r1 !== e1 && (t1.textProperty.currentData.t = e1, (i1 = new String(r1)).value = r1 || new String(r1)), i1;
                    }
                }), r1;
            };
            function _typeof$2(t1) {
                return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, _typeof$2(t1);
            }
            var FootageInterface = (dataInterfaceFactory = function(t1) {
                function e1(t1) {
                    return "Outline" === t1 ? e1.outlineInterface() : null;
                }
                return e1._name = "Outline", e1.outlineInterface = function(t1) {
                    var e1 = "", i1 = t1.getFootageData();
                    function r1(t1) {
                        if (i1[t1]) return e1 = t1, "object" === _typeof$2(i1 = i1[t1]) ? r1 : i1;
                        var a1 = t1.indexOf(e1);
                        if (-1 !== a1) {
                            var s1 = parseInt(t1.substr(a1 + e1.length), 10);
                            return "object" === _typeof$2(i1 = i1[s1]) ? r1 : i1;
                        }
                        return "";
                    }
                    return function() {
                        return e1 = "", i1 = t1.getFootageData(), r1;
                    };
                }(t1), e1;
            }, function(t1) {
                function e1(t1) {
                    return "Data" === t1 ? e1.dataInterface : null;
                }
                return e1._name = "Data", e1.dataInterface = dataInterfaceFactory(t1), e1;
            }), dataInterfaceFactory, interfaces = {
                layer: LayerExpressionInterface,
                effects: EffectsExpressionInterface,
                comp: CompExpressionInterface,
                shape: ShapeExpressionInterface,
                text: TextExpressionInterface,
                footage: FootageInterface
            };
            function getInterface(t1) {
                return interfaces[t1] || null;
            }
            function _typeof$1(t1) {
                return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, _typeof$1(t1);
            }
            function seedRandom(t1, e1) {
                var i1 = this, r1 = 256, a1 = e1.pow(r1, 6), s1 = e1.pow(2, 52), n1 = 2 * s1, o1 = 255;
                function h1(t1) {
                    var e1, i1 = t1.length, a1 = this, s1 = 0, n1 = a1.i = a1.j = 0, h1 = a1.S = [];
                    for(i1 || (t1 = [
                        i1++
                    ]); s1 < r1;)h1[s1] = s1++;
                    for(s1 = 0; s1 < r1; s1++)h1[s1] = h1[n1 = o1 & n1 + t1[s1 % i1] + (e1 = h1[s1])], h1[n1] = e1;
                    a1.g = function(t1) {
                        for(var e1, i1 = 0, s1 = a1.i, n1 = a1.j, h1 = a1.S; t1--;)e1 = h1[s1 = o1 & s1 + 1], i1 = i1 * r1 + h1[o1 & (h1[s1] = h1[n1 = o1 & n1 + e1]) + (h1[n1] = e1)];
                        return a1.i = s1, a1.j = n1, i1;
                    };
                }
                function l1(t1, e1) {
                    return e1.i = t1.i, e1.j = t1.j, e1.S = t1.S.slice(), e1;
                }
                function p1(t1, e1) {
                    var i1, r1 = [], a1 = _typeof$1(t1);
                    if (e1 && "object" == a1) for(i1 in t1)try {
                        r1.push(p1(t1[i1], e1 - 1));
                    } catch (t1) {}
                    return r1.length ? r1 : "string" == a1 ? t1 : t1 + "\x00";
                }
                function f1(t1, e1) {
                    for(var i1, r1 = t1 + "", a1 = 0; a1 < r1.length;)e1[o1 & a1] = o1 & (i1 ^= 19 * e1[o1 & a1]) + r1.charCodeAt(a1++);
                    return d1(e1);
                }
                function d1(t1) {
                    return String.fromCharCode.apply(0, t1);
                }
                e1.seedrandom = function(o1, c1, m1) {
                    var u1 = [], y1 = f1(p1((c1 = !0 === c1 ? {
                        entropy: !0
                    } : c1 || {}).entropy ? [
                        o1,
                        d1(t1)
                    ] : null === o1 ? function() {
                        try {
                            var e1 = new Uint8Array(r1);
                            return (i1.crypto || i1.msCrypto).getRandomValues(e1), d1(e1);
                        } catch (e1) {
                            var a1 = i1.navigator, s1 = a1 && a1.plugins;
                            return [
                                +new Date,
                                i1,
                                s1,
                                i1.screen,
                                d1(t1)
                            ];
                        }
                    }() : o1, 3), u1), g1 = new h1(u1), _1 = function() {
                        for(var t1 = g1.g(6), e1 = a1, i1 = 0; t1 < s1;)t1 = (t1 + i1) * r1, e1 *= r1, i1 = g1.g(1);
                        for(; t1 >= n1;)t1 /= 2, e1 /= 2, i1 >>>= 1;
                        return (t1 + i1) / e1;
                    };
                    return _1.int32 = function() {
                        return 0 | g1.g(4);
                    }, _1.quick = function() {
                        return g1.g(4) / 4294967296;
                    }, _1.double = _1, f1(d1(g1.S), t1), (c1.pass || m1 || function(t1, i1, r1, a1) {
                        return a1 && (a1.S && l1(a1, g1), t1.state = function() {
                            return l1(g1, {});
                        }), r1 ? (e1.random = t1, i1) : t1;
                    })(_1, y1, "global" in c1 ? c1.global : this == e1, c1.state);
                }, f1(e1.random(), t1);
            }
            function initialize$2(t1) {
                seedRandom([], t1);
            }
            var propTypes = {
                SHAPE: "shape"
            };
            function _typeof(t1) {
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, _typeof(t1);
            }
            var ExpressionManager = function() {
                var ob = {}, Math = BMMath, window = null, document = null, XMLHttpRequest = null, fetch = null, frames = null;
                function $bm_isInstanceOfArray(t1) {
                    return t1.constructor === Array || t1.constructor === Float32Array;
                }
                function isNumerable(t1, e1) {
                    return "number" === t1 || "boolean" === t1 || "string" === t1 || e1 instanceof Number;
                }
                function $bm_neg(t1) {
                    var e1 = _typeof(t1);
                    if ("number" === e1 || "boolean" === e1 || t1 instanceof Number) return -t1;
                    if ($bm_isInstanceOfArray(t1)) {
                        var i1, r1 = t1.length, a1 = [];
                        for(i1 = 0; i1 < r1; i1 += 1)a1[i1] = -t1[i1];
                        return a1;
                    }
                    return t1.propType ? t1.v : -t1;
                }
                initialize$2(BMMath);
                var easeInBez = BezierFactory.getBezierEasing(.333, 0, .833, .833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(.167, .167, .667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(.33, 0, .667, 1, "easeInOut").get;
                function sum(t1, e1) {
                    var i1 = _typeof(t1), r1 = _typeof(e1);
                    if ("string" === i1 || "string" === r1) return t1 + e1;
                    if (isNumerable(i1, t1) && isNumerable(r1, e1)) return t1 + e1;
                    if ($bm_isInstanceOfArray(t1) && isNumerable(r1, e1)) return (t1 = t1.slice(0))[0] += e1, t1;
                    if (isNumerable(i1, t1) && $bm_isInstanceOfArray(e1)) return (e1 = e1.slice(0))[0] = t1 + e1[0], e1;
                    if ($bm_isInstanceOfArray(t1) && $bm_isInstanceOfArray(e1)) {
                        for(var a1 = 0, s1 = t1.length, n1 = e1.length, o1 = []; a1 < s1 || a1 < n1;)("number" == typeof t1[a1] || t1[a1] instanceof Number) && ("number" == typeof e1[a1] || e1[a1] instanceof Number) ? o1[a1] = t1[a1] + e1[a1] : o1[a1] = void 0 === e1[a1] ? t1[a1] : t1[a1] || e1[a1], a1 += 1;
                        return o1;
                    }
                    return 0;
                }
                var add = sum;
                function sub(t1, e1) {
                    var i1 = _typeof(t1), r1 = _typeof(e1);
                    if (isNumerable(i1, t1) && isNumerable(r1, e1)) return "string" === i1 && (t1 = parseInt(t1, 10)), "string" === r1 && (e1 = parseInt(e1, 10)), t1 - e1;
                    if ($bm_isInstanceOfArray(t1) && isNumerable(r1, e1)) return (t1 = t1.slice(0))[0] -= e1, t1;
                    if (isNumerable(i1, t1) && $bm_isInstanceOfArray(e1)) return (e1 = e1.slice(0))[0] = t1 - e1[0], e1;
                    if ($bm_isInstanceOfArray(t1) && $bm_isInstanceOfArray(e1)) {
                        for(var a1 = 0, s1 = t1.length, n1 = e1.length, o1 = []; a1 < s1 || a1 < n1;)("number" == typeof t1[a1] || t1[a1] instanceof Number) && ("number" == typeof e1[a1] || e1[a1] instanceof Number) ? o1[a1] = t1[a1] - e1[a1] : o1[a1] = void 0 === e1[a1] ? t1[a1] : t1[a1] || e1[a1], a1 += 1;
                        return o1;
                    }
                    return 0;
                }
                function mul(t1, e1) {
                    var i1, r1, a1, s1 = _typeof(t1), n1 = _typeof(e1);
                    if (isNumerable(s1, t1) && isNumerable(n1, e1)) return t1 * e1;
                    if ($bm_isInstanceOfArray(t1) && isNumerable(n1, e1)) {
                        for(a1 = t1.length, i1 = createTypedArray("float32", a1), r1 = 0; r1 < a1; r1 += 1)i1[r1] = t1[r1] * e1;
                        return i1;
                    }
                    if (isNumerable(s1, t1) && $bm_isInstanceOfArray(e1)) {
                        for(a1 = e1.length, i1 = createTypedArray("float32", a1), r1 = 0; r1 < a1; r1 += 1)i1[r1] = t1 * e1[r1];
                        return i1;
                    }
                    return 0;
                }
                function div(t1, e1) {
                    var i1, r1, a1, s1 = _typeof(t1), n1 = _typeof(e1);
                    if (isNumerable(s1, t1) && isNumerable(n1, e1)) return t1 / e1;
                    if ($bm_isInstanceOfArray(t1) && isNumerable(n1, e1)) {
                        for(a1 = t1.length, i1 = createTypedArray("float32", a1), r1 = 0; r1 < a1; r1 += 1)i1[r1] = t1[r1] / e1;
                        return i1;
                    }
                    if (isNumerable(s1, t1) && $bm_isInstanceOfArray(e1)) {
                        for(a1 = e1.length, i1 = createTypedArray("float32", a1), r1 = 0; r1 < a1; r1 += 1)i1[r1] = t1 / e1[r1];
                        return i1;
                    }
                    return 0;
                }
                function mod(t1, e1) {
                    return "string" == typeof t1 && (t1 = parseInt(t1, 10)), "string" == typeof e1 && (e1 = parseInt(e1, 10)), t1 % e1;
                }
                var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
                function clamp(t1, e1, i1) {
                    if (e1 > i1) {
                        var r1 = i1;
                        i1 = e1, e1 = r1;
                    }
                    return Math.min(Math.max(t1, e1), i1);
                }
                function radiansToDegrees(t1) {
                    return t1 / degToRads;
                }
                var radians_to_degrees = radiansToDegrees;
                function degreesToRadians(t1) {
                    return t1 * degToRads;
                }
                var degrees_to_radians = radiansToDegrees, helperLengthArray = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                function length(t1, e1) {
                    if ("number" == typeof t1 || t1 instanceof Number) return e1 = e1 || 0, Math.abs(t1 - e1);
                    var i1;
                    e1 || (e1 = helperLengthArray);
                    var r1 = Math.min(t1.length, e1.length), a1 = 0;
                    for(i1 = 0; i1 < r1; i1 += 1)a1 += Math.pow(e1[i1] - t1[i1], 2);
                    return Math.sqrt(a1);
                }
                function normalize(t1) {
                    return div(t1, length(t1));
                }
                function rgbToHsl(t1) {
                    var e1, i1, r1 = t1[0], a1 = t1[1], s1 = t1[2], n1 = Math.max(r1, a1, s1), o1 = Math.min(r1, a1, s1), h1 = (n1 + o1) / 2;
                    if (n1 === o1) e1 = 0, i1 = 0;
                    else {
                        var l1 = n1 - o1;
                        switch(i1 = h1 > .5 ? l1 / (2 - n1 - o1) : l1 / (n1 + o1), n1){
                            case r1:
                                e1 = (a1 - s1) / l1 + (a1 < s1 ? 6 : 0);
                                break;
                            case a1:
                                e1 = (s1 - r1) / l1 + 2;
                                break;
                            case s1:
                                e1 = (r1 - a1) / l1 + 4;
                        }
                        e1 /= 6;
                    }
                    return [
                        e1,
                        i1,
                        h1,
                        t1[3]
                    ];
                }
                function hue2rgb(t1, e1, i1) {
                    return i1 < 0 && (i1 += 1), i1 > 1 && (i1 -= 1), i1 < 1 / 6 ? t1 + 6 * (e1 - t1) * i1 : i1 < .5 ? e1 : i1 < 2 / 3 ? t1 + (e1 - t1) * (2 / 3 - i1) * 6 : t1;
                }
                function hslToRgb(t1) {
                    var e1, i1, r1, a1 = t1[0], s1 = t1[1], n1 = t1[2];
                    if (0 === s1) e1 = n1, r1 = n1, i1 = n1;
                    else {
                        var o1 = n1 < .5 ? n1 * (1 + s1) : n1 + s1 - n1 * s1, h1 = 2 * n1 - o1;
                        e1 = hue2rgb(h1, o1, a1 + 1 / 3), i1 = hue2rgb(h1, o1, a1), r1 = hue2rgb(h1, o1, a1 - 1 / 3);
                    }
                    return [
                        e1,
                        i1,
                        r1,
                        t1[3]
                    ];
                }
                function linear(t1, e1, i1, r1, a1) {
                    if (void 0 !== r1 && void 0 !== a1 || (r1 = e1, a1 = i1, e1 = 0, i1 = 1), i1 < e1) {
                        var s1 = i1;
                        i1 = e1, e1 = s1;
                    }
                    if (t1 <= e1) return r1;
                    if (t1 >= i1) return a1;
                    var n1, o1 = i1 === e1 ? 0 : (t1 - e1) / (i1 - e1);
                    if (!r1.length) return r1 + (a1 - r1) * o1;
                    var h1 = r1.length, l1 = createTypedArray("float32", h1);
                    for(n1 = 0; n1 < h1; n1 += 1)l1[n1] = r1[n1] + (a1[n1] - r1[n1]) * o1;
                    return l1;
                }
                function random(t1, e1) {
                    if (void 0 === e1 && (void 0 === t1 ? (t1 = 0, e1 = 1) : (e1 = t1, t1 = void 0)), e1.length) {
                        var i1, r1 = e1.length;
                        t1 || (t1 = createTypedArray("float32", r1));
                        var a1 = createTypedArray("float32", r1), s1 = BMMath.random();
                        for(i1 = 0; i1 < r1; i1 += 1)a1[i1] = t1[i1] + s1 * (e1[i1] - t1[i1]);
                        return a1;
                    }
                    return void 0 === t1 && (t1 = 0), t1 + BMMath.random() * (e1 - t1);
                }
                function createPath(t1, e1, i1, r1) {
                    var a1, s1 = t1.length, n1 = shapePool.newElement();
                    n1.setPathData(!!r1, s1);
                    var o1, h1, l1 = [
                        0,
                        0
                    ];
                    for(a1 = 0; a1 < s1; a1 += 1)o1 = e1 && e1[a1] ? e1[a1] : l1, h1 = i1 && i1[a1] ? i1[a1] : l1, n1.setTripleAt(t1[a1][0], t1[a1][1], h1[0] + t1[a1][0], h1[1] + t1[a1][1], o1[0] + t1[a1][0], o1[1] + t1[a1][1], a1, !0);
                    return n1;
                }
                function initiateExpression(elem, data, property) {
                    function noOp(t1) {
                        return t1;
                    }
                    if (!elem.globalData.renderConfig.runExpressions) return noOp;
                    var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = -1 !== val.indexOf("random"), elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
                    thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", {
                        get: function() {
                            return thisProperty.v;
                        }
                    }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
                    var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || !0 !== this.data.hd, wiggle = (function(t1, e1) {
                        var i1, r1, a1 = this.pv.length ? this.pv.length : 1, s1 = createTypedArray("float32", a1), n1 = Math.floor(5 * time);
                        for(i1 = 0, r1 = 0; i1 < n1;){
                            for(r1 = 0; r1 < a1; r1 += 1)s1[r1] += -e1 + 2 * e1 * BMMath.random();
                            i1 += 1;
                        }
                        var o1 = 5 * time, h1 = o1 - Math.floor(o1), l1 = createTypedArray("float32", a1);
                        if (a1 > 1) {
                            for(r1 = 0; r1 < a1; r1 += 1)l1[r1] = this.pv[r1] + s1[r1] + (-e1 + 2 * e1 * BMMath.random()) * h1;
                            return l1;
                        }
                        return this.pv + s1[0] + (-e1 + 2 * e1 * BMMath.random()) * h1;
                    }).bind(this);
                    function loopInDuration(t1, e1) {
                        return loopIn(t1, e1, !0);
                    }
                    function loopOutDuration(t1, e1) {
                        return loopOut(t1, e1, !0);
                    }
                    thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty)), this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
                    var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface), time, velocity, value, text, textIndex, textTotal, selectorValue;
                    function lookAt(t1, e1) {
                        var i1 = [
                            e1[0] - t1[0],
                            e1[1] - t1[1],
                            e1[2] - t1[2]
                        ], r1 = Math.atan2(i1[0], Math.sqrt(i1[1] * i1[1] + i1[2] * i1[2])) / degToRads;
                        return [
                            -Math.atan2(i1[1], i1[2]) / degToRads,
                            r1,
                            0
                        ];
                    }
                    function easeOut(t1, e1, i1, r1, a1) {
                        return applyEase(easeOutBez, t1, e1, i1, r1, a1);
                    }
                    function easeIn(t1, e1, i1, r1, a1) {
                        return applyEase(easeInBez, t1, e1, i1, r1, a1);
                    }
                    function ease(t1, e1, i1, r1, a1) {
                        return applyEase(easeInOutBez, t1, e1, i1, r1, a1);
                    }
                    function applyEase(t1, e1, i1, r1, a1, s1) {
                        void 0 === a1 ? (a1 = i1, s1 = r1) : e1 = (e1 - i1) / (r1 - i1), e1 > 1 ? e1 = 1 : e1 < 0 && (e1 = 0);
                        var n1 = t1(e1);
                        if ($bm_isInstanceOfArray(a1)) {
                            var o1, h1 = a1.length, l1 = createTypedArray("float32", h1);
                            for(o1 = 0; o1 < h1; o1 += 1)l1[o1] = (s1[o1] - a1[o1]) * n1 + a1[o1];
                            return l1;
                        }
                        return (s1 - a1) * n1 + a1;
                    }
                    function nearestKey(t1) {
                        var e1, i1, r1, a1 = data.k.length;
                        if (data.k.length && "number" != typeof data.k[0]) {
                            if (i1 = -1, (t1 *= elem.comp.globalData.frameRate) < data.k[0].t) i1 = 1, r1 = data.k[0].t;
                            else {
                                for(e1 = 0; e1 < a1 - 1; e1 += 1){
                                    if (t1 === data.k[e1].t) {
                                        i1 = e1 + 1, r1 = data.k[e1].t;
                                        break;
                                    }
                                    if (t1 > data.k[e1].t && t1 < data.k[e1 + 1].t) {
                                        t1 - data.k[e1].t > data.k[e1 + 1].t - t1 ? (i1 = e1 + 2, r1 = data.k[e1 + 1].t) : (i1 = e1 + 1, r1 = data.k[e1].t);
                                        break;
                                    }
                                }
                                -1 === i1 && (i1 = e1 + 1, r1 = data.k[e1].t);
                            }
                        } else i1 = 0, r1 = 0;
                        var s1 = {};
                        return s1.index = i1, s1.time = r1 / elem.comp.globalData.frameRate, s1;
                    }
                    function key(t1) {
                        var e1, i1, r1;
                        if (!data.k.length || "number" == typeof data.k[0]) throw new Error("The property has no keyframe at index " + t1);
                        t1 -= 1, e1 = {
                            time: data.k[t1].t / elem.comp.globalData.frameRate,
                            value: []
                        };
                        var a1 = Object.prototype.hasOwnProperty.call(data.k[t1], "s") ? data.k[t1].s : data.k[t1 - 1].e;
                        for(r1 = a1.length, i1 = 0; i1 < r1; i1 += 1)e1[i1] = a1[i1], e1.value[i1] = a1[i1];
                        return e1;
                    }
                    function framesToTime(t1, e1) {
                        return e1 || (e1 = elem.comp.globalData.frameRate), t1 / e1;
                    }
                    function timeToFrames(t1, e1) {
                        return t1 || 0 === t1 || (t1 = time), e1 || (e1 = elem.comp.globalData.frameRate), t1 * e1;
                    }
                    function seedRandom(t1) {
                        BMMath.seedrandom(randSeed + t1);
                    }
                    function sourceRectAtTime() {
                        return elem.sourceRectAtTime();
                    }
                    function substring(t1, e1) {
                        return "string" == typeof value ? void 0 === e1 ? value.substring(t1) : value.substring(t1, e1) : "";
                    }
                    function substr(t1, e1) {
                        return "string" == typeof value ? void 0 === e1 ? value.substr(t1) : value.substr(t1, e1) : "";
                    }
                    function posterizeTime(t1) {
                        time = 0 === t1 ? 0 : Math.floor(time * t1) / t1, value = valueAtTime(time);
                    }
                    var index = elem.data.ind, hasParent = !(!elem.hierarchy || !elem.hierarchy.length), parent, randSeed = Math.floor(1e6 * Math.random()), globalData = elem.globalData;
                    function executeExpression(t1) {
                        return value = t1, this.frameExpressionId === elem.globalData.frameId && "textSelector" !== this.propType ? value : ("textSelector" === this.propType && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), 4 !== elemType || content || (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), (hasParent = !(!elem.hierarchy || !elem.hierarchy.length)) && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt);
                    }
                    return executeExpression.__preventDeadCodeRemoval = [
                        $bm_transform,
                        anchorPoint,
                        time,
                        velocity,
                        inPoint,
                        outPoint,
                        width,
                        height,
                        name,
                        loop_in,
                        loop_out,
                        smooth,
                        toComp,
                        fromCompToSurface,
                        toWorld,
                        fromWorld,
                        mask,
                        position,
                        rotation,
                        scale,
                        thisComp,
                        numKeys,
                        active,
                        wiggle,
                        loopInDuration,
                        loopOutDuration,
                        comp,
                        lookAt,
                        easeOut,
                        easeIn,
                        ease,
                        nearestKey,
                        key,
                        text,
                        textIndex,
                        textTotal,
                        selectorValue,
                        framesToTime,
                        timeToFrames,
                        sourceRectAtTime,
                        substring,
                        substr,
                        posterizeTime,
                        index,
                        globalData
                    ], executeExpression;
                }
                return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [
                    window,
                    document,
                    XMLHttpRequest,
                    fetch,
                    frames,
                    $bm_neg,
                    add,
                    $bm_sum,
                    $bm_sub,
                    $bm_mul,
                    $bm_div,
                    $bm_mod,
                    clamp,
                    radians_to_degrees,
                    degreesToRadians,
                    degrees_to_radians,
                    normalize,
                    rgbToHsl,
                    hslToRgb,
                    linear,
                    random,
                    createPath
                ], ob;
            }(), expressionHelpers = {
                searchExpressions: function(t1, e1, i1) {
                    e1.x && (i1.k = !0, i1.x = !0, i1.initiateExpression = ExpressionManager.initiateExpression, i1.effectsSequence.push(i1.initiateExpression(t1, e1, i1).bind(i1)));
                },
                getSpeedAtTime: function(t1) {
                    var e1 = this.getValueAtTime(t1), i1 = this.getValueAtTime(t1 + -0.01), r1 = 0;
                    if (e1.length) {
                        var a1;
                        for(a1 = 0; a1 < e1.length; a1 += 1)r1 += Math.pow(i1[a1] - e1[a1], 2);
                        r1 = 100 * Math.sqrt(r1);
                    } else r1 = 0;
                    return r1;
                },
                getVelocityAtTime: function(t1) {
                    if (void 0 !== this.vel) return this.vel;
                    var e1, i1, r1 = -0.001, a1 = this.getValueAtTime(t1), s1 = this.getValueAtTime(t1 + r1);
                    if (a1.length) for(e1 = createTypedArray("float32", a1.length), i1 = 0; i1 < a1.length; i1 += 1)e1[i1] = (s1[i1] - a1[i1]) / r1;
                    else e1 = (s1 - a1) / r1;
                    return e1;
                },
                getValueAtTime: function(t1) {
                    return t1 *= this.elem.globalData.frameRate, (t1 -= this.offsetTime) !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < t1 ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(t1, this._cachingAtTime), this._cachingAtTime.lastFrame = t1), this._cachingAtTime.value;
                },
                getStaticValueAtTime: function() {
                    return this.pv;
                },
                setGroupProperty: function(t1) {
                    this.propertyGroup = t1;
                }
            };
            function addPropertyDecorator() {
                function t1(t1, e1, i1) {
                    if (!this.k || !this.keyframes) return this.pv;
                    t1 = t1 ? t1.toLowerCase() : "";
                    var r1, a1, s1, n1, o1, h1 = this.comp.renderedFrame, l1 = this.keyframes, p1 = l1[l1.length - 1].t;
                    if (h1 <= p1) return this.pv;
                    if (i1 ? a1 = p1 - (r1 = e1 ? Math.abs(p1 - this.elem.comp.globalData.frameRate * e1) : Math.max(0, p1 - this.elem.data.ip)) : ((!e1 || e1 > l1.length - 1) && (e1 = l1.length - 1), r1 = p1 - (a1 = l1[l1.length - 1 - e1].t)), "pingpong" === t1) {
                        if (Math.floor((h1 - a1) / r1) % 2 != 0) return this.getValueAtTime((r1 - (h1 - a1) % r1 + a1) / this.comp.globalData.frameRate, 0);
                    } else {
                        if ("offset" === t1) {
                            var f1 = this.getValueAtTime(a1 / this.comp.globalData.frameRate, 0), d1 = this.getValueAtTime(p1 / this.comp.globalData.frameRate, 0), c1 = this.getValueAtTime(((h1 - a1) % r1 + a1) / this.comp.globalData.frameRate, 0), m1 = Math.floor((h1 - a1) / r1);
                            if (this.pv.length) {
                                for(n1 = (o1 = new Array(f1.length)).length, s1 = 0; s1 < n1; s1 += 1)o1[s1] = (d1[s1] - f1[s1]) * m1 + c1[s1];
                                return o1;
                            }
                            return (d1 - f1) * m1 + c1;
                        }
                        if ("continue" === t1) {
                            var u1 = this.getValueAtTime(p1 / this.comp.globalData.frameRate, 0), y1 = this.getValueAtTime((p1 - .001) / this.comp.globalData.frameRate, 0);
                            if (this.pv.length) {
                                for(n1 = (o1 = new Array(u1.length)).length, s1 = 0; s1 < n1; s1 += 1)o1[s1] = u1[s1] + (u1[s1] - y1[s1]) * ((h1 - p1) / this.comp.globalData.frameRate) / 5e-4;
                                return o1;
                            }
                            return u1 + (h1 - p1) / .001 * (u1 - y1);
                        }
                    }
                    return this.getValueAtTime(((h1 - a1) % r1 + a1) / this.comp.globalData.frameRate, 0);
                }
                function e1(t1, e1, i1) {
                    if (!this.k) return this.pv;
                    t1 = t1 ? t1.toLowerCase() : "";
                    var r1, a1, s1, n1, o1, h1 = this.comp.renderedFrame, l1 = this.keyframes, p1 = l1[0].t;
                    if (h1 >= p1) return this.pv;
                    if (i1 ? a1 = p1 + (r1 = e1 ? Math.abs(this.elem.comp.globalData.frameRate * e1) : Math.max(0, this.elem.data.op - p1)) : ((!e1 || e1 > l1.length - 1) && (e1 = l1.length - 1), r1 = (a1 = l1[e1].t) - p1), "pingpong" === t1) {
                        if (Math.floor((p1 - h1) / r1) % 2 == 0) return this.getValueAtTime(((p1 - h1) % r1 + p1) / this.comp.globalData.frameRate, 0);
                    } else {
                        if ("offset" === t1) {
                            var f1 = this.getValueAtTime(p1 / this.comp.globalData.frameRate, 0), d1 = this.getValueAtTime(a1 / this.comp.globalData.frameRate, 0), c1 = this.getValueAtTime((r1 - (p1 - h1) % r1 + p1) / this.comp.globalData.frameRate, 0), m1 = Math.floor((p1 - h1) / r1) + 1;
                            if (this.pv.length) {
                                for(n1 = (o1 = new Array(f1.length)).length, s1 = 0; s1 < n1; s1 += 1)o1[s1] = c1[s1] - (d1[s1] - f1[s1]) * m1;
                                return o1;
                            }
                            return c1 - (d1 - f1) * m1;
                        }
                        if ("continue" === t1) {
                            var u1 = this.getValueAtTime(p1 / this.comp.globalData.frameRate, 0), y1 = this.getValueAtTime((p1 + .001) / this.comp.globalData.frameRate, 0);
                            if (this.pv.length) {
                                for(n1 = (o1 = new Array(u1.length)).length, s1 = 0; s1 < n1; s1 += 1)o1[s1] = u1[s1] + (u1[s1] - y1[s1]) * (p1 - h1) / .001;
                                return o1;
                            }
                            return u1 + (u1 - y1) * (p1 - h1) / .001;
                        }
                    }
                    return this.getValueAtTime((r1 - ((p1 - h1) % r1 + p1)) / this.comp.globalData.frameRate, 0);
                }
                function i1(t1, e1) {
                    if (!this.k) return this.pv;
                    if (t1 = .5 * (t1 || .4), (e1 = Math.floor(e1 || 5)) <= 1) return this.pv;
                    var i1, r1, a1 = this.comp.renderedFrame / this.comp.globalData.frameRate, s1 = a1 - t1, n1 = e1 > 1 ? (a1 + t1 - s1) / (e1 - 1) : 1, o1 = 0, h1 = 0;
                    for(i1 = this.pv.length ? createTypedArray("float32", this.pv.length) : 0; o1 < e1;){
                        if (r1 = this.getValueAtTime(s1 + o1 * n1), this.pv.length) for(h1 = 0; h1 < this.pv.length; h1 += 1)i1[h1] += r1[h1];
                        else i1 += r1;
                        o1 += 1;
                    }
                    if (this.pv.length) for(h1 = 0; h1 < this.pv.length; h1 += 1)i1[h1] /= e1;
                    else i1 /= e1;
                    return i1;
                }
                function r1(t1) {
                    this._transformCachingAtTime || (this._transformCachingAtTime = {
                        v: new Matrix
                    });
                    var e1 = this._transformCachingAtTime.v;
                    if (e1.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
                        var i1 = this.a.getValueAtTime(t1);
                        e1.translate(-i1[0] * this.a.mult, -i1[1] * this.a.mult, i1[2] * this.a.mult);
                    }
                    if (this.appliedTransformations < 2) {
                        var r1 = this.s.getValueAtTime(t1);
                        e1.scale(r1[0] * this.s.mult, r1[1] * this.s.mult, r1[2] * this.s.mult);
                    }
                    if (this.sk && this.appliedTransformations < 3) {
                        var a1 = this.sk.getValueAtTime(t1), s1 = this.sa.getValueAtTime(t1);
                        e1.skewFromAxis(-a1 * this.sk.mult, s1 * this.sa.mult);
                    }
                    if (this.r && this.appliedTransformations < 4) {
                        var n1 = this.r.getValueAtTime(t1);
                        e1.rotate(-n1 * this.r.mult);
                    } else if (!this.r && this.appliedTransformations < 4) {
                        var o1 = this.rz.getValueAtTime(t1), h1 = this.ry.getValueAtTime(t1), l1 = this.rx.getValueAtTime(t1), p1 = this.or.getValueAtTime(t1);
                        e1.rotateZ(-o1 * this.rz.mult).rotateY(h1 * this.ry.mult).rotateX(l1 * this.rx.mult).rotateZ(-p1[2] * this.or.mult).rotateY(p1[1] * this.or.mult).rotateX(p1[0] * this.or.mult);
                    }
                    if (this.data.p && this.data.p.s) {
                        var f1 = this.px.getValueAtTime(t1), d1 = this.py.getValueAtTime(t1);
                        if (this.data.p.z) {
                            var c1 = this.pz.getValueAtTime(t1);
                            e1.translate(f1 * this.px.mult, d1 * this.py.mult, -c1 * this.pz.mult);
                        } else e1.translate(f1 * this.px.mult, d1 * this.py.mult, 0);
                    } else {
                        var m1 = this.p.getValueAtTime(t1);
                        e1.translate(m1[0] * this.p.mult, m1[1] * this.p.mult, -m1[2] * this.p.mult);
                    }
                    return e1;
                }
                function a1() {
                    return this.v.clone(new Matrix);
                }
                var s1 = TransformPropertyFactory.getTransformProperty;
                TransformPropertyFactory.getTransformProperty = function(t1, e1, i1) {
                    var n1 = s1(t1, e1, i1);
                    return n1.dynamicProperties.length ? n1.getValueAtTime = r1.bind(n1) : n1.getValueAtTime = a1.bind(n1), n1.setGroupProperty = expressionHelpers.setGroupProperty, n1;
                };
                var n1 = PropertyFactory.getProp;
                PropertyFactory.getProp = function(r1, a1, s1, o1, h1) {
                    var l1 = n1(r1, a1, s1, o1, h1);
                    l1.kf ? l1.getValueAtTime = expressionHelpers.getValueAtTime.bind(l1) : l1.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(l1), l1.setGroupProperty = expressionHelpers.setGroupProperty, l1.loopOut = t1, l1.loopIn = e1, l1.smooth = i1, l1.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(l1), l1.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(l1), l1.numKeys = 1 === a1.a ? a1.k.length : 0, l1.propertyIndex = a1.ix;
                    var p1 = 0;
                    return 0 !== s1 && (p1 = createTypedArray("float32", 1 === a1.a ? a1.k[0].s.length : a1.k.length)), l1._cachingAtTime = {
                        lastFrame: initialDefaultFrame,
                        lastIndex: 0,
                        value: p1
                    }, expressionHelpers.searchExpressions(r1, a1, l1), l1.k && h1.addDynamicProperty(l1), l1;
                };
                var o1 = ShapePropertyFactory.getConstructorFunction(), h1 = ShapePropertyFactory.getKeyframedConstructorFunction();
                function l1() {}
                l1.prototype = {
                    vertices: function(t1, e1) {
                        this.k && this.getValue();
                        var i1, r1 = this.v;
                        void 0 !== e1 && (r1 = this.getValueAtTime(e1, 0));
                        var a1 = r1._length, s1 = r1[t1], n1 = r1.v, o1 = createSizedArray(a1);
                        for(i1 = 0; i1 < a1; i1 += 1)o1[i1] = "i" === t1 || "o" === t1 ? [
                            s1[i1][0] - n1[i1][0],
                            s1[i1][1] - n1[i1][1]
                        ] : [
                            s1[i1][0],
                            s1[i1][1]
                        ];
                        return o1;
                    },
                    points: function(t1) {
                        return this.vertices("v", t1);
                    },
                    inTangents: function(t1) {
                        return this.vertices("i", t1);
                    },
                    outTangents: function(t1) {
                        return this.vertices("o", t1);
                    },
                    isClosed: function() {
                        return this.v.c;
                    },
                    pointOnPath: function(t1, e1) {
                        var i1 = this.v;
                        void 0 !== e1 && (i1 = this.getValueAtTime(e1, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(i1));
                        for(var r1, a1 = this._segmentsLength, s1 = a1.lengths, n1 = a1.totalLength * t1, o1 = 0, h1 = s1.length, l1 = 0; o1 < h1;){
                            if (l1 + s1[o1].addedLength > n1) {
                                var p1 = o1, f1 = i1.c && o1 === h1 - 1 ? 0 : o1 + 1, d1 = (n1 - l1) / s1[o1].addedLength;
                                r1 = bez.getPointInSegment(i1.v[p1], i1.v[f1], i1.o[p1], i1.i[f1], d1, s1[o1]);
                                break;
                            }
                            l1 += s1[o1].addedLength, o1 += 1;
                        }
                        return r1 || (r1 = i1.c ? [
                            i1.v[0][0],
                            i1.v[0][1]
                        ] : [
                            i1.v[i1._length - 1][0],
                            i1.v[i1._length - 1][1]
                        ]), r1;
                    },
                    vectorOnPath: function(t1, e1, i1) {
                        1 == t1 ? t1 = this.v.c : 0 == t1 && (t1 = .999);
                        var r1 = this.pointOnPath(t1, e1), a1 = this.pointOnPath(t1 + .001, e1), s1 = a1[0] - r1[0], n1 = a1[1] - r1[1], o1 = Math.sqrt(Math.pow(s1, 2) + Math.pow(n1, 2));
                        return 0 === o1 ? [
                            0,
                            0
                        ] : "tangent" === i1 ? [
                            s1 / o1,
                            n1 / o1
                        ] : [
                            -n1 / o1,
                            s1 / o1
                        ];
                    },
                    tangentOnPath: function(t1, e1) {
                        return this.vectorOnPath(t1, e1, "tangent");
                    },
                    normalOnPath: function(t1, e1) {
                        return this.vectorOnPath(t1, e1, "normal");
                    },
                    setGroupProperty: expressionHelpers.setGroupProperty,
                    getValueAtTime: expressionHelpers.getStaticValueAtTime
                }, extendPrototype([
                    l1
                ], o1), extendPrototype([
                    l1
                ], h1), h1.prototype.getValueAtTime = function(t1) {
                    return this._cachingAtTime || (this._cachingAtTime = {
                        shapeValue: shapePool.clone(this.pv),
                        lastIndex: 0,
                        lastTime: initialDefaultFrame
                    }), t1 *= this.elem.globalData.frameRate, (t1 -= this.offsetTime) !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < t1 ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = t1, this.interpolateShape(t1, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
                }, h1.prototype.initiateExpression = ExpressionManager.initiateExpression;
                var p1 = ShapePropertyFactory.getShapeProp;
                ShapePropertyFactory.getShapeProp = function(t1, e1, i1, r1, a1) {
                    var s1 = p1(t1, e1, i1, r1, a1);
                    return s1.propertyIndex = e1.ix, s1.lock = !1, 3 === i1 ? expressionHelpers.searchExpressions(t1, e1.pt, s1) : 4 === i1 && expressionHelpers.searchExpressions(t1, e1.ks, s1), s1.k && t1.addDynamicProperty(s1), s1;
                };
            }
            function initialize$1() {
                addPropertyDecorator();
            }
            function addDecorator() {
                TextProperty.prototype.getExpressionValue = function(t1, e1) {
                    var i1 = this.calculateExpression(e1);
                    if (t1.t !== i1) {
                        var r1 = {};
                        return this.copyData(r1, t1), r1.t = i1.toString(), r1.__complete = !1, r1;
                    }
                    return t1;
                }, TextProperty.prototype.searchProperty = function() {
                    var t1 = this.searchKeyframes(), e1 = this.searchExpressions();
                    return this.kf = t1 || e1, this.kf;
                }, TextProperty.prototype.searchExpressions = function() {
                    return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
                };
            }
            function initialize() {
                addDecorator();
            }
            function SVGComposableEffect() {}
            function SVGTintFilter(t1, e1, i1, r1, a1) {
                this.filterManager = e1;
                var s1 = createNS("feColorMatrix");
                s1.setAttribute("type", "matrix"), s1.setAttribute("color-interpolation-filters", "linearRGB"), s1.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), s1.setAttribute("result", r1 + "_tint_1"), t1.appendChild(s1), (s1 = createNS("feColorMatrix")).setAttribute("type", "matrix"), s1.setAttribute("color-interpolation-filters", "sRGB"), s1.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), s1.setAttribute("result", r1 + "_tint_2"), t1.appendChild(s1), this.matrixFilter = s1;
                var n1 = this.createMergeNode(r1, [
                    a1,
                    r1 + "_tint_1",
                    r1 + "_tint_2"
                ]);
                t1.appendChild(n1);
            }
            function SVGFillFilter(t1, e1, i1, r1) {
                this.filterManager = e1;
                var a1 = createNS("feColorMatrix");
                a1.setAttribute("type", "matrix"), a1.setAttribute("color-interpolation-filters", "sRGB"), a1.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), a1.setAttribute("result", r1), t1.appendChild(a1), this.matrixFilter = a1;
            }
            function SVGStrokeEffect(t1, e1, i1) {
                this.initialized = !1, this.filterManager = e1, this.elem = i1, this.paths = [];
            }
            function SVGTritoneFilter(t1, e1, i1, r1) {
                this.filterManager = e1;
                var a1 = createNS("feColorMatrix");
                a1.setAttribute("type", "matrix"), a1.setAttribute("color-interpolation-filters", "linearRGB"), a1.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), t1.appendChild(a1);
                var s1 = createNS("feComponentTransfer");
                s1.setAttribute("color-interpolation-filters", "sRGB"), s1.setAttribute("result", r1), this.matrixFilter = s1;
                var n1 = createNS("feFuncR");
                n1.setAttribute("type", "table"), s1.appendChild(n1), this.feFuncR = n1;
                var o1 = createNS("feFuncG");
                o1.setAttribute("type", "table"), s1.appendChild(o1), this.feFuncG = o1;
                var h1 = createNS("feFuncB");
                h1.setAttribute("type", "table"), s1.appendChild(h1), this.feFuncB = h1, t1.appendChild(s1);
            }
            function SVGProLevelsFilter(t1, e1, i1, r1) {
                this.filterManager = e1;
                var a1 = this.filterManager.effectElements, s1 = createNS("feComponentTransfer");
                (a1[10].p.k || 0 !== a1[10].p.v || a1[11].p.k || 1 !== a1[11].p.v || a1[12].p.k || 1 !== a1[12].p.v || a1[13].p.k || 0 !== a1[13].p.v || a1[14].p.k || 1 !== a1[14].p.v) && (this.feFuncR = this.createFeFunc("feFuncR", s1)), (a1[17].p.k || 0 !== a1[17].p.v || a1[18].p.k || 1 !== a1[18].p.v || a1[19].p.k || 1 !== a1[19].p.v || a1[20].p.k || 0 !== a1[20].p.v || a1[21].p.k || 1 !== a1[21].p.v) && (this.feFuncG = this.createFeFunc("feFuncG", s1)), (a1[24].p.k || 0 !== a1[24].p.v || a1[25].p.k || 1 !== a1[25].p.v || a1[26].p.k || 1 !== a1[26].p.v || a1[27].p.k || 0 !== a1[27].p.v || a1[28].p.k || 1 !== a1[28].p.v) && (this.feFuncB = this.createFeFunc("feFuncB", s1)), (a1[31].p.k || 0 !== a1[31].p.v || a1[32].p.k || 1 !== a1[32].p.v || a1[33].p.k || 1 !== a1[33].p.v || a1[34].p.k || 0 !== a1[34].p.v || a1[35].p.k || 1 !== a1[35].p.v) && (this.feFuncA = this.createFeFunc("feFuncA", s1)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (s1.setAttribute("color-interpolation-filters", "sRGB"), t1.appendChild(s1)), (a1[3].p.k || 0 !== a1[3].p.v || a1[4].p.k || 1 !== a1[4].p.v || a1[5].p.k || 1 !== a1[5].p.v || a1[6].p.k || 0 !== a1[6].p.v || a1[7].p.k || 1 !== a1[7].p.v) && ((s1 = createNS("feComponentTransfer")).setAttribute("color-interpolation-filters", "sRGB"), s1.setAttribute("result", r1), t1.appendChild(s1), this.feFuncRComposed = this.createFeFunc("feFuncR", s1), this.feFuncGComposed = this.createFeFunc("feFuncG", s1), this.feFuncBComposed = this.createFeFunc("feFuncB", s1));
            }
            function SVGDropShadowEffect(t1, e1, i1, r1, a1) {
                var s1 = e1.container.globalData.renderConfig.filterSize, n1 = e1.data.fs || s1;
                t1.setAttribute("x", n1.x || s1.x), t1.setAttribute("y", n1.y || s1.y), t1.setAttribute("width", n1.width || s1.width), t1.setAttribute("height", n1.height || s1.height), this.filterManager = e1;
                var o1 = createNS("feGaussianBlur");
                o1.setAttribute("in", "SourceAlpha"), o1.setAttribute("result", r1 + "_drop_shadow_1"), o1.setAttribute("stdDeviation", "0"), this.feGaussianBlur = o1, t1.appendChild(o1);
                var h1 = createNS("feOffset");
                h1.setAttribute("dx", "25"), h1.setAttribute("dy", "0"), h1.setAttribute("in", r1 + "_drop_shadow_1"), h1.setAttribute("result", r1 + "_drop_shadow_2"), this.feOffset = h1, t1.appendChild(h1);
                var l1 = createNS("feFlood");
                l1.setAttribute("flood-color", "#00ff00"), l1.setAttribute("flood-opacity", "1"), l1.setAttribute("result", r1 + "_drop_shadow_3"), this.feFlood = l1, t1.appendChild(l1);
                var p1 = createNS("feComposite");
                p1.setAttribute("in", r1 + "_drop_shadow_3"), p1.setAttribute("in2", r1 + "_drop_shadow_2"), p1.setAttribute("operator", "in"), p1.setAttribute("result", r1 + "_drop_shadow_4"), t1.appendChild(p1);
                var f1 = this.createMergeNode(r1, [
                    r1 + "_drop_shadow_4",
                    a1
                ]);
                t1.appendChild(f1);
            }
            SVGComposableEffect.prototype = {
                createMergeNode: function(t1, e1) {
                    var i1, r1, a1 = createNS("feMerge");
                    for(a1.setAttribute("result", t1), r1 = 0; r1 < e1.length; r1 += 1)(i1 = createNS("feMergeNode")).setAttribute("in", e1[r1]), a1.appendChild(i1), a1.appendChild(i1);
                    return a1;
                }
            }, extendPrototype([
                SVGComposableEffect
            ], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(t1) {
                if (t1 || this.filterManager._mdf) {
                    var e1 = this.filterManager.effectElements[0].p.v, i1 = this.filterManager.effectElements[1].p.v, r1 = this.filterManager.effectElements[2].p.v / 100;
                    this.matrixFilter.setAttribute("values", i1[0] - e1[0] + " 0 0 0 " + e1[0] + " " + (i1[1] - e1[1]) + " 0 0 0 " + e1[1] + " " + (i1[2] - e1[2]) + " 0 0 0 " + e1[2] + " 0 0 0 " + r1 + " 0");
                }
            }, SVGFillFilter.prototype.renderFrame = function(t1) {
                if (t1 || this.filterManager._mdf) {
                    var e1 = this.filterManager.effectElements[2].p.v, i1 = this.filterManager.effectElements[6].p.v;
                    this.matrixFilter.setAttribute("values", "0 0 0 0 " + e1[0] + " 0 0 0 0 " + e1[1] + " 0 0 0 0 " + e1[2] + " 0 0 0 " + i1 + " 0");
                }
            }, SVGStrokeEffect.prototype.initialize = function() {
                var t1, e1, i1, r1, a1 = this.elem.layerElement.children || this.elem.layerElement.childNodes;
                for(1 === this.filterManager.effectElements[1].p.v ? (r1 = this.elem.maskManager.masksProperties.length, i1 = 0) : r1 = 1 + (i1 = this.filterManager.effectElements[0].p.v - 1), (e1 = createNS("g")).setAttribute("fill", "none"), e1.setAttribute("stroke-linecap", "round"), e1.setAttribute("stroke-dashoffset", 1); i1 < r1; i1 += 1)t1 = createNS("path"), e1.appendChild(t1), this.paths.push({
                    p: t1,
                    m: i1
                });
                if (3 === this.filterManager.effectElements[10].p.v) {
                    var s1 = createNS("mask"), n1 = createElementID();
                    s1.setAttribute("id", n1), s1.setAttribute("mask-type", "alpha"), s1.appendChild(e1), this.elem.globalData.defs.appendChild(s1);
                    var o1 = createNS("g");
                    for(o1.setAttribute("mask", "url(" + getLocationHref() + "#" + n1 + ")"); a1[0];)o1.appendChild(a1[0]);
                    this.elem.layerElement.appendChild(o1), this.masker = s1, e1.setAttribute("stroke", "#fff");
                } else if (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) {
                    if (2 === this.filterManager.effectElements[10].p.v) for(a1 = this.elem.layerElement.children || this.elem.layerElement.childNodes; a1.length;)this.elem.layerElement.removeChild(a1[0]);
                    this.elem.layerElement.appendChild(e1), this.elem.layerElement.removeAttribute("mask"), e1.setAttribute("stroke", "#fff");
                }
                this.initialized = !0, this.pathMasker = e1;
            }, SVGStrokeEffect.prototype.renderFrame = function(t1) {
                var e1;
                this.initialized || this.initialize();
                var i1, r1, a1 = this.paths.length;
                for(e1 = 0; e1 < a1; e1 += 1)if (-1 !== this.paths[e1].m && (i1 = this.elem.maskManager.viewData[this.paths[e1].m], r1 = this.paths[e1].p, (t1 || this.filterManager._mdf || i1.prop._mdf) && r1.setAttribute("d", i1.lastPath), t1 || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || i1.prop._mdf)) {
                    var s1;
                    if (0 !== this.filterManager.effectElements[7].p.v || 100 !== this.filterManager.effectElements[8].p.v) {
                        var n1 = .01 * Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), o1 = .01 * Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), h1 = r1.getTotalLength();
                        s1 = "0 0 0 " + h1 * n1 + " ";
                        var l1, p1 = h1 * (o1 - n1), f1 = 1 + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01, d1 = Math.floor(p1 / f1);
                        for(l1 = 0; l1 < d1; l1 += 1)s1 += "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01 + " ";
                        s1 += "0 " + 10 * h1 + " 0 0";
                    } else s1 = "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01;
                    r1.setAttribute("stroke-dasharray", s1);
                }
                if ((t1 || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", 2 * this.filterManager.effectElements[4].p.v), (t1 || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) && (t1 || this.filterManager.effectElements[3].p._mdf)) {
                    var c1 = this.filterManager.effectElements[3].p.v;
                    this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(255 * c1[0]) + "," + bmFloor(255 * c1[1]) + "," + bmFloor(255 * c1[2]) + ")");
                }
            }, SVGTritoneFilter.prototype.renderFrame = function(t1) {
                if (t1 || this.filterManager._mdf) {
                    var e1 = this.filterManager.effectElements[0].p.v, i1 = this.filterManager.effectElements[1].p.v, r1 = this.filterManager.effectElements[2].p.v, a1 = r1[0] + " " + i1[0] + " " + e1[0], s1 = r1[1] + " " + i1[1] + " " + e1[1], n1 = r1[2] + " " + i1[2] + " " + e1[2];
                    this.feFuncR.setAttribute("tableValues", a1), this.feFuncG.setAttribute("tableValues", s1), this.feFuncB.setAttribute("tableValues", n1);
                }
            }, SVGProLevelsFilter.prototype.createFeFunc = function(t1, e1) {
                var i1 = createNS(t1);
                return i1.setAttribute("type", "table"), e1.appendChild(i1), i1;
            }, SVGProLevelsFilter.prototype.getTableValue = function(t1, e1, i1, r1, a1) {
                for(var s1, n1, o1 = 0, h1 = Math.min(t1, e1), l1 = Math.max(t1, e1), p1 = Array.call(null, {
                    length: 256
                }), f1 = 0, d1 = a1 - r1, c1 = e1 - t1; o1 <= 256;)n1 = (s1 = o1 / 256) <= h1 ? c1 < 0 ? a1 : r1 : s1 >= l1 ? c1 < 0 ? r1 : a1 : r1 + d1 * Math.pow((s1 - t1) / c1, 1 / i1), p1[f1] = n1, f1 += 1, o1 += 256 / 255;
                return p1.join(" ");
            }, SVGProLevelsFilter.prototype.renderFrame = function(t1) {
                if (t1 || this.filterManager._mdf) {
                    var e1, i1 = this.filterManager.effectElements;
                    this.feFuncRComposed && (t1 || i1[3].p._mdf || i1[4].p._mdf || i1[5].p._mdf || i1[6].p._mdf || i1[7].p._mdf) && (e1 = this.getTableValue(i1[3].p.v, i1[4].p.v, i1[5].p.v, i1[6].p.v, i1[7].p.v), this.feFuncRComposed.setAttribute("tableValues", e1), this.feFuncGComposed.setAttribute("tableValues", e1), this.feFuncBComposed.setAttribute("tableValues", e1)), this.feFuncR && (t1 || i1[10].p._mdf || i1[11].p._mdf || i1[12].p._mdf || i1[13].p._mdf || i1[14].p._mdf) && (e1 = this.getTableValue(i1[10].p.v, i1[11].p.v, i1[12].p.v, i1[13].p.v, i1[14].p.v), this.feFuncR.setAttribute("tableValues", e1)), this.feFuncG && (t1 || i1[17].p._mdf || i1[18].p._mdf || i1[19].p._mdf || i1[20].p._mdf || i1[21].p._mdf) && (e1 = this.getTableValue(i1[17].p.v, i1[18].p.v, i1[19].p.v, i1[20].p.v, i1[21].p.v), this.feFuncG.setAttribute("tableValues", e1)), this.feFuncB && (t1 || i1[24].p._mdf || i1[25].p._mdf || i1[26].p._mdf || i1[27].p._mdf || i1[28].p._mdf) && (e1 = this.getTableValue(i1[24].p.v, i1[25].p.v, i1[26].p.v, i1[27].p.v, i1[28].p.v), this.feFuncB.setAttribute("tableValues", e1)), this.feFuncA && (t1 || i1[31].p._mdf || i1[32].p._mdf || i1[33].p._mdf || i1[34].p._mdf || i1[35].p._mdf) && (e1 = this.getTableValue(i1[31].p.v, i1[32].p.v, i1[33].p.v, i1[34].p.v, i1[35].p.v), this.feFuncA.setAttribute("tableValues", e1));
                }
            }, extendPrototype([
                SVGComposableEffect
            ], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(t1) {
                if (t1 || this.filterManager._mdf) {
                    if ((t1 || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), t1 || this.filterManager.effectElements[0].p._mdf) {
                        var e1 = this.filterManager.effectElements[0].p.v;
                        this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(255 * e1[0]), Math.round(255 * e1[1]), Math.round(255 * e1[2])));
                    }
                    if ((t1 || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), t1 || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                        var i1 = this.filterManager.effectElements[3].p.v, r1 = (this.filterManager.effectElements[2].p.v - 90) * degToRads, a1 = i1 * Math.cos(r1), s1 = i1 * Math.sin(r1);
                        this.feOffset.setAttribute("dx", a1), this.feOffset.setAttribute("dy", s1);
                    }
                }
            };
            var _svgMatteSymbols = [];
            function SVGMatte3Effect(t1, e1, i1) {
                this.initialized = !1, this.filterManager = e1, this.filterElem = t1, this.elem = i1, i1.matteElement = createNS("g"), i1.matteElement.appendChild(i1.layerElement), i1.matteElement.appendChild(i1.transformedElement), i1.baseElement = i1.matteElement;
            }
            function SVGGaussianBlurEffect(t1, e1, i1, r1) {
                t1.setAttribute("x", "-100%"), t1.setAttribute("y", "-100%"), t1.setAttribute("width", "300%"), t1.setAttribute("height", "300%"), this.filterManager = e1;
                var a1 = createNS("feGaussianBlur");
                a1.setAttribute("result", r1), t1.appendChild(a1), this.feGaussianBlur = a1;
            }
            return SVGMatte3Effect.prototype.findSymbol = function(t1) {
                for(var e1 = 0, i1 = _svgMatteSymbols.length; e1 < i1;){
                    if (_svgMatteSymbols[e1] === t1) return _svgMatteSymbols[e1];
                    e1 += 1;
                }
                return null;
            }, SVGMatte3Effect.prototype.replaceInParent = function(t1, e1) {
                var i1 = t1.layerElement.parentNode;
                if (i1) {
                    for(var r1, a1 = i1.children, s1 = 0, n1 = a1.length; s1 < n1 && a1[s1] !== t1.layerElement;)s1 += 1;
                    s1 <= n1 - 2 && (r1 = a1[s1 + 1]);
                    var o1 = createNS("use");
                    o1.setAttribute("href", "#" + e1), r1 ? i1.insertBefore(o1, r1) : i1.appendChild(o1);
                }
            }, SVGMatte3Effect.prototype.setElementAsMask = function(t1, e1) {
                if (!this.findSymbol(e1)) {
                    var i1 = createElementID(), r1 = createNS("mask");
                    r1.setAttribute("id", e1.layerId), r1.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(e1);
                    var a1 = t1.globalData.defs;
                    a1.appendChild(r1);
                    var s1 = createNS("symbol");
                    s1.setAttribute("id", i1), this.replaceInParent(e1, i1), s1.appendChild(e1.layerElement), a1.appendChild(s1);
                    var n1 = createNS("use");
                    n1.setAttribute("href", "#" + i1), r1.appendChild(n1), e1.data.hd = !1, e1.show();
                }
                t1.setMatte(e1.layerId);
            }, SVGMatte3Effect.prototype.initialize = function() {
                for(var t1 = this.filterManager.effectElements[0].p.v, e1 = this.elem.comp.elements, i1 = 0, r1 = e1.length; i1 < r1;)e1[i1] && e1[i1].data.ind === t1 && this.setElementAsMask(this.elem, e1[i1]), i1 += 1;
                this.initialized = !0;
            }, SVGMatte3Effect.prototype.renderFrame = function() {
                this.initialized || this.initialize();
            }, SVGGaussianBlurEffect.prototype.renderFrame = function(t1) {
                if (t1 || this.filterManager._mdf) {
                    var e1 = .3 * this.filterManager.effectElements[0].p.v, i1 = this.filterManager.effectElements[1].p.v, r1 = 3 == i1 ? 0 : e1, a1 = 2 == i1 ? 0 : e1;
                    this.feGaussianBlur.setAttribute("stdDeviation", r1 + " " + a1);
                    var s1 = 1 == this.filterManager.effectElements[2].p.v ? "wrap" : "duplicate";
                    this.feGaussianBlur.setAttribute("edgeMode", s1);
                }
            }, registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect(20, SVGTintFilter, !0), registerEffect(21, SVGFillFilter, !0), registerEffect(22, SVGStrokeEffect, !1), registerEffect(23, SVGTritoneFilter, !0), registerEffect(24, SVGProLevelsFilter, !0), registerEffect(25, SVGDropShadowEffect, !0), registerEffect(28, SVGMatte3Effect, !1), registerEffect(29, SVGGaussianBlurEffect, !0), lottie;
        }, module.exports = factory());
    })(lottie, lottie.exports);
    var styles$1 = r$2(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral([
        "\n  * {\n    box-sizing: border-box;\n  }\n\n  :host {\n    --lottie-player-toolbar-height: 35px;\n    --lottie-player-toolbar-background-color: transparent;\n    --lottie-player-toolbar-icon-color: #999;\n    --lottie-player-toolbar-icon-hover-color: #222;\n    --lottie-player-toolbar-icon-active-color: #555;\n    --lottie-player-seeker-track-color: #ccc;\n    --lottie-player-seeker-thumb-color: rgba(0, 107, 120, 0.8);\n    --lottie-player-seeker-display: block;\n\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n\n  .main {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n  }\n\n  .animation {\n    width: 100%;\n    height: 100%;\n    display: flex;\n  }\n  .animation.controls {\n    height: calc(100% - 35px);\n  }\n\n  .toolbar {\n    display: flex;\n    align-items: center;\n    justify-items: center;\n    background-color: var(--lottie-player-toolbar-background-color);\n    margin: 0 5px;\n    height: 35px;\n  }\n\n  .toolbar button {\n    cursor: pointer;\n    fill: var(--lottie-player-toolbar-icon-color);\n    display: flex;\n    background: none;\n    border: 0;\n    padding: 0;\n    outline: none;\n    height: 100%;\n  }\n\n  .toolbar button:hover {\n    fill: var(--lottie-player-toolbar-icon-hover-color);\n  }\n\n  .toolbar button.active {\n    fill: var(--lottie-player-toolbar-icon-active-color);\n  }\n\n  .toolbar button.active:hover {\n    fill: var(--lottie-player-toolbar-icon-hover-color);\n  }\n\n  .toolbar button:focus {\n    outline: 1px dotted var(--lottie-player-toolbar-icon-active-color);\n  }\n\n  .toolbar button svg {\n  }\n\n  .toolbar button.disabled svg {\n    display: none;\n  }\n\n  .seeker {\n    -webkit-appearance: none;\n    width: 95%;\n    outline: none;\n    background-color: var(--lottie-player-toolbar-background-color);\n    display: var(--lottie-player-seeker-display);\n  }\n\n  .seeker::-webkit-slider-runnable-track {\n    width: 100%;\n    height: 5px;\n    cursor: pointer;\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-webkit-slider-thumb {\n    height: 15px;\n    width: 15px;\n    border-radius: 50%;\n    background: var(--lottie-player-seeker-thumb-color);\n    cursor: pointer;\n    -webkit-appearance: none;\n    margin-top: -5px;\n  }\n  .seeker:focus::-webkit-slider-runnable-track {\n    background: #999;\n  }\n  .seeker::-moz-range-track {\n    width: 100%;\n    height: 5px;\n    cursor: pointer;\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-moz-range-thumb {\n    height: 15px;\n    width: 15px;\n    border-radius: 50%;\n    background: var(--lottie-player-seeker-thumb-color);\n    cursor: pointer;\n  }\n  .seeker::-ms-track {\n    width: 100%;\n    height: 5px;\n    cursor: pointer;\n    background: transparent;\n    border-color: transparent;\n    color: transparent;\n  }\n  .seeker::-ms-fill-lower {\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-ms-fill-upper {\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-ms-thumb {\n    border: 0;\n    height: 15px;\n    width: 15px;\n    border-radius: 50%;\n    background: var(--lottie-player-seeker-thumb-color);\n    cursor: pointer;\n  }\n  .seeker:focus::-ms-fill-lower {\n    background: var(--lottie-player-seeker-track-color);\n  }\n  .seeker:focus::-ms-fill-upper {\n    background: var(--lottie-player-seeker-track-color);\n  }\n\n  .error {\n    display: flex;\n    justify-content: center;\n    height: 100%;\n    align-items: center;\n  }\n"
    ]))), LOTTIE_PLAYER_VERSION = "1.7.1", LOTTIE_WEB_VERSION = "^5.10.0", _templateObject$1, _templateObject2, _templateObject3, _templateObject4, _templateObject5, PlayerState, PlayMode, PlayerEvents;
    function parseSrc(t1) {
        if ("object" == typeof t1) return t1;
        try {
            return JSON.parse(t1);
        } catch (e1) {
            return new URL(t1, window.location.href).toString();
        }
    }
    function isLottie(t1) {
        return [
            "v",
            "ip",
            "op",
            "layers",
            "fr",
            "w",
            "h"
        ].every((e1)=>Object.prototype.hasOwnProperty.call(t1, e1));
    }
    function fromURL(t1) {
        return _fromURL.apply(this, arguments);
    }
    function _fromURL() {
        return (_fromURL = _asyncToGenerator(function*(t1) {
            if ("string" != typeof t1) throw new Error("The url value must be a string");
            var e1;
            try {
                var i1 = new URL(t1), r1 = yield fetch(i1.toString());
                e1 = yield r1.json();
            } catch (t1) {
                throw new Error("An error occurred while trying to load the Lottie file from URL");
            }
            return e1;
        })).apply(this, arguments);
    }
    !function(t1) {
        t1.Destroyed = "destroyed", t1.Error = "error", t1.Frozen = "frozen", t1.Loading = "loading", t1.Paused = "paused", t1.Playing = "playing", t1.Stopped = "stopped";
    }(PlayerState || (PlayerState = {})), function(t1) {
        t1.Bounce = "bounce", t1.Normal = "normal";
    }(PlayMode || (PlayMode = {})), function(t1) {
        t1.Complete = "complete", t1.Destroyed = "destroyed", t1.Error = "error", t1.Frame = "frame", t1.Freeze = "freeze", t1.Load = "load", t1.Loop = "loop", t1.Pause = "pause", t1.Play = "play", t1.Ready = "ready", t1.Rendered = "rendered", t1.Stop = "stop";
    }(PlayerEvents || (PlayerEvents = {}));
    var LottiePlayer = class extends s {
        constructor(){
            super(...arguments), this.autoplay = !1, this.background = "transparent", this.controls = !1, this.currentState = PlayerState.Loading, this.description = "Lottie animation", this.direction = 1, this.disableCheck = !1, this.disableShadowDOM = !1, this.hover = !1, this.intermission = 1, this.loop = !1, this.mode = PlayMode.Normal, this.preserveAspectRatio = "xMidYMid meet", this.renderer = "svg", this.speed = 1, this._io = void 0, this._counter = 1;
        }
        load(t1) {
            var e1 = this;
            return _asyncToGenerator(function*() {
                var i1 = {
                    container: e1.container,
                    loop: !1,
                    autoplay: !1,
                    renderer: e1.renderer,
                    rendererSettings: Object.assign({
                        preserveAspectRatio: e1.preserveAspectRatio,
                        clearCanvas: !1,
                        progressiveLoad: !0,
                        hideOnTransparent: !0
                    }, e1.viewBoxSize && {
                        viewBoxSize: e1.viewBoxSize
                    })
                };
                try {
                    var r1 = parseSrc(t1), a1 = {}, s1 = "string" == typeof r1 ? "path" : "animationData";
                    e1._lottie && e1._lottie.destroy(), e1.webworkers && lottie.exports.useWebWorker(!0), e1._lottie = lottie.exports.loadAnimation(Object.assign(Object.assign({}, i1), {
                        [s1]: r1
                    })), e1._attachEventListeners(), e1.disableCheck || ("path" === s1 ? (a1 = yield fromURL(r1), s1 = "animationData") : a1 = r1, isLottie(a1) || (e1.currentState = PlayerState.Error, e1.dispatchEvent(new CustomEvent(PlayerEvents.Error))));
                } catch (t1) {
                    e1.currentState = PlayerState.Error, e1.dispatchEvent(new CustomEvent(PlayerEvents.Error));
                }
            })();
        }
        getLottie() {
            return this._lottie;
        }
        getVersions() {
            return {
                lottieWebVersion: LOTTIE_WEB_VERSION,
                lottiePlayerVersion: LOTTIE_PLAYER_VERSION
            };
        }
        play() {
            this._lottie && (this._lottie.play(), this.currentState = PlayerState.Playing, this.dispatchEvent(new CustomEvent(PlayerEvents.Play)));
        }
        pause() {
            this._lottie && (this._lottie.pause(), this.currentState = PlayerState.Paused, this.dispatchEvent(new CustomEvent(PlayerEvents.Pause)));
        }
        stop() {
            this._lottie && (this._counter = 1, this._lottie.stop(), this.currentState = PlayerState.Stopped, this.dispatchEvent(new CustomEvent(PlayerEvents.Stop)));
        }
        destroy() {
            this._lottie && (this._lottie.destroy(), this._lottie = null, this.currentState = PlayerState.Destroyed, this.dispatchEvent(new CustomEvent(PlayerEvents.Destroyed)), this.remove());
        }
        seek(t1) {
            if (this._lottie) {
                var e1 = /^(\d+)(%?)$/.exec(t1.toString());
                if (e1) {
                    var i1 = "%" === e1[2] ? this._lottie.totalFrames * Number(e1[1]) / 100 : Number(e1[1]);
                    this.seeker = i1, this.currentState === PlayerState.Playing ? this._lottie.goToAndPlay(i1, !0) : (this._lottie.goToAndStop(i1, !0), this._lottie.pause());
                }
            }
        }
        snapshot() {
            var t1 = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
            if (this.shadowRoot) {
                var e1 = this.shadowRoot.querySelector(".animation svg"), i1 = (new XMLSerializer).serializeToString(e1);
                if (t1) {
                    var r1 = document.createElement("a");
                    r1.href = "data:image/svg+xml;charset=utf-8,".concat(encodeURIComponent(i1)), r1.download = "download_".concat(this.seeker, ".svg"), document.body.appendChild(r1), r1.click(), document.body.removeChild(r1);
                }
                return i1;
            }
        }
        setSpeed() {
            var t1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
            this._lottie && this._lottie.setSpeed(t1);
        }
        setDirection(t1) {
            this._lottie && this._lottie.setDirection(t1);
        }
        setLooping(t1) {
            this._lottie && (this.loop = t1, this._lottie.loop = t1);
        }
        togglePlay() {
            return this.currentState === PlayerState.Playing ? this.pause() : this.play();
        }
        toggleLooping() {
            this.setLooping(!this.loop);
        }
        resize() {
            this._lottie && this._lottie.resize();
        }
        static get styles() {
            return styles$1;
        }
        disconnectedCallback() {
            this.isConnected || (this._io && (this._io.disconnect(), this._io = void 0), document.removeEventListener("visibilitychange", ()=>this._onVisibilityChange()), this.destroy());
        }
        render() {
            var t1 = this.controls ? "main controls" : "main", e1 = this.controls ? "animation controls" : "animation";
            return $(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral([
                ' <div\n      id="animation-container"\n      class=',
                '\n      lang="en"\n      aria-label=',
                '\n      role="img"\n    >\n      <div\n        id="animation"\n        class=',
                '\n        style="background:',
                ';"\n      >\n        ',
                "\n      </div>\n      ",
                "\n    </div>"
            ])), t1, this.description, e1, this.background, this.currentState === PlayerState.Error ? $(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([
                '<div class="error">⚠️</div>'
            ]))) : void 0, this.controls && !this.disableShadowDOM ? this.renderControls() : void 0);
        }
        createRenderRoot() {
            return this.disableShadowDOM && (this.style.display = "block"), this.disableShadowDOM ? this : super.createRenderRoot();
        }
        firstUpdated() {
            "IntersectionObserver" in window && (this._io = new IntersectionObserver((t1)=>{
                t1[0].isIntersecting ? this.currentState === PlayerState.Frozen && this.play() : this.currentState === PlayerState.Playing && this.freeze();
            }), this._io.observe(this.container)), void 0 !== document.hidden && document.addEventListener("visibilitychange", ()=>this._onVisibilityChange()), this.src && this.load(this.src), this.dispatchEvent(new CustomEvent(PlayerEvents.Rendered));
        }
        renderControls() {
            var t1 = this.currentState === PlayerState.Playing, e1 = this.currentState === PlayerState.Paused, i1 = this.currentState === PlayerState.Stopped;
            return $(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([
                '\n      <div\n        id="lottie-controls"\n        aria-label="lottie-animation-controls"\n        class="toolbar"\n      >\n        <button\n          id="lottie-play-button"\n          @click=',
                "\n          class=",
                '\n          style="align-items:center;"\n          tabindex="0"\n          aria-label="play-pause"\n        >\n          ',
                '\n        </button>\n        <button\n          id="lottie-stop-button"\n          @click=',
                "\n          class=",
                '\n          style="align-items:center;"\n          tabindex="0"\n          aria-label="stop"\n        >\n          <svg width="24" height="24" aria-hidden="true" focusable="false">\n            <path d="M6 6h12v12H6V6z" />\n          </svg>\n        </button>\n        <input\n          id="lottie-seeker-input"\n          class="seeker"\n          type="range"\n          min="0"\n          step="1"\n          max="100"\n          .value=',
                "\n          @input=",
                "\n          @mousedown=",
                "\n          @mouseup=",
                '\n          aria-valuemin="1"\n          aria-valuemax="100"\n          role="slider"\n          aria-valuenow=',
                '\n          tabindex="0"\n          aria-label="lottie-seek-input"\n        />\n        <button\n          id="lottie-loop-toggle"\n          @click=',
                "\n          class=",
                '\n          style="align-items:center;"\n          tabindex="0"\n          aria-label="loop-toggle"\n        >\n          <svg width="24" height="24" aria-hidden="true" focusable="false">\n            <path\n              d="M17.016 17.016v-4.031h1.969v6h-12v3l-3.984-3.984 3.984-3.984v3h10.031zM6.984 6.984v4.031H5.015v-6h12v-3l3.984 3.984-3.984 3.984v-3H6.984z"\n            />\n          </svg>\n        </button>\n      </div>\n    '
            ])), this.togglePlay, t1 || e1 ? "active" : "", $(t1 ? _templateObject4 || (_templateObject4 = _taggedTemplateLiteral([
                '<svg\n                width="24"\n                height="24"\n                aria-hidden="true"\n                focusable="false"\n              >\n                <path\n                  d="M14.016 5.016H18v13.969h-3.984V5.016zM6 18.984V5.015h3.984v13.969H6z"\n                />\n              </svg>'
            ])) : _templateObject5 || (_templateObject5 = _taggedTemplateLiteral([
                '<svg\n                width="24"\n                height="24"\n                aria-hidden="true"\n                focusable="false"\n              >\n                <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z" />\n              </svg>'
            ]))), this.stop, i1 ? "active" : "", this.seeker, this._handleSeekChange, ()=>{
                this._prevState = this.currentState, this.freeze();
            }, ()=>{
                this._prevState === PlayerState.Playing && this.play();
            }, this.seeker, this.toggleLooping, this.loop ? "active" : "");
        }
        _onVisibilityChange() {
            !0 === document.hidden && this.currentState === PlayerState.Playing ? this.freeze() : this.currentState === PlayerState.Frozen && this.play();
        }
        _handleSeekChange(t1) {
            if (this._lottie && !isNaN(t1.target.value)) {
                var e1 = t1.target.value / 100 * this._lottie.totalFrames;
                this.seek(e1);
            }
        }
        _attachEventListeners() {
            this._lottie.addEventListener("enterFrame", ()=>{
                this.seeker = this._lottie.currentFrame / this._lottie.totalFrames * 100, this.dispatchEvent(new CustomEvent(PlayerEvents.Frame, {
                    detail: {
                        frame: this._lottie.currentFrame,
                        seeker: this.seeker
                    }
                }));
            }), this._lottie.addEventListener("complete", ()=>{
                if (this.currentState === PlayerState.Playing) {
                    if (!this.loop || this.count && this._counter >= this.count) {
                        if (this.dispatchEvent(new CustomEvent(PlayerEvents.Complete)), this.mode !== PlayMode.Bounce) return;
                        if (0 === this._lottie.currentFrame) return;
                    }
                    this.mode === PlayMode.Bounce ? (this.count && (this._counter += .5), setTimeout(()=>{
                        this.dispatchEvent(new CustomEvent(PlayerEvents.Loop)), this.currentState === PlayerState.Playing && (this._lottie.setDirection(-1 * this._lottie.playDirection), this._lottie.play());
                    }, this.intermission)) : (this.count && (this._counter += 1), window.setTimeout(()=>{
                        this.dispatchEvent(new CustomEvent(PlayerEvents.Loop)), this.currentState === PlayerState.Playing && (-1 === this.direction ? (this.seek("99%"), this.play()) : (this._lottie.stop(), this._lottie.play()));
                    }, this.intermission));
                } else this.dispatchEvent(new CustomEvent(PlayerEvents.Complete));
            }), this._lottie.addEventListener("DOMLoaded", ()=>{
                this.setSpeed(this.speed), this.setDirection(this.direction), this.autoplay && (-1 === this.direction && this.seek("100%"), this.play()), this.dispatchEvent(new CustomEvent(PlayerEvents.Ready));
            }), this._lottie.addEventListener("data_ready", ()=>{
                this.dispatchEvent(new CustomEvent(PlayerEvents.Load));
            }), this._lottie.addEventListener("data_failed", ()=>{
                this.currentState = PlayerState.Error, this.dispatchEvent(new CustomEvent(PlayerEvents.Error));
            }), this.container.addEventListener("mouseenter", ()=>{
                this.hover && this.currentState !== PlayerState.Playing && this.play();
            }), this.container.addEventListener("mouseleave", ()=>{
                this.hover && this.currentState === PlayerState.Playing && this.stop();
            });
        }
        freeze() {
            this._lottie && (this._lottie.pause(), this.currentState = PlayerState.Frozen, this.dispatchEvent(new CustomEvent(PlayerEvents.Freeze)));
        }
    }, _templateObject;
    __decorate([
        e$3({
            type: Boolean
        })
    ], LottiePlayer.prototype, "autoplay", void 0), __decorate([
        e$3({
            type: String,
            reflect: !0
        })
    ], LottiePlayer.prototype, "background", void 0), __decorate([
        e$3({
            type: Boolean
        })
    ], LottiePlayer.prototype, "controls", void 0), __decorate([
        e$3({
            type: Number
        })
    ], LottiePlayer.prototype, "count", void 0), __decorate([
        e$3({
            type: String
        })
    ], LottiePlayer.prototype, "currentState", void 0), __decorate([
        e$3({
            type: String
        })
    ], LottiePlayer.prototype, "description", void 0), __decorate([
        e$3({
            type: Number
        })
    ], LottiePlayer.prototype, "direction", void 0), __decorate([
        e$3({
            type: Boolean
        })
    ], LottiePlayer.prototype, "disableCheck", void 0), __decorate([
        e$3({
            type: Boolean
        })
    ], LottiePlayer.prototype, "disableShadowDOM", void 0), __decorate([
        e$3({
            type: Boolean
        })
    ], LottiePlayer.prototype, "hover", void 0), __decorate([
        e$3()
    ], LottiePlayer.prototype, "intermission", void 0), __decorate([
        e$3({
            type: Boolean,
            reflect: !0
        })
    ], LottiePlayer.prototype, "loop", void 0), __decorate([
        e$3()
    ], LottiePlayer.prototype, "mode", void 0), __decorate([
        e$3({
            type: String
        })
    ], LottiePlayer.prototype, "preserveAspectRatio", void 0), __decorate([
        e$3({
            type: String
        })
    ], LottiePlayer.prototype, "renderer", void 0), __decorate([
        e$3({
            type: String
        })
    ], LottiePlayer.prototype, "viewBoxSize", void 0), __decorate([
        e$3()
    ], LottiePlayer.prototype, "seeker", void 0), __decorate([
        e$3({
            type: Number
        })
    ], LottiePlayer.prototype, "speed", void 0), __decorate([
        e$3({
            type: String
        })
    ], LottiePlayer.prototype, "src", void 0), __decorate([
        e$3({
            type: Boolean
        })
    ], LottiePlayer.prototype, "webworkers", void 0), __decorate([
        i$2(".animation")
    ], LottiePlayer.prototype, "container", void 0), LottiePlayer = __decorate([
        n$5("lottie-player")
    ], LottiePlayer), /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */ console.warn("The main 'lit-element' module entrypoint is deprecated. Please update your imports to use the 'lit' package: 'lit' and 'lit/decorators.ts' or import from 'lit-element/lit-element.ts'. See https://lit.dev/msg/deprecated-import-path for more information.");
    var styles = r$2(_templateObject || (_templateObject = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  :host {\n    width: 512px;\n    height: 512px;\n  }\n"
    ])), styles$1);
    function fetchPath(t1) {
        return _fetchPath.apply(this, arguments);
    }
    function _fetchPath() {
        return _fetchPath = _asyncToGenerator(function*(t1) {
            return new Promise((e1, i1)=>{
                var r1 = new XMLHttpRequest;
                r1.open("GET", t1, !0), r1.responseType = "arraybuffer", r1.send(), r1.onreadystatechange = function() {
                    if (4 == r1.readyState && 200 == r1.status) try {
                        var t1 = String.fromCharCode.apply(null, new Uint8Array(r1.response));
                        return e1(JSON.parse(t1));
                    } catch (t1) {
                        try {
                            var a1 = inflate_1(r1.response, {
                                to: "string"
                            });
                            return e1(JSON.parse(a1));
                        } catch (t1) {
                            return i1(t1);
                        }
                    }
                };
            });
        }), _fetchPath.apply(this, arguments);
    }
    exports.TGSPlayer = class extends LottiePlayer {
        constructor(){
            super(...arguments), this.strict = !0;
        }
        load(t1) {
            var e1 = ()=>super.load, i1 = this;
            return _asyncToGenerator(function*() {
                var r1 = parseSrc(t1);
                if ("path" === ("string" == typeof r1 ? "path" : "animationData") && (r1 = yield fetchPath(r1)), !0 === i1.strict) {
                    var a1 = i1.formatCheck(r1);
                    0 !== a1.length && i1.dispatchEvent(new CustomEvent(PlayerEvents.Error, {
                        detail: a1
                    }));
                }
                return delete r1.tgs, e1().call(i1, r1);
            })();
        }
        static get styles() {
            return styles;
        }
        formatCheck(t1) {
            var e1 = [];
            return "tgs" in t1 && 1 === t1.tgs || e1.push("Must be marked as a TGS Lottie variant"), (t1.op - t1.ip) / t1.fr > 3 && e1.push("Longer than 3 seconds"), 512 == t1.w && 512 == t1.h || e1.push("Dimensions should be exactly 512pxx512px"), null != t1.ddd && 0 != t1.ddd && e1.push("Must not have 3D layers"), "markers" in t1 && e1.push("Must not have markers"), null != t1.assets && t1.assets.forEach((t1)=>{
                e1.concat(this.checkLayer(t1.layers));
            }), t1.layers.forEach((t1)=>{
                e1.concat(this.checkLayer(t1));
            }), e1;
        }
        checkLayer(t1) {
            var e1 = [];
            return null != t1.ddd && 0 != t1.ddd && e1.push("Composition should not include any 3D Layers"), null != t1.sr && 1 != t1.sr && e1.push("Composition should not include any Time Stretching"), null != t1.tm && e1.push("Composition should not include any Time Remapping"), 1 === t1.ty && e1.push("Composition should not include any Solids"), 2 === t1.ty && e1.push("Composition should not include any Images"), 5 === t1.ty && e1.push("Composition should not include any Texts"), !0 !== t1.hasMask && null == t1.masksProperties || e1.push("Composition should not include any Masks"), null != t1.tt && e1.push("Composition should not include any Mattes"), 1 === t1.ao && e1.push("Composition should not include any Auto-Oriented Layers"), null != t1.ef && e1.push("Composition should not include any Layer Effects"), e1.concat(this.checkItems(t1.shapes, !0)), e1;
        }
        checkItems(t1, e1) {
            var i1 = [];
            return null != t1 && t1.forEach((t1)=>{
                "rp" == t1.ty && i1.push("Composition should not include any Repeaters"), "sr" == t1.ty && i1.push("Composition should not include any Star Shapes"), "mm" == t1.ty && i1.push("Composition should not include any Merge Paths"), "gs" == t1.ty && i1.push("Composition should not include any Gradient Strokes"), !0 === e1 && i1.concat(this.checkItems(t1.it, !1));
            }), i1;
        }
    }, __decorate([
        e$3({
            type: Boolean
        })
    ], exports.TGSPlayer.prototype, "strict", void 0), exports.TGSPlayer = __decorate([
        n$5("tgs-player")
    ], exports.TGSPlayer), Object.defineProperty(exports, "__esModule", {
        value: !0
    });
});

},{}]},["2ebq0"], "2ebq0", "parcelRequire94c2")

//# sourceMappingURL=about.11c0c4f8.js.map
